import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AcceptAdminInvitationInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type AccountDeletionResponse = {
  __typename?: 'AccountDeletionResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddSubscriberInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
};

export type AddSubscriberResponse = {
  __typename?: 'AddSubscriberResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminInvitation = {
  __typename?: 'AdminInvitation';
  accepted_at?: Maybe<Scalars['Time']['output']>;
  accepted_by?: Maybe<User>;
  accepted_by_user_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  expires_at: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  invited_by?: Maybe<User>;
  invited_by_user_id: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  status: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type AdminInvitationPublic = {
  __typename?: 'AdminInvitationPublic';
  email: Scalars['String']['output'];
  expires_at: Scalars['Time']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invited_by_name?: Maybe<Scalars['String']['output']>;
  is_expired: Scalars['Boolean']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  user_exists: Scalars['Boolean']['output'];
};

export type AdminPostInput = {
  category_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  post_media?: InputMaybe<Array<InputMaybe<PostMediaInput>>>;
  release_at?: InputMaybe<Scalars['Time']['input']>;
  run_at?: InputMaybe<Scalars['Time']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  seo_schema?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ArchivedContent = {
  __typename?: 'ArchivedContent';
  archived_locations?: Maybe<Array<Maybe<SellingLocation>>>;
  archived_products?: Maybe<Array<Maybe<DirectoryIngredient>>>;
  archived_vendors?: Maybe<Array<Maybe<Listing>>>;
  listing_id: Scalars['Int']['output'];
};

export type AuthUser = {
  __typename?: 'AuthUser';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Availability = {
  __typename?: 'Availability';
  day: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type AvailabilityInput = {
  day: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type AvailabilityPromptResponse = {
  __typename?: 'AvailabilityPromptResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BannerImage = {
  __typename?: 'BannerImage';
  active?: Maybe<Scalars['Boolean']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  img_path?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Scalars['String']['output']>;
  mainlink?: Maybe<Scalars['String']['output']>;
  memberlink?: Maybe<Scalars['String']['output']>;
  record_id: Scalars['Int']['output'];
};

export type BannerImageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mainlink?: InputMaybe<Scalars['String']['input']>;
  memberlink?: InputMaybe<Scalars['String']['input']>;
};

export type BillingAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type BlockedUser = {
  __typename?: 'BlockedUser';
  blocked_user_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type BlockedUserResult = {
  __typename?: 'BlockedUserResult';
  pageInfo: UserPageInfo;
  totalCount: Scalars['Int']['output'];
  users: Array<User>;
};

export type BookmarkResponse = {
  __typename?: 'BookmarkResponse';
  recipes: Array<Maybe<Recipe>>;
  total: Scalars['Int']['output'];
};

export type BusinessRegEmailInput = {
  base_url?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  marketName?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  vendorName: Scalars['String']['input'];
};

export type Category = {
  __typename?: 'Category';
  category_description?: Maybe<Scalars['String']['output']>;
  category_id: Scalars['Int']['output'];
  category_name?: Maybe<Scalars['String']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  recipe_id?: Maybe<Scalars['Int']['output']>;
  user_created?: Maybe<Scalars['Int']['output']>;
  user_updated?: Maybe<Scalars['Int']['output']>;
};

export type CategoryCompliance = {
  __typename?: 'CategoryCompliance';
  disabled: Scalars['Int']['output'];
  enabled: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Int']['output'];
};

export type CategoryInput = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  category_name?: InputMaybe<Scalars['String']['input']>;
  date_created?: InputMaybe<Scalars['Time']['input']>;
  date_updated?: InputMaybe<Scalars['Time']['input']>;
  recipe_id?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  user_created?: InputMaybe<Scalars['Int']['input']>;
  user_updated?: InputMaybe<Scalars['Int']['input']>;
};

export type CompliancePeriod = {
  __typename?: 'CompliancePeriod';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type ComplianceSummary = {
  __typename?: 'ComplianceSummary';
  consentRate: Scalars['Int']['output'];
  explicitConsents: Scalars['Int']['output'];
  totalConsents: Scalars['Int']['output'];
  withdrawals: Scalars['Int']['output'];
};

export type ConsumerFunnel = {
  __typename?: 'ConsumerFunnel';
  added_comment: Scalars['Int']['output'];
  added_recipe: Scalars['Int']['output'];
  bio_completed: Scalars['Int']['output'];
  communication_completed: Scalars['Int']['output'];
  completed_profile: Scalars['Int']['output'];
  feed_posts_commented: Scalars['Int']['output'];
  feed_posts_opened: Scalars['Int']['output'];
  followed: Scalars['Int']['output'];
  location_completed: Scalars['Int']['output'];
  new_registrations: Scalars['Int']['output'];
  profile_image_completed: Scalars['Int']['output'];
  registered: Scalars['Int']['output'];
  searches_performed: Scalars['Int']['output'];
  wau: Scalars['Int']['output'];
};

export type ContactFormInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type Cookbook = {
  __typename?: 'Cookbook';
  can_anyone_contribute_recipes?: Maybe<Scalars['Boolean']['output']>;
  can_members_invite?: Maybe<Scalars['Boolean']['output']>;
  community_id?: Maybe<Scalars['Int']['output']>;
  contest_id?: Maybe<Scalars['Int']['output']>;
  cookbook_contest_date_finished?: Maybe<Scalars['Time']['output']>;
  cookbook_contest_description?: Maybe<Scalars['String']['output']>;
  cookbook_contest_name?: Maybe<Scalars['String']['output']>;
  cookbook_description?: Maybe<Scalars['String']['output']>;
  cookbook_id: Scalars['Int']['output'];
  cookbook_img_url?: Maybe<Scalars['String']['output']>;
  cookbook_name: Scalars['String']['output'];
  date_created?: Maybe<Scalars['Time']['output']>;
  date_featured?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  hide_cookbook_from_public?: Maybe<Scalars['Boolean']['output']>;
  is_favorite_recipes_cookbook?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_country?: Maybe<Scalars['String']['output']>;
  location_description?: Maybe<Scalars['String']['output']>;
  location_state?: Maybe<Scalars['String']['output']>;
  location_zipcode?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  number_of_members?: Maybe<Scalars['Int']['output']>;
  user_id: Scalars['Int']['output'];
};

export type CookbookConnection = {
  __typename?: 'CookbookConnection';
  edges: Array<CookbookEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CookbookEdge = {
  __typename?: 'CookbookEdge';
  cursor: Scalars['Int']['output'];
  node?: Maybe<Cookbook>;
};

export type CookbookResponse = {
  __typename?: 'CookbookResponse';
  cookbooks?: Maybe<Array<Cookbook>>;
  page: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type Cookbook_Membership = {
  __typename?: 'Cookbook_Membership';
  cookbook_id?: Maybe<Scalars['Int']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  inviting_user_id?: Maybe<Scalars['Int']['output']>;
  membership_id: Scalars['Int']['output'];
  membership_user_id: Scalars['Int']['output'];
  status_id?: Maybe<Scalars['Int']['output']>;
};

export type CookieAuditEntry = {
  __typename?: 'CookieAuditEntry';
  action: Scalars['String']['output'];
  consentVersion: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Scalars['String']['output'];
  preferences: CookiePreferences;
  sessionId: Scalars['String']['output'];
  timestamp: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
  userAgent: Scalars['String']['output'];
};

export type CookieAuditLogResponse = {
  __typename?: 'CookieAuditLogResponse';
  entries: Array<CookieAuditEntry>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CookieAuditStats = {
  __typename?: 'CookieAuditStats';
  acceptAll: Scalars['Int']['output'];
  acceptAllRate: Scalars['Int']['output'];
  analyticsRate: Scalars['Int']['output'];
  byDay: Array<DailyStats>;
  customSave: Scalars['Int']['output'];
  customSaveRate: Scalars['Int']['output'];
  declineAll: Scalars['Int']['output'];
  declineAllRate: Scalars['Int']['output'];
  functionalRate: Scalars['Int']['output'];
  last7d: Scalars['Int']['output'];
  last24h: Scalars['Int']['output'];
  last30d: Scalars['Int']['output'];
  marketingRate: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CookieComplianceReport = {
  __typename?: 'CookieComplianceReport';
  categories: Array<CategoryCompliance>;
  compliant: Scalars['Boolean']['output'];
  framework: Scalars['String']['output'];
  generatedAt: Scalars['Time']['output'];
  issues: Array<Scalars['String']['output']>;
  period: CompliancePeriod;
  recommendations: Array<Scalars['String']['output']>;
  summary: ComplianceSummary;
};

export type CookieConsentInput = {
  action: Scalars['String']['input'];
  consentVersion: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  ipAddress: Scalars['String']['input'];
  preferences: CookiePreferencesInput;
  sessionId: Scalars['String']['input'];
  timestamp: Scalars['Time']['input'];
  url: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
};

export type CookiePreferences = {
  __typename?: 'CookiePreferences';
  analytics: Scalars['Boolean']['output'];
  essential: Scalars['Boolean']['output'];
  functional: Scalars['Boolean']['output'];
  marketing: Scalars['Boolean']['output'];
};

export type CookiePreferencesInput = {
  analytics: Scalars['Boolean']['input'];
  essential: Scalars['Boolean']['input'];
  functional: Scalars['Boolean']['input'];
  marketing: Scalars['Boolean']['input'];
};

export type CouponValidationResult = {
  __typename?: 'CouponValidationResult';
  discount?: Maybe<Scalars['String']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CreateOrUpdatePostInput = {
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  post_media?: InputMaybe<Array<InputMaybe<PostMediaInput>>>;
  product_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  recipe_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  run_at?: InputMaybe<Scalars['Time']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRegionInput = {
  featured_listings?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  featured_markets?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  featured_producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  featured_recipes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hero_image?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_keywords?: InputMaybe<Scalars['String']['input']>;
  month: Scalars['String']['input'];
  name: Scalars['String']['input'];
  short_description?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type CreateSmsTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  messageType: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type CreateSurveyInput = {
  ctaLabel: Scalars['String']['input'];
  intro: Scalars['String']['input'];
  questions: Array<SurveyQuestionInput>;
  sendgridTemplateId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SurveyStatus>;
  successBody: Scalars['String']['input'];
  successCtaLabel: Scalars['String']['input'];
  successCtaUrl: Scalars['String']['input'];
  successHeading: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: SurveyType;
};

export type CustomPlanInput = {
  bizName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type DailyStats = {
  __typename?: 'DailyStats';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type DashboardResponse = {
  __typename?: 'DashboardResponse';
  cookbook?: Maybe<Scalars['Int']['output']>;
  listingStats?: Maybe<Scalars['JSON']['output']>;
  ond_listings?: Maybe<Array<Maybe<Listing>>>;
  ond_products?: Maybe<Array<Maybe<DirectoryIngredient>>>;
  pending_approval?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Scalars['Int']['output']>;
  recipes?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  userStats?: Maybe<Scalars['JSON']['output']>;
};

export type DirectoryAdmin = {
  __typename?: 'DirectoryAdmin';
  email?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['Int']['output'];
};

export type DirectoryIngredient = {
  __typename?: 'DirectoryIngredient';
  allowUsage?: Maybe<Scalars['Boolean']['output']>;
  availableMonths?: Maybe<Array<IngredientMonth>>;
  child_listings?: Maybe<Array<Maybe<Listing>>>;
  choosing?: Maybe<Scalars['String']['output']>;
  cooking?: Maybe<Scalars['String']['output']>;
  cookingGuidance?: Maybe<Scalars['String']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_month?: Maybe<Scalars['Int']['output']>;
  flavoring?: Maybe<Scalars['String']['output']>;
  illustrationImage?: Maybe<Scalars['String']['output']>;
  ingredient_id: Scalars['Int']['output'];
  isSeasonal?: Maybe<Scalars['Boolean']['output']>;
  is_generic?: Maybe<Scalars['Boolean']['output']>;
  listings?: Maybe<Array<Maybe<Listing>>>;
  mainImage?: Maybe<Scalars['String']['output']>;
  methods?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pairing?: Maybe<Scalars['String']['output']>;
  parent_listings?: Maybe<Array<Maybe<Listing>>>;
  parent_name?: Maybe<Scalars['String']['output']>;
  parent_product_id?: Maybe<Scalars['Int']['output']>;
  peak_month?: Maybe<Scalars['Int']['output']>;
  preparation?: Maybe<Scalars['String']['output']>;
  requires_enhanced?: Maybe<Scalars['Boolean']['output']>;
  resource_illustration_path?: Maybe<Scalars['String']['output']>;
  resource_main_path?: Maybe<Scalars['String']['output']>;
  seasonal_manual_until?: Maybe<Scalars['Time']['output']>;
  seasonal_source?: Maybe<Scalars['String']['output']>;
  seasonal_updated_at?: Maybe<Scalars['Time']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start_month?: Maybe<Scalars['Int']['output']>;
  thumbnail_path?: Maybe<DirectoryIngredientImage>;
  type?: Maybe<Scalars['String']['output']>;
  userOwned?: Maybe<Scalars['Boolean']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type DirectoryIngredientImage = {
  __typename?: 'DirectoryIngredientImage';
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  ingredient_id?: Maybe<Scalars['Int']['output']>;
  main_image_path?: Maybe<Scalars['String']['output']>;
  record_id: Scalars['Int']['output'];
  thumbnail_path?: Maybe<Scalars['String']['output']>;
};

export type DirectoryIngredientImageResponse = {
  __typename?: 'DirectoryIngredientImageResponse';
  illustrationImage?: Maybe<Scalars['String']['output']>;
};

export type DirectoryIngredientInput = {
  allow_usage?: InputMaybe<Scalars['Boolean']['input']>;
  choosing?: InputMaybe<Scalars['String']['input']>;
  cooking?: InputMaybe<Scalars['String']['input']>;
  cookingGuidance?: InputMaybe<Scalars['String']['input']>;
  date_created?: InputMaybe<Scalars['Time']['input']>;
  date_updated?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_month?: InputMaybe<Scalars['Int']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  flavoring?: InputMaybe<Scalars['String']['input']>;
  illustrationImage?: InputMaybe<Scalars['String']['input']>;
  ingredient_id?: InputMaybe<Scalars['Int']['input']>;
  isSeasonal?: InputMaybe<Scalars['Boolean']['input']>;
  is_generic?: InputMaybe<Scalars['Boolean']['input']>;
  mainImage?: InputMaybe<Scalars['String']['input']>;
  methods?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pairing?: InputMaybe<Scalars['String']['input']>;
  parent_product_id?: InputMaybe<Scalars['Int']['input']>;
  peak_month?: InputMaybe<Scalars['Int']['input']>;
  preparation?: InputMaybe<Scalars['String']['input']>;
  requires_enhanced?: InputMaybe<Scalars['Boolean']['input']>;
  seasonal_manual_until?: InputMaybe<Scalars['Time']['input']>;
  seasonal_source?: InputMaybe<Scalars['String']['input']>;
  seasonal_updated_at?: InputMaybe<Scalars['Time']['input']>;
  start_month?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DirectoryInput = {
  contact?: InputMaybe<Scalars['String']['input']>;
  date_from?: InputMaybe<Scalars['String']['input']>;
  date_to?: InputMaybe<Scalars['String']['input']>;
  include_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  membership_type?: InputMaybe<Scalars['String']['input']>;
  miles?: InputMaybe<Scalars['Float']['input']>;
  origin_lat?: InputMaybe<Scalars['Float']['input']>;
  origin_lon?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DirectoryResponse = {
  __typename?: 'DirectoryResponse';
  dataCount?: Maybe<Scalars['Int']['output']>;
  directoryIngredient?: Maybe<Array<Maybe<DirectoryIngredient>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
};

export type DiscoverRecipeResponse = {
  __typename?: 'DiscoverRecipeResponse';
  recipes?: Maybe<Array<Maybe<Recipe>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EmailConfirmationCode = {
  __typename?: 'EmailConfirmationCode';
  code: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type File = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  relatedId: Scalars['Int']['input'];
};

export type FilesystemResource = {
  __typename?: 'FilesystemResource';
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
  resource_path?: Maybe<Scalars['String']['output']>;
  thumbnail_path?: Maybe<Scalars['String']['output']>;
  type_id?: Maybe<Scalars['Int']['output']>;
  user_created?: Maybe<Scalars['Int']['output']>;
  user_updated?: Maybe<Scalars['Int']['output']>;
};

export type FinancialConnectionSessionResponse = {
  __typename?: 'FinancialConnectionSessionResponse';
  clientSecret: Scalars['String']['output'];
  customerID: Scalars['String']['output'];
};

export type FollowInput = {
  user_following_id: Scalars['Int']['input'];
};

export type FollowerFollowingResponse = {
  __typename?: 'FollowerFollowingResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  results?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Ingredient = {
  __typename?: 'Ingredient';
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  exclude_from_shopping_cart?: Maybe<Scalars['Boolean']['output']>;
  ingredient_description?: Maybe<Scalars['String']['output']>;
  ingredient_id: Scalars['Int']['output'];
  ingredient_name?: Maybe<Scalars['String']['output']>;
  is_user_added?: Maybe<Scalars['Boolean']['output']>;
  is_validated?: Maybe<Scalars['Boolean']['output']>;
  measurement_amount?: Maybe<Scalars['String']['output']>;
  recipes?: Maybe<Array<Maybe<Recipe>>>;
  unit_abbreviation?: Maybe<Scalars['String']['output']>;
  unit_description?: Maybe<Scalars['String']['output']>;
  unit_name?: Maybe<Scalars['String']['output']>;
  user_created?: Maybe<Scalars['Int']['output']>;
  user_updated?: Maybe<Scalars['Int']['output']>;
};

export type IngredientGrowerCounts = {
  __typename?: 'IngredientGrowerCounts';
  children: Scalars['Int']['output'];
  exact: Scalars['Int']['output'];
  ingredient_id: Scalars['Int']['output'];
  parent: Scalars['Int']['output'];
  parent_name?: Maybe<Scalars['String']['output']>;
};

export type IngredientMonth = {
  __typename?: 'IngredientMonth';
  isPeak: Scalars['Boolean']['output'];
  month: Scalars['Int']['output'];
};

export type IngredientMonthInput = {
  isPeak?: InputMaybe<Scalars['Boolean']['input']>;
  month: Scalars['Int']['input'];
};

export type Listing = {
  __typename?: 'Listing';
  OperatingPeriod?: Maybe<Array<Maybe<OperatingHours>>>;
  Practices?: Maybe<Array<Maybe<Practice>>>;
  SalesChannels?: Maybe<Array<Maybe<SalesChannel>>>;
  address?: Maybe<Scalars['String']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  business_description_completed?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  communication_completed?: Maybe<Scalars['Boolean']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  deleted_at?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enhanced?: Maybe<Scalars['Boolean']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  geolocation_completed?: Maybe<Scalars['Boolean']['output']>;
  has_created_feed_post?: Maybe<Scalars['Boolean']['output']>;
  has_created_recipe?: Maybe<Scalars['Boolean']['output']>;
  has_shared_content?: Maybe<Scalars['Boolean']['output']>;
  ingredients?: Maybe<Array<Maybe<DirectoryIngredient>>>;
  instagram?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  legacy_slug?: Maybe<Scalars['String']['output']>;
  listing_id: Scalars['Int']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nearby_market_count?: Maybe<Scalars['Int']['output']>;
  notifications_enabled?: Maybe<Scalars['Boolean']['output']>;
  on_demand?: Maybe<Scalars['Boolean']['output']>;
  pending?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  products_completed?: Maybe<Scalars['Boolean']['output']>;
  profile_image_completed?: Maybe<Scalars['Boolean']['output']>;
  publicEmail?: Maybe<Scalars['String']['output']>;
  publicPhone?: Maybe<Scalars['String']['output']>;
  resourcePath?: Maybe<Scalars['String']['output']>;
  sales_channels_completed?: Maybe<Scalars['Boolean']['output']>;
  selling_locations_completed?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<UserSubscription>;
  tagLine?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_type?: Maybe<Scalars['String']['output']>;
  vendors?: Maybe<Array<Maybe<Listing>>>;
  vendors_completed?: Maybe<Scalars['Boolean']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ListingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  base_url?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  date_created?: InputMaybe<Scalars['Time']['input']>;
  date_updated?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enhanced?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  membership_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  on_demand?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  publicPhone?: InputMaybe<Scalars['String']['input']>;
  referral_code?: InputMaybe<Scalars['String']['input']>;
  referral_id?: InputMaybe<Scalars['String']['input']>;
  resource_path?: InputMaybe<Scalars['String']['input']>;
  sellingLocations?: InputMaybe<Array<InputMaybe<SellingLocationInput>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  stripe_price_id?: InputMaybe<Scalars['String']['input']>;
  stripe_sub_id?: InputMaybe<Scalars['String']['input']>;
  subscription_expiry?: InputMaybe<Scalars['Int']['input']>;
  subscription_status?: InputMaybe<Scalars['String']['input']>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  tax_exemption?: InputMaybe<Scalars['Boolean']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<Scalars['String']['input']>;
  vendors?: InputMaybe<Array<InputMaybe<VendorListingInput>>>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type ListingResponse = {
  __typename?: 'ListingResponse';
  listings?: Maybe<Array<Maybe<Listing>>>;
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListingSortInput = {
  miles?: InputMaybe<Scalars['Float']['input']>;
  origin_lat?: InputMaybe<Scalars['Float']['input']>;
  origin_lon?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LogReferralConversionInput = {
  new_user_id: Scalars['Int']['input'];
  ref_slug: Scalars['String']['input'];
};

export type LogShareInput = {
  content_id: Scalars['String']['input'];
  content_type: Scalars['String']['input'];
  ref_slug: Scalars['String']['input'];
  share_channel: Scalars['String']['input'];
};

export type MatchedIngredient = {
  __typename?: 'MatchedIngredient';
  availability_level: Scalars['String']['output'];
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  source: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAdminInvitation: AuthUser;
  acceptShoppingListInvite: ShoppingList;
  addBookmark: Scalars['Boolean']['output'];
  addComment?: Maybe<PostComment>;
  addMarketVendors: Scalars['Boolean']['output'];
  addProducerLocations: Scalars['Boolean']['output'];
  addProducerProducts: Scalars['Boolean']['output'];
  addRecipeComment: RecipeComment;
  addRecipeCommentReaction?: Maybe<RecipeCommentReaction>;
  addRecipeToShoppingList: ShoppingList;
  addShoppingItem: ShoppingListItem;
  addSubscriber: AddSubscriberResponse;
  approvalUnValidatedIngredient: Scalars['Boolean']['output'];
  approveEnhance: Listing;
  approveSuggestion?: Maybe<SeasonalRecipePick>;
  archiveListingIngredient: Scalars['Boolean']['output'];
  archiveListingVendor: Scalars['Boolean']['output'];
  archiveSellingLocation: Scalars['Boolean']['output'];
  blockUser: Scalars['Boolean']['output'];
  bulkUpdateShoppingItems: ShoppingList;
  businessRegistration?: Maybe<AuthUser>;
  cancelSubscription: SubscriptionResponse;
  changeSubscriptionPlan: SubscriptionResponse;
  checkEmailSend: Scalars['Boolean']['output'];
  clearShoppingListMarks: ShoppingList;
  confirmEmail?: Maybe<Scalars['Boolean']['output']>;
  createACHSubscription: SubscriptionResponse;
  createAccountWithAI: User;
  createBannerImg: BannerImage;
  createEnhanced: Listing;
  createFinancialConnectionsSession: FinancialConnectionSessionResponse;
  createIngredient: DirectoryIngredient;
  createListing: Listing;
  createListingIngredient?: Maybe<Array<DirectoryIngredient>>;
  createListingOperationTime?: Maybe<Array<OperatingHours>>;
  createListingPractices: Scalars['Boolean']['output'];
  createListingVendor?: Maybe<Array<Listing>>;
  createNote?: Maybe<Array<RecipeNote>>;
  createOrUpdateAdminPost: Post;
  createOrUpdatePost: Post;
  createOrUpdatePostCategory: PostCategory;
  createPractice: Practice;
  createRecipe: Recipe;
  createRecipeTag: Array<Maybe<Category>>;
  createRegion?: Maybe<Region>;
  createSellingLocation: SellingLocation;
  createShoppingList: ShoppingList;
  createShoppingListInvite: Scalars['String']['output'];
  createShoppingListWithRecipe: ShoppingList;
  createSmsTemplate: SmsTemplate;
  createStep?: Maybe<Array<RecipeSteps>>;
  createSubscription: SubscriptionResponse;
  createSurvey: Survey;
  createUnitOfMesurement: UnitOfMeasurement;
  deactivateListing: AccountDeletionResponse;
  declineEnhance: Listing;
  deleteAccount: AccountDeletionResponse;
  deleteAllListings: AccountDeletionResponse;
  deleteBanner: Scalars['Boolean']['output'];
  deleteComment: Scalars['Boolean']['output'];
  deleteDirectoryIngredient: Scalars['Boolean']['output'];
  deleteIngredient: Scalars['Boolean']['output'];
  deleteListing: Scalars['Boolean']['output'];
  deleteListingIngredientFromProfile: Scalars['Boolean']['output'];
  deleteListingVendorFromProfile: Scalars['Boolean']['output'];
  deleteOldCookieAuditEntries: Scalars['Int']['output'];
  deletePost: Scalars['Boolean']['output'];
  deletePostCategory: Scalars['Boolean']['output'];
  deleteRecipe: Scalars['Boolean']['output'];
  deleteRecipeComment: Scalars['Boolean']['output'];
  deleteRecipeIngredient: Scalars['Boolean']['output'];
  deleteRecipeNote: Scalars['Boolean']['output'];
  deleteRecipeStep: Scalars['Boolean']['output'];
  deleteRecipeTag: Scalars['Boolean']['output'];
  deleteRegion: Scalars['Boolean']['output'];
  deleteSellingLocation: Scalars['Boolean']['output'];
  deleteShoppingList: Scalars['Boolean']['output'];
  deleteSingleListing: AccountDeletionResponse;
  deleteSmsTemplate: Scalars['Boolean']['output'];
  deleteSurvey: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  directoryIngredientPrivacy: Scalars['Boolean']['output'];
  disableSmsNotifications: Scalars['Boolean']['output'];
  dismissRecipeRatingPrompt: Scalars['Boolean']['output'];
  dismissShoppingSuggestion: ShoppingList;
  emailExist: Scalars['String']['output'];
  follow: Scalars['Boolean']['output'];
  forgotPassword: ForgotPasswordResponse;
  generateSeasonalSuggestions?: Maybe<Array<Maybe<SeasonalRecipeSuggestion>>>;
  importSpoonacularRecipe?: Maybe<SeasonalRecipePick>;
  initiateSmsOptIn: SmsOptInResponse;
  inviteAdmin: AdminInvitation;
  likePost: Post;
  logReferralConversion: Scalars['Boolean']['output'];
  logShare: Scalars['Boolean']['output'];
  login: AuthUser;
  loginAdminUser: DirectoryAdmin;
  markNotificationAsRead: Scalars['Boolean']['output'];
  markOnDemandListingCleared: Scalars['Boolean']['output'];
  mergeShoppingItems: ShoppingList;
  postFileUpload: Scalars['String']['output'];
  purgeDeletedAccounts: PurgeResult;
  rateRecipe: RecipeRatingResponse;
  reactivateAccount: AccountDeletionResponse;
  reactivateListing: AccountDeletionResponse;
  recordCookieConsent: CookieAuditEntry;
  register: AuthUser;
  rejectSuggestion?: Maybe<Scalars['Boolean']['output']>;
  removeAdmin: Scalars['Boolean']['output'];
  removeBookmark: Scalars['Boolean']['output'];
  removeRecipeFromShoppingList: ShoppingList;
  removeSeasonalRecipePick?: Maybe<Scalars['Boolean']['output']>;
  removeShoppingItem: Scalars['Boolean']['output'];
  removeShoppingListMember: Scalars['Boolean']['output'];
  renameShoppingList: ShoppingList;
  renewOrCreateSubscription: Scalars['Boolean']['output'];
  reorderShoppingItems: ShoppingList;
  replaceListingOperationTime?: Maybe<Array<OperatingHours>>;
  replaceListingPractices?: Maybe<Scalars['Boolean']['output']>;
  replaceListingSalesChannels?: Maybe<Scalars['Boolean']['output']>;
  requestCustomPlan: Scalars['Boolean']['output'];
  requestSignInLink: ForgotPasswordResponse;
  resendAdminInvitation: AdminInvitation;
  resendSmsOtp: SmsOptInResponse;
  resetPassword: ForgotPasswordResponse;
  resetShoppingListInvite: Scalars['String']['output'];
  restoreArchivedContent: Scalars['Boolean']['output'];
  revokeAdminInvitation: Scalars['Boolean']['output'];
  sendAvailabilityPrompt: AvailabilityPromptResponse;
  sendBusinessRegEmail: Scalars['Boolean']['output'];
  sendEmailConfirmationCode: ForgotPasswordResponse;
  sendSurvey: SendSurveyResponse;
  setIngredientAvailableMonths: DirectoryIngredient;
  setRecipeAsFeatured: Recipe;
  setSeasonalRecipePick?: Maybe<SeasonalRecipePick>;
  signInWithLink: AuthUser;
  socialLogin: AuthUser;
  splitShoppingItem: ShoppingList;
  startBusinessAccount?: Maybe<AuthUser>;
  submitContactForm: Scalars['Boolean']['output'];
  switchBannerState: Scalars['Boolean']['output'];
  switchUserDefaultListing?: Maybe<User>;
  switchUserRole: User;
  tokenRefresh: Scalars['String']['output'];
  trackEvent: Scalars['Boolean']['output'];
  trackProductInteraction: TrackProductInteractionResponse;
  triggerTextToPost: TextToPostResponse;
  unFollow: Scalars['Boolean']['output'];
  unblockUser: Scalars['Boolean']['output'];
  updateBannerDetail: BannerImage;
  updateDirectoryIngredient: DirectoryIngredient;
  updateIngredient: Ingredient;
  updateIngredientImage: DirectoryIngredientImageResponse;
  updateListing: Listing;
  updateListingImage?: Maybe<Scalars['String']['output']>;
  updateNote?: Maybe<Array<RecipeNote>>;
  updateOrCreateRecipeTag?: Maybe<Array<RecipeCategory>>;
  updatePaymentMethod: SubscriptionResponse;
  updateProfile: UserResponse;
  updateRecipe: Recipe;
  updateRecipeImage: Scalars['Boolean']['output'];
  updateRegion?: Maybe<Region>;
  updateSellingLocation: SellingLocation;
  updateShoppingItem: ShoppingListItem;
  updateSmsTemplate: SmsTemplate;
  updateStep?: Maybe<Array<RecipeSteps>>;
  updateSurvey: Survey;
  updateSurveyStatus: Survey;
  updateUserAvatar: UserImage;
  updateUserSubscription: UserSubscription;
  updateVendors: Listing;
  upgradeToProfessional: SubscriptionResponse;
  upgradeWithACHToProfessional: SubscriptionResponse;
  uploadHeroImage: Scalars['Boolean']['output'];
  uploadImage: Scalars['String']['output'];
  upsertNotificationPreferences: Scalars['Boolean']['output'];
  userConversion?: Maybe<User>;
  verifySmsOtp: Scalars['Boolean']['output'];
};


export type MutationAcceptAdminInvitationArgs = {
  input?: InputMaybe<AcceptAdminInvitationInput>;
  token: Scalars['String']['input'];
};


export type MutationAcceptShoppingListInviteArgs = {
  token: Scalars['String']['input'];
};


export type MutationAddBookmarkArgs = {
  recipe_id: Scalars['Int']['input'];
};


export type MutationAddCommentArgs = {
  content: Scalars['String']['input'];
  postId: Scalars['Int']['input'];
};


export type MutationAddMarketVendorsArgs = {
  input?: InputMaybe<Array<VendorListingInput>>;
  listingID: Scalars['Int']['input'];
};


export type MutationAddProducerLocationsArgs = {
  input?: InputMaybe<Array<SellingLocationInput>>;
};


export type MutationAddProducerProductsArgs = {
  input?: InputMaybe<Array<DirectoryIngredientInput>>;
  listingID: Scalars['Int']['input'];
};


export type MutationAddRecipeCommentArgs = {
  content: Scalars['String']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  recipeID: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};


export type MutationAddRecipeCommentReactionArgs = {
  commentID: Scalars['Int']['input'];
  emoji: Scalars['String']['input'];
  userID: Scalars['Int']['input'];
};


export type MutationAddRecipeToShoppingListArgs = {
  list_id: Scalars['Int']['input'];
  recipe_id: Scalars['Int']['input'];
  redirects?: InputMaybe<Array<RecipeRedirectInput>>;
};


export type MutationAddShoppingItemArgs = {
  input: ShoppingItemInput;
};


export type MutationAddSubscriberArgs = {
  input: AddSubscriberInput;
};


export type MutationApprovalUnValidatedIngredientArgs = {
  ingredientID: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
};


export type MutationApproveEnhanceArgs = {
  approve: Scalars['Boolean']['input'];
  enhance: Scalars['Boolean']['input'];
  listingId: Scalars['Int']['input'];
  pending: Scalars['Boolean']['input'];
  taxCertExpirationDate?: InputMaybe<Scalars['Time']['input']>;
  taxCertNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveSuggestionArgs = {
  admin_notes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationArchiveListingIngredientArgs = {
  ingredientId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
};


export type MutationArchiveListingVendorArgs = {
  listingId: Scalars['Int']['input'];
  vendorId: Scalars['Int']['input'];
};


export type MutationArchiveSellingLocationArgs = {
  locationId: Scalars['Int']['input'];
};


export type MutationBlockUserArgs = {
  user_id: Scalars['Int']['input'];
};


export type MutationBulkUpdateShoppingItemsArgs = {
  input: ShoppingBulkUpdateInput;
};


export type MutationBusinessRegistrationArgs = {
  ingredientInput?: InputMaybe<Array<InputMaybe<DirectoryIngredientInput>>>;
  input?: InputMaybe<ListingInput>;
  practices?: InputMaybe<Array<InputMaybe<PracticeInput>>>;
  salesChannels?: InputMaybe<Array<InputMaybe<SalesChannelInput>>>;
  sellingLocations?: InputMaybe<Array<InputMaybe<SellingLocationInput>>>;
};


export type MutationChangeSubscriptionPlanArgs = {
  newPriceID: Scalars['ID']['input'];
  proration?: InputMaybe<ProrationBehavior>;
  subscriptionID: Scalars['ID']['input'];
};


export type MutationCheckEmailSendArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};


export type MutationClearShoppingListMarksArgs = {
  list_id: Scalars['Int']['input'];
};


export type MutationConfirmEmailArgs = {
  code: Scalars['String']['input'];
  email_address: Scalars['String']['input'];
};


export type MutationCreateAchSubscriptionArgs = {
  bankAccountID: Scalars['String']['input'];
  customerID: Scalars['String']['input'];
  input: PaymentIntentInput;
};


export type MutationCreateAccountWithAiArgs = {
  input: UserConversionInput;
};


export type MutationCreateBannerImgArgs = {
  file: Scalars['Upload']['input'];
  input: BannerImageInput;
};


export type MutationCreateEnhancedArgs = {
  Practices?: InputMaybe<Array<InputMaybe<PracticeInput>>>;
  ingredientInput?: InputMaybe<Array<InputMaybe<DirectoryIngredientInput>>>;
  input?: InputMaybe<ListingInput>;
  sellingLocations?: InputMaybe<Array<InputMaybe<SellingLocationInput>>>;
  vendors?: InputMaybe<Array<InputMaybe<ListingInput>>>;
};


export type MutationCreateFinancialConnectionsSessionArgs = {
  input?: InputMaybe<PaymentIntentInput>;
};


export type MutationCreateIngredientArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  input: DirectoryIngredientInput;
  mainFile?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationCreateListingArgs = {
  ingredientInput?: InputMaybe<Array<InputMaybe<DirectoryIngredientInput>>>;
  input?: InputMaybe<ListingInput>;
  vendors?: InputMaybe<Array<InputMaybe<VendorListingInput>>>;
};


export type MutationCreateListingIngredientArgs = {
  ingredients?: InputMaybe<Array<DirectoryIngredientInput>>;
  listing_id: Scalars['Int']['input'];
};


export type MutationCreateListingOperationTimeArgs = {
  input?: InputMaybe<Array<OperatingHoursInput>>;
};


export type MutationCreateListingPracticesArgs = {
  input?: InputMaybe<Array<PracticeInput>>;
  listingID: Scalars['Int']['input'];
};


export type MutationCreateListingVendorArgs = {
  listing_id: Scalars['Int']['input'];
  vendors?: InputMaybe<Array<ListingInput>>;
};


export type MutationCreateNoteArgs = {
  input?: InputMaybe<Array<NoteInput>>;
};


export type MutationCreateOrUpdateAdminPostArgs = {
  input: AdminPostInput;
};


export type MutationCreateOrUpdatePostArgs = {
  group?: InputMaybe<Scalars['String']['input']>;
  input: CreateOrUpdatePostInput;
};


export type MutationCreateOrUpdatePostCategoryArgs = {
  input: PostCategoryInput;
};


export type MutationCreatePracticeArgs = {
  file: Scalars['Upload']['input'];
  input?: InputMaybe<PracticeInput>;
};


export type MutationCreateRecipeArgs = {
  ingredientInput?: InputMaybe<Array<NewIngredientInput>>;
  input: RecipeInput;
};


export type MutationCreateRecipeTagArgs = {
  input?: InputMaybe<Array<CategoryInput>>;
};


export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};


export type MutationCreateSellingLocationArgs = {
  input: SellingLocationInput;
};


export type MutationCreateShoppingListArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateShoppingListInviteArgs = {
  list_id: Scalars['Int']['input'];
};


export type MutationCreateShoppingListWithRecipeArgs = {
  name: Scalars['String']['input'];
  recipe_id: Scalars['Int']['input'];
  redirects?: InputMaybe<Array<RecipeRedirectInput>>;
};


export type MutationCreateSmsTemplateArgs = {
  input: CreateSmsTemplateInput;
};


export type MutationCreateStepArgs = {
  input?: InputMaybe<Array<StepInput>>;
};


export type MutationCreateSubscriptionArgs = {
  input: PaymentIntentInput;
  paymentMethodID: Scalars['String']['input'];
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


export type MutationCreateUnitOfMesurementArgs = {
  input: UnitOfMeasurementInput;
};


export type MutationDeactivateListingArgs = {
  listingId: Scalars['Int']['input'];
};


export type MutationDeclineEnhanceArgs = {
  listingId: Scalars['Int']['input'];
};


export type MutationDeleteAccountArgs = {
  password: Scalars['String']['input'];
};


export type MutationDeleteBannerArgs = {
  bannerId: Scalars['Int']['input'];
};


export type MutationDeleteCommentArgs = {
  commentID: Scalars['Int']['input'];
};


export type MutationDeleteDirectoryIngredientArgs = {
  ingredientId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteIngredientArgs = {
  ingredient_id: Scalars['Int']['input'];
};


export type MutationDeleteListingArgs = {
  listingId: Scalars['Int']['input'];
};


export type MutationDeleteListingIngredientFromProfileArgs = {
  ingredientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  listing_id: Scalars['Int']['input'];
};


export type MutationDeleteListingVendorFromProfileArgs = {
  listing_id: Scalars['Int']['input'];
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationDeleteOldCookieAuditEntriesArgs = {
  olderThanDays: Scalars['Int']['input'];
};


export type MutationDeletePostArgs = {
  postID: Scalars['Int']['input'];
};


export type MutationDeletePostCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRecipeArgs = {
  recipe_id: Scalars['Int']['input'];
};


export type MutationDeleteRecipeCommentArgs = {
  commentID: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};


export type MutationDeleteRecipeIngredientArgs = {
  record_id: Scalars['Int']['input'];
};


export type MutationDeleteRecipeNoteArgs = {
  note_id: Scalars['Int']['input'];
};


export type MutationDeleteRecipeStepArgs = {
  step_id: Scalars['Int']['input'];
};


export type MutationDeleteRecipeTagArgs = {
  category_id: Scalars['Int']['input'];
};


export type MutationDeleteRegionArgs = {
  region_id: Scalars['Int']['input'];
};


export type MutationDeleteSellingLocationArgs = {
  locationID: Scalars['Int']['input'];
};


export type MutationDeleteShoppingListArgs = {
  list_id: Scalars['Int']['input'];
};


export type MutationDeleteSingleListingArgs = {
  listingId: Scalars['Int']['input'];
};


export type MutationDeleteSmsTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSurveyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  user_id: Scalars['Int']['input'];
};


export type MutationDirectoryIngredientPrivacyArgs = {
  record_id: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
};


export type MutationDismissRecipeRatingPromptArgs = {
  recipe_id: Scalars['Int']['input'];
};


export type MutationDismissShoppingSuggestionArgs = {
  item_id: Scalars['Int']['input'];
  other_item_id: Scalars['Int']['input'];
};


export type MutationEmailExistArgs = {
  email_address: Scalars['String']['input'];
};


export type MutationFollowArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationForgotPasswordArgs = {
  email_address: Scalars['String']['input'];
};


export type MutationGenerateSeasonalSuggestionsArgs = {
  weekOf: Scalars['String']['input'];
};


export type MutationImportSpoonacularRecipeArgs = {
  spoonacularId: Scalars['Int']['input'];
  weekOf: Scalars['String']['input'];
};


export type MutationInitiateSmsOptInArgs = {
  input: SmsOptInInput;
};


export type MutationInviteAdminArgs = {
  email: Scalars['String']['input'];
};


export type MutationLikePostArgs = {
  postId: Scalars['Int']['input'];
};


export type MutationLogReferralConversionArgs = {
  input: LogReferralConversionInput;
};


export type MutationLogShareArgs = {
  input: LogShareInput;
};


export type MutationLoginArgs = {
  email_address: Scalars['String']['input'];
  password_hash: Scalars['String']['input'];
};


export type MutationLoginAdminUserArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['Int']['input'];
};


export type MutationMarkOnDemandListingClearedArgs = {
  listing_id: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
};


export type MutationMergeShoppingItemsArgs = {
  item_ids: Array<Scalars['Int']['input']>;
  list_id: Scalars['Int']['input'];
};


export type MutationPostFileUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationPurgeDeletedAccountsArgs = {
  businessDays?: InputMaybe<Scalars['Int']['input']>;
  consumerDays?: InputMaybe<Scalars['Int']['input']>;
  dryRun: Scalars['Boolean']['input'];
  listingDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRateRecipeArgs = {
  rating: Scalars['Float']['input'];
  recipe_id: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};


export type MutationReactivateAccountArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationReactivateListingArgs = {
  listingId: Scalars['Int']['input'];
};


export type MutationRecordCookieConsentArgs = {
  input: CookieConsentInput;
};


export type MutationRegisterArgs = {
  input: NewUser;
};


export type MutationRejectSuggestionArgs = {
  admin_notes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationRemoveAdminArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationRemoveBookmarkArgs = {
  recipe_id: Scalars['Int']['input'];
};


export type MutationRemoveRecipeFromShoppingListArgs = {
  list_id: Scalars['Int']['input'];
  recipe_id: Scalars['Int']['input'];
};


export type MutationRemoveSeasonalRecipePickArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveShoppingItemArgs = {
  item_id: Scalars['Int']['input'];
};


export type MutationRemoveShoppingListMemberArgs = {
  collaborator_id: Scalars['Int']['input'];
  list_id: Scalars['Int']['input'];
};


export type MutationRenameShoppingListArgs = {
  list_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenewOrCreateSubscriptionArgs = {
  planId: Scalars['Int']['input'];
  price_id: Scalars['Int']['input'];
  stripeCustomerID?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationReorderShoppingItemsArgs = {
  input: ShoppingReorderInput;
};


export type MutationReplaceListingOperationTimeArgs = {
  input: Array<OperatingHoursInput>;
  listingId: Scalars['Int']['input'];
};


export type MutationReplaceListingPracticesArgs = {
  input: Array<PracticeInput>;
  listingId: Scalars['Int']['input'];
};


export type MutationReplaceListingSalesChannelsArgs = {
  input: Array<SalesChannelInput>;
  listingId: Scalars['Int']['input'];
};


export type MutationRequestCustomPlanArgs = {
  input: CustomPlanInput;
};


export type MutationRequestSignInLinkArgs = {
  email_address: Scalars['String']['input'];
};


export type MutationResendAdminInvitationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationResetPasswordArgs = {
  input: PasswordResetInput;
};


export type MutationResetShoppingListInviteArgs = {
  list_id: Scalars['Int']['input'];
};


export type MutationRestoreArchivedContentArgs = {
  listingId: Scalars['Int']['input'];
};


export type MutationRevokeAdminInvitationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSendAvailabilityPromptArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationSendBusinessRegEmailArgs = {
  emailType: Scalars['String']['input'];
  input: BusinessRegEmailInput;
};


export type MutationSendEmailConfirmationCodeArgs = {
  email_address: Scalars['String']['input'];
  fName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendSurveyArgs = {
  input: SendSurveyInput;
};


export type MutationSetIngredientAvailableMonthsArgs = {
  ingredientId: Scalars['Int']['input'];
  months: Array<IngredientMonthInput>;
};


export type MutationSetRecipeAsFeaturedArgs = {
  isFeatured: Scalars['Boolean']['input'];
  recipe_id: Scalars['Int']['input'];
};


export type MutationSetSeasonalRecipePickArgs = {
  recipeId: Scalars['Int']['input'];
  weekOf: Scalars['String']['input'];
};


export type MutationSignInWithLinkArgs = {
  email_address: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSocialLoginArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSplitShoppingItemArgs = {
  item_id: Scalars['Int']['input'];
};


export type MutationStartBusinessAccountArgs = {
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};


export type MutationSubmitContactFormArgs = {
  input: ContactFormInput;
};


export type MutationSwitchBannerStateArgs = {
  bannerId: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
};


export type MutationSwitchUserDefaultListingArgs = {
  listingID: Scalars['Int']['input'];
};


export type MutationSwitchUserRoleArgs = {
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationTokenRefreshArgs = {
  token: Scalars['String']['input'];
};


export type MutationTrackEventArgs = {
  input: TrackEventInput;
};


export type MutationTrackProductInteractionArgs = {
  input: TrackProductInteractionInput;
};


export type MutationTriggerTextToPostArgs = {
  message: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationUnFollowArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationUnblockUserArgs = {
  blocked_user_id: Scalars['Int']['input'];
};


export type MutationUpdateBannerDetailArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['Int']['input'];
  input?: InputMaybe<BannerImageInput>;
};


export type MutationUpdateDirectoryIngredientArgs = {
  ingredientId: Scalars['Int']['input'];
  input: DirectoryIngredientInput;
};


export type MutationUpdateIngredientArgs = {
  input: UpdateIngredientInput;
};


export type MutationUpdateIngredientImageArgs = {
  file: Scalars['Upload']['input'];
  ingredientID: Scalars['Int']['input'];
  typeArg: Scalars['String']['input'];
};


export type MutationUpdateListingArgs = {
  input?: InputMaybe<ListingInput>;
  listingId: Scalars['Int']['input'];
};


export type MutationUpdateListingImageArgs = {
  file: Scalars['Upload']['input'];
  listingID: Scalars['Int']['input'];
};


export type MutationUpdateNoteArgs = {
  input?: InputMaybe<Array<NoteInput>>;
};


export type MutationUpdateOrCreateRecipeTagArgs = {
  input: RecipeTagUpdateInput;
};


export type MutationUpdatePaymentMethodArgs = {
  paymentMethodID: Scalars['String']['input'];
};


export type MutationUpdateProfileArgs = {
  input: UserInput;
  userID: Scalars['Int']['input'];
};


export type MutationUpdateRecipeArgs = {
  ingredientInput?: InputMaybe<Array<NewIngredientInput>>;
  input: RecipeInput;
};


export type MutationUpdateRecipeImageArgs = {
  RecipeID: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUpdateRegionArgs = {
  input: UpdateRegionInput;
};


export type MutationUpdateSellingLocationArgs = {
  input: SellingLocationInput;
  locationID: Scalars['Int']['input'];
};


export type MutationUpdateShoppingItemArgs = {
  input: ShoppingItemUpdateInput;
  item_id: Scalars['Int']['input'];
};


export type MutationUpdateSmsTemplateArgs = {
  input: UpdateSmsTemplateInput;
};


export type MutationUpdateStepArgs = {
  input?: InputMaybe<Array<StepInput>>;
};


export type MutationUpdateSurveyArgs = {
  input: UpdateSurveyInput;
};


export type MutationUpdateSurveyStatusArgs = {
  input: UpdateSurveyStatusInput;
};


export type MutationUpdateUserAvatarArgs = {
  file: Scalars['Upload']['input'];
  userID: Scalars['Int']['input'];
};


export type MutationUpdateUserSubscriptionArgs = {
  currentPeriodEnd?: InputMaybe<Scalars['Time']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationUpdateVendorsArgs = {
  listingId: Scalars['Int']['input'];
  vendorIDS?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationUpgradeToProfessionalArgs = {
  input: PaymentIntentInput;
  paymentMethodID: Scalars['String']['input'];
};


export type MutationUpgradeWithAchToProfessionalArgs = {
  bankAccountID: Scalars['String']['input'];
  customerID: Scalars['String']['input'];
  input: PaymentIntentInput;
};


export type MutationUploadHeroImageArgs = {
  file: Scalars['Upload']['input'];
  region_id: Scalars['Int']['input'];
};


export type MutationUploadImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpsertNotificationPreferencesArgs = {
  input: Array<NotificationPreferenceInput>;
};


export type MutationUserConversionArgs = {
  input: UserConversionInput;
};


export type MutationVerifySmsOtpArgs = {
  input: SmsVerifyOtpInput;
};

export type NewIngredientInput = {
  date_created?: InputMaybe<Scalars['Time']['input']>;
  date_disabled?: InputMaybe<Scalars['Time']['input']>;
  date_updated?: InputMaybe<Scalars['Time']['input']>;
  denominator?: InputMaybe<Scalars['Int']['input']>;
  exclude_from_shopping_cart?: InputMaybe<Scalars['Boolean']['input']>;
  ingredient_description?: InputMaybe<Scalars['String']['input']>;
  ingredient_id?: InputMaybe<Scalars['Int']['input']>;
  ingredient_name?: InputMaybe<Scalars['String']['input']>;
  is_validated?: InputMaybe<Scalars['Boolean']['input']>;
  measurement_amount?: InputMaybe<Scalars['String']['input']>;
  numerator?: InputMaybe<Scalars['Int']['input']>;
  record_id?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  unit_abbreviation?: InputMaybe<Scalars['String']['input']>;
  unit_description?: InputMaybe<Scalars['String']['input']>;
  unit_name?: InputMaybe<Scalars['String']['input']>;
  unit_of_measurement_id?: InputMaybe<Scalars['Int']['input']>;
  user_created?: InputMaybe<Scalars['Int']['input']>;
  user_updated?: InputMaybe<Scalars['Int']['input']>;
  whole_number?: InputMaybe<Scalars['Int']['input']>;
};

export type NewUser = {
  email_address: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  password_hash: Scalars['String']['input'];
};

export type NoteInput = {
  date_created?: InputMaybe<Scalars['Time']['input']>;
  date_disabled?: InputMaybe<Scalars['Time']['input']>;
  date_updated?: InputMaybe<Scalars['Time']['input']>;
  note_description?: InputMaybe<Scalars['String']['input']>;
  note_name?: InputMaybe<Scalars['String']['input']>;
  note_order?: InputMaybe<Scalars['Int']['input']>;
  recipe_id?: InputMaybe<Scalars['Int']['input']>;
  record_id?: InputMaybe<Scalars['Int']['input']>;
  user_created?: InputMaybe<Scalars['Int']['input']>;
  user_updated?: InputMaybe<Scalars['Int']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  read: Scalars['Boolean']['output'];
  template: Scalars['String']['output'];
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  channel: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  smsListType?: Maybe<Scalars['String']['output']>;
  updateType: Scalars['String']['output'];
  userID: Scalars['Int']['output'];
};

export type NotificationPreferenceInput = {
  channel: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  update_type: Scalars['String']['input'];
  userID: Scalars['Int']['input'];
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  limit?: Maybe<Scalars['Int']['output']>;
  notifications: Array<Notification>;
  offset?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type OperatingHours = {
  __typename?: 'OperatingHours';
  closingTime: Scalars['String']['output'];
  day: Scalars['String']['output'];
  listing_id: Scalars['Int']['output'];
  openingTime: Scalars['String']['output'];
  operationId: Scalars['Int']['output'];
};

export type OperatingHoursInput = {
  closingTime: Scalars['String']['input'];
  day: Scalars['String']['input'];
  listing_id: Scalars['Int']['input'];
  openingTime: Scalars['String']['input'];
  operationId?: InputMaybe<Scalars['Int']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type PasswordResetToken = {
  __typename?: 'PasswordResetToken';
  id: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

export type PaymentIntentInput = {
  amount: Scalars['Int']['input'];
  billing_details?: InputMaybe<BillingAddressInput>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  full_name?: InputMaybe<Scalars['String']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  plan_id?: InputMaybe<Scalars['String']['input']>;
  price_id: Scalars['String']['input'];
  tax_exemption: Scalars['Boolean']['input'];
};

export type PaymentIntentResponse = {
  __typename?: 'PaymentIntentResponse';
  clientSecret?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Any']['output']>;
};

export type PaymentMethodInfo = {
  __typename?: 'PaymentMethodInfo';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type Post = {
  __typename?: 'Post';
  categories?: Maybe<Array<Maybe<PostCategory>>>;
  commentCount?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<Maybe<PostComment>>>;
  content: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Time']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  likeCount?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Array<Maybe<PostLike>>>;
  listing?: Maybe<Listing>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  post_medias?: Maybe<Array<Maybe<PostMedia>>>;
  post_products?: Maybe<Array<Maybe<PostProduct>>>;
  post_recipes?: Maybe<Array<Maybe<PostRecipe>>>;
  release_at?: Maybe<Scalars['Time']['output']>;
  run_at?: Maybe<Scalars['Time']['output']>;
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  seo_schema?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Time']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type PostCategory = {
  __typename?: 'PostCategory';
  created_at?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type PostCategoryInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type PostComment = {
  __typename?: 'PostComment';
  content: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  post?: Maybe<Post>;
  post_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['Time']['output']>;
  user?: Maybe<User>;
  user_id: Scalars['Int']['output'];
};

export type PostLike = {
  __typename?: 'PostLike';
  created_at?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  post: Post;
  post_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['Time']['output']>;
  user: User;
  user_id: Scalars['Int']['output'];
};

export type PostMedia = {
  __typename?: 'PostMedia';
  id: Scalars['Int']['output'];
  post?: Maybe<Post>;
  post_id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PostMediaInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};

export type PostPagination = {
  __typename?: 'PostPagination';
  posts: Array<Post>;
  recipes?: Maybe<Array<Maybe<Recipe>>>;
  totalCount: Scalars['Int']['output'];
};

export type PostProduct = {
  __typename?: 'PostProduct';
  id: Scalars['Int']['output'];
  post: Post;
  post_id: Scalars['Int']['output'];
  product: DirectoryIngredient;
  product_id: Scalars['Int']['output'];
};

export type PostRecipe = {
  __typename?: 'PostRecipe';
  id: Scalars['Int']['output'];
  post: Post;
  post_id: Scalars['Int']['output'];
  recipe: Recipe;
  recipe_id: Scalars['Int']['output'];
};

export type Practice = {
  __typename?: 'Practice';
  imgUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  practice_id: Scalars['Int']['output'];
  resource_path?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type PracticeInput = {
  imgUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  practice_id?: InputMaybe<Scalars['Int']['input']>;
  resource_path?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type ProducerSegmentCounts = {
  __typename?: 'ProducerSegmentCounts';
  inactive_30_days: Scalars['Int']['output'];
  logged_in_no_products: Scalars['Int']['output'];
  never_logged_in: Scalars['Int']['output'];
  posting_and_sharing: Scalars['Int']['output'];
  posting_not_sharing: Scalars['Int']['output'];
  products_no_posts: Scalars['Int']['output'];
  updated_at: Scalars['String']['output'];
  wau: Scalars['Int']['output'];
};

export type ProducerSegmentResult = {
  __typename?: 'ProducerSegmentResult';
  rows: Array<ProducerSegmentRow>;
  total: Scalars['Int']['output'];
};

export type ProducerSegmentRow = {
  __typename?: 'ProducerSegmentRow';
  city?: Maybe<Scalars['String']['output']>;
  date_created?: Maybe<Scalars['String']['output']>;
  date_last_login?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  engagement_score?: Maybe<Scalars['Float']['output']>;
  enhanced?: Maybe<Scalars['Boolean']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  has_login: Scalars['Boolean']['output'];
  has_posts: Scalars['Boolean']['output'];
  has_products: Scalars['Boolean']['output'];
  has_shares: Scalars['Boolean']['output'];
  is_active: Scalars['Boolean']['output'];
  listing_id?: Maybe<Scalars['Int']['output']>;
  listing_name?: Maybe<Scalars['String']['output']>;
  location_count?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  post_count?: Maybe<Scalars['Int']['output']>;
  product_count?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['Int']['output'];
  user_type?: Maybe<Scalars['String']['output']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  name: Scalars['String']['output'];
  product_category_id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type ProfileView = {
  __typename?: 'ProfileView';
  listing_id: Scalars['Int']['output'];
  listing_name: Scalars['String']['output'];
  views: Scalars['Int']['output'];
  wow_pct: Scalars['Int']['output'];
};

export enum ProrationBehavior {
  AlwaysInvoice = 'ALWAYS_INVOICE',
  CreateProrations = 'CREATE_PRORATIONS',
  None = 'NONE'
}

export type PurgePreview = {
  __typename?: 'PurgePreview';
  business_eligible: Scalars['Int']['output'];
  consumers_eligible: Scalars['Int']['output'];
  grace_period_business_days: Scalars['Int']['output'];
  grace_period_consumer_days: Scalars['Int']['output'];
  grace_period_listing_days: Scalars['Int']['output'];
  listings_eligible: Scalars['Int']['output'];
};

export type PurgeResult = {
  __typename?: 'PurgeResult';
  details: Array<PurgedEntity>;
  dry_run: Scalars['Boolean']['output'];
  grace_period_business_days: Scalars['Int']['output'];
  grace_period_consumer_days: Scalars['Int']['output'];
  grace_period_listing_days: Scalars['Int']['output'];
  listings_hard_deleted: Scalars['Int']['output'];
  users_hard_deleted: Scalars['Int']['output'];
};

export type PurgedEntity = {
  __typename?: 'PurgedEntity';
  deletions: Array<TableDeletion>;
  email?: Maybe<Scalars['String']['output']>;
  entity_id: Scalars['Int']['output'];
  entity_type: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  FirstFourCookbooks?: Maybe<Array<Cookbook>>;
  MyFollowers: FollowerFollowingResponse;
  MyFollowing: FollowerFollowingResponse;
  blockedUsers: BlockedUserResult;
  computeTax?: Maybe<TaxCalculationResponse>;
  cookbook: Cookbook;
  cookbooks?: Maybe<Array<Cookbook>>;
  cookbooksIFollow?: Maybe<Array<Cookbook>>;
  cooks?: Maybe<CookbookConnection>;
  currentPaymentMethod?: Maybe<PaymentMethodInfo>;
  exportCookieAuditLogCSV: Scalars['String']['output'];
  exportSurveyResponsesCSV: Scalars['String']['output'];
  findDirectoryIngredientByName?: Maybe<DirectoryIngredient>;
  generalSearch?: Maybe<SearchResponse>;
  getAdminInvitationByToken: AdminInvitationPublic;
  getAdminInvitations: Array<AdminInvitation>;
  getAdminUsers: Array<User>;
  getAllOnDemandListing?: Maybe<Array<Listing>>;
  getApprovedListings?: Maybe<Array<Listing>>;
  getArchivedContent?: Maybe<ArchivedContent>;
  getBanner: BannerImage;
  getBanners?: Maybe<Array<BannerImage>>;
  getComments?: Maybe<Array<Maybe<PostComment>>>;
  getConsumerFunnel: ConsumerFunnel;
  getCookieAuditLog: CookieAuditLogResponse;
  getCookieAuditStats: CookieAuditStats;
  getCookieComplianceReport: CookieComplianceReport;
  getDashboardStats: DashboardResponse;
  getDirectoryListing: ListingResponse;
  getDiscoverRecipes: DiscoverRecipeResponse;
  getFeatureListing: Listing;
  getGetDirectoryIngredientByListingID?: Maybe<Array<DirectoryIngredient>>;
  getIngredients?: Maybe<Array<DirectoryIngredient>>;
  getListingOperatingTime?: Maybe<Array<Maybe<OperatingHours>>>;
  getListingVendors?: Maybe<Array<Listing>>;
  getListings?: Maybe<Array<Listing>>;
  getMarketsNearMe?: Maybe<Array<Listing>>;
  getNotificationPreferences: Array<NotificationPreference>;
  getNotifications: NotificationResponse;
  getPendingListings?: Maybe<Array<Listing>>;
  getPost?: Maybe<Post>;
  getPostCategories: Array<PostCategory>;
  getPostLikes?: Maybe<Array<Maybe<PostLike>>>;
  getPosts: PostPagination;
  getPractices?: Maybe<Array<Practice>>;
  getProducerSegment: ProducerSegmentResult;
  getProducerSegmentCounts: ProducerSegmentCounts;
  getProducersNearMe?: Maybe<Array<Listing>>;
  getProductCategories: Array<ProductCategory>;
  getPublicListingProducts?: Maybe<Array<DirectoryIngredient>>;
  getPublicPosts: PostPagination;
  getPurgePreview: PurgePreview;
  getRecipeComments?: Maybe<Array<Maybe<RecipeComment>>>;
  getRecipeIngredients?: Maybe<Array<Maybe<Ingredient>>>;
  getRecipeIngredientsForApproval?: Maybe<Array<Maybe<Ingredient>>>;
  getRecipeRating: RecipeRatingResponse;
  getRegionById?: Maybe<Region>;
  getRegionBySlug?: Maybe<Region>;
  getRegions?: Maybe<RegionsResponse>;
  getSalesChannels?: Maybe<Array<SalesChannel>>;
  getSeasonalIngredients?: Maybe<Array<DirectoryIngredient>>;
  getSeasonalRecipePicks?: Maybe<Array<Maybe<SeasonalRecipePick>>>;
  getSeasonalRecipeSuggestions?: Maybe<Array<Maybe<SeasonalRecipeSuggestion>>>;
  getSegmentTierBreakdown: Array<SegmentTierRow>;
  getSellingLocations?: Maybe<Array<Maybe<SellingLocation>>>;
  getSendGridContactLists: Array<SendGridContactList>;
  getSendGridContacts: Array<SendGridContact>;
  getSendGridTemplates: Array<SendGridTemplate>;
  getSitemapPosts?: Maybe<Array<Post>>;
  getSmsTemplate: SmsTemplate;
  getSmsTemplates: Array<SmsTemplate>;
  getSurvey?: Maybe<Survey>;
  getSurveys: Array<Survey>;
  getTimeToValueStats: TimeToValueStats;
  getTopProfileViews: Array<ProfileView>;
  getTopSearches: Array<TopSearch>;
  getTopSharedListings: Array<SharedListing>;
  getUnitOfMesurement?: Maybe<Array<UnitOfMeasurement>>;
  getUserAddedDirectoryIngredient?: Maybe<Array<DirectoryIngredient>>;
  getUserCookbooks: CookbookResponse;
  getUserIngredients?: Maybe<Array<Maybe<DirectoryIngredient>>>;
  getVendorByListingID?: Maybe<Array<Listing>>;
  ingredientDetail: DirectoryIngredient;
  ingredientGrowerCounts: Array<IngredientGrowerCounts>;
  listingDetail?: Maybe<Listing>;
  listingProfileViews: Scalars['Int']['output'];
  myBookmarkedRecipeIds: Array<Scalars['Int']['output']>;
  myBookmarks: BookmarkResponse;
  myCookbooks?: Maybe<Array<Cookbook>>;
  myNotifications: NotificationResponse;
  myProfile: User;
  myRecipes?: Maybe<Array<Recipe>>;
  myRecipesWithPaths?: Maybe<Array<Recipe>>;
  myShoppingLists: Array<ShoppingList>;
  pendingApprovalTimeline?: Maybe<Array<Listing>>;
  recipe: Recipe;
  recipeNote?: Maybe<Array<Maybe<RecipeNote>>>;
  recipeSteps?: Maybe<Array<Maybe<RecipeSteps>>>;
  recipes?: Maybe<Array<Recipe>>;
  recipesForDirectoryIngredient: RecipesForDirectoryIngredientResponse;
  recipesWithPaths?: Maybe<Array<Recipe>>;
  searchSpoonacular?: Maybe<Array<Maybe<SpoonacularResult>>>;
  shoppingList?: Maybe<ShoppingList>;
  shoppingListInvitePreview?: Maybe<ShoppingListInvitePreview>;
  shoppingRecipeOverlaps: Array<ShoppingListOverlap>;
  shouldPromptRecipeRating: Scalars['Boolean']['output'];
  stripePrices: Array<StripePrice>;
  suggestedListings: SuggestedListingsResponse;
  suggestedUsers: SuggestedUserResponse;
  upgradeToEnhancedListing: SubscriptionResponse;
  userExist: User;
  userProfile: User;
  userRecipes?: Maybe<RecipeResponse>;
  userSubscriptions: UserSubscriptionResult;
  users?: Maybe<Array<User>>;
  validateCoupon: CouponValidationResult;
};


export type QueryFirstFourCookbooksArgs = {
  user_id: Scalars['Int']['input'];
};


export type QueryMyFollowersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['Int']['input'];
};


export type QueryMyFollowingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['Int']['input'];
};


export type QueryBlockedUsersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryComputeTaxArgs = {
  input: TaxInput;
  price_id: Scalars['String']['input'];
};


export type QueryCookbookArgs = {
  cookbookID: Scalars['Int']['input'];
};


export type QueryCookbooksIFollowArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCooksArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExportSurveyResponsesCsvArgs = {
  surveyId: Scalars['ID']['input'];
};


export type QueryFindDirectoryIngredientByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGeneralSearchArgs = {
  dataToSearch: Array<SearchType>;
  distanceSort?: InputMaybe<DirectoryInput>;
  ifollow?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recentSort?: InputMaybe<Scalars['String']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type QueryGetAdminInvitationByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetArchivedContentArgs = {
  listingId: Scalars['Int']['input'];
};


export type QueryGetBannersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCommentsArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postID: Scalars['Int']['input'];
};


export type QueryGetConsumerFunnelArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCookieAuditLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCookieComplianceReportArgs = {
  framework: Scalars['String']['input'];
  from?: InputMaybe<Scalars['Time']['input']>;
  to?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryGetDirectoryListingArgs = {
  filter?: InputMaybe<DirectoryInput>;
  isEnhanced?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDiscoverRecipesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  public: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGetDirectoryIngredientByListingIdArgs = {
  listingID: Scalars['Int']['input'];
};


export type QueryGetIngredientsArgs = {
  includeUnverified?: InputMaybe<Scalars['Boolean']['input']>;
  isSeasonal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetListingOperatingTimeArgs = {
  listing_id: Scalars['Int']['input'];
};


export type QueryGetListingVendorsArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMarketsNearMeArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  lat: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  long: Scalars['Float']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNotificationPreferencesArgs = {
  userID: Scalars['Int']['input'];
};


export type QueryGetNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPostArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetPostLikesArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postID: Scalars['Int']['input'];
};


export type QueryGetPostsArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  followingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  group: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingID?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortBy>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProducerSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProducerSegmentCountsArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProducersNearMeArgs = {
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  lat: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  long: Scalars['Float']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  salesChannelSlug?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPublicListingProductsArgs = {
  listingID: Scalars['Int']['input'];
};


export type QueryGetPublicPostsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['ID']['input']>;
  followingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  includeUnreleased?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingID?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortBy>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPurgePreviewArgs = {
  businessDays?: InputMaybe<Scalars['Int']['input']>;
  consumerDays?: InputMaybe<Scalars['Int']['input']>;
  listingDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRecipeCommentsArgs = {
  recipe_id: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  starRating?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRecipeIngredientsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QueryGetRecipeRatingArgs = {
  recipe_id: Scalars['Int']['input'];
};


export type QueryGetRegionByIdArgs = {
  region_id: Scalars['Int']['input'];
};


export type QueryGetRegionBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSeasonalRecipePicksArgs = {
  weekOf: Scalars['String']['input'];
};


export type QueryGetSeasonalRecipeSuggestionsArgs = {
  weekOf: Scalars['String']['input'];
};


export type QueryGetSegmentTierBreakdownArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSellingLocationsArgs = {
  listingID: Scalars['Int']['input'];
};


export type QueryGetSendGridContactsArgs = {
  listId: Scalars['String']['input'];
};


export type QueryGetSmsTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetSurveyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTopProfileViewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTopSearchesArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTopSharedListingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUserCookbooksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['Int']['input'];
};


export type QueryGetUserIngredientsArgs = {
  user_id: Scalars['Int']['input'];
};


export type QueryGetVendorByListingIdArgs = {
  listingID: Scalars['Int']['input'];
};


export type QueryIngredientDetailArgs = {
  ingredient_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIngredientGrowerCountsArgs = {
  ingredientIds: Array<Scalars['Int']['input']>;
};


export type QueryListingDetailArgs = {
  listingId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListingProfileViewsArgs = {
  listingId: Scalars['Int']['input'];
};


export type QueryMyBookmarksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyCookbooksArgs = {
  user_id: Scalars['Int']['input'];
};


export type QueryMyNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyRecipesArgs = {
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyRecipesWithPathsArgs = {
  user_id: Scalars['Int']['input'];
};


export type QueryRecipeArgs = {
  recipe_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecipeNoteArgs = {
  recipe_id: Scalars['Int']['input'];
};


export type QueryRecipeStepsArgs = {
  recipe_id: Scalars['Int']['input'];
};


export type QueryRecipesArgs = {
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  public: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecipesForDirectoryIngredientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type QuerySearchSpoonacularArgs = {
  number?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryShoppingListArgs = {
  list_id: Scalars['Int']['input'];
};


export type QueryShoppingListInvitePreviewArgs = {
  token: Scalars['String']['input'];
};


export type QueryShoppingRecipeOverlapsArgs = {
  exclude_list_id?: InputMaybe<Scalars['Int']['input']>;
  recipe_id: Scalars['Int']['input'];
};


export type QueryShouldPromptRecipeRatingArgs = {
  recipe_id: Scalars['Int']['input'];
};


export type QuerySuggestedListingsArgs = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuggestedUsersArgs = {
  broader?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryUpgradeToEnhancedListingArgs = {
  baseURL: Scalars['String']['input'];
  priceID: Scalars['String']['input'];
};


export type QueryUserExistArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserProfileArgs = {
  slug: Scalars['String']['input'];
};


export type QueryUserRecipesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidateCouponArgs = {
  code: Scalars['String']['input'];
};

export enum QuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  Rating = 'RATING',
  Text = 'TEXT',
  YesNo = 'YES_NO'
}

export type Recipe = {
  __typename?: 'Recipe';
  author_link?: Maybe<Scalars['String']['output']>;
  author_name?: Maybe<Scalars['String']['output']>;
  average_recipe_rating?: Maybe<Scalars['Float']['output']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  community_id?: Maybe<Scalars['Int']['output']>;
  cook_time?: Maybe<Scalars['Int']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  inspired_by?: Maybe<Scalars['String']['output']>;
  is_featured?: Maybe<Scalars['Boolean']['output']>;
  is_private?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_country?: Maybe<Scalars['String']['output']>;
  location_description?: Maybe<Scalars['String']['output']>;
  location_state?: Maybe<Scalars['String']['output']>;
  location_zipcode?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  number_of_servings?: Maybe<Scalars['Int']['output']>;
  preparation_time?: Maybe<Scalars['Int']['output']>;
  recipe_comments?: Maybe<Array<Maybe<RecipeComment>>>;
  recipe_id: Scalars['Int']['output'];
  recipe_image?: Maybe<RecipeImage>;
  recipe_img_url?: Maybe<Scalars['String']['output']>;
  recipe_ingredients?: Maybe<Array<Maybe<RecipeIngredient>>>;
  recipe_name?: Maybe<Scalars['String']['output']>;
  recipe_notes?: Maybe<Array<Maybe<RecipeNote>>>;
  recipe_steps?: Maybe<Array<Maybe<RecipeSteps>>>;
  report_reason?: Maybe<Scalars['String']['output']>;
  resourcePath: Scalars['String']['output'];
  serving_type?: Maybe<Scalars['String']['output']>;
  show_on_profile?: Maybe<Scalars['Boolean']['output']>;
  skill_level_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  source_id?: Maybe<Scalars['Int']['output']>;
  status_id?: Maybe<Scalars['Int']['output']>;
  thumbnailPath: Scalars['String']['output'];
  total_time?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  user_id: Scalars['Int']['output'];
};

export type RecipeCategory = {
  __typename?: 'RecipeCategory';
  category_id?: Maybe<Scalars['Int']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  recipe_id?: Maybe<Scalars['Int']['output']>;
  record_id?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  user_created?: Maybe<Scalars['Int']['output']>;
  user_updated?: Maybe<Scalars['Int']['output']>;
};

export type RecipeComment = {
  __typename?: 'RecipeComment';
  content: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  imagePath?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reactions?: Maybe<Array<Maybe<RecipeCommentReaction>>>;
  recipeID: Scalars['Int']['output'];
  user: User;
  userID: Scalars['Int']['output'];
};

export type RecipeCommentReaction = {
  __typename?: 'RecipeCommentReaction';
  commentID: Scalars['Int']['output'];
  emoji: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  userID: Scalars['Int']['output'];
};

export type RecipeImage = {
  __typename?: 'RecipeImage';
  date_cover_photo?: Maybe<Scalars['Time']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_primary_photo?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  recipe_id?: Maybe<Scalars['Int']['output']>;
  record_id: Scalars['Int']['output'];
  resource_path?: Maybe<Scalars['String']['output']>;
  thumbnail_path?: Maybe<Scalars['String']['output']>;
  user_created?: Maybe<Scalars['Int']['output']>;
  user_updated?: Maybe<Scalars['Int']['output']>;
};

export type RecipeIngredient = {
  __typename?: 'RecipeIngredient';
  adjective_list?: Maybe<Scalars['JSON']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  denominator?: Maybe<Scalars['Int']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  ingredient?: Maybe<Ingredient>;
  ingredient_id?: Maybe<Scalars['Int']['output']>;
  measurement_amount?: Maybe<Scalars['String']['output']>;
  numerator?: Maybe<Scalars['Int']['output']>;
  ocr_end_ingredient_name?: Maybe<Scalars['Int']['output']>;
  ocr_end_range_high?: Maybe<Scalars['Int']['output']>;
  ocr_end_range_low?: Maybe<Scalars['Int']['output']>;
  ocr_end_unit_of_measurement?: Maybe<Scalars['Int']['output']>;
  ocr_raw_line?: Maybe<Scalars['JSON']['output']>;
  ocr_start_ingredient_name?: Maybe<Scalars['Int']['output']>;
  ocr_start_range_high?: Maybe<Scalars['Int']['output']>;
  ocr_start_range_low?: Maybe<Scalars['Int']['output']>;
  ocr_start_unit_of_measurement?: Maybe<Scalars['Int']['output']>;
  range_high_amount?: Maybe<Scalars['Float']['output']>;
  range_high_denominator?: Maybe<Scalars['Int']['output']>;
  range_high_numerator?: Maybe<Scalars['Int']['output']>;
  range_high_string_representation?: Maybe<Scalars['String']['output']>;
  range_high_whole_number?: Maybe<Scalars['Int']['output']>;
  range_low_amount?: Maybe<Scalars['Float']['output']>;
  range_low_denominator?: Maybe<Scalars['Int']['output']>;
  range_low_numerator?: Maybe<Scalars['Int']['output']>;
  range_low_string_representation?: Maybe<Scalars['Int']['output']>;
  range_low_whole_number?: Maybe<Scalars['Int']['output']>;
  raw_name?: Maybe<Scalars['String']['output']>;
  recipe?: Maybe<Recipe>;
  recipe_id?: Maybe<Scalars['Int']['output']>;
  record_id: Scalars['Int']['output'];
  sort_order?: Maybe<Scalars['Int']['output']>;
  string_representation?: Maybe<Scalars['String']['output']>;
  unit_of_measurement?: Maybe<UnitOfMeasurement>;
  unit_of_measurement_id?: Maybe<Scalars['Int']['output']>;
  user_created?: Maybe<Scalars['Int']['output']>;
  user_updated?: Maybe<Scalars['Int']['output']>;
  whole_number?: Maybe<Scalars['Int']['output']>;
};

export type RecipeInput = {
  author_name?: InputMaybe<Scalars['String']['input']>;
  cook_time?: InputMaybe<Scalars['Int']['input']>;
  date_created?: InputMaybe<Scalars['Time']['input']>;
  date_disabled?: InputMaybe<Scalars['Time']['input']>;
  date_updated?: InputMaybe<Scalars['Time']['input']>;
  inspired_by?: InputMaybe<Scalars['String']['input']>;
  is_featured?: InputMaybe<Scalars['Boolean']['input']>;
  is_private?: InputMaybe<Scalars['Boolean']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  number_of_servings?: InputMaybe<Scalars['Int']['input']>;
  preparation_time?: InputMaybe<Scalars['Int']['input']>;
  recipe_id?: InputMaybe<Scalars['Int']['input']>;
  recipe_name?: InputMaybe<Scalars['String']['input']>;
  serving_type?: InputMaybe<Scalars['String']['input']>;
  show_on_profile?: InputMaybe<Scalars['Boolean']['input']>;
  total_time?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['Int']['input'];
};

export type RecipeNote = {
  __typename?: 'RecipeNote';
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  note_description?: Maybe<Scalars['String']['output']>;
  note_name?: Maybe<Scalars['String']['output']>;
  note_order?: Maybe<Scalars['Int']['output']>;
  recipe_id?: Maybe<Scalars['Int']['output']>;
  record_id?: Maybe<Scalars['Int']['output']>;
  user_created?: Maybe<Scalars['Int']['output']>;
  user_updated?: Maybe<Scalars['Int']['output']>;
};

export type RecipeRating = {
  __typename?: 'RecipeRating';
  DateCreated?: Maybe<Scalars['Time']['output']>;
  ID?: Maybe<Scalars['Int']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  RecipeID?: Maybe<Scalars['Int']['output']>;
  UserID?: Maybe<Scalars['Int']['output']>;
};

export type RecipeRatingResponse = {
  __typename?: 'RecipeRatingResponse';
  averageRating: Scalars['Float']['output'];
  ratingCount: Scalars['Int']['output'];
  starCounts: Array<StarCount>;
};

export type RecipeRedirectInput = {
  item_id: Scalars['Int']['input'];
  recipe_ingredient_id: Scalars['Int']['input'];
};

export type RecipeResponse = {
  __typename?: 'RecipeResponse';
  dataCount?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  recipes?: Maybe<Array<Maybe<Recipe>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RecipeSteps = {
  __typename?: 'RecipeSteps';
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  recipe_id?: Maybe<Scalars['Int']['output']>;
  record_id: Scalars['Int']['output'];
  step_description?: Maybe<Scalars['String']['output']>;
  step_name?: Maybe<Scalars['String']['output']>;
  step_order?: Maybe<Scalars['Int']['output']>;
};

export type RecipeTagUpdateInput = {
  recipe_id: Scalars['Int']['input'];
  tags?: InputMaybe<Array<InputMaybe<CategoryInput>>>;
};

export type RecipesForDirectoryIngredientResponse = {
  __typename?: 'RecipesForDirectoryIngredientResponse';
  recipes: Array<Recipe>;
  total: Scalars['Int']['output'];
};

export type Region = {
  __typename?: 'Region';
  created_at?: Maybe<Scalars['Time']['output']>;
  featured_listing_objects?: Maybe<Array<Maybe<Listing>>>;
  featured_listings?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  featured_recipe_objects?: Maybe<Array<Maybe<Recipe>>>;
  featured_recipes?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  hero_image?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
  month: Scalars['String']['output'];
  name: Scalars['String']['output'];
  region_id: Scalars['Int']['output'];
  short_description?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  state: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Time']['output']>;
};

export type RegionsResponse = {
  __typename?: 'RegionsResponse';
  regions?: Maybe<Array<Maybe<Region>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Role = {
  __typename?: 'Role';
  name: Scalars['String']['output'];
  role_id: Scalars['Int']['output'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type SalesChannel = {
  __typename?: 'SalesChannel';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sales_channel_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type SalesChannelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  results: Array<SearchResult>;
  total: Scalars['Int']['output'];
};

export type SearchResult = DirectoryIngredient | Listing | Recipe | User;

export enum SearchType {
  Ingredient = 'INGREDIENT',
  Listing = 'LISTING',
  Market = 'MARKET',
  Producer = 'PRODUCER',
  Recipe = 'RECIPE',
  User = 'USER'
}

export type SeasonalRecipePick = {
  __typename?: 'SeasonalRecipePick';
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  recipe?: Maybe<Recipe>;
  recipe_id: Scalars['Int']['output'];
  sort_order?: Maybe<Scalars['Int']['output']>;
  week_of: Scalars['String']['output'];
};

export type SeasonalRecipeSuggestion = {
  __typename?: 'SeasonalRecipeSuggestion';
  admin_notes?: Maybe<Scalars['String']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  approved_at?: Maybe<Scalars['Time']['output']>;
  approved_by?: Maybe<Scalars['Int']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  ingredients_matched: Array<MatchedIngredient>;
  proposed_sort_order: Scalars['Int']['output'];
  recipe?: Maybe<Recipe>;
  recipe_id: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  spoonacular_source_url?: Maybe<Scalars['String']['output']>;
  week_of: Scalars['String']['output'];
};

export type SegmentTierRow = {
  __typename?: 'SegmentTierRow';
  pro: Scalars['Int']['output'];
  segment: Scalars['String']['output'];
  verified: Scalars['Int']['output'];
};

export type SellingLocation = {
  __typename?: 'SellingLocation';
  SalesChannels?: Maybe<Array<Maybe<SalesChannel>>>;
  address?: Maybe<Scalars['String']['output']>;
  archived_at?: Maybe<Scalars['Time']['output']>;
  availabilities: Array<Availability>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  listing_id: Scalars['Int']['output'];
  location_id: Scalars['Int']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type SellingLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  availabilities: Array<AvailabilityInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  salesChannels?: InputMaybe<Array<SalesChannelInput>>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type SendGridContact = {
  __typename?: 'SendGridContact';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type SendGridContactList = {
  __typename?: 'SendGridContactList';
  contactCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SendGridTemplate = {
  __typename?: 'SendGridTemplate';
  generation: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  versions: Array<SendGridTemplateVersion>;
};

export type SendGridTemplateVersion = {
  __typename?: 'SendGridTemplateVersion';
  active: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SendSurveyInput = {
  contactListIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sendToAll: Scalars['Boolean']['input'];
  specificEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  surveyId: Scalars['ID']['input'];
};

export type SendSurveyResponse = {
  __typename?: 'SendSurveyResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tokensSent: Scalars['Int']['output'];
};

export type SharedListing = {
  __typename?: 'SharedListing';
  listing_id: Scalars['Int']['output'];
  listing_name: Scalars['String']['output'];
  shares_last_week: Scalars['Int']['output'];
  shares_this_week: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  wow_pct: Scalars['Int']['output'];
};

export type ShoppingBulkUpdateInput = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  is_checked?: InputMaybe<Scalars['Boolean']['input']>;
  item_ids: Array<Scalars['Int']['input']>;
  list_id: Scalars['Int']['input'];
  move_to_list_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ShoppingItemInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  item_name: Scalars['String']['input'];
  list_id: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  unit_of_measurement_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ShoppingItemUpdateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  is_checked?: InputMaybe<Scalars['Boolean']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  reset_quantity?: InputMaybe<Scalars['Boolean']['input']>;
  unit_of_measurement_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ShoppingList = {
  __typename?: 'ShoppingList';
  collaborators: Array<ShoppingListCollaborator>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  is_owner: Scalars['Boolean']['output'];
  items: Array<ShoppingListItem>;
  list_id: Scalars['Int']['output'];
  list_name: Scalars['String']['output'];
  owner_name?: Maybe<Scalars['String']['output']>;
  recipes: Array<ShoppingListRecipe>;
  user_id: Scalars['Int']['output'];
};

export type ShoppingListCollaborator = {
  __typename?: 'ShoppingListCollaborator';
  collaborator_id: Scalars['Int']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  invited_email?: Maybe<Scalars['String']['output']>;
  status_id: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type ShoppingListInvitePreview = {
  __typename?: 'ShoppingListInvitePreview';
  list_name: Scalars['String']['output'];
  member_count: Scalars['Int']['output'];
  owner_name?: Maybe<Scalars['String']['output']>;
};

export type ShoppingListItem = {
  __typename?: 'ShoppingListItem';
  category: Scalars['String']['output'];
  date_created?: Maybe<Scalars['Time']['output']>;
  ingredient_id?: Maybe<Scalars['Int']['output']>;
  is_checked: Scalars['Boolean']['output'];
  is_staple: Scalars['Boolean']['output'];
  item_id: Scalars['Int']['output'];
  item_name: Scalars['String']['output'];
  list_id: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  quantity_edited: Scalars['Boolean']['output'];
  similar_item_ids: Array<Scalars['Int']['output']>;
  sort_order: Scalars['Int']['output'];
  sources: Array<ShoppingListItemSource>;
  unit_of_measurement?: Maybe<UnitOfMeasurement>;
  unit_of_measurement_id?: Maybe<Scalars['Int']['output']>;
};

export type ShoppingListItemSource = {
  __typename?: 'ShoppingListItemSource';
  quantity_string?: Maybe<Scalars['String']['output']>;
  recipe_id?: Maybe<Scalars['Int']['output']>;
  recipe_ingredient_id?: Maybe<Scalars['Int']['output']>;
  recipe_name?: Maybe<Scalars['String']['output']>;
  source_id: Scalars['Int']['output'];
  source_name?: Maybe<Scalars['String']['output']>;
  unit_label?: Maybe<Scalars['String']['output']>;
};

export type ShoppingListOverlap = {
  __typename?: 'ShoppingListOverlap';
  exact: Scalars['Boolean']['output'];
  ingredient_name: Scalars['String']['output'];
  item_id: Scalars['Int']['output'];
  item_name: Scalars['String']['output'];
  item_quantity?: Maybe<Scalars['String']['output']>;
  list_id: Scalars['Int']['output'];
  list_name: Scalars['String']['output'];
  recipe_ingredient_id: Scalars['Int']['output'];
};

export type ShoppingListRecipe = {
  __typename?: 'ShoppingListRecipe';
  item_count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  recipe_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type ShoppingReorderInput = {
  category: Scalars['String']['input'];
  item_ids: Array<Scalars['Int']['input']>;
  list_id: Scalars['Int']['input'];
};

export type SmsOptInInput = {
  phoneNumber: Scalars['String']['input'];
};

export type SmsOptInResponse = {
  __typename?: 'SmsOptInResponse';
  message?: Maybe<Scalars['String']['output']>;
  sessionExpiry?: Maybe<Scalars['Time']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SmsTemplate = {
  __typename?: 'SmsTemplate';
  active: Scalars['Boolean']['output'];
  approvedAt?: Maybe<Scalars['Time']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  legalApproved: Scalars['Boolean']['output'];
  messageType: Scalars['String']['output'];
  template: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type SmsVerifyOtpInput = {
  code: Scalars['String']['input'];
};

export enum SortBy {
  MostLiked = 'MOST_LIKED',
  Newest = 'NEWEST',
  Oldest = 'OLDEST'
}

export type SpoonacularResult = {
  __typename?: 'SpoonacularResult';
  aggregate_likes?: Maybe<Scalars['Int']['output']>;
  credits_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  ready_in_minutes?: Maybe<Scalars['Int']['output']>;
  servings?: Maybe<Scalars['Int']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type StarCount = {
  __typename?: 'StarCount';
  count: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
};

export enum StatusEnum {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Paused = 'paused',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type StepInput = {
  date_created?: InputMaybe<Scalars['Time']['input']>;
  date_disabled?: InputMaybe<Scalars['Time']['input']>;
  date_updated?: InputMaybe<Scalars['Time']['input']>;
  recipe_id?: InputMaybe<Scalars['Int']['input']>;
  record_id?: InputMaybe<Scalars['Int']['input']>;
  step_description?: InputMaybe<Scalars['String']['input']>;
  step_name?: InputMaybe<Scalars['String']['input']>;
  step_order?: InputMaybe<Scalars['Int']['input']>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  active: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  intervalCount?: Maybe<Scalars['Int']['output']>;
  lookup_key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  unitAmount: Scalars['Int']['output'];
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  prices: Array<StripePrice>;
};

export type Subscription = {
  __typename?: 'Subscription';
  notificationFeed: Notification;
  pendingApproval: Listing;
  subscribeToPostDetail: Post;
  subscribeToPostList: Post;
};


export type SubscriptionPendingApprovalArgs = {
  user_id: Scalars['Int']['input'];
};


export type SubscriptionSubscribeToPostDetailArgs = {
  postID: Scalars['Int']['input'];
};

export type SubscriptionPayment = {
  __typename?: 'SubscriptionPayment';
  amount: Scalars['Float']['output'];
  created_at?: Maybe<Scalars['Time']['output']>;
  currency: Scalars['String']['output'];
  customer_email: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stripe_session_id: Scalars['String']['output'];
  subscription_payment_id: Scalars['Int']['output'];
};

export type SubscriptionPaymentResult = {
  __typename?: 'SubscriptionPaymentResult';
  pageInfo: UserPageInfo;
  payments: Array<SubscriptionPayment>;
  totalCount: Scalars['Int']['output'];
};

export type SubscriptionResponse = {
  __typename?: 'SubscriptionResponse';
  currentPeriodEnd?: Maybe<Scalars['Int']['output']>;
  customerID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  redirect_url?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SuggestedListingsResponse = {
  __typename?: 'SuggestedListingsResponse';
  has_next_page?: Maybe<Scalars['Boolean']['output']>;
  listings?: Maybe<Array<Listing>>;
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SuggestedUserResponse = {
  __typename?: 'SuggestedUserResponse';
  has_next_page?: Maybe<Scalars['Boolean']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<User>>;
};

export type Survey = {
  __typename?: 'Survey';
  completions: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['Int']['output'];
  ctaLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intro: Scalars['String']['output'];
  lastResponse?: Maybe<Scalars['Time']['output']>;
  questions: Array<SurveyQuestion>;
  responses: Scalars['Int']['output'];
  sendgridTemplateId?: Maybe<Scalars['String']['output']>;
  status: SurveyStatus;
  successBody: Scalars['String']['output'];
  successCtaLabel: Scalars['String']['output'];
  successCtaUrl: Scalars['String']['output'];
  successHeading: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tokensSent: Scalars['Int']['output'];
  type: SurveyType;
};

export type SurveyOption = {
  __typename?: 'SurveyOption';
  emoji?: Maybe<Scalars['String']['output']>;
  is_freetext?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  subtext?: Maybe<Scalars['String']['output']>;
};

export type SurveyOptionInput = {
  emoji?: InputMaybe<Scalars['String']['input']>;
  is_freetext?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  subtext?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  id: Scalars['ID']['output'];
  options?: Maybe<Array<SurveyOption>>;
  question: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: QuestionType;
};

export type SurveyQuestionInput = {
  options?: InputMaybe<Array<SurveyOptionInput>>;
  question: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  type: QuestionType;
};

export enum SurveyStatus {
  Active = 'active',
  Closed = 'closed',
  Draft = 'draft'
}

export enum SurveyType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type TableDeletion = {
  __typename?: 'TableDeletion';
  count: Scalars['Int']['output'];
  ids: Array<Scalars['Int']['output']>;
  table: Scalars['String']['output'];
};

export type TaxCalculationResponse = {
  __typename?: 'TaxCalculationResponse';
  taxAmount: Scalars['Float']['output'];
  taxPercentage?: Maybe<Scalars['Any']['output']>;
  totalAmount: Scalars['Float']['output'];
};

export type TaxInput = {
  address_source: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  country: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type TextToPostResponse = {
  __typename?: 'TextToPostResponse';
  message: Scalars['String']['output'];
  postId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TimeToValueStats = {
  __typename?: 'TimeToValueStats';
  median_days_follower_to_post2?: Maybe<Scalars['Float']['output']>;
  median_days_login_to_product?: Maybe<Scalars['Float']['output']>;
  median_days_post_to_follower?: Maybe<Scalars['Float']['output']>;
  median_days_product_to_post?: Maybe<Scalars['Float']['output']>;
};

export type TopSearch = {
  __typename?: 'TopSearch';
  count: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type TrackEventInput = {
  entity_id?: InputMaybe<Scalars['String']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  event_type: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type TrackProductInteractionInput = {
  interaction_type: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  product_id: Scalars['Int']['input'];
  search_query?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TrackProductInteractionResponse = {
  __typename?: 'TrackProductInteractionResponse';
  interaction_id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnitOfMeasurement = {
  __typename?: 'UnitOfMeasurement';
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  unit_abbreviation?: Maybe<Scalars['String']['output']>;
  unit_description?: Maybe<Scalars['String']['output']>;
  unit_name?: Maybe<Scalars['String']['output']>;
  unit_of_measurement_id: Scalars['Int']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type UnitOfMeasurementInput = {
  unit_abbreviation?: InputMaybe<Scalars['String']['input']>;
  unit_description?: InputMaybe<Scalars['String']['input']>;
  unit_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIngredientInput = {
  date_created?: InputMaybe<Scalars['Time']['input']>;
  date_disabled?: InputMaybe<Scalars['Time']['input']>;
  date_updated?: InputMaybe<Scalars['Time']['input']>;
  denominator?: InputMaybe<Scalars['Int']['input']>;
  exclude_from_shopping_cart?: InputMaybe<Scalars['Boolean']['input']>;
  ingredient_description?: InputMaybe<Scalars['String']['input']>;
  ingredient_id?: InputMaybe<Scalars['Int']['input']>;
  ingredient_name?: InputMaybe<Scalars['String']['input']>;
  is_validated?: InputMaybe<Scalars['Boolean']['input']>;
  measurement_amount?: InputMaybe<Scalars['String']['input']>;
  numerator?: InputMaybe<Scalars['Int']['input']>;
  recipe_id: Scalars['Int']['input'];
  unit_of_measurement_id?: InputMaybe<Scalars['Int']['input']>;
  user_created?: InputMaybe<Scalars['Int']['input']>;
  user_updated?: InputMaybe<Scalars['Int']['input']>;
  whole_number?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRegionInput = {
  featured_listings?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  featured_markets?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  featured_producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  featured_recipes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hero_image?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_keywords?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region_id: Scalars['Int']['input'];
  short_description?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSmsTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  approvedBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  legalApproved?: InputMaybe<Scalars['Boolean']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSurveyInput = {
  ctaLabel: Scalars['String']['input'];
  intro: Scalars['String']['input'];
  questions: Array<SurveyQuestionInput>;
  sendgridTemplateId?: InputMaybe<Scalars['String']['input']>;
  successBody: Scalars['String']['input'];
  successCtaLabel: Scalars['String']['input'];
  successCtaUrl: Scalars['String']['input'];
  successHeading: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: SurveyType;
};

export type UpdateSurveyStatusInput = {
  status: SurveyStatus;
  surveyId: Scalars['ID']['input'];
};

export type User = {
  __typename?: 'User';
  billing_interval?: Maybe<Scalars['String']['output']>;
  bio_completed?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  communication_completed?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  current_period_end?: Maybe<Scalars['Time']['output']>;
  date_account_purged?: Maybe<Scalars['Time']['output']>;
  date_created?: Maybe<Scalars['Time']['output']>;
  date_disabled?: Maybe<Scalars['Time']['output']>;
  date_last_login?: Maybe<Scalars['Time']['output']>;
  date_onboarding_completed?: Maybe<Scalars['Time']['output']>;
  date_pro_user?: Maybe<Scalars['Time']['output']>;
  date_welcome_followup_email_sent?: Maybe<Scalars['Time']['output']>;
  default_listing?: Maybe<Listing>;
  default_listing_id?: Maybe<Scalars['Int']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  followers?: Maybe<Array<Maybe<User>>>;
  followers_count?: Maybe<Scalars['Int']['output']>;
  followings?: Maybe<Array<Maybe<User>>>;
  full_name?: Maybe<Scalars['String']['output']>;
  ifollow?: Maybe<Scalars['Boolean']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  interests?: Maybe<Scalars['JSON']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_internal?: Maybe<Scalars['Boolean']['output']>;
  last_login_ip_address?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  listings?: Maybe<Array<Maybe<Listing>>>;
  location_completed?: Maybe<Scalars['Boolean']['output']>;
  notification_prefs?: Maybe<NotificationPreference>;
  notifications_enabled?: Maybe<Scalars['Boolean']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  phone_verified?: Maybe<Scalars['Boolean']['output']>;
  phone_verified_at?: Maybe<Scalars['Time']['output']>;
  producer_welcome_dismissed?: Maybe<Scalars['Boolean']['output']>;
  profile_completion?: Maybe<Scalars['JSON']['output']>;
  profile_image_completed?: Maybe<Scalars['Boolean']['output']>;
  profile_photo_resource?: Maybe<Scalars['String']['output']>;
  profile_widget_completed_at?: Maybe<Scalars['Time']['output']>;
  profile_widget_dismissed?: Maybe<Scalars['Boolean']['output']>;
  referral_by_id?: Maybe<Scalars['Int']['output']>;
  referral_code?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  signup_ip_address?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sms_consent_captured_at?: Maybe<Scalars['Time']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  subscription_amount?: Maybe<Scalars['Float']['output']>;
  subscription_status?: Maybe<Scalars['String']['output']>;
  twitter_url?: Maybe<Scalars['String']['output']>;
  type_id?: Maybe<Scalars['Int']['output']>;
  userImage?: Maybe<UserImage>;
  userRoles?: Maybe<Array<UserRole>>;
  user_bio?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['Int']['output'];
  user_type?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type UserConversionInput = {
  Name: Scalars['String']['input'];
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  lat: Scalars['String']['input'];
  long: Scalars['String']['input'];
  membershipType: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['String']['input']>;
  userType: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type UserFollower = {
  __typename?: 'UserFollower';
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  follower_id: Scalars['Int']['output'];
  record_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type UserFollowing = {
  __typename?: 'UserFollowing';
  record_id: Scalars['Int']['output'];
  user?: Maybe<User>;
  user_following_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type UserImage = {
  __typename?: 'UserImage';
  date_created?: Maybe<Scalars['Time']['output']>;
  date_updated?: Maybe<Scalars['Time']['output']>;
  img_path?: Maybe<Scalars['String']['output']>;
  record_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type UserInput = {
  bio_completed?: InputMaybe<Scalars['Boolean']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  communication_completed?: InputMaybe<Scalars['Boolean']['input']>;
  date_onboarding_completed?: InputMaybe<Scalars['Time']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Scalars['JSON']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location_completed?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  producer_welcome_dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  profile_image_completed?: InputMaybe<Scalars['Boolean']['input']>;
  profile_photo_resource?: InputMaybe<Scalars['String']['input']>;
  profile_widget_completed_at?: InputMaybe<Scalars['Time']['input']>;
  profile_widget_dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  twitter_url?: InputMaybe<Scalars['String']['input']>;
  user_bio?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UserPageInfo = {
  __typename?: 'UserPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type UserResponse = {
  __typename?: 'UserResponse';
  bio_completed?: Maybe<Scalars['Boolean']['output']>;
  communication_completed?: Maybe<Scalars['Boolean']['output']>;
  date_onboarding_completed?: Maybe<Scalars['Time']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  interests?: Maybe<Scalars['JSON']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location_completed?: Maybe<Scalars['Boolean']['output']>;
  producer_welcome_dismissed?: Maybe<Scalars['Boolean']['output']>;
  profile_image_completed?: Maybe<Scalars['Boolean']['output']>;
  profile_photo_resource?: Maybe<Scalars['String']['output']>;
  profile_widget_completed_at?: Maybe<Scalars['Time']['output']>;
  profile_widget_dismissed?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  user_bio?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  role?: Maybe<Role>;
  role_id: Scalars['Int']['output'];
  user?: Maybe<User>;
  user_id: Scalars['Int']['output'];
};

export type UserSearchResponse = {
  __typename?: 'UserSearchResponse';
  dataCount?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  cancel_at?: Maybe<Scalars['Time']['output']>;
  cancel_at_period_end?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['Time']['output']>;
  current_period_end: Scalars['Time']['output'];
  pending_approval_date?: Maybe<Scalars['Time']['output']>;
  pending_payment_intent_id?: Maybe<Scalars['String']['output']>;
  status: StatusEnum;
  stripe_price_id?: Maybe<Scalars['String']['output']>;
  stripe_sub_id?: Maybe<Scalars['String']['output']>;
  subscription_id: Scalars['Int']['output'];
  tax_cert_expiration_date?: Maybe<Scalars['Time']['output']>;
  tax_cert_number?: Maybe<Scalars['String']['output']>;
  tax_exemption?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['Time']['output']>;
  user?: Maybe<User>;
  user_id: Scalars['Int']['output'];
};

export type UserSubscriptionResult = {
  __typename?: 'UserSubscriptionResult';
  pageInfo: UserPageInfo;
  subscriptions: Array<UserSubscription>;
  totalCount: Scalars['Int']['output'];
};

export type VendorListingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  base_url?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  date_created?: InputMaybe<Scalars['Time']['input']>;
  date_updated?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enhanced?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  membership_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  on_demand?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  publicPhone?: InputMaybe<Scalars['String']['input']>;
  resource_path?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<Scalars['String']['input']>;
  vendor_avatar?: InputMaybe<Scalars['Upload']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordResetInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email_address: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type GetDashboardStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardStatsQuery = { __typename?: 'Query', getDashboardStats: { __typename?: 'DashboardResponse', revenue?: number | null, products?: number | null, pending_approval?: number | null, recipes?: number | null, cookbook?: number | null, userStats?: any | null, listingStats?: any | null, ond_listings?: Array<{ __typename?: 'Listing', listing_id: number, name?: string | null, photo?: string | null, date_created?: any | null, slug?: string | null, user?: { __typename?: 'User', full_name?: string | null } | null } | null> | null, ond_products?: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, date_created?: any | null, slug?: string | null } | null> | null } };

export type GetPendingApprovalTimelineQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingApprovalTimelineQuery = { __typename?: 'Query', pendingApprovalTimeline?: Array<{ __typename?: 'Listing', listing_id: number, name?: string | null, photo?: string | null, date_updated?: any | null, pending?: boolean | null }> | null };

export type GetPendingApprovalSubscriptionVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetPendingApprovalSubscription = { __typename?: 'Subscription', pendingApproval: { __typename?: 'Listing', listing_id: number, name?: string | null, photo?: string | null, date_updated?: any | null, pending?: boolean | null } };

export type GetProducerSegmentCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProducerSegmentCountsQuery = { __typename?: 'Query', getProducerSegmentCounts: { __typename?: 'ProducerSegmentCounts', never_logged_in: number, logged_in_no_products: number, products_no_posts: number, posting_not_sharing: number, posting_and_sharing: number, updated_at: string } };

export type GetProducerSegmentQueryVariables = Exact<{
  filters?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProducerSegmentQuery = { __typename?: 'Query', getProducerSegment: { __typename?: 'ProducerSegmentResult', total: number, rows: Array<{ __typename?: 'ProducerSegmentRow', user_id: number, full_name?: string | null, email_address?: string | null, user_type?: string | null, date_created?: string | null, date_last_login?: string | null, listing_id?: number | null, listing_name?: string | null }> } };

export type GetTimeToValueStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeToValueStatsQuery = { __typename?: 'Query', getTimeToValueStats: { __typename?: 'TimeToValueStats', median_days_login_to_product?: number | null, median_days_product_to_post?: number | null, median_days_post_to_follower?: number | null, median_days_follower_to_post2?: number | null } };

export type GetAdminInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminInvitationsQuery = { __typename?: 'Query', getAdminInvitations: Array<{ __typename?: 'AdminInvitation', id: number, email: string, token: string, invited_by_user_id: number, status: string, role: string, created_at: any, expires_at: any, accepted_at?: any | null, accepted_by_user_id?: number | null, invited_by?: { __typename?: 'User', user_id: number, full_name?: string | null, first_name?: string | null, email_address?: string | null } | null, accepted_by?: { __typename?: 'User', user_id: number, full_name?: string | null, first_name?: string | null, email_address?: string | null } | null }> };

export type GetAdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminUsersQuery = { __typename?: 'Query', getAdminUsers: Array<{ __typename?: 'User', user_id: number, full_name?: string | null, first_name?: string | null, last_name?: string | null, email_address?: string | null, user_type?: string | null, date_created?: any | null, date_last_login?: any | null, profile_photo_resource?: string | null, userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null }> };

export type GetAdminInvitationByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetAdminInvitationByTokenQuery = { __typename?: 'Query', getAdminInvitationByToken: { __typename?: 'AdminInvitationPublic', id: number, email: string, status: string, expires_at: any, is_expired: boolean, invited_by_name?: string | null, user_exists: boolean, first_name?: string | null, last_name?: string | null } };

export type InviteAdminMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type InviteAdminMutation = { __typename?: 'Mutation', inviteAdmin: { __typename?: 'AdminInvitation', id: number, email: string, token: string, status: string, role: string, created_at: any, expires_at: any, invited_by?: { __typename?: 'User', full_name?: string | null, first_name?: string | null } | null } };

export type ResendAdminInvitationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ResendAdminInvitationMutation = { __typename?: 'Mutation', resendAdminInvitation: { __typename?: 'AdminInvitation', id: number, email: string, token: string, status: string, expires_at: any } };

export type RevokeAdminInvitationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RevokeAdminInvitationMutation = { __typename?: 'Mutation', revokeAdminInvitation: boolean };

export type AcceptAdminInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
  input?: InputMaybe<AcceptAdminInvitationInput>;
}>;


export type AcceptAdminInvitationMutation = { __typename?: 'Mutation', acceptAdminInvitation: { __typename?: 'AuthUser', token?: string | null, user?: { __typename?: 'User', user_id: number, full_name?: string | null, first_name?: string | null, last_name?: string | null, email_address?: string | null, slug?: string | null, user_type?: string | null, userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null, roles?: Array<{ __typename?: 'Role', name: string, role_id: number }> | null } | null } };

export type RemoveAdminMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type RemoveAdminMutation = { __typename?: 'Mutation', removeAdmin: boolean };

export type LoginMutationVariables = Exact<{
  email_address: Scalars['String']['input'];
  password_hash: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthUser', token?: string | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, username?: string | null, email_address?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, zipcode?: string | null, user_bio?: string | null, user_type?: string | null, is_internal?: boolean | null, referral_code?: string | null, slug?: string | null, default_listing_id?: number | null, stripe_customer_id?: string | null, subscription_status?: string | null, billing_interval?: string | null, current_period_end?: any | null, subscription_amount?: number | null, profile_image_completed?: boolean | null, bio_completed?: boolean | null, communication_completed?: boolean | null, location_completed?: boolean | null, profile_widget_dismissed?: boolean | null, producer_welcome_dismissed?: boolean | null, profile_widget_completed_at?: any | null, date_onboarding_completed?: any | null, default_listing?: { __typename?: 'Listing', membership_type?: string | null, enhanced?: boolean | null, photo?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null, slug?: string | null } | null, listings?: Array<{ __typename?: 'Listing', listing_id: number, membership_type?: string | null, user_type?: string | null, name?: string | null, city?: string | null, state?: string | null, firstName?: string | null, lastName?: string | null, slug?: string | null } | null> | null, userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, user_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null, roles?: Array<{ __typename?: 'Role', name: string, role_id: number }> | null } | null } };

export type LoginAdminUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginAdminUserMutation = { __typename?: 'Mutation', loginAdminUser: { __typename?: 'DirectoryAdmin', email?: string | null, password?: string | null } };

export type CreateUserMutationVariables = Exact<{
  input: NewUser;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthUser', token?: string | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, username?: string | null, email_address?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, zipcode?: string | null, user_bio?: string | null, user_type?: string | null, is_internal?: boolean | null, slug?: string | null, default_listing_id?: number | null, date_onboarding_completed?: any | null, default_listing?: { __typename?: 'Listing', membership_type?: string | null, photo?: string | null, name?: string | null } | null, userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, user_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null } | null } };

export type EmailTakenMutationVariables = Exact<{
  email_address: Scalars['String']['input'];
}>;


export type EmailTakenMutation = { __typename?: 'Mutation', emailExist: string };

export type ConfirmationCodeMutationVariables = Exact<{
  email_address: Scalars['String']['input'];
  fName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmationCodeMutation = { __typename?: 'Mutation', sendEmailConfirmationCode: { __typename?: 'ForgotPasswordResponse', success: boolean, message: string } };

export type ConfirmEmailMutationVariables = Exact<{
  email_address: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail?: boolean | null };

export type ForgotPasswordMutationVariables = Exact<{
  email_address: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordResponse', success: boolean, message: string } };

export type ResetPasswordMutationVariables = Exact<{
  input: PasswordResetInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ForgotPasswordResponse', success: boolean, message: string } };

export type SwitchUserRoleMutationVariables = Exact<{
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}>;


export type SwitchUserRoleMutation = { __typename?: 'Mutation', switchUserRole: { __typename?: 'User', userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, user_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null } };

export type SocialLoginMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
}>;


export type SocialLoginMutation = { __typename?: 'Mutation', socialLogin: { __typename?: 'AuthUser', token?: string | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, username?: string | null, email_address?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, zipcode?: string | null, user_bio?: string | null, user_type?: string | null, is_internal?: boolean | null, referral_code?: string | null, slug?: string | null, default_listing_id?: number | null, stripe_customer_id?: string | null, subscription_status?: string | null, billing_interval?: string | null, current_period_end?: any | null, subscription_amount?: number | null, profile_image_completed?: boolean | null, bio_completed?: boolean | null, communication_completed?: boolean | null, location_completed?: boolean | null, profile_widget_dismissed?: boolean | null, producer_welcome_dismissed?: boolean | null, profile_widget_completed_at?: any | null, date_onboarding_completed?: any | null, date_created?: any | null, default_listing?: { __typename?: 'Listing', membership_type?: string | null, enhanced?: boolean | null, photo?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null, slug?: string | null } | null, listings?: Array<{ __typename?: 'Listing', listing_id: number, membership_type?: string | null, user_type?: string | null, name?: string | null, city?: string | null, state?: string | null, firstName?: string | null, lastName?: string | null, slug?: string | null } | null> | null, userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, user_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null, roles?: Array<{ __typename?: 'Role', name: string, role_id: number }> | null } | null } };

export type RequestSignInLinkMutationVariables = Exact<{
  email_address: Scalars['String']['input'];
}>;


export type RequestSignInLinkMutation = { __typename?: 'Mutation', requestSignInLink: { __typename?: 'ForgotPasswordResponse', success: boolean, message: string } };

export type SignInWithLinkMutationVariables = Exact<{
  email_address: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SignInWithLinkMutation = { __typename?: 'Mutation', signInWithLink: { __typename?: 'AuthUser', token?: string | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, username?: string | null, email_address?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, zipcode?: string | null, user_bio?: string | null, user_type?: string | null, is_internal?: boolean | null, referral_code?: string | null, slug?: string | null, default_listing_id?: number | null, stripe_customer_id?: string | null, subscription_status?: string | null, billing_interval?: string | null, current_period_end?: any | null, subscription_amount?: number | null, profile_image_completed?: boolean | null, bio_completed?: boolean | null, communication_completed?: boolean | null, location_completed?: boolean | null, profile_widget_dismissed?: boolean | null, producer_welcome_dismissed?: boolean | null, profile_widget_completed_at?: any | null, date_onboarding_completed?: any | null, default_listing?: { __typename?: 'Listing', membership_type?: string | null, enhanced?: boolean | null, photo?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null, slug?: string | null } | null, listings?: Array<{ __typename?: 'Listing', listing_id: number, membership_type?: string | null, user_type?: string | null, name?: string | null, city?: string | null, state?: string | null, firstName?: string | null, lastName?: string | null, slug?: string | null } | null> | null, userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, user_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null, roles?: Array<{ __typename?: 'Role', name: string, role_id: number }> | null } | null } };

export type GetBannersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBannersQuery = { __typename?: 'Query', getBanners?: Array<{ __typename?: 'BannerImage', record_id: number, img_url?: string | null, img_path?: string | null, active?: boolean | null, mainlink?: string | null, memberlink?: string | null, description?: string | null }> | null };

export type GetBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBannerQuery = { __typename?: 'Query', getBanner: { __typename?: 'BannerImage', record_id: number, img_url?: string | null, img_path?: string | null, active?: boolean | null, mainlink?: string | null, memberlink?: string | null, description?: string | null } };

export type CreateBannerImgMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  input: BannerImageInput;
}>;


export type CreateBannerImgMutation = { __typename?: 'Mutation', createBannerImg: { __typename?: 'BannerImage', record_id: number, img_url?: string | null, img_path?: string | null, description?: string | null, mainlink?: string | null, memberlink?: string | null, date_created?: any | null, active?: boolean | null } };

export type UpdateBannerDetailMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: BannerImageInput;
  file: Scalars['Upload']['input'];
}>;


export type UpdateBannerDetailMutation = { __typename?: 'Mutation', updateBannerDetail: { __typename?: 'BannerImage', record_id: number, img_url?: string | null, img_path?: string | null, description?: string | null, mainlink?: string | null, memberlink?: string | null, date_created?: any | null, active?: boolean | null } };

export type SwitchBannerStateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
}>;


export type SwitchBannerStateMutation = { __typename?: 'Mutation', switchBannerState: boolean };

export type DeleteBannerImgMutationVariables = Exact<{
  bannerId: Scalars['Int']['input'];
}>;


export type DeleteBannerImgMutation = { __typename?: 'Mutation', deleteBanner: boolean };

export type AddBookmarkMutationVariables = Exact<{
  recipe_id: Scalars['Int']['input'];
}>;


export type AddBookmarkMutation = { __typename?: 'Mutation', addBookmark: boolean };

export type RemoveBookmarkMutationVariables = Exact<{
  recipe_id: Scalars['Int']['input'];
}>;


export type RemoveBookmarkMutation = { __typename?: 'Mutation', removeBookmark: boolean };

export type GetMyBookmarkedRecipeIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyBookmarkedRecipeIdsQuery = { __typename?: 'Query', myBookmarkedRecipeIds: Array<number> };

export type GetMyBookmarksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMyBookmarksQuery = { __typename?: 'Query', myBookmarks: { __typename?: 'BookmarkResponse', total: number, recipes: Array<{ __typename?: 'Recipe', recipe_id: number, user_id: number, slug?: string | null, resourcePath: string, thumbnailPath: string, recipe_img_url?: string | null, recipe_name?: string | null, average_recipe_rating?: number | null, cook_time?: number | null, preparation_time?: number | null, total_time?: number | null, is_featured?: boolean | null, recipe_comments?: Array<{ __typename?: 'RecipeComment', id: string } | null> | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_abbreviation?: string | null, unit_name?: string | null } | null } | null> | null, recipe_image?: { __typename?: 'RecipeImage', thumbnail_path?: string | null, resource_path?: string | null } | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, full_name?: string | null, slug?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, resourcePath?: string | null } | null } | null } | null> } };

export type MyCookbooksQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
}>;


export type MyCookbooksQuery = { __typename?: 'Query', myCookbooks?: Array<{ __typename?: 'Cookbook', cookbook_id: number, user_id: number, cookbook_name: string, cookbook_img_url?: string | null, cookbook_description?: string | null, cookbook_contest_date_finished?: any | null, date_featured?: any | null, number_of_members?: number | null, latitude?: number | null, longitude?: number | null, location_city?: string | null, location_state?: string | null, location_country?: string | null, location_description?: string | null }> | null };

export type CookbooksIFollowQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
}>;


export type CookbooksIFollowQuery = { __typename?: 'Query', cookbooksIFollow?: Array<{ __typename?: 'Cookbook', cookbook_id: number, user_id: number, cookbook_name: string, cookbook_img_url?: string | null, cookbook_description?: string | null, cookbook_contest_date_finished?: any | null, date_featured?: any | null, number_of_members?: number | null, latitude?: number | null, longitude?: number | null, location_city?: string | null, location_state?: string | null, location_country?: string | null, location_description?: string | null }> | null };

export type FirstFourCookbooksQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
}>;


export type FirstFourCookbooksQuery = { __typename?: 'Query', FirstFourCookbooks?: Array<{ __typename?: 'Cookbook', cookbook_id: number, cookbook_name: string, cookbook_img_url?: string | null }> | null };

export type GetUserCookbooksQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserCookbooksQuery = { __typename?: 'Query', getUserCookbooks: { __typename?: 'CookbookResponse', total?: number | null, page: number, cookbooks?: Array<{ __typename?: 'Cookbook', cookbook_id: number, user_id: number, cookbook_name: string, cookbook_img_url?: string | null, cookbook_description?: string | null, cookbook_contest_date_finished?: any | null, date_featured?: any | null, number_of_members?: number | null, latitude?: number | null, longitude?: number | null, location_city?: string | null, location_state?: string | null, location_country?: string | null, location_description?: string | null }> | null } };

export type RecordCookieConsentMutationVariables = Exact<{
  input: CookieConsentInput;
}>;


export type RecordCookieConsentMutation = { __typename?: 'Mutation', recordCookieConsent: { __typename?: 'CookieAuditEntry', id: string, sessionId: string, timestamp: any, action: string, userAgent: string, ipAddress: string, url: string, consentVersion: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'CookiePreferences', essential: boolean, functional: boolean, analytics: boolean, marketing: boolean } } };

export type GetCookieAuditLogQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCookieAuditLogQuery = { __typename?: 'Query', getCookieAuditLog: { __typename?: 'CookieAuditLogResponse', total: number, limit: number, offset: number, entries: Array<{ __typename?: 'CookieAuditEntry', id: string, sessionId: string, timestamp: any, action: string, userAgent: string, ipAddress: string, url: string, consentVersion: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'CookiePreferences', essential: boolean, functional: boolean, analytics: boolean, marketing: boolean } }> } };

export type GetCookieAuditStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCookieAuditStatsQuery = { __typename?: 'Query', getCookieAuditStats: { __typename?: 'CookieAuditStats', total: number, acceptAll: number, declineAll: number, customSave: number, acceptAllRate: number, declineAllRate: number, customSaveRate: number, functionalRate: number, analyticsRate: number, marketingRate: number, last24h: number, last7d: number, last30d: number, byDay: Array<{ __typename?: 'DailyStats', date: string, count: number }> } };

export type GetCookieComplianceReportQueryVariables = Exact<{
  framework: Scalars['String']['input'];
  from?: InputMaybe<Scalars['Time']['input']>;
  to?: InputMaybe<Scalars['Time']['input']>;
}>;


export type GetCookieComplianceReportQuery = { __typename?: 'Query', getCookieComplianceReport: { __typename?: 'CookieComplianceReport', generatedAt: any, framework: string, recommendations: Array<string>, compliant: boolean, issues: Array<string>, period: { __typename?: 'CompliancePeriod', from: string, to: string }, summary: { __typename?: 'ComplianceSummary', totalConsents: number, explicitConsents: number, withdrawals: number, consentRate: number }, categories: Array<{ __typename?: 'CategoryCompliance', name: string, enabled: number, disabled: number, rate: number }> } };

export type ExportCookieAuditLogCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportCookieAuditLogCsvQuery = { __typename?: 'Query', exportCookieAuditLogCSV: string };

export type DeleteOldCookieAuditEntriesMutationVariables = Exact<{
  olderThanDays: Scalars['Int']['input'];
}>;


export type DeleteOldCookieAuditEntriesMutation = { __typename?: 'Mutation', deleteOldCookieAuditEntries: number };

export type FollowUserMutationVariables = Exact<{
  userID: Scalars['Int']['input'];
}>;


export type FollowUserMutation = { __typename?: 'Mutation', follow: boolean };

export type UnFollowUserMutationVariables = Exact<{
  userID: Scalars['Int']['input'];
}>;


export type UnFollowUserMutation = { __typename?: 'Mutation', unFollow: boolean };

export type UnblockUserMutationVariables = Exact<{
  blockedUserId: Scalars['Int']['input'];
}>;


export type UnblockUserMutation = { __typename?: 'Mutation', unblockUser: boolean };

export type BlockUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type BlockUserMutation = { __typename?: 'Mutation', blockUser: boolean };

export type GetBlockedUsersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetBlockedUsersQuery = { __typename?: 'Query', blockedUsers: { __typename?: 'BlockedUserResult', totalCount: number, users: Array<{ __typename?: 'User', user_id: number, profile_photo_resource?: string | null, full_name?: string | null, slug?: string | null, user_type?: string | null }>, pageInfo: { __typename?: 'UserPageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type FollowerFollowingQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type FollowerFollowingQuery = { __typename?: 'Query', MyFollowing: { __typename?: 'FollowerFollowingResponse', total?: number | null, offset: number, limit: number, results?: Array<{ __typename?: 'User', user_id: number, profile_photo_resource?: string | null, slug?: string | null, full_name?: string | null, user_type?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', membership_type?: string | null, photo?: string | null, name?: string | null, slug?: string | null, user_type?: string | null, enhanced?: boolean | null, verified?: boolean | null } | null } | null> | null }, MyFollowers: { __typename?: 'FollowerFollowingResponse', total?: number | null, offset: number, limit: number, results?: Array<{ __typename?: 'User', user_id: number, profile_photo_resource?: string | null, slug?: string | null, full_name?: string | null, user_type?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', membership_type?: string | null, photo?: string | null, name?: string | null, slug?: string | null, user_type?: string | null, enhanced?: boolean | null, verified?: boolean | null } | null } | null> | null } };

export type GetSuggestedUsersQueryVariables = Exact<{
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  broader?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSuggestedUsersQuery = { __typename?: 'Query', suggestedUsers: { __typename?: 'SuggestedUserResponse', total?: number | null, page?: number | null, has_next_page?: boolean | null, users?: Array<{ __typename?: 'User', user_id: number, full_name?: string | null, default_listing_id?: number | null, user_type?: string | null, slug?: string | null, profile_photo_resource?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, user_id?: number | null, user_type?: string | null, name?: string | null, enhanced?: boolean | null, verified?: boolean | null, photo?: string | null, slug?: string | null, business_description_completed?: boolean | null, products_completed?: boolean | null, vendors_completed?: boolean | null, selling_locations_completed?: boolean | null, sales_channels_completed?: boolean | null } | null }> | null } };

export type GetSuggestedListingsQueryVariables = Exact<{
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSuggestedListingsQuery = { __typename?: 'Query', suggestedListings: { __typename?: 'SuggestedListingsResponse', total?: number | null, has_next_page?: boolean | null, page?: number | null, listings?: Array<{ __typename?: 'Listing', listing_id: number, user_id?: number | null, user_type?: string | null, name?: string | null, enhanced?: boolean | null, photo?: string | null, slug?: string | null, latitude?: number | null, longitude?: number | null, distance?: number | null, city?: string | null, state?: string | null, user?: { __typename?: 'User', profile_photo_resource?: string | null, slug?: string | null, user_id: number } | null }> | null } };

export type GeneralUserSearchQueryVariables = Exact<{
  dataToSearch: Array<SearchType> | SearchType;
  searchTerm: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GeneralUserSearchQuery = { __typename?: 'Query', generalSearch?: { __typename?: 'SearchResponse', limit: number, total: number, results: Array<{ __typename?: 'DirectoryIngredient' } | { __typename?: 'Listing', listing_id: number, user_type?: string | null, name?: string | null, photo?: string | null, slug?: string | null, user?: { __typename?: 'User', profile_photo_resource?: string | null } | null } | { __typename?: 'Recipe' } | { __typename?: 'User', full_name?: string | null, profile_photo_resource?: string | null, user_type?: string | null, slug?: string | null, user_id: number, default_listing?: { __typename?: 'Listing', name?: string | null, photo?: string | null, slug?: string | null } | null }> } | null };

export type GetUnitOfMeasurementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitOfMeasurementQuery = { __typename?: 'Query', getUnitOfMesurement?: Array<{ __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_name?: string | null, unit_abbreviation?: string | null }> | null };

export type GeneralRecipeSearchQueryVariables = Exact<{
  dataToSearch: Array<SearchType> | SearchType;
  searchTerm: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  distanceSort?: InputMaybe<DirectoryInput>;
}>;


export type GeneralRecipeSearchQuery = { __typename?: 'Query', generalSearch?: { __typename: 'SearchResponse', limit: number, total: number, results: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, type?: string | null, mainImage?: string | null, illustrationImage?: string | null, description?: string | null, allowUsage?: boolean | null, date_created?: any | null, slug?: string | null, listings?: Array<{ __typename?: 'Listing', name?: string | null } | null> | null, thumbnail_path?: { __typename?: 'DirectoryIngredientImage', thumbnail_path?: string | null, main_image_path?: string | null } | null } | { __typename?: 'Listing', listing_id: number, user_type?: string | null, description?: string | null, tagLine?: string | null, enhanced?: boolean | null, verified?: boolean | null, membership_type?: string | null, name?: string | null, photo?: string | null, latitude?: number | null, longitude?: number | null, city?: string | null, state?: string | null, slug?: string | null, business_description_completed?: boolean | null, products_completed?: boolean | null, vendors_completed?: boolean | null, selling_locations_completed?: boolean | null, sales_channels_completed?: boolean | null, user?: { __typename?: 'User', profile_photo_resource?: string | null, full_name?: string | null, slug?: string | null } | null, ingredients?: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null } | null> | null, vendors?: Array<{ __typename?: 'Listing', name?: string | null } | null> | null } | { __typename?: 'Recipe', recipe_id: number, user_id: number, recipe_img_url?: string | null, recipe_name?: string | null, number_of_servings?: number | null, serving_type?: string | null, author_name?: string | null, preparation_time?: number | null, cook_time?: number | null, total_time?: number | null, average_recipe_rating?: number | null, resourcePath: string, slug?: string | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_abbreviation?: string | null, unit_name?: string | null } | null } | null> | null, recipe_image?: { __typename?: 'RecipeImage', resource_path?: string | null, thumbnail_path?: string | null } | null, user?: { __typename?: 'User', profile_photo_resource?: string | null, full_name?: string | null, slug?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, resourcePath?: string | null } | null } | null } | { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, username?: string | null, email_address?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, date_last_login?: any | null, zipcode?: string | null, user_bio?: string | null, date_pro_user?: any | null, user_type?: string | null, date_onboarding_completed?: any | null, city?: string | null, country?: string | null, twitter_url?: string | null, youtube_url?: string | null, slug?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, resourcePath?: string | null, slug?: string | null } | null }> } | null };

export type SendBusinessRegInviteMutationVariables = Exact<{
  input: BusinessRegEmailInput;
  emailType: Scalars['String']['input'];
}>;


export type SendBusinessRegInviteMutation = { __typename?: 'Mutation', sendBusinessRegEmail: boolean };

export type RequestCustomPlanMutationVariables = Exact<{
  input: CustomPlanInput;
}>;


export type RequestCustomPlanMutation = { __typename?: 'Mutation', requestCustomPlan: boolean };

export type SubscribeForNewsletterMutationVariables = Exact<{
  input: AddSubscriberInput;
}>;


export type SubscribeForNewsletterMutation = { __typename?: 'Mutation', addSubscriber: { __typename?: 'AddSubscriberResponse', success: boolean, message?: string | null } };

export type GetIngredientsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  isSeasonal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetIngredientsQuery = { __typename?: 'Query', getIngredients?: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, slug?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, cookingGuidance?: string | null, cooking?: string | null, choosing?: string | null, parent_product_id?: number | null, is_generic?: boolean | null, requires_enhanced?: boolean | null, seasonal_source?: string | null, seasonal_manual_until?: any | null, seasonal_updated_at?: any | null, date_updated?: any | null, date_created?: any | null, start_month?: number | null, peak_month?: number | null, end_month?: number | null, userOwned?: boolean | null, allowUsage?: boolean | null, listings?: Array<{ __typename?: 'Listing', listing_id: number } | null> | null, availableMonths?: Array<{ __typename?: 'IngredientMonth', month: number, isPeak: boolean }> | null }> | null };

export type FindDirectoryIngredientByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type FindDirectoryIngredientByNameQuery = { __typename?: 'Query', findDirectoryIngredientByName?: { __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, verified?: boolean | null } | null };

export type GetSeasonalIngredientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSeasonalIngredientsQuery = { __typename?: 'Query', getSeasonalIngredients?: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, slug?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, cookingGuidance?: string | null, cooking?: string | null, choosing?: string | null, parent_product_id?: number | null, is_generic?: boolean | null, requires_enhanced?: boolean | null, seasonal_source?: string | null, seasonal_manual_until?: any | null, seasonal_updated_at?: any | null, date_updated?: any | null, date_created?: any | null, start_month?: number | null, peak_month?: number | null, end_month?: number | null, listings?: Array<{ __typename?: 'Listing', name?: string | null } | null> | null }> | null };

export type CreateIngredientMutationVariables = Exact<{
  input: DirectoryIngredientInput;
  file?: InputMaybe<Scalars['Upload']['input']>;
  mainFile?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type CreateIngredientMutation = { __typename?: 'Mutation', createIngredient: { __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, cookingGuidance?: string | null, cooking?: string | null, choosing?: string | null, parent_product_id?: number | null, is_generic?: boolean | null, requires_enhanced?: boolean | null, date_updated?: any | null, date_created?: any | null } };

export type UpdateDirectoryIngredientMutationVariables = Exact<{
  ingredientId: Scalars['Int']['input'];
  input: DirectoryIngredientInput;
}>;


export type UpdateDirectoryIngredientMutation = { __typename?: 'Mutation', updateDirectoryIngredient: { __typename?: 'DirectoryIngredient', name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, cookingGuidance?: string | null, flavoring?: string | null, preparation?: string | null, methods?: string | null, cooking?: string | null, choosing?: string | null, parent_product_id?: number | null, is_generic?: boolean | null, requires_enhanced?: boolean | null, seasonal_source?: string | null, seasonal_manual_until?: any | null, seasonal_updated_at?: any | null, start_month?: number | null, peak_month?: number | null, end_month?: number | null, resource_illustration_path?: string | null, resource_main_path?: string | null, date_updated?: any | null, date_created?: any | null } };

export type DeleteDirectoryIngredientMutationVariables = Exact<{
  ingredientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DeleteDirectoryIngredientMutation = { __typename?: 'Mutation', deleteDirectoryIngredient: boolean };

export type IngredientDetailQueryVariables = Exact<{
  ingredient_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type IngredientDetailQuery = { __typename?: 'Query', ingredientDetail: { __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, slug?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, flavoring?: string | null, preparation?: string | null, methods?: string | null, cookingGuidance?: string | null, parent_product_id?: number | null, is_generic?: boolean | null, requires_enhanced?: boolean | null, cooking?: string | null, choosing?: string | null, date_updated?: any | null, date_created?: any | null, start_month?: number | null, peak_month?: number | null, end_month?: number | null, listings?: Array<{ __typename?: 'Listing', listing_id: number, enhanced?: boolean | null, verified?: boolean | null, user_type?: string | null, membership_type?: string | null, resourcePath?: string | null, email?: string | null, name?: string | null, photo?: string | null, phone?: string | null, website?: string | null, latitude?: number | null, longitude?: number | null, publicPhone?: string | null, city?: string | null, date_updated?: any | null, date_created?: any | null, slug?: string | null, business_description_completed?: boolean | null, products_completed?: boolean | null, vendors_completed?: boolean | null, selling_locations_completed?: boolean | null, sales_channels_completed?: boolean | null } | null> | null, availableMonths?: Array<{ __typename?: 'IngredientMonth', month: number, isPeak: boolean }> | null } };

export type SetIngredientAvailableMonthsMutationVariables = Exact<{
  ingredientId: Scalars['Int']['input'];
  months: Array<IngredientMonthInput> | IngredientMonthInput;
}>;


export type SetIngredientAvailableMonthsMutation = { __typename?: 'Mutation', setIngredientAvailableMonths: { __typename?: 'DirectoryIngredient', ingredient_id: number, start_month?: number | null, peak_month?: number | null, end_month?: number | null, availableMonths?: Array<{ __typename?: 'IngredientMonth', month: number, isPeak: boolean }> | null } };

export type UpdateIngredientImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  ingredientID: Scalars['Int']['input'];
  type: Scalars['String']['input'];
}>;


export type UpdateIngredientImageMutation = { __typename?: 'Mutation', updateIngredientImage: { __typename?: 'DirectoryIngredientImageResponse', illustrationImage?: string | null } };

export type GetRecipeIngredientsQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetRecipeIngredientsQuery = { __typename?: 'Query', getRecipeIngredients?: Array<{ __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null> | null };

export type GetUserProductsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserProductsQuery = { __typename?: 'Query', getUserIngredients?: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, slug?: string | null, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, isSeasonal?: boolean | null, parent_product_id?: number | null, is_generic?: boolean | null, requires_enhanced?: boolean | null, start_month?: number | null, peak_month?: number | null, end_month?: number | null } | null> | null };

export type GetRecipeIngredientsForApprovalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecipeIngredientsForApprovalQuery = { __typename?: 'Query', getRecipeIngredientsForApproval?: Array<{ __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null, ingredient_description?: string | null, is_validated?: boolean | null } | null> | null };

export type ApprovalUnvalidatedIngredientMutationVariables = Exact<{
  ingredID: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
}>;


export type ApprovalUnvalidatedIngredientMutation = { __typename?: 'Mutation', approvalUnValidatedIngredient: boolean };

export type GetDirectoryListingQueryVariables = Exact<{
  filter?: InputMaybe<DirectoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  isEnhanced?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDirectoryListingQuery = { __typename?: 'Query', getDirectoryListing: { __typename?: 'ListingResponse', total?: number | null, page?: number | null, listings?: Array<{ __typename?: 'Listing', listing_id: number, name?: string | null, enhanced?: boolean | null, user_type?: string | null, membership_type?: string | null, photo?: string | null, description?: string | null, latitude?: number | null, longitude?: number | null, city?: string | null, state?: string | null, email?: string | null, publicEmail?: string | null, instagram?: string | null, publicPhone?: string | null, phone?: string | null, facebook?: string | null, twitter?: string | null, pending?: boolean | null, website?: string | null, approved?: boolean | null, address?: string | null, zipcode?: string | null, tagLine?: string | null, slug?: string | null, verified?: boolean | null, deleted_at?: any | null, date_created?: any | null, subscription?: { __typename?: 'UserSubscription', stripe_sub_id?: string | null } | null, user?: { __typename?: 'User', profile_photo_resource?: string | null, slug?: string | null, user_id: number, user_type?: string | null, date_last_login?: any | null } | null } | null> | null } };

export type GetListingVendorsQueryVariables = Exact<{
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetListingVendorsQuery = { __typename?: 'Query', getListingVendors?: Array<{ __typename?: 'Listing', listing_id: number, name?: string | null, enhanced?: boolean | null, user_type?: string | null, membership_type?: string | null, photo?: string | null, description?: string | null, latitude?: number | null, longitude?: number | null, city?: string | null, state?: string | null, zipcode?: string | null, pending?: boolean | null, website?: string | null, approved?: boolean | null, address?: string | null, tagLine?: string | null, slug?: string | null, publicEmail?: string | null, ingredients?: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, cookingGuidance?: string | null, cooking?: string | null, choosing?: string | null } | null> | null }> | null };

export type ListingDetailQueryVariables = Exact<{
  listingId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListingDetailQuery = { __typename?: 'Query', listingDetail?: { __typename?: 'Listing', listing_id: number, user_id?: number | null, name?: string | null, enhanced?: boolean | null, user_type?: string | null, membership_type?: string | null, photo?: string | null, firstName?: string | null, lastName?: string | null, description?: string | null, latitude?: number | null, longitude?: number | null, city?: string | null, state?: string | null, email?: string | null, publicEmail?: string | null, instagram?: string | null, publicPhone?: string | null, phone?: string | null, facebook?: string | null, twitter?: string | null, pending?: boolean | null, website?: string | null, approved?: boolean | null, address?: string | null, zipcode?: string | null, tagLine?: string | null, verified?: boolean | null, slug?: string | null, business_description_completed?: boolean | null, products_completed?: boolean | null, selling_locations_completed?: boolean | null, sales_channels_completed?: boolean | null, profile_image_completed?: boolean | null, geolocation_completed?: boolean | null, has_created_recipe?: boolean | null, has_created_feed_post?: boolean | null, has_shared_content?: boolean | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, slug?: string | null } | null, vendors?: Array<{ __typename?: 'Listing', listing_id: number, slug?: string | null, enhanced?: boolean | null, user_type?: string | null, membership_type?: string | null, resourcePath?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, photo?: string | null, phone?: string | null, website?: string | null, latitude?: number | null, longitude?: number | null, publicPhone?: string | null, address?: string | null, zipcode?: string | null, city?: string | null, state?: string | null, description?: string | null, tagLine?: string | null } | null> | null, ingredients?: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, start_month?: number | null, end_month?: number | null, cookingGuidance?: string | null, cooking?: string | null, choosing?: string | null, availableMonths?: Array<{ __typename?: 'IngredientMonth', month: number, isPeak: boolean }> | null, listings?: Array<{ __typename?: 'Listing', name?: string | null, photo?: string | null } | null> | null } | null> | null, Practices?: Array<{ __typename?: 'Practice', practice_id: number, tag?: string | null, name?: string | null, imgUrl?: string | null } | null> | null, SalesChannels?: Array<{ __typename?: 'SalesChannel', sales_channel_id: number, name?: string | null, description?: string | null, icon?: string | null } | null> | null, OperatingPeriod?: Array<{ __typename?: 'OperatingHours', operationId: number, listing_id: number, day: string, openingTime: string, closingTime: string } | null> | null, subscription?: { __typename?: 'UserSubscription', subscription_id: number, user_id: number, status: StatusEnum, current_period_end: any, created_at?: any | null, tax_exemption?: boolean | null, tax_cert_number?: string | null, tax_cert_expiration_date?: any | null } | null } | null };

export type GetPracticesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPracticesQuery = { __typename?: 'Query', getPractices?: Array<{ __typename?: 'Practice', practice_id: number, tag?: string | null, name?: string | null, resource_path?: string | null, imgUrl?: string | null }> | null };

export type GetSalesChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesChannelsQuery = { __typename?: 'Query', getSalesChannels?: Array<{ __typename?: 'SalesChannel', sales_channel_id: number, name?: string | null, description?: string | null, icon?: string | null }> | null };

export type GetPendingListingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingListingsQuery = { __typename?: 'Query', getPendingListings?: Array<{ __typename?: 'Listing', listing_id: number, name?: string | null, enhanced?: boolean | null, pending?: boolean | null, approved?: boolean | null, address?: string | null }> | null };

export type CreateListingMutationVariables = Exact<{
  input?: InputMaybe<ListingInput>;
}>;


export type CreateListingMutation = { __typename?: 'Mutation', createListing: { __typename?: 'Listing', listing_id: number, enhanced?: boolean | null, user_type?: string | null, membership_type?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, photo?: string | null, phone?: string | null, website?: string | null, latitude?: number | null, longitude?: number | null, publicPhone?: string | null, city?: string | null, state?: string | null, description?: string | null, pending?: boolean | null, approved?: boolean | null, address?: string | null, instagram?: string | null, facebook?: string | null, twitter?: string | null, tagLine?: string | null, date_updated?: any | null, date_created?: any | null } };

export type UpdateListingMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  input?: InputMaybe<ListingInput>;
}>;


export type UpdateListingMutation = { __typename?: 'Mutation', updateListing: { __typename?: 'Listing', listing_id: number, enhanced?: boolean | null, user_type?: string | null, membership_type?: string | null, resourcePath?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, photo?: string | null, phone?: string | null, website?: string | null, latitude?: number | null, longitude?: number | null, publicPhone?: string | null, city?: string | null, state?: string | null, description?: string | null, pending?: boolean | null, approved?: boolean | null, address?: string | null, instagram?: string | null, facebook?: string | null, twitter?: string | null, zipcode?: string | null, tagLine?: string | null, slug?: string | null } };

export type CreateEnhancedMutationVariables = Exact<{
  input?: InputMaybe<ListingInput>;
  vendors?: InputMaybe<Array<InputMaybe<ListingInput>> | InputMaybe<ListingInput>>;
  ingredientInput?: InputMaybe<Array<InputMaybe<DirectoryIngredientInput>> | InputMaybe<DirectoryIngredientInput>>;
  practices?: InputMaybe<Array<InputMaybe<PracticeInput>> | InputMaybe<PracticeInput>>;
  sellingLocations?: InputMaybe<Array<InputMaybe<SellingLocationInput>> | InputMaybe<SellingLocationInput>>;
}>;


export type CreateEnhancedMutation = { __typename?: 'Mutation', createEnhanced: { __typename?: 'Listing', listing_id: number, enhanced?: boolean | null, user_type?: string | null, membership_type?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, photo?: string | null, phone?: string | null, website?: string | null, latitude?: number | null, longitude?: number | null, publicPhone?: string | null, city?: string | null, state?: string | null, description?: string | null, pending?: boolean | null, approved?: boolean | null, address?: string | null, instagram?: string | null, facebook?: string | null, twitter?: string | null, date_updated?: any | null, date_created?: any | null, tagLine?: string | null } };

export type CreateListingOperationTimeMutationVariables = Exact<{
  input?: InputMaybe<Array<OperatingHoursInput> | OperatingHoursInput>;
}>;


export type CreateListingOperationTimeMutation = { __typename?: 'Mutation', createListingOperationTime?: Array<{ __typename?: 'OperatingHours', operationId: number, listing_id: number, day: string, openingTime: string, closingTime: string }> | null };

export type ReplaceListingPracticesMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  input: Array<PracticeInput> | PracticeInput;
}>;


export type ReplaceListingPracticesMutation = { __typename?: 'Mutation', replaceListingPractices?: boolean | null };

export type ReplaceListingSalesChannelsMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  input: Array<SalesChannelInput> | SalesChannelInput;
}>;


export type ReplaceListingSalesChannelsMutation = { __typename?: 'Mutation', replaceListingSalesChannels?: boolean | null };

export type ReplaceListingOperationTimeMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  input: Array<OperatingHoursInput> | OperatingHoursInput;
}>;


export type ReplaceListingOperationTimeMutation = { __typename?: 'Mutation', replaceListingOperationTime?: Array<{ __typename?: 'OperatingHours', operationId: number, listing_id: number, day: string, openingTime: string, closingTime: string }> | null };

export type UpdateListingImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  listingID: Scalars['Int']['input'];
}>;


export type UpdateListingImageMutation = { __typename?: 'Mutation', updateListingImage?: string | null };

export type GetListingOperatingTimeQueryVariables = Exact<{
  listingID: Scalars['Int']['input'];
}>;


export type GetListingOperatingTimeQuery = { __typename?: 'Query', getListingOperatingTime?: Array<{ __typename?: 'OperatingHours', operationId: number, listing_id: number, day: string, openingTime: string, closingTime: string } | null> | null };

export type DeleteListingMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type DeleteListingMutation = { __typename?: 'Mutation', deleteListing: boolean };

export type ApproveEnhanceMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  approve: Scalars['Boolean']['input'];
  pending: Scalars['Boolean']['input'];
  enhance: Scalars['Boolean']['input'];
  taxCertNumber?: InputMaybe<Scalars['String']['input']>;
  taxCertExpirationDate?: InputMaybe<Scalars['Time']['input']>;
}>;


export type ApproveEnhanceMutation = { __typename?: 'Mutation', approveEnhance: { __typename?: 'Listing', listing_id: number, enhanced?: boolean | null, user_type?: string | null, membership_type?: string | null, resourcePath?: string | null, email?: string | null, pending?: boolean | null, approved?: boolean | null } };

export type GetProducersNearMeQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
  distance?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProducersNearMeQuery = { __typename?: 'Query', getProducersNearMe?: Array<{ __typename?: 'Listing', listing_id: number, user_type?: string | null, membership_type?: string | null, resourcePath?: string | null, name?: string | null, photo?: string | null, latitude?: number | null, longitude?: number | null, distance?: number | null, city?: string | null, state?: string | null, address?: string | null, slug?: string | null, tagLine?: string | null, description?: string | null, zipcode?: string | null, verified?: boolean | null, enhanced?: boolean | null, nearby_market_count?: number | null, business_description_completed?: boolean | null, products_completed?: boolean | null, selling_locations_completed?: boolean | null, sales_channels_completed?: boolean | null, user?: { __typename?: 'User', user_id: number, slug?: string | null, profile_photo_resource?: string | null, full_name?: string | null } | null, ingredients?: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null } | null> | null, vendors?: Array<{ __typename?: 'Listing', name?: string | null } | null> | null }> | null };

export type GetMarketsNearMeQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
  distance?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMarketsNearMeQuery = { __typename?: 'Query', getMarketsNearMe?: Array<{ __typename?: 'Listing', listing_id: number, user_id?: number | null, user_type?: string | null, membership_type?: string | null, resourcePath?: string | null, name?: string | null, photo?: string | null, latitude?: number | null, longitude?: number | null, distance?: number | null, city?: string | null, state?: string | null, address?: string | null, description?: string | null, slug?: string | null, tagLine?: string | null, zipcode?: string | null, verified?: boolean | null, enhanced?: boolean | null, business_description_completed?: boolean | null, vendors_completed?: boolean | null, selling_locations_completed?: boolean | null, user?: { __typename?: 'User', user_id: number, slug?: string | null, profile_photo_resource?: string | null, full_name?: string | null } | null }> | null };

export type DeclineEnhanceRequestMutationVariables = Exact<{
  listing_id: Scalars['Int']['input'];
}>;


export type DeclineEnhanceRequestMutation = { __typename?: 'Mutation', declineEnhance: { __typename?: 'Listing', listing_id: number, enhanced?: boolean | null, user_type?: string | null } };

export type GetProductByListingIdQueryVariables = Exact<{
  listingID: Scalars['Int']['input'];
}>;


export type GetProductByListingIdQuery = { __typename?: 'Query', getGetDirectoryIngredientByListingID?: Array<{ __typename?: 'DirectoryIngredient', ingredient_id: number, illustrationImage?: string | null, mainImage?: string | null, name?: string | null, slug?: string | null, description?: string | null, isSeasonal?: boolean | null, start_month?: number | null, end_month?: number | null, availableMonths?: Array<{ __typename?: 'IngredientMonth', month: number, isPeak: boolean }> | null, listings?: Array<{ __typename?: 'Listing', listing_id: number } | null> | null }> | null };

export type GetVendorByListingIdQueryVariables = Exact<{
  listingID: Scalars['Int']['input'];
}>;


export type GetVendorByListingIdQuery = { __typename?: 'Query', getVendorByListingID?: Array<{ __typename?: 'Listing', listing_id: number, name?: string | null, photo?: string | null, slug?: string | null, tagLine?: string | null, user?: { __typename?: 'User', user_id: number, slug?: string | null } | null, ingredients?: Array<{ __typename?: 'DirectoryIngredient', type?: string | null } | null> | null }> | null };

export type GetSellingLocationsQueryVariables = Exact<{
  listingId: Scalars['Int']['input'];
}>;


export type GetSellingLocationsQuery = { __typename?: 'Query', getSellingLocations?: Array<{ __typename?: 'SellingLocation', location_id: number, listing_id: number, user_id?: number | null, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, note?: string | null, availabilities: Array<{ __typename?: 'Availability', day: string, time: string }> } | null> | null };

export type CreateSellingLocationMutationVariables = Exact<{
  input: SellingLocationInput;
}>;


export type CreateSellingLocationMutation = { __typename?: 'Mutation', createSellingLocation: { __typename?: 'SellingLocation', location_id: number, listing_id: number, user_id?: number | null, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, note?: string | null, availabilities: Array<{ __typename?: 'Availability', day: string, time: string }> } };

export type UpdateSellingLocationMutationVariables = Exact<{
  locationID: Scalars['Int']['input'];
  input: SellingLocationInput;
}>;


export type UpdateSellingLocationMutation = { __typename?: 'Mutation', updateSellingLocation: { __typename?: 'SellingLocation', location_id: number, listing_id: number, user_id?: number | null, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, note?: string | null, availabilities: Array<{ __typename?: 'Availability', day: string, time: string }> } };

export type DeleteSellingLocationMutationVariables = Exact<{
  locationID: Scalars['Int']['input'];
}>;


export type DeleteSellingLocationMutation = { __typename?: 'Mutation', deleteSellingLocation: boolean };

export type GetAllOnDemandListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOnDemandListingQuery = { __typename?: 'Query', getAllOnDemandListing?: Array<{ __typename?: 'Listing', listing_id: number, photo?: string | null, name?: string | null, phone?: string | null, email?: string | null, city?: string | null, state?: string | null, firstName?: string | null, lastName?: string | null, user_type?: string | null, description?: string | null, date_created?: any | null, user?: { __typename?: 'User', slug?: string | null, full_name?: string | null } | null }> | null };

export type GetUserAddedDirectoryIngredientQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAddedDirectoryIngredientQuery = { __typename?: 'Query', getUserAddedDirectoryIngredient?: Array<{ __typename?: 'DirectoryIngredient', name?: string | null, type?: string | null, mainImage?: string | null, illustrationImage?: string | null, ingredient_id: number, description?: string | null, allowUsage?: boolean | null, date_created?: any | null, slug?: string | null }> | null };

export type MarkOnDemandListingClearedMutationVariables = Exact<{
  listing_id: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
}>;


export type MarkOnDemandListingClearedMutation = { __typename?: 'Mutation', markOnDemandListingCleared: boolean };

export type DirectoryIngredientPrivacyMutationVariables = Exact<{
  record_id: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
}>;


export type DirectoryIngredientPrivacyMutation = { __typename?: 'Mutation', directoryIngredientPrivacy: boolean };

export type DeleteListingIngredientFromProfileMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  ingredients?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type DeleteListingIngredientFromProfileMutation = { __typename?: 'Mutation', deleteListingIngredientFromProfile: boolean };

export type DeleteListingVendorFromProfileMutationVariables = Exact<{
  listingId: Scalars['Int']['input'];
  vendors?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type DeleteListingVendorFromProfileMutation = { __typename?: 'Mutation', deleteListingVendorFromProfile: boolean };

export type BusinessRegistrationMutationVariables = Exact<{
  input?: InputMaybe<ListingInput>;
  ingredientInput?: InputMaybe<Array<InputMaybe<DirectoryIngredientInput>> | InputMaybe<DirectoryIngredientInput>>;
  practices?: InputMaybe<Array<InputMaybe<PracticeInput>> | InputMaybe<PracticeInput>>;
  salesChannels?: InputMaybe<Array<InputMaybe<SalesChannelInput>> | InputMaybe<SalesChannelInput>>;
  sellingLocations?: InputMaybe<Array<InputMaybe<SellingLocationInput>> | InputMaybe<SellingLocationInput>>;
}>;


export type BusinessRegistrationMutation = { __typename?: 'Mutation', businessRegistration?: { __typename?: 'AuthUser', token?: string | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, username?: string | null, email_address?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, zipcode?: string | null, user_bio?: string | null, user_type?: string | null, slug?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', slug?: string | null } | null, userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, user_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null } | null } | null };

export type AddProducerLocationsMutationVariables = Exact<{
  input?: InputMaybe<Array<SellingLocationInput> | SellingLocationInput>;
}>;


export type AddProducerLocationsMutation = { __typename?: 'Mutation', addProducerLocations: boolean };

export type AddProducerProductsMutationVariables = Exact<{
  listingID: Scalars['Int']['input'];
  input?: InputMaybe<Array<DirectoryIngredientInput> | DirectoryIngredientInput>;
}>;


export type AddProducerProductsMutation = { __typename?: 'Mutation', addProducerProducts: boolean };

export type AddMarketVendorsMutationVariables = Exact<{
  listingID: Scalars['Int']['input'];
  input?: InputMaybe<Array<VendorListingInput> | VendorListingInput>;
}>;


export type AddMarketVendorsMutation = { __typename?: 'Mutation', addMarketVendors: boolean };

export type SwitchUserDefaultListingMutationVariables = Exact<{
  listingID: Scalars['Int']['input'];
}>;


export type SwitchUserDefaultListingMutation = { __typename?: 'Mutation', switchUserDefaultListing?: { __typename?: 'User', user_id: number, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', membership_type?: string | null, name?: string | null, latitude?: number | null, longitude?: number | null, photo?: string | null } | null, listings?: Array<{ __typename?: 'Listing', listing_id: number, name?: string | null } | null> | null } | null };

export type DeleteLocationMutationVariables = Exact<{
  locationID: Scalars['Int']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteSellingLocation: boolean };

export type UpdateLocationMutationVariables = Exact<{
  locationID: Scalars['Int']['input'];
  input: SellingLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateSellingLocation: { __typename?: 'SellingLocation', user_id?: number | null, location_id: number, name: string, note?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, availabilities: Array<{ __typename?: 'Availability', time: string, day: string }> } };

export type AddListingPracticesMutationVariables = Exact<{
  listingID: Scalars['Int']['input'];
  input?: InputMaybe<Array<PracticeInput> | PracticeInput>;
}>;


export type AddListingPracticesMutation = { __typename?: 'Mutation', createListingPractices: boolean };

export type UploadImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadImageMutation = { __typename?: 'Mutation', uploadImage: string };

export type GetPublicPostsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['ID']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortBy>;
}>;


export type GetPublicPostsQuery = { __typename?: 'Query', getPublicPosts: { __typename?: 'PostPagination', totalCount: number, posts: Array<{ __typename?: 'Post', id: number, title?: string | null, content: string, created_at?: any | null, updated_at?: any | null, likeCount?: number | null, commentCount?: number | null, group: string, slug?: string | null, status?: string | null, user_id?: number | null, post_medias?: Array<{ __typename?: 'PostMedia', url: string, type: string } | null> | null, user?: { __typename?: 'User', user_id: number, user_type?: string | null, full_name?: string | null, username?: string | null, slug?: string | null, profile_photo_resource?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', listing_id: number, slug?: string | null, photo?: string | null, name?: string | null } | null } | null, post_products?: Array<{ __typename?: 'PostProduct', product: { __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, cookingGuidance?: string | null, cooking?: string | null, choosing?: string | null, date_updated?: any | null, date_created?: any | null } } | null> | null, post_recipes?: Array<{ __typename?: 'PostRecipe', recipe: { __typename?: 'Recipe', recipe_id: number, user_id: number, recipe_img_url?: string | null, recipe_name?: string | null, number_of_servings?: number | null, serving_type?: string | null, author_name?: string | null, preparation_time?: number | null, resourcePath: string, thumbnailPath: string, cook_time?: number | null, inspired_by?: string | null, total_time?: number | null, average_recipe_rating?: number | null, recipe_image?: { __typename?: 'RecipeImage', record_id: number, resource_path?: string | null, thumbnail_path?: string | null } | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_name?: string | null } | null } | null> | null } } | null> | null, comments?: Array<{ __typename?: 'PostComment', id: number, content: string, user?: { __typename?: 'User', user_id: number, full_name?: string | null, username?: string | null, user_type?: string | null, profile_photo_resource?: string | null, slug?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, name?: string | null } | null } | null } | null> | null }> } };

export type GetPostsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['ID']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  listingID?: InputMaybe<Scalars['Int']['input']>;
  group: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  followingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<SortBy>;
}>;


export type GetPostsQuery = { __typename?: 'Query', getPosts: { __typename?: 'PostPagination', totalCount: number, posts: Array<{ __typename?: 'Post', id: number, title?: string | null, content: string, created_at?: any | null, updated_at?: any | null, likeCount?: number | null, commentCount?: number | null, group: string, slug?: string | null, status?: string | null, scheduled?: boolean | null, run_at?: any | null, user_id?: number | null, post_medias?: Array<{ __typename?: 'PostMedia', url: string, type: string } | null> | null, user?: { __typename?: 'User', user_id: number, user_type?: string | null, full_name?: string | null, username?: string | null, profile_photo_resource?: string | null, slug?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', listing_id: number, slug?: string | null, photo?: string | null, name?: string | null } | null } | null, post_products?: Array<{ __typename?: 'PostProduct', product: { __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, cookingGuidance?: string | null, cooking?: string | null, choosing?: string | null, date_updated?: any | null, date_created?: any | null } } | null> | null, post_recipes?: Array<{ __typename?: 'PostRecipe', recipe: { __typename?: 'Recipe', recipe_id: number, user_id: number, recipe_img_url?: string | null, recipe_name?: string | null, number_of_servings?: number | null, serving_type?: string | null, author_name?: string | null, preparation_time?: number | null, resourcePath: string, thumbnailPath: string, cook_time?: number | null, inspired_by?: string | null, total_time?: number | null, average_recipe_rating?: number | null, recipe_image?: { __typename?: 'RecipeImage', record_id: number, resource_path?: string | null, thumbnail_path?: string | null } | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_name?: string | null } | null } | null> | null } } | null> | null, comments?: Array<{ __typename?: 'PostComment', id: number, content: string, user?: { __typename?: 'User', user_id: number, full_name?: string | null, username?: string | null, user_type?: string | null, profile_photo_resource?: string | null, slug?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, name?: string | null } | null } | null } | null> | null }> } };

export type GetPostDetailQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPostDetailQuery = { __typename?: 'Query', getPost?: { __typename?: 'Post', id: number, title?: string | null, content: string, created_at?: any | null, updated_at?: any | null, slug?: string | null, status?: string | null, scheduled?: boolean | null, run_at?: any | null, group: string, likeCount?: number | null, commentCount?: number | null, post_medias?: Array<{ __typename?: 'PostMedia', url: string, type: string } | null> | null, user?: { __typename?: 'User', user_id: number, full_name?: string | null, username?: string | null, user_type?: string | null, default_listing_id?: number | null, profile_photo_resource?: string | null, slug?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, slug?: string | null, name?: string | null, photo?: string | null } | null } | null, post_products?: Array<{ __typename?: 'PostProduct', product: { __typename?: 'DirectoryIngredient', ingredient_id: number, name?: string | null, illustrationImage?: string | null, mainImage?: string | null, type?: string | null, pairing?: string | null, isSeasonal?: boolean | null, description?: string | null, cookingGuidance?: string | null, cooking?: string | null, choosing?: string | null, date_updated?: any | null, date_created?: any | null } } | null> | null, post_recipes?: Array<{ __typename?: 'PostRecipe', recipe: { __typename?: 'Recipe', recipe_id: number, user_id: number, recipe_img_url?: string | null, recipe_name?: string | null, number_of_servings?: number | null, serving_type?: string | null, author_name?: string | null, preparation_time?: number | null, resourcePath: string, thumbnailPath: string, cook_time?: number | null, inspired_by?: string | null, total_time?: number | null, average_recipe_rating?: number | null, recipe_image?: { __typename?: 'RecipeImage', record_id: number, resource_path?: string | null, thumbnail_path?: string | null } | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_name?: string | null } | null } | null> | null } } | null> | null, comments?: Array<{ __typename?: 'PostComment', id: number, content: string, created_at?: any | null, user?: { __typename?: 'User', user_id: number, full_name?: string | null, username?: string | null, profile_photo_resource?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', listing_id: number, name?: string | null, photo?: string | null } | null } | null } | null> | null } | null };

export type CreateOrUpdatePostMutationVariables = Exact<{
  group?: InputMaybe<Scalars['String']['input']>;
  input: CreateOrUpdatePostInput;
}>;


export type CreateOrUpdatePostMutation = { __typename?: 'Mutation', createOrUpdatePost: { __typename?: 'Post', id: number, title?: string | null, content: string, created_at?: any | null, slug?: string | null, user?: { __typename?: 'User', user_id: number, username?: string | null, full_name?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', photo?: string | null, name?: string | null } | null } | null } };

export type CreateOrUpdateAdminPostMutationVariables = Exact<{
  input: AdminPostInput;
}>;


export type CreateOrUpdateAdminPostMutation = { __typename?: 'Mutation', createOrUpdateAdminPost: { __typename?: 'Post', id: number, title?: string | null, content: string, created_at?: any | null, slug?: string | null, user?: { __typename?: 'User', user_id: number, username?: string | null, full_name?: string | null } | null } };

export type AddCommentMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment?: { __typename?: 'PostComment', id: number, content: string } | null };

export type LikePostMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
}>;


export type LikePostMutation = { __typename?: 'Mutation', likePost: { __typename?: 'Post', likeCount?: number | null } };

export type GetPostLikesQueryVariables = Exact<{
  postId: Scalars['Int']['input'];
}>;


export type GetPostLikesQuery = { __typename?: 'Query', getPostLikes?: Array<{ __typename?: 'PostLike', user_id: number } | null> | null };

export type DeleteCommentMutationVariables = Exact<{
  commentID: Scalars['Int']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: boolean };

export type GetPostCommentsQueryVariables = Exact<{
  postId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPostCommentsQuery = { __typename?: 'Query', getComments?: Array<{ __typename?: 'PostComment', id: number, content: string, created_at?: any | null, user?: { __typename?: 'User', user_id: number, username?: string | null, full_name?: string | null, user_type?: string | null, default_listing_id?: number | null, profile_photo_resource?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, name?: string | null, photo?: string | null } | null } | null } | null> | null };

export type DeletePostMutationVariables = Exact<{
  postID: Scalars['Int']['input'];
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePost: boolean };

export type PostFileUploadMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type PostFileUploadMutation = { __typename?: 'Mutation', postFileUpload: string };

export type GetUserRecipesQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['Int']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserRecipesQuery = { __typename?: 'Query', userRecipes?: { __typename?: 'RecipeResponse', total?: number | null, page: number, recipes?: Array<{ __typename?: 'Recipe', recipe_id: number, user_id: number, slug?: string | null, recipe_img_url?: string | null, recipe_name?: string | null, number_of_servings?: number | null, serving_type?: string | null, author_name?: string | null, preparation_time?: number | null, is_featured?: boolean | null, resourcePath: string, thumbnailPath: string, cook_time?: number | null, inspired_by?: string | null, total_time?: number | null, average_recipe_rating?: number | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_abbreviation?: string | null, unit_name?: string | null } | null } | null> | null, recipe_image?: { __typename?: 'RecipeImage', record_id: number, resource_path?: string | null, thumbnail_path?: string | null } | null, recipe_comments?: Array<{ __typename?: 'RecipeComment', id: string } | null> | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, slug?: string | null, full_name?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, resourcePath?: string | null } | null } | null } | null> | null } | null };

export type MyRecipesQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['Int']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyRecipesQuery = { __typename?: 'Query', myRecipes?: Array<{ __typename?: 'Recipe', recipe_id: number, user_id: number, slug?: string | null, recipe_img_url?: string | null, recipe_name?: string | null, number_of_servings?: number | null, serving_type?: string | null, author_name?: string | null, preparation_time?: number | null, is_featured?: boolean | null, resourcePath: string, thumbnailPath: string, cook_time?: number | null, inspired_by?: string | null, total_time?: number | null, average_recipe_rating?: number | null, recipe_comments?: Array<{ __typename?: 'RecipeComment', id: string } | null> | null, recipe_image?: { __typename?: 'RecipeImage', record_id: number, resource_path?: string | null, thumbnail_path?: string | null } | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, slug?: string | null, full_name?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, resourcePath?: string | null } | null } | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_abbreviation?: string | null, unit_name?: string | null } | null } | null> | null }> | null };

export type RecipeStepsQueryVariables = Exact<{
  recipe_id: Scalars['Int']['input'];
}>;


export type RecipeStepsQuery = { __typename?: 'Query', recipeSteps?: Array<{ __typename?: 'RecipeSteps', record_id: number, recipe_id?: number | null, step_name?: string | null, step_description?: string | null, step_order?: number | null } | null> | null };

export type RecipeNoteQueryVariables = Exact<{
  recipe_id: Scalars['Int']['input'];
}>;


export type RecipeNoteQuery = { __typename?: 'Query', recipeNote?: Array<{ __typename?: 'RecipeNote', record_id?: number | null, recipe_id?: number | null, note_name?: string | null, note_description?: string | null, note_order?: number | null } | null> | null };

export type UpdateRecipeMutationVariables = Exact<{
  ReciInput: RecipeInput;
  Inginput?: InputMaybe<Array<NewIngredientInput> | NewIngredientInput>;
}>;


export type UpdateRecipeMutation = { __typename?: 'Mutation', updateRecipe: { __typename?: 'Recipe', recipe_id: number, user_id: number, source_id?: number | null, recipe_img_url?: string | null, recipe_name?: string | null, number_of_servings?: number | null, preparation_time?: number | null, is_private?: boolean | null, resourcePath: string, thumbnailPath: string, cook_time?: number | null, recipe_image?: { __typename?: 'RecipeImage', record_id: number, resource_path?: string | null, thumbnail_path?: string | null } | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_abbreviation?: string | null, unit_name?: string | null } | null } | null> | null } };

export type CreateRecipeMutationVariables = Exact<{
  ReciInput: RecipeInput;
  Inginput?: InputMaybe<Array<NewIngredientInput> | NewIngredientInput>;
}>;


export type CreateRecipeMutation = { __typename?: 'Mutation', createRecipe: { __typename?: 'Recipe', recipe_id: number, user_id: number, slug?: string | null, source_id?: number | null, recipe_img_url?: string | null, recipe_name?: string | null, number_of_servings?: number | null, preparation_time?: number | null, is_private?: boolean | null, resourcePath: string, thumbnailPath: string, cook_time?: number | null, recipe_image?: { __typename?: 'RecipeImage', record_id: number, resource_path?: string | null, thumbnail_path?: string | null } | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_abbreviation?: string | null, unit_name?: string | null } | null } | null> | null } };

export type UpdateIngredientMutationVariables = Exact<{
  input: UpdateIngredientInput;
}>;


export type UpdateIngredientMutation = { __typename?: 'Mutation', updateIngredient: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null, ingredient_description?: string | null, date_created?: any | null, measurement_amount?: string | null, unit_name?: string | null, unit_abbreviation?: string | null, unit_description?: string | null } };

export type UpdateStepMutationVariables = Exact<{
  input?: InputMaybe<Array<StepInput> | StepInput>;
}>;


export type UpdateStepMutation = { __typename?: 'Mutation', updateStep?: Array<{ __typename?: 'RecipeSteps', record_id: number, recipe_id?: number | null, step_name?: string | null, step_description?: string | null, step_order?: number | null, date_created?: any | null, date_updated?: any | null, date_disabled?: any | null }> | null };

export type CreateStepMutationVariables = Exact<{
  input?: InputMaybe<Array<StepInput> | StepInput>;
}>;


export type CreateStepMutation = { __typename?: 'Mutation', createStep?: Array<{ __typename?: 'RecipeSteps', record_id: number, recipe_id?: number | null, step_name?: string | null, step_description?: string | null, step_order?: number | null, date_created?: any | null, date_updated?: any | null, date_disabled?: any | null }> | null };

export type CreateNoteMutationVariables = Exact<{
  input?: InputMaybe<Array<NoteInput> | NoteInput>;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote?: Array<{ __typename?: 'RecipeNote', record_id?: number | null, recipe_id?: number | null, note_name?: string | null, note_description?: string | null, note_order?: number | null }> | null };

export type UpdateNoteMutationVariables = Exact<{
  input?: InputMaybe<Array<NoteInput> | NoteInput>;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote?: Array<{ __typename?: 'RecipeNote', record_id?: number | null, recipe_id?: number | null, note_name?: string | null, note_description?: string | null, note_order?: number | null, date_created?: any | null, user_created?: number | null, date_updated?: any | null, user_updated?: number | null, date_disabled?: any | null }> | null };

export type CreateRecipeTagMutationVariables = Exact<{
  input?: InputMaybe<Array<CategoryInput> | CategoryInput>;
}>;


export type CreateRecipeTagMutation = { __typename?: 'Mutation', createRecipeTag: Array<{ __typename?: 'Category', category_id: number, category_name?: string | null, category_description?: string | null, date_created?: any | null, user_created?: number | null, date_updated?: any | null, user_updated?: number | null, date_disabled?: any | null, recipe_id?: number | null } | null> };

export type UpdateOrCreateRecipeTagMutationVariables = Exact<{
  input: RecipeTagUpdateInput;
}>;


export type UpdateOrCreateRecipeTagMutation = { __typename?: 'Mutation', updateOrCreateRecipeTag?: Array<{ __typename?: 'RecipeCategory', recipe_id?: number | null }> | null };

export type UpdateRecipeImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  RecipeID: Scalars['Int']['input'];
}>;


export type UpdateRecipeImageMutation = { __typename?: 'Mutation', updateRecipeImage: boolean };

export type DeleteRecipeTagMutationVariables = Exact<{
  category_id: Scalars['Int']['input'];
}>;


export type DeleteRecipeTagMutation = { __typename?: 'Mutation', deleteRecipeTag: boolean };

export type DeleteRecipeNoteMutationVariables = Exact<{
  note_id: Scalars['Int']['input'];
}>;


export type DeleteRecipeNoteMutation = { __typename?: 'Mutation', deleteRecipeNote: boolean };

export type DeleteRecipeStepMutationVariables = Exact<{
  step_id: Scalars['Int']['input'];
}>;


export type DeleteRecipeStepMutation = { __typename?: 'Mutation', deleteRecipeStep: boolean };

export type DeleteIngredientMutationVariables = Exact<{
  ingredient_id: Scalars['Int']['input'];
}>;


export type DeleteIngredientMutation = { __typename?: 'Mutation', deleteIngredient: boolean };

export type DeleteRecipeIngredientMutationVariables = Exact<{
  record_id: Scalars['Int']['input'];
}>;


export type DeleteRecipeIngredientMutation = { __typename?: 'Mutation', deleteRecipeIngredient: boolean };

export type GetRecipeQueryVariables = Exact<{
  recipeId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRecipeQuery = { __typename?: 'Query', recipe: { __typename?: 'Recipe', recipe_id: number, user_id: number, slug?: string | null, recipe_img_url?: string | null, recipe_name?: string | null, number_of_servings?: number | null, serving_type?: string | null, author_name?: string | null, preparation_time?: number | null, resourcePath: string, thumbnailPath: string, is_private?: boolean | null, is_featured?: boolean | null, cook_time?: number | null, inspired_by?: string | null, total_time?: number | null, average_recipe_rating?: number | null, recipe_comments?: Array<{ __typename?: 'RecipeComment', id: string } | null> | null, recipe_image?: { __typename?: 'RecipeImage', record_id: number, resource_path?: string | null, thumbnail_path?: string | null } | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_abbreviation?: string | null, unit_name?: string | null } | null } | null> | null, categories?: Array<{ __typename?: 'Category', category_id: number, category_name?: string | null } | null> | null, recipe_notes?: Array<{ __typename?: 'RecipeNote', recipe_id?: number | null, note_name?: string | null, note_description?: string | null, note_order?: number | null } | null> | null, recipe_steps?: Array<{ __typename?: 'RecipeSteps', record_id: number, recipe_id?: number | null, step_name?: string | null, step_description?: string | null, step_order?: number | null } | null> | null, user?: { __typename?: 'User', profile_photo_resource?: string | null, slug?: string | null, user_id: number, full_name?: string | null, user_type?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, resourcePath?: string | null, slug?: string | null } | null } | null } };

export type GetRecipesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  public: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRecipesQuery = { __typename?: 'Query', recipes?: Array<{ __typename?: 'Recipe', slug?: string | null, recipe_id: number, user_id: number, resourcePath: string, thumbnailPath: string, recipe_img_url?: string | null, recipe_name?: string | null, average_recipe_rating?: number | null, cook_time?: number | null, preparation_time?: number | null, total_time?: number | null, is_featured?: boolean | null, recipe_comments?: Array<{ __typename?: 'RecipeComment', id: string } | null> | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_abbreviation?: string | null, unit_name?: string | null } | null } | null> | null, recipe_image?: { __typename?: 'RecipeImage', thumbnail_path?: string | null, resource_path?: string | null } | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, full_name?: string | null, slug?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, resourcePath?: string | null } | null } | null }> | null };

export type GetDiscoverRecipesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  public: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDiscoverRecipesQuery = { __typename?: 'Query', getDiscoverRecipes: { __typename?: 'DiscoverRecipeResponse', total?: number | null, recipes?: Array<{ __typename?: 'Recipe', recipe_id: number, user_id: number, slug?: string | null, resourcePath: string, recipe_img_url?: string | null, recipe_name?: string | null, average_recipe_rating?: number | null, cook_time?: number | null, preparation_time?: number | null, total_time?: number | null, is_featured?: boolean | null, recipe_comments?: Array<{ __typename?: 'RecipeComment', id: string } | null> | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', record_id: number, recipe_id?: number | null, ingredient_id?: number | null, unit_of_measurement_id?: number | null, whole_number?: number | null, sort_order?: number | null, numerator?: number | null, denominator?: number | null, measurement_amount?: string | null, raw_name?: string | null, ingredient?: { __typename?: 'Ingredient', ingredient_id: number, ingredient_name?: string | null } | null, unit_of_measurement?: { __typename?: 'UnitOfMeasurement', unit_of_measurement_id: number, unit_abbreviation?: string | null, unit_name?: string | null } | null } | null> | null, recipe_image?: { __typename?: 'RecipeImage', thumbnail_path?: string | null, resource_path?: string | null } | null, user?: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, full_name?: string | null, slug?: string | null, default_listing?: { __typename?: 'Listing', listing_id: number, photo?: string | null, resourcePath?: string | null } | null } | null } | null> | null } };

export type DeleteRecipeMutationVariables = Exact<{
  recipeId: Scalars['Int']['input'];
}>;


export type DeleteRecipeMutation = { __typename?: 'Mutation', deleteRecipe: boolean };

export type GetRecipeCommentsQueryVariables = Exact<{
  recipeId: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  starRating?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecipeCommentsQuery = { __typename?: 'Query', getRecipeComments?: Array<{ __typename?: 'RecipeComment', id: string, recipeID: number, userID: number, content: string, rating?: number | null, imagePath?: string | null, user: { __typename?: 'User', user_id: number, full_name?: string | null, username?: string | null, user_type?: string | null, profile_photo_resource?: string | null, slug?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', listing_id: number, name?: string | null, photo?: string | null } | null }, reactions?: Array<{ __typename?: 'RecipeCommentReaction', id: string, commentID: number, emoji: string, userID: number } | null> | null } | null> | null };

export type AddRecipeCommentMutationVariables = Exact<{
  recipeID: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Float']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type AddRecipeCommentMutation = { __typename?: 'Mutation', addRecipeComment: { __typename?: 'RecipeComment', id: string, recipeID: number, userID: number, content: string, rating?: number | null, imagePath?: string | null, user: { __typename?: 'User', user_id: number, full_name?: string | null, username?: string | null, user_type?: string | null, profile_photo_resource?: string | null, slug?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', listing_id: number, name?: string | null, photo?: string | null } | null }, reactions?: Array<{ __typename?: 'RecipeCommentReaction', id: string, commentID: number, emoji: string, userID: number } | null> | null } };

export type AddRecipeCommentReactionMutationVariables = Exact<{
  commentID: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
  emoji: Scalars['String']['input'];
}>;


export type AddRecipeCommentReactionMutation = { __typename?: 'Mutation', addRecipeCommentReaction?: { __typename?: 'RecipeCommentReaction', id: string, commentID: number, userID: number, emoji: string } | null };

export type DeleteRecipeCommentMutationVariables = Exact<{
  commentID: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
}>;


export type DeleteRecipeCommentMutation = { __typename?: 'Mutation', deleteRecipeComment: boolean };

export type SetRecipeAsFeaturedMutationVariables = Exact<{
  recipe_id: Scalars['Int']['input'];
  isFeatured: Scalars['Boolean']['input'];
}>;


export type SetRecipeAsFeaturedMutation = { __typename?: 'Mutation', setRecipeAsFeatured: { __typename?: 'Recipe', recipe_id: number, recipe_name?: string | null, recipe_img_url?: string | null, is_featured?: boolean | null, recipe_image?: { __typename?: 'RecipeImage', thumbnail_path?: string | null, resource_path?: string | null } | null } };

export type GetSeasonalRecipePicksQueryVariables = Exact<{
  weekOf: Scalars['String']['input'];
}>;


export type GetSeasonalRecipePicksQuery = { __typename?: 'Query', getSeasonalRecipePicks?: Array<{ __typename?: 'SeasonalRecipePick', id: number, recipe_id: number, week_of: string, sort_order?: number | null, recipe?: { __typename?: 'Recipe', recipe_id: number, recipe_name?: string | null, recipe_img_url?: string | null, author_name?: string | null, author_link?: string | null, total_time?: number | null, number_of_servings?: number | null, recipe_image?: { __typename?: 'RecipeImage', thumbnail_path?: string | null, resource_path?: string | null } | null } | null } | null> | null };

export type SetSeasonalRecipePickMutationVariables = Exact<{
  recipeId: Scalars['Int']['input'];
  weekOf: Scalars['String']['input'];
}>;


export type SetSeasonalRecipePickMutation = { __typename?: 'Mutation', setSeasonalRecipePick?: { __typename?: 'SeasonalRecipePick', id: number, recipe_id: number, week_of: string, sort_order?: number | null, recipe?: { __typename?: 'Recipe', recipe_id: number, recipe_name?: string | null, recipe_img_url?: string | null, author_name?: string | null, author_link?: string | null, recipe_image?: { __typename?: 'RecipeImage', thumbnail_path?: string | null, resource_path?: string | null } | null } | null } | null };

export type RemoveSeasonalRecipePickMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveSeasonalRecipePickMutation = { __typename?: 'Mutation', removeSeasonalRecipePick?: boolean | null };

export type SearchSpoonacularQueryVariables = Exact<{
  query: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchSpoonacularQuery = { __typename?: 'Query', searchSpoonacular?: Array<{ __typename?: 'SpoonacularResult', id: number, title: string, image?: string | null, ready_in_minutes?: number | null, servings?: number | null, aggregate_likes?: number | null, credits_text?: string | null, source_url?: string | null } | null> | null };

export type ImportSpoonacularRecipeMutationVariables = Exact<{
  spoonacularId: Scalars['Int']['input'];
  weekOf: Scalars['String']['input'];
}>;


export type ImportSpoonacularRecipeMutation = { __typename?: 'Mutation', importSpoonacularRecipe?: { __typename?: 'SeasonalRecipePick', id: number, recipe_id: number, week_of: string, recipe?: { __typename?: 'Recipe', recipe_id: number, recipe_name?: string | null, recipe_img_url?: string | null, author_name?: string | null, author_link?: string | null, recipe_image?: { __typename?: 'RecipeImage', thumbnail_path?: string | null, resource_path?: string | null } | null } | null } | null };

export type CreateRegionMutationVariables = Exact<{
  input: CreateRegionInput;
}>;


export type CreateRegionMutation = { __typename?: 'Mutation', createRegion?: { __typename?: 'Region', region_id: number, slug: string, name: string, month: string, state: string, latitude?: number | null, longitude?: number | null, is_active: boolean, featured_recipes?: Array<number | null> | null, featured_listings?: Array<number | null> | null, created_at?: any | null } | null };

export type UpdateRegionMutationVariables = Exact<{
  input: UpdateRegionInput;
}>;


export type UpdateRegionMutation = { __typename?: 'Mutation', updateRegion?: { __typename?: 'Region', region_id: number, slug: string, name: string, month: string, state: string, latitude?: number | null, longitude?: number | null, is_active: boolean, featured_recipes?: Array<number | null> | null, featured_listings?: Array<number | null> | null, updated_at?: any | null } | null };

export type GetRegionsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetRegionsQuery = { __typename?: 'Query', getRegions?: { __typename?: 'RegionsResponse', total?: number | null, regions?: Array<{ __typename?: 'Region', region_id: number, slug: string, name: string, state: string, month: string, latitude?: number | null, longitude?: number | null, hero_image?: string | null, short_description?: string | null, featured_recipes?: Array<number | null> | null, featured_listings?: Array<number | null> | null, is_active: boolean, created_at?: any | null, updated_at?: any | null } | null> | null } | null };

export type GetRegionBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetRegionBySlugQuery = { __typename?: 'Query', getRegionBySlug?: { __typename?: 'Region', region_id: number, slug: string, name: string, state: string, month: string, latitude?: number | null, longitude?: number | null, hero_image?: string | null, short_description?: string | null, meta_description?: string | null, meta_keywords?: string | null, is_active: boolean, created_at?: any | null, updated_at?: any | null, featured_recipe_objects?: Array<{ __typename?: 'Recipe', recipe_id: number, recipe_name?: string | null, recipe_img_url?: string | null, resourcePath: string, average_recipe_rating?: number | null, total_time?: number | null, slug?: string | null, recipe_image?: { __typename?: 'RecipeImage', resource_path?: string | null, thumbnail_path?: string | null } | null, recipe_comments?: Array<{ __typename?: 'RecipeComment', id: string } | null> | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', ingredient_id?: number | null } | null> | null, user?: { __typename?: 'User', profile_photo_resource?: string | null, slug?: string | null, full_name?: string | null } | null } | null> | null, featured_listing_objects?: Array<{ __typename?: 'Listing', listing_id: number, tagLine?: string | null, enhanced?: boolean | null, verified?: boolean | null, photo?: string | null, name?: string | null, slug?: string | null, user_type?: string | null, description?: string | null, city?: string | null, address?: string | null, state?: string | null, user?: { __typename?: 'User', profile_photo_resource?: string | null } | null } | null> | null } | null };

export type DeleteRegionMutationVariables = Exact<{
  region_id: Scalars['Int']['input'];
}>;


export type DeleteRegionMutation = { __typename?: 'Mutation', deleteRegion: boolean };

export type GetRegionByIdQueryVariables = Exact<{
  region_id: Scalars['Int']['input'];
}>;


export type GetRegionByIdQuery = { __typename?: 'Query', getRegionById?: { __typename?: 'Region', region_id: number, slug: string, name: string, state: string, month: string, latitude?: number | null, longitude?: number | null, hero_image?: string | null, short_description?: string | null, meta_description?: string | null, meta_keywords?: string | null, is_active: boolean, created_at?: any | null, updated_at?: any | null, featured_recipe_objects?: Array<{ __typename?: 'Recipe', recipe_id: number, recipe_name?: string | null, recipe_img_url?: string | null, resourcePath: string, average_recipe_rating?: number | null, total_time?: number | null, slug?: string | null, recipe_image?: { __typename?: 'RecipeImage', resource_path?: string | null, thumbnail_path?: string | null } | null, recipe_comments?: Array<{ __typename?: 'RecipeComment', id: string } | null> | null, recipe_ingredients?: Array<{ __typename?: 'RecipeIngredient', ingredient_id?: number | null } | null> | null, user?: { __typename?: 'User', profile_photo_resource?: string | null, slug?: string | null, full_name?: string | null } | null } | null> | null, featured_listing_objects?: Array<{ __typename?: 'Listing', listing_id: number, tagLine?: string | null, enhanced?: boolean | null, verified?: boolean | null, photo?: string | null, name?: string | null, slug?: string | null, user_type?: string | null, description?: string | null, city?: string | null, address?: string | null, state?: string | null, user?: { __typename?: 'User', profile_photo_resource?: string | null } | null } | null> | null } | null };

export type UploadHeroImageMutationVariables = Exact<{
  region_id: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
}>;


export type UploadHeroImageMutation = { __typename?: 'Mutation', uploadHeroImage: boolean };

export type LogShareMutationVariables = Exact<{
  input: LogShareInput;
}>;


export type LogShareMutation = { __typename?: 'Mutation', logShare: boolean };

export type LogReferralConversionMutationVariables = Exact<{
  input: LogReferralConversionInput;
}>;


export type LogReferralConversionMutation = { __typename?: 'Mutation', logReferralConversion: boolean };

export type GetSmsTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmsTemplatesQuery = { __typename?: 'Query', getSmsTemplates: Array<{ __typename?: 'SmsTemplate', id: number, messageType: string, template: string, approvedBy?: string | null, approvedAt?: any | null, legalApproved: boolean, description: string, active: boolean, createdAt: any, updatedAt: any }> };

export type GetSmsTemplateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSmsTemplateQuery = { __typename?: 'Query', getSmsTemplate: { __typename?: 'SmsTemplate', id: number, messageType: string, template: string, approvedBy?: string | null, approvedAt?: any | null, legalApproved: boolean, description: string, active: boolean, createdAt: any, updatedAt: any } };

export type UpdateSmsTemplateMutationVariables = Exact<{
  input: UpdateSmsTemplateInput;
}>;


export type UpdateSmsTemplateMutation = { __typename?: 'Mutation', updateSmsTemplate: { __typename?: 'SmsTemplate', id: number, messageType: string, template: string, approvedBy?: string | null, approvedAt?: any | null, legalApproved: boolean, description: string, active: boolean, updatedAt: any } };

export type CreateSmsTemplateMutationVariables = Exact<{
  input: CreateSmsTemplateInput;
}>;


export type CreateSmsTemplateMutation = { __typename?: 'Mutation', createSmsTemplate: { __typename?: 'SmsTemplate', id: number, messageType: string, template: string, description: string, active: boolean, createdAt: any } };

export type DeleteSmsTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSmsTemplateMutation = { __typename?: 'Mutation', deleteSmsTemplate: boolean };

export type InitiateSmsOptInMutationVariables = Exact<{
  input: SmsOptInInput;
}>;


export type InitiateSmsOptInMutation = { __typename?: 'Mutation', initiateSmsOptIn: { __typename?: 'SmsOptInResponse', success: boolean, message?: string | null, sessionExpiry?: any | null } };

export type VerifySmsOtpMutationVariables = Exact<{
  input: SmsVerifyOtpInput;
}>;


export type VerifySmsOtpMutation = { __typename?: 'Mutation', verifySmsOtp: boolean };

export type ResendSmsOtpMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendSmsOtpMutation = { __typename?: 'Mutation', resendSmsOtp: { __typename?: 'SmsOptInResponse', success: boolean, message?: string | null, sessionExpiry?: any | null } };

export type DisableSmsNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableSmsNotificationsMutation = { __typename?: 'Mutation', disableSmsNotifications: boolean };

export type GetStripePricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripePricesQuery = { __typename?: 'Query', stripePrices: Array<{ __typename?: 'StripePrice', id: string, name: string, currency: string, unitAmount: number, interval?: string | null, intervalCount?: number | null, active: boolean, lookup_key?: string | null }> };

export type GetTaxQueryVariables = Exact<{
  priceID: Scalars['String']['input'];
  input: TaxInput;
}>;


export type GetTaxQuery = { __typename?: 'Query', computeTax?: { __typename?: 'TaxCalculationResponse', taxAmount: number, totalAmount: number, taxPercentage?: any | null } | null };

export type ValidateCouponQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ValidateCouponQuery = { __typename?: 'Query', validateCoupon: { __typename?: 'CouponValidationResult', valid: boolean, discount?: string | null, duration_in_months?: number | null, error?: string | null } };

export type NewSubscriptionMutationVariables = Exact<{
  paymentMethodID: Scalars['String']['input'];
  input: PaymentIntentInput;
}>;


export type NewSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'SubscriptionResponse', id?: string | null, customerID?: string | null, currentPeriodEnd?: number | null, status?: string | null, success: boolean, message: string } };

export type CreateFinancialConnectionSessionMutationVariables = Exact<{
  input: PaymentIntentInput;
}>;


export type CreateFinancialConnectionSessionMutation = { __typename?: 'Mutation', createFinancialConnectionsSession: { __typename?: 'FinancialConnectionSessionResponse', clientSecret: string, customerID: string } };

export type NewAchSubscriptionMutationVariables = Exact<{
  customerID: Scalars['String']['input'];
  bankAccountID: Scalars['String']['input'];
  input: PaymentIntentInput;
}>;


export type NewAchSubscriptionMutation = { __typename?: 'Mutation', createACHSubscription: { __typename?: 'SubscriptionResponse', id?: string | null, customerID?: string | null, currentPeriodEnd?: number | null, status?: string | null, success: boolean, message: string } };

export type UpgradeSubscriptionQueryVariables = Exact<{
  priceID: Scalars['String']['input'];
  baseURL: Scalars['String']['input'];
}>;


export type UpgradeSubscriptionQuery = { __typename?: 'Query', upgradeToEnhancedListing: { __typename?: 'SubscriptionResponse', redirect_url?: string | null, id?: string | null, customerID?: string | null, success: boolean, message: string } };

export type AccountUpgradeMutationVariables = Exact<{
  paymentMethodID: Scalars['String']['input'];
  input: PaymentIntentInput;
}>;


export type AccountUpgradeMutation = { __typename?: 'Mutation', upgradeToProfessional: { __typename?: 'SubscriptionResponse', id?: string | null, customerID?: string | null, currentPeriodEnd?: number | null, status?: string | null, success: boolean, message: string } };

export type AccountUpgradeWithAchMutationVariables = Exact<{
  customerID: Scalars['String']['input'];
  bankAccountID: Scalars['String']['input'];
  input: PaymentIntentInput;
}>;


export type AccountUpgradeWithAchMutation = { __typename?: 'Mutation', createACHSubscription: { __typename?: 'SubscriptionResponse', id?: string | null, customerID?: string | null, currentPeriodEnd?: number | null, status?: string | null, success: boolean, message: string } };

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'SubscriptionResponse', id?: string | null, customerID?: string | null, currentPeriodEnd?: number | null, status?: string | null, success: boolean, message: string } };

export type CurrentPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentPaymentMethodQuery = { __typename?: 'Query', currentPaymentMethod?: { __typename?: 'PaymentMethodInfo', brand?: string | null, last4?: string | null, expMonth?: number | null, expYear?: number | null } | null };

export type UpdatePaymentMethodMutationVariables = Exact<{
  paymentMethodID: Scalars['String']['input'];
}>;


export type UpdatePaymentMethodMutation = { __typename?: 'Mutation', updatePaymentMethod: { __typename?: 'SubscriptionResponse', success: boolean, message: string, id?: string | null } };

export type UpdateUserSubscriptionMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  currentPeriodEnd?: InputMaybe<Scalars['Time']['input']>;
}>;


export type UpdateUserSubscriptionMutation = { __typename?: 'Mutation', updateUserSubscription: { __typename?: 'UserSubscription', subscription_id: number, user_id: number, status: StatusEnum, current_period_end: any, created_at?: any | null, updated_at?: any | null } };

export type GetSendGridTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSendGridTemplatesQuery = { __typename?: 'Query', getSendGridTemplates: Array<{ __typename?: 'SendGridTemplate', id: string, name: string, generation: string, updatedAt: string, versions: Array<{ __typename?: 'SendGridTemplateVersion', id: string, templateId: string, active: number, name: string, subject: string, updatedAt: string }> }> };

export type GetSendGridContactListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSendGridContactListsQuery = { __typename?: 'Query', getSendGridContactLists: Array<{ __typename?: 'SendGridContactList', id: string, name: string, contactCount: number }> };

export type GetSendGridContactsQueryVariables = Exact<{
  listId: Scalars['String']['input'];
}>;


export type GetSendGridContactsQuery = { __typename?: 'Query', getSendGridContacts: Array<{ __typename?: 'SendGridContact', id: string, email: string, firstName?: string | null, lastName?: string | null }> };

export type GetSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurveysQuery = { __typename?: 'Query', getSurveys: Array<{ __typename?: 'Survey', id: string, title: string, intro: string, type: SurveyType, status: SurveyStatus, sendgridTemplateId?: string | null, ctaLabel: string, successHeading: string, successBody: string, successCtaLabel: string, successCtaUrl: string, createdAt: any, createdBy: number, tokensSent: number, responses: number, completions: number, lastResponse?: any | null, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string, type: QuestionType, required: boolean, options?: Array<{ __typename?: 'SurveyOption', label: string, emoji?: string | null, subtext?: string | null, is_freetext?: boolean | null }> | null }> }> };

export type UpdateSurveyStatusMutationVariables = Exact<{
  input: UpdateSurveyStatusInput;
}>;


export type UpdateSurveyStatusMutation = { __typename?: 'Mutation', updateSurveyStatus: { __typename?: 'Survey', id: string, status: SurveyStatus } };

export type DeleteSurveyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSurveyMutation = { __typename?: 'Mutation', deleteSurvey: boolean };

export type GetSurveyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSurveyQuery = { __typename?: 'Query', getSurvey?: { __typename?: 'Survey', id: string, title: string, intro: string, type: SurveyType, sendgridTemplateId?: string | null, ctaLabel: string, successHeading: string, successBody: string, successCtaLabel: string, successCtaUrl: string, createdAt: any, createdBy: number, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string, type: QuestionType, required: boolean, options?: Array<{ __typename?: 'SurveyOption', label: string, emoji?: string | null, subtext?: string | null, is_freetext?: boolean | null }> | null }> } | null };

export type CreateSurveyMutationVariables = Exact<{
  input: CreateSurveyInput;
}>;


export type CreateSurveyMutation = { __typename?: 'Mutation', createSurvey: { __typename?: 'Survey', id: string, title: string, intro: string, type: SurveyType, sendgridTemplateId?: string | null, ctaLabel: string, successHeading: string, successBody: string, successCtaLabel: string, successCtaUrl: string, createdAt: any, createdBy: number, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string, type: QuestionType, required: boolean, options?: Array<{ __typename?: 'SurveyOption', label: string, emoji?: string | null, subtext?: string | null, is_freetext?: boolean | null }> | null }> } };

export type SendSurveyMutationVariables = Exact<{
  input: SendSurveyInput;
}>;


export type SendSurveyMutation = { __typename?: 'Mutation', sendSurvey: { __typename?: 'SendSurveyResponse', success: boolean, message: string, tokensSent: number } };

export type ExportSurveyResponsesCsvQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type ExportSurveyResponsesCsvQuery = { __typename?: 'Query', exportSurveyResponsesCSV: string };

export type UpdateSurveyMutationVariables = Exact<{
  input: UpdateSurveyInput;
}>;


export type UpdateSurveyMutation = { __typename?: 'Mutation', updateSurvey: { __typename?: 'Survey', id: string, title: string, intro: string, type: SurveyType, sendgridTemplateId?: string | null, ctaLabel: string, successHeading: string, successBody: string, successCtaLabel: string, successCtaUrl: string, createdAt: any, createdBy: number, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string, type: QuestionType, required: boolean, options?: Array<{ __typename?: 'SurveyOption', label: string, emoji?: string | null, subtext?: string | null, is_freetext?: boolean | null }> | null }> } };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename?: 'Query', myProfile: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, username?: string | null, email_address?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, date_last_login?: any | null, zipcode?: string | null, user_bio?: string | null, date_pro_user?: any | null, phone_number?: string | null, phone_verified?: boolean | null, phone_verified_at?: any | null, sms_consent_captured_at?: any | null, user_type?: string | null, is_internal?: boolean | null, date_onboarding_completed?: any | null, state?: string | null, city?: string | null, country?: string | null, twitter_url?: string | null, youtube_url?: string | null, instagram_url?: string | null, facebook_url?: string | null, website?: string | null, slug?: string | null, stripe_customer_id?: string | null, subscription_status?: string | null, billing_interval?: string | null, current_period_end?: any | null, subscription_amount?: number | null, default_listing_id?: number | null, profile_image_completed?: boolean | null, bio_completed?: boolean | null, communication_completed?: boolean | null, location_completed?: boolean | null, profile_widget_dismissed?: boolean | null, producer_welcome_dismissed?: boolean | null, profile_widget_completed_at?: any | null, interests?: any | null, followers_count?: number | null, default_listing?: { __typename?: 'Listing', listing_id: number, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, publicEmail?: string | null, photo?: string | null, description?: string | null, membership_type?: string | null, enhanced?: boolean | null, verified?: boolean | null, address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, twitter?: string | null, instagram?: string | null, facebook?: string | null, website?: string | null, user_type?: string | null, slug?: string | null, phone?: string | null, tagLine?: string | null, publicPhone?: string | null, OperatingPeriod?: Array<{ __typename?: 'OperatingHours', operationId: number, day: string, openingTime: string, closingTime: string } | null> | null, Practices?: Array<{ __typename?: 'Practice', practice_id: number, tag?: string | null, name?: string | null, imgUrl?: string | null } | null> | null, subscription?: { __typename?: 'UserSubscription', status: StatusEnum } | null } | null, followers?: Array<{ __typename?: 'User', user_id: number } | null> | null, followings?: Array<{ __typename?: 'User', user_id: number } | null> | null, listings?: Array<{ __typename?: 'Listing', listing_id: number, user_type?: string | null, name?: string | null, city?: string | null, state?: string | null, slug?: string | null } | null> | null, userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, user_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null, notification_prefs?: { __typename?: 'NotificationPreference', id: number, userID: number, updateType: string, channel: string, isEnabled: boolean } | null } };

export type UserProfileQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UserProfileQuery = { __typename?: 'Query', userProfile: { __typename?: 'User', user_id: number, profile_photo_resource?: string | null, username?: string | null, email_address?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, date_last_login?: any | null, zipcode?: string | null, user_bio?: string | null, date_pro_user?: any | null, phone_number?: string | null, user_type?: string | null, date_onboarding_completed?: any | null, state?: string | null, city?: string | null, country?: string | null, twitter_url?: string | null, youtube_url?: string | null, instagram_url?: string | null, facebook_url?: string | null, website?: string | null, slug?: string | null, stripe_customer_id?: string | null, subscription_status?: string | null, billing_interval?: string | null, current_period_end?: any | null, subscription_amount?: number | null, default_listing_id?: number | null, profile_image_completed?: boolean | null, bio_completed?: boolean | null, communication_completed?: boolean | null, location_completed?: boolean | null, followers_count?: number | null, default_listing?: { __typename?: 'Listing', listing_id: number, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, publicEmail?: string | null, photo?: string | null, description?: string | null, membership_type?: string | null, enhanced?: boolean | null, verified?: boolean | null, address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, twitter?: string | null, instagram?: string | null, facebook?: string | null, website?: string | null, user_type?: string | null, slug?: string | null, phone?: string | null, tagLine?: string | null, publicPhone?: string | null, OperatingPeriod?: Array<{ __typename?: 'OperatingHours', operationId: number, day: string, openingTime: string, closingTime: string } | null> | null, Practices?: Array<{ __typename?: 'Practice', practice_id: number, tag?: string | null, name?: string | null, imgUrl?: string | null } | null> | null, subscription?: { __typename?: 'UserSubscription', status: StatusEnum } | null } | null, followers?: Array<{ __typename?: 'User', user_id: number } | null> | null, followings?: Array<{ __typename?: 'User', user_id: number } | null> | null, listings?: Array<{ __typename?: 'Listing', listing_id: number, user_type?: string | null, name?: string | null, city?: string | null, state?: string | null, slug?: string | null } | null> | null, userRoles?: Array<{ __typename?: 'UserRole', id: number, role_id: number, user_id: number, default?: boolean | null, role?: { __typename?: 'Role', name: string, role_id: number } | null }> | null } };

export type UpdateProfileMutationVariables = Exact<{
  userID: Scalars['Int']['input'];
  input: UserInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'UserResponse', user_id?: number | null, profile_photo_resource?: string | null, username?: string | null, email_address?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_bio?: string | null, slug?: string | null, profile_image_completed?: boolean | null, bio_completed?: boolean | null, communication_completed?: boolean | null, location_completed?: boolean | null, interests?: any | null, date_onboarding_completed?: any | null } };

export type UpdateUserAvatarMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  userID: Scalars['Int']['input'];
}>;


export type UpdateUserAvatarMutation = { __typename?: 'Mutation', updateUserAvatar: { __typename?: 'UserImage', record_id: number, date_updated?: any | null, img_path?: string | null } };

export type DeleteUserAccountMutationVariables = Exact<{
  userID: Scalars['Int']['input'];
}>;


export type DeleteUserAccountMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type UserExistQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserExistQuery = { __typename?: 'Query', userExist: { __typename?: 'User', email_address?: string | null, user_id: number, user_type?: string | null, default_listing_id?: number | null, default_listing?: { __typename?: 'Listing', membership_type?: string | null, enhanced?: boolean | null, verified?: boolean | null, approved?: boolean | null } | null } };

export type GetNotificationPreferencesQueryVariables = Exact<{
  userID: Scalars['Int']['input'];
}>;


export type GetNotificationPreferencesQuery = { __typename?: 'Query', getNotificationPreferences: Array<{ __typename?: 'NotificationPreference', updateType: string, channel: string, isEnabled: boolean }> };

export type UpsertNotificationPreferencesMutationVariables = Exact<{
  input: Array<NotificationPreferenceInput> | NotificationPreferenceInput;
}>;


export type UpsertNotificationPreferencesMutation = { __typename?: 'Mutation', upsertNotificationPreferences: boolean };


export const GetDashboardStatsDocument = gql`
    query GetDashboardStats {
  getDashboardStats {
    revenue
    products
    pending_approval
    recipes
    cookbook
    userStats
    listingStats
    ond_listings {
      listing_id
      name
      photo
      date_created
      slug
      user {
        full_name
      }
    }
    ond_products {
      ingredient_id
      name
      illustrationImage
      mainImage
      date_created
      slug
    }
  }
}
    `;

/**
 * __useGetDashboardStatsQuery__
 *
 * To run a query within a React component, call `useGetDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>(GetDashboardStatsDocument, options);
      }
export function useGetDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>(GetDashboardStatsDocument, options);
        }
export function useGetDashboardStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>(GetDashboardStatsDocument, options);
        }
export type GetDashboardStatsQueryHookResult = ReturnType<typeof useGetDashboardStatsQuery>;
export type GetDashboardStatsLazyQueryHookResult = ReturnType<typeof useGetDashboardStatsLazyQuery>;
export type GetDashboardStatsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardStatsSuspenseQuery>;
export type GetDashboardStatsQueryResult = Apollo.QueryResult<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>;
export const GetPendingApprovalTimelineDocument = gql`
    query GetPendingApprovalTimeline {
  pendingApprovalTimeline {
    listing_id
    name
    photo
    date_updated
    pending
  }
}
    `;

/**
 * __useGetPendingApprovalTimelineQuery__
 *
 * To run a query within a React component, call `useGetPendingApprovalTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingApprovalTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingApprovalTimelineQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingApprovalTimelineQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingApprovalTimelineQuery, GetPendingApprovalTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingApprovalTimelineQuery, GetPendingApprovalTimelineQueryVariables>(GetPendingApprovalTimelineDocument, options);
      }
export function useGetPendingApprovalTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingApprovalTimelineQuery, GetPendingApprovalTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingApprovalTimelineQuery, GetPendingApprovalTimelineQueryVariables>(GetPendingApprovalTimelineDocument, options);
        }
export function useGetPendingApprovalTimelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingApprovalTimelineQuery, GetPendingApprovalTimelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingApprovalTimelineQuery, GetPendingApprovalTimelineQueryVariables>(GetPendingApprovalTimelineDocument, options);
        }
export type GetPendingApprovalTimelineQueryHookResult = ReturnType<typeof useGetPendingApprovalTimelineQuery>;
export type GetPendingApprovalTimelineLazyQueryHookResult = ReturnType<typeof useGetPendingApprovalTimelineLazyQuery>;
export type GetPendingApprovalTimelineSuspenseQueryHookResult = ReturnType<typeof useGetPendingApprovalTimelineSuspenseQuery>;
export type GetPendingApprovalTimelineQueryResult = Apollo.QueryResult<GetPendingApprovalTimelineQuery, GetPendingApprovalTimelineQueryVariables>;
export const GetPendingApprovalDocument = gql`
    subscription GetPendingApproval($userId: Int!) {
  pendingApproval(user_id: $userId) {
    listing_id
    name
    photo
    date_updated
    pending
  }
}
    `;

/**
 * __useGetPendingApprovalSubscription__
 *
 * To run a query within a React component, call `useGetPendingApprovalSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingApprovalSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingApprovalSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPendingApprovalSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPendingApprovalSubscription, GetPendingApprovalSubscriptionVariables> & ({ variables: GetPendingApprovalSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPendingApprovalSubscription, GetPendingApprovalSubscriptionVariables>(GetPendingApprovalDocument, options);
      }
export type GetPendingApprovalSubscriptionHookResult = ReturnType<typeof useGetPendingApprovalSubscription>;
export type GetPendingApprovalSubscriptionResult = Apollo.SubscriptionResult<GetPendingApprovalSubscription>;
export const GetProducerSegmentCountsDocument = gql`
    query GetProducerSegmentCounts {
  getProducerSegmentCounts {
    never_logged_in
    logged_in_no_products
    products_no_posts
    posting_not_sharing
    posting_and_sharing
    updated_at
  }
}
    `;

/**
 * __useGetProducerSegmentCountsQuery__
 *
 * To run a query within a React component, call `useGetProducerSegmentCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProducerSegmentCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProducerSegmentCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProducerSegmentCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetProducerSegmentCountsQuery, GetProducerSegmentCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProducerSegmentCountsQuery, GetProducerSegmentCountsQueryVariables>(GetProducerSegmentCountsDocument, options);
      }
export function useGetProducerSegmentCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProducerSegmentCountsQuery, GetProducerSegmentCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProducerSegmentCountsQuery, GetProducerSegmentCountsQueryVariables>(GetProducerSegmentCountsDocument, options);
        }
export function useGetProducerSegmentCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProducerSegmentCountsQuery, GetProducerSegmentCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProducerSegmentCountsQuery, GetProducerSegmentCountsQueryVariables>(GetProducerSegmentCountsDocument, options);
        }
export type GetProducerSegmentCountsQueryHookResult = ReturnType<typeof useGetProducerSegmentCountsQuery>;
export type GetProducerSegmentCountsLazyQueryHookResult = ReturnType<typeof useGetProducerSegmentCountsLazyQuery>;
export type GetProducerSegmentCountsSuspenseQueryHookResult = ReturnType<typeof useGetProducerSegmentCountsSuspenseQuery>;
export type GetProducerSegmentCountsQueryResult = Apollo.QueryResult<GetProducerSegmentCountsQuery, GetProducerSegmentCountsQueryVariables>;
export const GetProducerSegmentDocument = gql`
    query GetProducerSegment($filters: [String!], $limit: Int, $offset: Int) {
  getProducerSegment(filters: $filters, limit: $limit, offset: $offset) {
    rows {
      user_id
      full_name
      email_address
      user_type
      date_created
      date_last_login
      listing_id
      listing_name
    }
    total
  }
}
    `;

/**
 * __useGetProducerSegmentQuery__
 *
 * To run a query within a React component, call `useGetProducerSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProducerSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProducerSegmentQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetProducerSegmentQuery(baseOptions?: Apollo.QueryHookOptions<GetProducerSegmentQuery, GetProducerSegmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProducerSegmentQuery, GetProducerSegmentQueryVariables>(GetProducerSegmentDocument, options);
      }
export function useGetProducerSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProducerSegmentQuery, GetProducerSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProducerSegmentQuery, GetProducerSegmentQueryVariables>(GetProducerSegmentDocument, options);
        }
export function useGetProducerSegmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProducerSegmentQuery, GetProducerSegmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProducerSegmentQuery, GetProducerSegmentQueryVariables>(GetProducerSegmentDocument, options);
        }
export type GetProducerSegmentQueryHookResult = ReturnType<typeof useGetProducerSegmentQuery>;
export type GetProducerSegmentLazyQueryHookResult = ReturnType<typeof useGetProducerSegmentLazyQuery>;
export type GetProducerSegmentSuspenseQueryHookResult = ReturnType<typeof useGetProducerSegmentSuspenseQuery>;
export type GetProducerSegmentQueryResult = Apollo.QueryResult<GetProducerSegmentQuery, GetProducerSegmentQueryVariables>;
export const GetTimeToValueStatsDocument = gql`
    query GetTimeToValueStats {
  getTimeToValueStats {
    median_days_login_to_product
    median_days_product_to_post
    median_days_post_to_follower
    median_days_follower_to_post2
  }
}
    `;

/**
 * __useGetTimeToValueStatsQuery__
 *
 * To run a query within a React component, call `useGetTimeToValueStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeToValueStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeToValueStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimeToValueStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetTimeToValueStatsQuery, GetTimeToValueStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeToValueStatsQuery, GetTimeToValueStatsQueryVariables>(GetTimeToValueStatsDocument, options);
      }
export function useGetTimeToValueStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeToValueStatsQuery, GetTimeToValueStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeToValueStatsQuery, GetTimeToValueStatsQueryVariables>(GetTimeToValueStatsDocument, options);
        }
export function useGetTimeToValueStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimeToValueStatsQuery, GetTimeToValueStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimeToValueStatsQuery, GetTimeToValueStatsQueryVariables>(GetTimeToValueStatsDocument, options);
        }
export type GetTimeToValueStatsQueryHookResult = ReturnType<typeof useGetTimeToValueStatsQuery>;
export type GetTimeToValueStatsLazyQueryHookResult = ReturnType<typeof useGetTimeToValueStatsLazyQuery>;
export type GetTimeToValueStatsSuspenseQueryHookResult = ReturnType<typeof useGetTimeToValueStatsSuspenseQuery>;
export type GetTimeToValueStatsQueryResult = Apollo.QueryResult<GetTimeToValueStatsQuery, GetTimeToValueStatsQueryVariables>;
export const GetAdminInvitationsDocument = gql`
    query GetAdminInvitations {
  getAdminInvitations {
    id
    email
    token
    invited_by_user_id
    status
    role
    created_at
    expires_at
    accepted_at
    accepted_by_user_id
    invited_by {
      user_id
      full_name
      first_name
      email_address
    }
    accepted_by {
      user_id
      full_name
      first_name
      email_address
    }
  }
}
    `;

/**
 * __useGetAdminInvitationsQuery__
 *
 * To run a query within a React component, call `useGetAdminInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminInvitationsQuery, GetAdminInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminInvitationsQuery, GetAdminInvitationsQueryVariables>(GetAdminInvitationsDocument, options);
      }
export function useGetAdminInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminInvitationsQuery, GetAdminInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminInvitationsQuery, GetAdminInvitationsQueryVariables>(GetAdminInvitationsDocument, options);
        }
export function useGetAdminInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminInvitationsQuery, GetAdminInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminInvitationsQuery, GetAdminInvitationsQueryVariables>(GetAdminInvitationsDocument, options);
        }
export type GetAdminInvitationsQueryHookResult = ReturnType<typeof useGetAdminInvitationsQuery>;
export type GetAdminInvitationsLazyQueryHookResult = ReturnType<typeof useGetAdminInvitationsLazyQuery>;
export type GetAdminInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetAdminInvitationsSuspenseQuery>;
export type GetAdminInvitationsQueryResult = Apollo.QueryResult<GetAdminInvitationsQuery, GetAdminInvitationsQueryVariables>;
export const GetAdminUsersDocument = gql`
    query GetAdminUsers {
  getAdminUsers {
    user_id
    full_name
    first_name
    last_name
    email_address
    user_type
    date_created
    date_last_login
    profile_photo_resource
    userRoles {
      id
      role_id
      default
      role {
        name
        role_id
      }
    }
  }
}
    `;

/**
 * __useGetAdminUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
      }
export function useGetAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export function useGetAdminUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export type GetAdminUsersQueryHookResult = ReturnType<typeof useGetAdminUsersQuery>;
export type GetAdminUsersLazyQueryHookResult = ReturnType<typeof useGetAdminUsersLazyQuery>;
export type GetAdminUsersSuspenseQueryHookResult = ReturnType<typeof useGetAdminUsersSuspenseQuery>;
export type GetAdminUsersQueryResult = Apollo.QueryResult<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const GetAdminInvitationByTokenDocument = gql`
    query GetAdminInvitationByToken($token: String!) {
  getAdminInvitationByToken(token: $token) {
    id
    email
    status
    expires_at
    is_expired
    invited_by_name
    user_exists
    first_name
    last_name
  }
}
    `;

/**
 * __useGetAdminInvitationByTokenQuery__
 *
 * To run a query within a React component, call `useGetAdminInvitationByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminInvitationByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminInvitationByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetAdminInvitationByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetAdminInvitationByTokenQuery, GetAdminInvitationByTokenQueryVariables> & ({ variables: GetAdminInvitationByTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminInvitationByTokenQuery, GetAdminInvitationByTokenQueryVariables>(GetAdminInvitationByTokenDocument, options);
      }
export function useGetAdminInvitationByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminInvitationByTokenQuery, GetAdminInvitationByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminInvitationByTokenQuery, GetAdminInvitationByTokenQueryVariables>(GetAdminInvitationByTokenDocument, options);
        }
export function useGetAdminInvitationByTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminInvitationByTokenQuery, GetAdminInvitationByTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminInvitationByTokenQuery, GetAdminInvitationByTokenQueryVariables>(GetAdminInvitationByTokenDocument, options);
        }
export type GetAdminInvitationByTokenQueryHookResult = ReturnType<typeof useGetAdminInvitationByTokenQuery>;
export type GetAdminInvitationByTokenLazyQueryHookResult = ReturnType<typeof useGetAdminInvitationByTokenLazyQuery>;
export type GetAdminInvitationByTokenSuspenseQueryHookResult = ReturnType<typeof useGetAdminInvitationByTokenSuspenseQuery>;
export type GetAdminInvitationByTokenQueryResult = Apollo.QueryResult<GetAdminInvitationByTokenQuery, GetAdminInvitationByTokenQueryVariables>;
export const InviteAdminDocument = gql`
    mutation InviteAdmin($email: String!) {
  inviteAdmin(email: $email) {
    id
    email
    token
    status
    role
    created_at
    expires_at
    invited_by {
      full_name
      first_name
    }
  }
}
    `;
export type InviteAdminMutationFn = Apollo.MutationFunction<InviteAdminMutation, InviteAdminMutationVariables>;

/**
 * __useInviteAdminMutation__
 *
 * To run a mutation, you first call `useInviteAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteAdminMutation, { data, loading, error }] = useInviteAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInviteAdminMutation(baseOptions?: Apollo.MutationHookOptions<InviteAdminMutation, InviteAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteAdminMutation, InviteAdminMutationVariables>(InviteAdminDocument, options);
      }
export type InviteAdminMutationHookResult = ReturnType<typeof useInviteAdminMutation>;
export type InviteAdminMutationResult = Apollo.MutationResult<InviteAdminMutation>;
export type InviteAdminMutationOptions = Apollo.BaseMutationOptions<InviteAdminMutation, InviteAdminMutationVariables>;
export const ResendAdminInvitationDocument = gql`
    mutation ResendAdminInvitation($id: Int!) {
  resendAdminInvitation(id: $id) {
    id
    email
    token
    status
    expires_at
  }
}
    `;
export type ResendAdminInvitationMutationFn = Apollo.MutationFunction<ResendAdminInvitationMutation, ResendAdminInvitationMutationVariables>;

/**
 * __useResendAdminInvitationMutation__
 *
 * To run a mutation, you first call `useResendAdminInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendAdminInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendAdminInvitationMutation, { data, loading, error }] = useResendAdminInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendAdminInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendAdminInvitationMutation, ResendAdminInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendAdminInvitationMutation, ResendAdminInvitationMutationVariables>(ResendAdminInvitationDocument, options);
      }
export type ResendAdminInvitationMutationHookResult = ReturnType<typeof useResendAdminInvitationMutation>;
export type ResendAdminInvitationMutationResult = Apollo.MutationResult<ResendAdminInvitationMutation>;
export type ResendAdminInvitationMutationOptions = Apollo.BaseMutationOptions<ResendAdminInvitationMutation, ResendAdminInvitationMutationVariables>;
export const RevokeAdminInvitationDocument = gql`
    mutation RevokeAdminInvitation($id: Int!) {
  revokeAdminInvitation(id: $id)
}
    `;
export type RevokeAdminInvitationMutationFn = Apollo.MutationFunction<RevokeAdminInvitationMutation, RevokeAdminInvitationMutationVariables>;

/**
 * __useRevokeAdminInvitationMutation__
 *
 * To run a mutation, you first call `useRevokeAdminInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAdminInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAdminInvitationMutation, { data, loading, error }] = useRevokeAdminInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeAdminInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RevokeAdminInvitationMutation, RevokeAdminInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeAdminInvitationMutation, RevokeAdminInvitationMutationVariables>(RevokeAdminInvitationDocument, options);
      }
export type RevokeAdminInvitationMutationHookResult = ReturnType<typeof useRevokeAdminInvitationMutation>;
export type RevokeAdminInvitationMutationResult = Apollo.MutationResult<RevokeAdminInvitationMutation>;
export type RevokeAdminInvitationMutationOptions = Apollo.BaseMutationOptions<RevokeAdminInvitationMutation, RevokeAdminInvitationMutationVariables>;
export const AcceptAdminInvitationDocument = gql`
    mutation AcceptAdminInvitation($token: String!, $input: AcceptAdminInvitationInput) {
  acceptAdminInvitation(token: $token, input: $input) {
    token
    user {
      user_id
      full_name
      first_name
      last_name
      email_address
      slug
      user_type
      userRoles {
        id
        role_id
        default
        role {
          name
          role_id
        }
      }
      roles {
        name
        role_id
      }
    }
  }
}
    `;
export type AcceptAdminInvitationMutationFn = Apollo.MutationFunction<AcceptAdminInvitationMutation, AcceptAdminInvitationMutationVariables>;

/**
 * __useAcceptAdminInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptAdminInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAdminInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAdminInvitationMutation, { data, loading, error }] = useAcceptAdminInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptAdminInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptAdminInvitationMutation, AcceptAdminInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptAdminInvitationMutation, AcceptAdminInvitationMutationVariables>(AcceptAdminInvitationDocument, options);
      }
export type AcceptAdminInvitationMutationHookResult = ReturnType<typeof useAcceptAdminInvitationMutation>;
export type AcceptAdminInvitationMutationResult = Apollo.MutationResult<AcceptAdminInvitationMutation>;
export type AcceptAdminInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptAdminInvitationMutation, AcceptAdminInvitationMutationVariables>;
export const RemoveAdminDocument = gql`
    mutation RemoveAdmin($userId: Int!) {
  removeAdmin(userId: $userId)
}
    `;
export type RemoveAdminMutationFn = Apollo.MutationFunction<RemoveAdminMutation, RemoveAdminMutationVariables>;

/**
 * __useRemoveAdminMutation__
 *
 * To run a mutation, you first call `useRemoveAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminMutation, { data, loading, error }] = useRemoveAdminMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveAdminMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAdminMutation, RemoveAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAdminMutation, RemoveAdminMutationVariables>(RemoveAdminDocument, options);
      }
export type RemoveAdminMutationHookResult = ReturnType<typeof useRemoveAdminMutation>;
export type RemoveAdminMutationResult = Apollo.MutationResult<RemoveAdminMutation>;
export type RemoveAdminMutationOptions = Apollo.BaseMutationOptions<RemoveAdminMutation, RemoveAdminMutationVariables>;
export const LoginDocument = gql`
    mutation login($email_address: String!, $password_hash: String!) {
  login(email_address: $email_address, password_hash: $password_hash) {
    token
    user {
      user_id
      profile_photo_resource
      username
      email_address
      first_name
      last_name
      full_name
      zipcode
      user_bio
      user_type
      is_internal
      referral_code
      slug
      default_listing_id
      stripe_customer_id
      subscription_status
      billing_interval
      current_period_end
      subscription_amount
      default_listing {
        membership_type
        enhanced
        photo
        name
        latitude
        longitude
        slug
      }
      listings {
        listing_id
        membership_type
        user_type
        name
        city
        state
        firstName
        lastName
        slug
      }
      profile_image_completed
      bio_completed
      communication_completed
      location_completed
      profile_widget_dismissed
      producer_welcome_dismissed
      profile_widget_completed_at
      date_onboarding_completed
      userRoles {
        id
        role_id
        user_id
        default
        role {
          name
          role_id
        }
      }
      roles {
        name
        role_id
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email_address: // value for 'email_address'
 *      password_hash: // value for 'password_hash'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginAdminUserDocument = gql`
    mutation loginAdminUser($email: String!, $password: String!) {
  loginAdminUser(email: $email, password: $password) {
    email
    password
  }
}
    `;
export type LoginAdminUserMutationFn = Apollo.MutationFunction<LoginAdminUserMutation, LoginAdminUserMutationVariables>;

/**
 * __useLoginAdminUserMutation__
 *
 * To run a mutation, you first call `useLoginAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminUserMutation, { data, loading, error }] = useLoginAdminUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginAdminUserMutation, LoginAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAdminUserMutation, LoginAdminUserMutationVariables>(LoginAdminUserDocument, options);
      }
export type LoginAdminUserMutationHookResult = ReturnType<typeof useLoginAdminUserMutation>;
export type LoginAdminUserMutationResult = Apollo.MutationResult<LoginAdminUserMutation>;
export type LoginAdminUserMutationOptions = Apollo.BaseMutationOptions<LoginAdminUserMutation, LoginAdminUserMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: NewUser!) {
  register(input: $input) {
    user {
      user_id
      profile_photo_resource
      username
      email_address
      first_name
      last_name
      full_name
      zipcode
      user_bio
      user_type
      is_internal
      slug
      default_listing_id
      date_onboarding_completed
      default_listing {
        membership_type
        photo
        name
      }
      userRoles {
        id
        role_id
        user_id
        default
        role {
          name
          role_id
        }
      }
    }
    token
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const EmailTakenDocument = gql`
    mutation emailTaken($email_address: String!) {
  emailExist(email_address: $email_address)
}
    `;
export type EmailTakenMutationFn = Apollo.MutationFunction<EmailTakenMutation, EmailTakenMutationVariables>;

/**
 * __useEmailTakenMutation__
 *
 * To run a mutation, you first call `useEmailTakenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailTakenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailTakenMutation, { data, loading, error }] = useEmailTakenMutation({
 *   variables: {
 *      email_address: // value for 'email_address'
 *   },
 * });
 */
export function useEmailTakenMutation(baseOptions?: Apollo.MutationHookOptions<EmailTakenMutation, EmailTakenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailTakenMutation, EmailTakenMutationVariables>(EmailTakenDocument, options);
      }
export type EmailTakenMutationHookResult = ReturnType<typeof useEmailTakenMutation>;
export type EmailTakenMutationResult = Apollo.MutationResult<EmailTakenMutation>;
export type EmailTakenMutationOptions = Apollo.BaseMutationOptions<EmailTakenMutation, EmailTakenMutationVariables>;
export const ConfirmationCodeDocument = gql`
    mutation confirmationCode($email_address: String!, $fName: String) {
  sendEmailConfirmationCode(email_address: $email_address, fName: $fName) {
    success
    message
  }
}
    `;
export type ConfirmationCodeMutationFn = Apollo.MutationFunction<ConfirmationCodeMutation, ConfirmationCodeMutationVariables>;

/**
 * __useConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmationCodeMutation, { data, loading, error }] = useConfirmationCodeMutation({
 *   variables: {
 *      email_address: // value for 'email_address'
 *      fName: // value for 'fName'
 *   },
 * });
 */
export function useConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmationCodeMutation, ConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmationCodeMutation, ConfirmationCodeMutationVariables>(ConfirmationCodeDocument, options);
      }
export type ConfirmationCodeMutationHookResult = ReturnType<typeof useConfirmationCodeMutation>;
export type ConfirmationCodeMutationResult = Apollo.MutationResult<ConfirmationCodeMutation>;
export type ConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<ConfirmationCodeMutation, ConfirmationCodeMutationVariables>;
export const ConfirmEmailDocument = gql`
    mutation confirmEmail($email_address: String!, $code: String!) {
  confirmEmail(email_address: $email_address, code: $code)
}
    `;
export type ConfirmEmailMutationFn = Apollo.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>;

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailMutation, { data, loading, error }] = useConfirmEmailMutation({
 *   variables: {
 *      email_address: // value for 'email_address'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfirmEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, options);
      }
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>;
export type ConfirmEmailMutationResult = Apollo.MutationResult<ConfirmEmailMutation>;
export type ConfirmEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email_address: String!) {
  forgotPassword(email_address: $email_address) {
    success
    message
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email_address: // value for 'email_address'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: passwordResetInput!) {
  resetPassword(input: $input) {
    success
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SwitchUserRoleDocument = gql`
    mutation SwitchUserRole($roleId: Int!, $userId: Int!) {
  switchUserRole(roleId: $roleId, userId: $userId) {
    userRoles {
      id
      role_id
      user_id
      default
      role {
        name
        role_id
      }
    }
  }
}
    `;
export type SwitchUserRoleMutationFn = Apollo.MutationFunction<SwitchUserRoleMutation, SwitchUserRoleMutationVariables>;

/**
 * __useSwitchUserRoleMutation__
 *
 * To run a mutation, you first call `useSwitchUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchUserRoleMutation, { data, loading, error }] = useSwitchUserRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSwitchUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<SwitchUserRoleMutation, SwitchUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchUserRoleMutation, SwitchUserRoleMutationVariables>(SwitchUserRoleDocument, options);
      }
export type SwitchUserRoleMutationHookResult = ReturnType<typeof useSwitchUserRoleMutation>;
export type SwitchUserRoleMutationResult = Apollo.MutationResult<SwitchUserRoleMutation>;
export type SwitchUserRoleMutationOptions = Apollo.BaseMutationOptions<SwitchUserRoleMutation, SwitchUserRoleMutationVariables>;
export const SocialLoginDocument = gql`
    mutation socialLogin($provider: String!, $token: String!, $email: String!, $firstName: String, $lastName: String, $profilePhoto: String) {
  socialLogin(
    provider: $provider
    token: $token
    email: $email
    firstName: $firstName
    lastName: $lastName
    profilePhoto: $profilePhoto
  ) {
    token
    user {
      user_id
      profile_photo_resource
      username
      email_address
      first_name
      last_name
      full_name
      zipcode
      user_bio
      user_type
      is_internal
      referral_code
      slug
      default_listing_id
      stripe_customer_id
      subscription_status
      billing_interval
      current_period_end
      subscription_amount
      default_listing {
        membership_type
        enhanced
        photo
        name
        latitude
        longitude
        slug
      }
      listings {
        listing_id
        membership_type
        user_type
        name
        city
        state
        firstName
        lastName
        slug
      }
      profile_image_completed
      bio_completed
      communication_completed
      location_completed
      profile_widget_dismissed
      producer_welcome_dismissed
      profile_widget_completed_at
      date_onboarding_completed
      date_created
      userRoles {
        id
        role_id
        user_id
        default
        role {
          name
          role_id
        }
      }
      roles {
        name
        role_id
      }
    }
  }
}
    `;
export type SocialLoginMutationFn = Apollo.MutationFunction<SocialLoginMutation, SocialLoginMutationVariables>;

/**
 * __useSocialLoginMutation__
 *
 * To run a mutation, you first call `useSocialLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialLoginMutation, { data, loading, error }] = useSocialLoginMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      token: // value for 'token'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      profilePhoto: // value for 'profilePhoto'
 *   },
 * });
 */
export function useSocialLoginMutation(baseOptions?: Apollo.MutationHookOptions<SocialLoginMutation, SocialLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialLoginMutation, SocialLoginMutationVariables>(SocialLoginDocument, options);
      }
export type SocialLoginMutationHookResult = ReturnType<typeof useSocialLoginMutation>;
export type SocialLoginMutationResult = Apollo.MutationResult<SocialLoginMutation>;
export type SocialLoginMutationOptions = Apollo.BaseMutationOptions<SocialLoginMutation, SocialLoginMutationVariables>;
export const RequestSignInLinkDocument = gql`
    mutation requestSignInLink($email_address: String!) {
  requestSignInLink(email_address: $email_address) {
    success
    message
  }
}
    `;
export type RequestSignInLinkMutationFn = Apollo.MutationFunction<RequestSignInLinkMutation, RequestSignInLinkMutationVariables>;

/**
 * __useRequestSignInLinkMutation__
 *
 * To run a mutation, you first call `useRequestSignInLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSignInLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSignInLinkMutation, { data, loading, error }] = useRequestSignInLinkMutation({
 *   variables: {
 *      email_address: // value for 'email_address'
 *   },
 * });
 */
export function useRequestSignInLinkMutation(baseOptions?: Apollo.MutationHookOptions<RequestSignInLinkMutation, RequestSignInLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSignInLinkMutation, RequestSignInLinkMutationVariables>(RequestSignInLinkDocument, options);
      }
export type RequestSignInLinkMutationHookResult = ReturnType<typeof useRequestSignInLinkMutation>;
export type RequestSignInLinkMutationResult = Apollo.MutationResult<RequestSignInLinkMutation>;
export type RequestSignInLinkMutationOptions = Apollo.BaseMutationOptions<RequestSignInLinkMutation, RequestSignInLinkMutationVariables>;
export const SignInWithLinkDocument = gql`
    mutation signInWithLink($email_address: String!, $token: String!) {
  signInWithLink(email_address: $email_address, token: $token) {
    token
    user {
      user_id
      profile_photo_resource
      username
      email_address
      first_name
      last_name
      full_name
      zipcode
      user_bio
      user_type
      is_internal
      referral_code
      slug
      default_listing_id
      stripe_customer_id
      subscription_status
      billing_interval
      current_period_end
      subscription_amount
      default_listing {
        membership_type
        enhanced
        photo
        name
        latitude
        longitude
        slug
      }
      listings {
        listing_id
        membership_type
        user_type
        name
        city
        state
        firstName
        lastName
        slug
      }
      profile_image_completed
      bio_completed
      communication_completed
      location_completed
      profile_widget_dismissed
      producer_welcome_dismissed
      profile_widget_completed_at
      date_onboarding_completed
      userRoles {
        id
        role_id
        user_id
        default
        role {
          name
          role_id
        }
      }
      roles {
        name
        role_id
      }
    }
  }
}
    `;
export type SignInWithLinkMutationFn = Apollo.MutationFunction<SignInWithLinkMutation, SignInWithLinkMutationVariables>;

/**
 * __useSignInWithLinkMutation__
 *
 * To run a mutation, you first call `useSignInWithLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithLinkMutation, { data, loading, error }] = useSignInWithLinkMutation({
 *   variables: {
 *      email_address: // value for 'email_address'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSignInWithLinkMutation(baseOptions?: Apollo.MutationHookOptions<SignInWithLinkMutation, SignInWithLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInWithLinkMutation, SignInWithLinkMutationVariables>(SignInWithLinkDocument, options);
      }
export type SignInWithLinkMutationHookResult = ReturnType<typeof useSignInWithLinkMutation>;
export type SignInWithLinkMutationResult = Apollo.MutationResult<SignInWithLinkMutation>;
export type SignInWithLinkMutationOptions = Apollo.BaseMutationOptions<SignInWithLinkMutation, SignInWithLinkMutationVariables>;
export const GetBannersDocument = gql`
    query GetBanners($limit: Int, $offset: Int) {
  getBanners(limit: $limit, offset: $offset) {
    record_id
    img_url
    img_path
    active
    mainlink
    memberlink
    description
  }
}
    `;

/**
 * __useGetBannersQuery__
 *
 * To run a query within a React component, call `useGetBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetBannersQuery(baseOptions?: Apollo.QueryHookOptions<GetBannersQuery, GetBannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannersQuery, GetBannersQueryVariables>(GetBannersDocument, options);
      }
export function useGetBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannersQuery, GetBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannersQuery, GetBannersQueryVariables>(GetBannersDocument, options);
        }
export function useGetBannersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBannersQuery, GetBannersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBannersQuery, GetBannersQueryVariables>(GetBannersDocument, options);
        }
export type GetBannersQueryHookResult = ReturnType<typeof useGetBannersQuery>;
export type GetBannersLazyQueryHookResult = ReturnType<typeof useGetBannersLazyQuery>;
export type GetBannersSuspenseQueryHookResult = ReturnType<typeof useGetBannersSuspenseQuery>;
export type GetBannersQueryResult = Apollo.QueryResult<GetBannersQuery, GetBannersQueryVariables>;
export const GetBannerDocument = gql`
    query GetBanner {
  getBanner {
    record_id
    img_url
    img_path
    active
    mainlink
    memberlink
    description
  }
}
    `;

/**
 * __useGetBannerQuery__
 *
 * To run a query within a React component, call `useGetBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBannerQuery(baseOptions?: Apollo.QueryHookOptions<GetBannerQuery, GetBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannerQuery, GetBannerQueryVariables>(GetBannerDocument, options);
      }
export function useGetBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannerQuery, GetBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannerQuery, GetBannerQueryVariables>(GetBannerDocument, options);
        }
export function useGetBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBannerQuery, GetBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBannerQuery, GetBannerQueryVariables>(GetBannerDocument, options);
        }
export type GetBannerQueryHookResult = ReturnType<typeof useGetBannerQuery>;
export type GetBannerLazyQueryHookResult = ReturnType<typeof useGetBannerLazyQuery>;
export type GetBannerSuspenseQueryHookResult = ReturnType<typeof useGetBannerSuspenseQuery>;
export type GetBannerQueryResult = Apollo.QueryResult<GetBannerQuery, GetBannerQueryVariables>;
export const CreateBannerImgDocument = gql`
    mutation CreateBannerImg($file: Upload!, $input: BannerImageInput!) {
  createBannerImg(file: $file, input: $input) {
    record_id
    img_url
    img_path
    description
    mainlink
    memberlink
    date_created
    active
  }
}
    `;
export type CreateBannerImgMutationFn = Apollo.MutationFunction<CreateBannerImgMutation, CreateBannerImgMutationVariables>;

/**
 * __useCreateBannerImgMutation__
 *
 * To run a mutation, you first call `useCreateBannerImgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBannerImgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBannerImgMutation, { data, loading, error }] = useCreateBannerImgMutation({
 *   variables: {
 *      file: // value for 'file'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBannerImgMutation(baseOptions?: Apollo.MutationHookOptions<CreateBannerImgMutation, CreateBannerImgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBannerImgMutation, CreateBannerImgMutationVariables>(CreateBannerImgDocument, options);
      }
export type CreateBannerImgMutationHookResult = ReturnType<typeof useCreateBannerImgMutation>;
export type CreateBannerImgMutationResult = Apollo.MutationResult<CreateBannerImgMutation>;
export type CreateBannerImgMutationOptions = Apollo.BaseMutationOptions<CreateBannerImgMutation, CreateBannerImgMutationVariables>;
export const UpdateBannerDetailDocument = gql`
    mutation UpdateBannerDetail($id: Int!, $input: BannerImageInput!, $file: Upload!) {
  updateBannerDetail(id: $id, input: $input, file: $file) {
    record_id
    img_url
    img_path
    description
    mainlink
    memberlink
    date_created
    active
  }
}
    `;
export type UpdateBannerDetailMutationFn = Apollo.MutationFunction<UpdateBannerDetailMutation, UpdateBannerDetailMutationVariables>;

/**
 * __useUpdateBannerDetailMutation__
 *
 * To run a mutation, you first call `useUpdateBannerDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBannerDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBannerDetailMutation, { data, loading, error }] = useUpdateBannerDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateBannerDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBannerDetailMutation, UpdateBannerDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBannerDetailMutation, UpdateBannerDetailMutationVariables>(UpdateBannerDetailDocument, options);
      }
export type UpdateBannerDetailMutationHookResult = ReturnType<typeof useUpdateBannerDetailMutation>;
export type UpdateBannerDetailMutationResult = Apollo.MutationResult<UpdateBannerDetailMutation>;
export type UpdateBannerDetailMutationOptions = Apollo.BaseMutationOptions<UpdateBannerDetailMutation, UpdateBannerDetailMutationVariables>;
export const SwitchBannerStateDocument = gql`
    mutation switchBannerState($id: Int!, $state: Boolean!) {
  switchBannerState(bannerId: $id, state: $state)
}
    `;
export type SwitchBannerStateMutationFn = Apollo.MutationFunction<SwitchBannerStateMutation, SwitchBannerStateMutationVariables>;

/**
 * __useSwitchBannerStateMutation__
 *
 * To run a mutation, you first call `useSwitchBannerStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchBannerStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchBannerStateMutation, { data, loading, error }] = useSwitchBannerStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSwitchBannerStateMutation(baseOptions?: Apollo.MutationHookOptions<SwitchBannerStateMutation, SwitchBannerStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchBannerStateMutation, SwitchBannerStateMutationVariables>(SwitchBannerStateDocument, options);
      }
export type SwitchBannerStateMutationHookResult = ReturnType<typeof useSwitchBannerStateMutation>;
export type SwitchBannerStateMutationResult = Apollo.MutationResult<SwitchBannerStateMutation>;
export type SwitchBannerStateMutationOptions = Apollo.BaseMutationOptions<SwitchBannerStateMutation, SwitchBannerStateMutationVariables>;
export const DeleteBannerImgDocument = gql`
    mutation DeleteBannerImg($bannerId: Int!) {
  deleteBanner(bannerId: $bannerId)
}
    `;
export type DeleteBannerImgMutationFn = Apollo.MutationFunction<DeleteBannerImgMutation, DeleteBannerImgMutationVariables>;

/**
 * __useDeleteBannerImgMutation__
 *
 * To run a mutation, you first call `useDeleteBannerImgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBannerImgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBannerImgMutation, { data, loading, error }] = useDeleteBannerImgMutation({
 *   variables: {
 *      bannerId: // value for 'bannerId'
 *   },
 * });
 */
export function useDeleteBannerImgMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBannerImgMutation, DeleteBannerImgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBannerImgMutation, DeleteBannerImgMutationVariables>(DeleteBannerImgDocument, options);
      }
export type DeleteBannerImgMutationHookResult = ReturnType<typeof useDeleteBannerImgMutation>;
export type DeleteBannerImgMutationResult = Apollo.MutationResult<DeleteBannerImgMutation>;
export type DeleteBannerImgMutationOptions = Apollo.BaseMutationOptions<DeleteBannerImgMutation, DeleteBannerImgMutationVariables>;
export const AddBookmarkDocument = gql`
    mutation AddBookmark($recipe_id: Int!) {
  addBookmark(recipe_id: $recipe_id)
}
    `;
export type AddBookmarkMutationFn = Apollo.MutationFunction<AddBookmarkMutation, AddBookmarkMutationVariables>;

/**
 * __useAddBookmarkMutation__
 *
 * To run a mutation, you first call `useAddBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBookmarkMutation, { data, loading, error }] = useAddBookmarkMutation({
 *   variables: {
 *      recipe_id: // value for 'recipe_id'
 *   },
 * });
 */
export function useAddBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<AddBookmarkMutation, AddBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBookmarkMutation, AddBookmarkMutationVariables>(AddBookmarkDocument, options);
      }
export type AddBookmarkMutationHookResult = ReturnType<typeof useAddBookmarkMutation>;
export type AddBookmarkMutationResult = Apollo.MutationResult<AddBookmarkMutation>;
export type AddBookmarkMutationOptions = Apollo.BaseMutationOptions<AddBookmarkMutation, AddBookmarkMutationVariables>;
export const RemoveBookmarkDocument = gql`
    mutation RemoveBookmark($recipe_id: Int!) {
  removeBookmark(recipe_id: $recipe_id)
}
    `;
export type RemoveBookmarkMutationFn = Apollo.MutationFunction<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;

/**
 * __useRemoveBookmarkMutation__
 *
 * To run a mutation, you first call `useRemoveBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookmarkMutation, { data, loading, error }] = useRemoveBookmarkMutation({
 *   variables: {
 *      recipe_id: // value for 'recipe_id'
 *   },
 * });
 */
export function useRemoveBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>(RemoveBookmarkDocument, options);
      }
export type RemoveBookmarkMutationHookResult = ReturnType<typeof useRemoveBookmarkMutation>;
export type RemoveBookmarkMutationResult = Apollo.MutationResult<RemoveBookmarkMutation>;
export type RemoveBookmarkMutationOptions = Apollo.BaseMutationOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;
export const GetMyBookmarkedRecipeIdsDocument = gql`
    query GetMyBookmarkedRecipeIds {
  myBookmarkedRecipeIds
}
    `;

/**
 * __useGetMyBookmarkedRecipeIdsQuery__
 *
 * To run a query within a React component, call `useGetMyBookmarkedRecipeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBookmarkedRecipeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBookmarkedRecipeIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyBookmarkedRecipeIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyBookmarkedRecipeIdsQuery, GetMyBookmarkedRecipeIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyBookmarkedRecipeIdsQuery, GetMyBookmarkedRecipeIdsQueryVariables>(GetMyBookmarkedRecipeIdsDocument, options);
      }
export function useGetMyBookmarkedRecipeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyBookmarkedRecipeIdsQuery, GetMyBookmarkedRecipeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyBookmarkedRecipeIdsQuery, GetMyBookmarkedRecipeIdsQueryVariables>(GetMyBookmarkedRecipeIdsDocument, options);
        }
export function useGetMyBookmarkedRecipeIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyBookmarkedRecipeIdsQuery, GetMyBookmarkedRecipeIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyBookmarkedRecipeIdsQuery, GetMyBookmarkedRecipeIdsQueryVariables>(GetMyBookmarkedRecipeIdsDocument, options);
        }
export type GetMyBookmarkedRecipeIdsQueryHookResult = ReturnType<typeof useGetMyBookmarkedRecipeIdsQuery>;
export type GetMyBookmarkedRecipeIdsLazyQueryHookResult = ReturnType<typeof useGetMyBookmarkedRecipeIdsLazyQuery>;
export type GetMyBookmarkedRecipeIdsSuspenseQueryHookResult = ReturnType<typeof useGetMyBookmarkedRecipeIdsSuspenseQuery>;
export type GetMyBookmarkedRecipeIdsQueryResult = Apollo.QueryResult<GetMyBookmarkedRecipeIdsQuery, GetMyBookmarkedRecipeIdsQueryVariables>;
export const GetMyBookmarksDocument = gql`
    query GetMyBookmarks($limit: Int, $page: Int) {
  myBookmarks(limit: $limit, page: $page) {
    recipes {
      recipe_id
      user_id
      slug
      resourcePath
      thumbnailPath
      recipe_img_url
      recipe_name
      average_recipe_rating
      cook_time
      preparation_time
      total_time
      is_featured
      recipe_comments {
        id
      }
      recipe_ingredients {
        record_id
        recipe_id
        ingredient_id
        unit_of_measurement_id
        whole_number
        sort_order
        numerator
        denominator
        measurement_amount
        raw_name
        ingredient {
          ingredient_id
          ingredient_name
        }
        unit_of_measurement {
          unit_of_measurement_id
          unit_abbreviation
          unit_name
        }
      }
      recipe_image {
        thumbnail_path
        resource_path
      }
      user {
        user_id
        profile_photo_resource
        full_name
        slug
        default_listing {
          listing_id
          photo
          resourcePath
        }
      }
    }
    total
  }
}
    `;

/**
 * __useGetMyBookmarksQuery__
 *
 * To run a query within a React component, call `useGetMyBookmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBookmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBookmarksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetMyBookmarksQuery(baseOptions?: Apollo.QueryHookOptions<GetMyBookmarksQuery, GetMyBookmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyBookmarksQuery, GetMyBookmarksQueryVariables>(GetMyBookmarksDocument, options);
      }
export function useGetMyBookmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyBookmarksQuery, GetMyBookmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyBookmarksQuery, GetMyBookmarksQueryVariables>(GetMyBookmarksDocument, options);
        }
export function useGetMyBookmarksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyBookmarksQuery, GetMyBookmarksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyBookmarksQuery, GetMyBookmarksQueryVariables>(GetMyBookmarksDocument, options);
        }
export type GetMyBookmarksQueryHookResult = ReturnType<typeof useGetMyBookmarksQuery>;
export type GetMyBookmarksLazyQueryHookResult = ReturnType<typeof useGetMyBookmarksLazyQuery>;
export type GetMyBookmarksSuspenseQueryHookResult = ReturnType<typeof useGetMyBookmarksSuspenseQuery>;
export type GetMyBookmarksQueryResult = Apollo.QueryResult<GetMyBookmarksQuery, GetMyBookmarksQueryVariables>;
export const MyCookbooksDocument = gql`
    query myCookbooks($user_id: Int!) {
  myCookbooks(user_id: $user_id) {
    cookbook_id
    user_id
    cookbook_name
    cookbook_img_url
    cookbook_description
    cookbook_contest_date_finished
    date_featured
    number_of_members
    latitude
    longitude
    location_city
    location_state
    location_country
    location_description
  }
}
    `;

/**
 * __useMyCookbooksQuery__
 *
 * To run a query within a React component, call `useMyCookbooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCookbooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCookbooksQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useMyCookbooksQuery(baseOptions: Apollo.QueryHookOptions<MyCookbooksQuery, MyCookbooksQueryVariables> & ({ variables: MyCookbooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCookbooksQuery, MyCookbooksQueryVariables>(MyCookbooksDocument, options);
      }
export function useMyCookbooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCookbooksQuery, MyCookbooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCookbooksQuery, MyCookbooksQueryVariables>(MyCookbooksDocument, options);
        }
export function useMyCookbooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyCookbooksQuery, MyCookbooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyCookbooksQuery, MyCookbooksQueryVariables>(MyCookbooksDocument, options);
        }
export type MyCookbooksQueryHookResult = ReturnType<typeof useMyCookbooksQuery>;
export type MyCookbooksLazyQueryHookResult = ReturnType<typeof useMyCookbooksLazyQuery>;
export type MyCookbooksSuspenseQueryHookResult = ReturnType<typeof useMyCookbooksSuspenseQuery>;
export type MyCookbooksQueryResult = Apollo.QueryResult<MyCookbooksQuery, MyCookbooksQueryVariables>;
export const CookbooksIFollowDocument = gql`
    query cookbooksIFollow($user_id: Int!) {
  cookbooksIFollow(user_id: $user_id) {
    cookbook_id
    user_id
    cookbook_name
    cookbook_img_url
    cookbook_description
    cookbook_contest_date_finished
    date_featured
    number_of_members
    latitude
    longitude
    location_city
    location_state
    location_country
    location_description
  }
}
    `;

/**
 * __useCookbooksIFollowQuery__
 *
 * To run a query within a React component, call `useCookbooksIFollowQuery` and pass it any options that fit your needs.
 * When your component renders, `useCookbooksIFollowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCookbooksIFollowQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useCookbooksIFollowQuery(baseOptions: Apollo.QueryHookOptions<CookbooksIFollowQuery, CookbooksIFollowQueryVariables> & ({ variables: CookbooksIFollowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CookbooksIFollowQuery, CookbooksIFollowQueryVariables>(CookbooksIFollowDocument, options);
      }
export function useCookbooksIFollowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CookbooksIFollowQuery, CookbooksIFollowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CookbooksIFollowQuery, CookbooksIFollowQueryVariables>(CookbooksIFollowDocument, options);
        }
export function useCookbooksIFollowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CookbooksIFollowQuery, CookbooksIFollowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CookbooksIFollowQuery, CookbooksIFollowQueryVariables>(CookbooksIFollowDocument, options);
        }
export type CookbooksIFollowQueryHookResult = ReturnType<typeof useCookbooksIFollowQuery>;
export type CookbooksIFollowLazyQueryHookResult = ReturnType<typeof useCookbooksIFollowLazyQuery>;
export type CookbooksIFollowSuspenseQueryHookResult = ReturnType<typeof useCookbooksIFollowSuspenseQuery>;
export type CookbooksIFollowQueryResult = Apollo.QueryResult<CookbooksIFollowQuery, CookbooksIFollowQueryVariables>;
export const FirstFourCookbooksDocument = gql`
    query FirstFourCookbooks($user_id: Int!) {
  FirstFourCookbooks(user_id: $user_id) {
    cookbook_id
    cookbook_name
    cookbook_img_url
  }
}
    `;

/**
 * __useFirstFourCookbooksQuery__
 *
 * To run a query within a React component, call `useFirstFourCookbooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirstFourCookbooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirstFourCookbooksQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useFirstFourCookbooksQuery(baseOptions: Apollo.QueryHookOptions<FirstFourCookbooksQuery, FirstFourCookbooksQueryVariables> & ({ variables: FirstFourCookbooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirstFourCookbooksQuery, FirstFourCookbooksQueryVariables>(FirstFourCookbooksDocument, options);
      }
export function useFirstFourCookbooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirstFourCookbooksQuery, FirstFourCookbooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirstFourCookbooksQuery, FirstFourCookbooksQueryVariables>(FirstFourCookbooksDocument, options);
        }
export function useFirstFourCookbooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FirstFourCookbooksQuery, FirstFourCookbooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirstFourCookbooksQuery, FirstFourCookbooksQueryVariables>(FirstFourCookbooksDocument, options);
        }
export type FirstFourCookbooksQueryHookResult = ReturnType<typeof useFirstFourCookbooksQuery>;
export type FirstFourCookbooksLazyQueryHookResult = ReturnType<typeof useFirstFourCookbooksLazyQuery>;
export type FirstFourCookbooksSuspenseQueryHookResult = ReturnType<typeof useFirstFourCookbooksSuspenseQuery>;
export type FirstFourCookbooksQueryResult = Apollo.QueryResult<FirstFourCookbooksQuery, FirstFourCookbooksQueryVariables>;
export const GetUserCookbooksDocument = gql`
    query GetUserCookbooks($user_id: Int!, $limit: Int, $page: Int) {
  getUserCookbooks(user_id: $user_id, limit: $limit, page: $page) {
    cookbooks {
      cookbook_id
      user_id
      cookbook_name
      cookbook_img_url
      cookbook_description
      cookbook_contest_date_finished
      date_featured
      number_of_members
      latitude
      longitude
      location_city
      location_state
      location_country
      location_description
    }
    total
    page
  }
}
    `;

/**
 * __useGetUserCookbooksQuery__
 *
 * To run a query within a React component, call `useGetUserCookbooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCookbooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCookbooksQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetUserCookbooksQuery(baseOptions: Apollo.QueryHookOptions<GetUserCookbooksQuery, GetUserCookbooksQueryVariables> & ({ variables: GetUserCookbooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCookbooksQuery, GetUserCookbooksQueryVariables>(GetUserCookbooksDocument, options);
      }
export function useGetUserCookbooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCookbooksQuery, GetUserCookbooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCookbooksQuery, GetUserCookbooksQueryVariables>(GetUserCookbooksDocument, options);
        }
export function useGetUserCookbooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCookbooksQuery, GetUserCookbooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserCookbooksQuery, GetUserCookbooksQueryVariables>(GetUserCookbooksDocument, options);
        }
export type GetUserCookbooksQueryHookResult = ReturnType<typeof useGetUserCookbooksQuery>;
export type GetUserCookbooksLazyQueryHookResult = ReturnType<typeof useGetUserCookbooksLazyQuery>;
export type GetUserCookbooksSuspenseQueryHookResult = ReturnType<typeof useGetUserCookbooksSuspenseQuery>;
export type GetUserCookbooksQueryResult = Apollo.QueryResult<GetUserCookbooksQuery, GetUserCookbooksQueryVariables>;
export const RecordCookieConsentDocument = gql`
    mutation RecordCookieConsent($input: CookieConsentInput!) {
  recordCookieConsent(input: $input) {
    id
    sessionId
    timestamp
    action
    preferences {
      essential
      functional
      analytics
      marketing
    }
    userAgent
    ipAddress
    url
    consentVersion
    createdAt
    updatedAt
  }
}
    `;
export type RecordCookieConsentMutationFn = Apollo.MutationFunction<RecordCookieConsentMutation, RecordCookieConsentMutationVariables>;

/**
 * __useRecordCookieConsentMutation__
 *
 * To run a mutation, you first call `useRecordCookieConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCookieConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCookieConsentMutation, { data, loading, error }] = useRecordCookieConsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordCookieConsentMutation(baseOptions?: Apollo.MutationHookOptions<RecordCookieConsentMutation, RecordCookieConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCookieConsentMutation, RecordCookieConsentMutationVariables>(RecordCookieConsentDocument, options);
      }
export type RecordCookieConsentMutationHookResult = ReturnType<typeof useRecordCookieConsentMutation>;
export type RecordCookieConsentMutationResult = Apollo.MutationResult<RecordCookieConsentMutation>;
export type RecordCookieConsentMutationOptions = Apollo.BaseMutationOptions<RecordCookieConsentMutation, RecordCookieConsentMutationVariables>;
export const GetCookieAuditLogDocument = gql`
    query GetCookieAuditLog($limit: Int, $offset: Int) {
  getCookieAuditLog(limit: $limit, offset: $offset) {
    entries {
      id
      sessionId
      timestamp
      action
      preferences {
        essential
        functional
        analytics
        marketing
      }
      userAgent
      ipAddress
      url
      consentVersion
      createdAt
      updatedAt
    }
    total
    limit
    offset
  }
}
    `;

/**
 * __useGetCookieAuditLogQuery__
 *
 * To run a query within a React component, call `useGetCookieAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCookieAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCookieAuditLogQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCookieAuditLogQuery(baseOptions?: Apollo.QueryHookOptions<GetCookieAuditLogQuery, GetCookieAuditLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCookieAuditLogQuery, GetCookieAuditLogQueryVariables>(GetCookieAuditLogDocument, options);
      }
export function useGetCookieAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCookieAuditLogQuery, GetCookieAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCookieAuditLogQuery, GetCookieAuditLogQueryVariables>(GetCookieAuditLogDocument, options);
        }
export function useGetCookieAuditLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCookieAuditLogQuery, GetCookieAuditLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCookieAuditLogQuery, GetCookieAuditLogQueryVariables>(GetCookieAuditLogDocument, options);
        }
export type GetCookieAuditLogQueryHookResult = ReturnType<typeof useGetCookieAuditLogQuery>;
export type GetCookieAuditLogLazyQueryHookResult = ReturnType<typeof useGetCookieAuditLogLazyQuery>;
export type GetCookieAuditLogSuspenseQueryHookResult = ReturnType<typeof useGetCookieAuditLogSuspenseQuery>;
export type GetCookieAuditLogQueryResult = Apollo.QueryResult<GetCookieAuditLogQuery, GetCookieAuditLogQueryVariables>;
export const GetCookieAuditStatsDocument = gql`
    query GetCookieAuditStats {
  getCookieAuditStats {
    total
    acceptAll
    declineAll
    customSave
    acceptAllRate
    declineAllRate
    customSaveRate
    functionalRate
    analyticsRate
    marketingRate
    last24h
    last7d
    last30d
    byDay {
      date
      count
    }
  }
}
    `;

/**
 * __useGetCookieAuditStatsQuery__
 *
 * To run a query within a React component, call `useGetCookieAuditStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCookieAuditStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCookieAuditStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCookieAuditStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetCookieAuditStatsQuery, GetCookieAuditStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCookieAuditStatsQuery, GetCookieAuditStatsQueryVariables>(GetCookieAuditStatsDocument, options);
      }
export function useGetCookieAuditStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCookieAuditStatsQuery, GetCookieAuditStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCookieAuditStatsQuery, GetCookieAuditStatsQueryVariables>(GetCookieAuditStatsDocument, options);
        }
export function useGetCookieAuditStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCookieAuditStatsQuery, GetCookieAuditStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCookieAuditStatsQuery, GetCookieAuditStatsQueryVariables>(GetCookieAuditStatsDocument, options);
        }
export type GetCookieAuditStatsQueryHookResult = ReturnType<typeof useGetCookieAuditStatsQuery>;
export type GetCookieAuditStatsLazyQueryHookResult = ReturnType<typeof useGetCookieAuditStatsLazyQuery>;
export type GetCookieAuditStatsSuspenseQueryHookResult = ReturnType<typeof useGetCookieAuditStatsSuspenseQuery>;
export type GetCookieAuditStatsQueryResult = Apollo.QueryResult<GetCookieAuditStatsQuery, GetCookieAuditStatsQueryVariables>;
export const GetCookieComplianceReportDocument = gql`
    query GetCookieComplianceReport($framework: String!, $from: Time, $to: Time) {
  getCookieComplianceReport(framework: $framework, from: $from, to: $to) {
    generatedAt
    period {
      from
      to
    }
    framework
    summary {
      totalConsents
      explicitConsents
      withdrawals
      consentRate
    }
    categories {
      name
      enabled
      disabled
      rate
    }
    recommendations
    compliant
    issues
  }
}
    `;

/**
 * __useGetCookieComplianceReportQuery__
 *
 * To run a query within a React component, call `useGetCookieComplianceReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCookieComplianceReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCookieComplianceReportQuery({
 *   variables: {
 *      framework: // value for 'framework'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetCookieComplianceReportQuery(baseOptions: Apollo.QueryHookOptions<GetCookieComplianceReportQuery, GetCookieComplianceReportQueryVariables> & ({ variables: GetCookieComplianceReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCookieComplianceReportQuery, GetCookieComplianceReportQueryVariables>(GetCookieComplianceReportDocument, options);
      }
export function useGetCookieComplianceReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCookieComplianceReportQuery, GetCookieComplianceReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCookieComplianceReportQuery, GetCookieComplianceReportQueryVariables>(GetCookieComplianceReportDocument, options);
        }
export function useGetCookieComplianceReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCookieComplianceReportQuery, GetCookieComplianceReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCookieComplianceReportQuery, GetCookieComplianceReportQueryVariables>(GetCookieComplianceReportDocument, options);
        }
export type GetCookieComplianceReportQueryHookResult = ReturnType<typeof useGetCookieComplianceReportQuery>;
export type GetCookieComplianceReportLazyQueryHookResult = ReturnType<typeof useGetCookieComplianceReportLazyQuery>;
export type GetCookieComplianceReportSuspenseQueryHookResult = ReturnType<typeof useGetCookieComplianceReportSuspenseQuery>;
export type GetCookieComplianceReportQueryResult = Apollo.QueryResult<GetCookieComplianceReportQuery, GetCookieComplianceReportQueryVariables>;
export const ExportCookieAuditLogCsvDocument = gql`
    query ExportCookieAuditLogCSV {
  exportCookieAuditLogCSV
}
    `;

/**
 * __useExportCookieAuditLogCsvQuery__
 *
 * To run a query within a React component, call `useExportCookieAuditLogCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCookieAuditLogCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCookieAuditLogCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportCookieAuditLogCsvQuery(baseOptions?: Apollo.QueryHookOptions<ExportCookieAuditLogCsvQuery, ExportCookieAuditLogCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCookieAuditLogCsvQuery, ExportCookieAuditLogCsvQueryVariables>(ExportCookieAuditLogCsvDocument, options);
      }
export function useExportCookieAuditLogCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCookieAuditLogCsvQuery, ExportCookieAuditLogCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCookieAuditLogCsvQuery, ExportCookieAuditLogCsvQueryVariables>(ExportCookieAuditLogCsvDocument, options);
        }
export function useExportCookieAuditLogCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCookieAuditLogCsvQuery, ExportCookieAuditLogCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportCookieAuditLogCsvQuery, ExportCookieAuditLogCsvQueryVariables>(ExportCookieAuditLogCsvDocument, options);
        }
export type ExportCookieAuditLogCsvQueryHookResult = ReturnType<typeof useExportCookieAuditLogCsvQuery>;
export type ExportCookieAuditLogCsvLazyQueryHookResult = ReturnType<typeof useExportCookieAuditLogCsvLazyQuery>;
export type ExportCookieAuditLogCsvSuspenseQueryHookResult = ReturnType<typeof useExportCookieAuditLogCsvSuspenseQuery>;
export type ExportCookieAuditLogCsvQueryResult = Apollo.QueryResult<ExportCookieAuditLogCsvQuery, ExportCookieAuditLogCsvQueryVariables>;
export const DeleteOldCookieAuditEntriesDocument = gql`
    mutation DeleteOldCookieAuditEntries($olderThanDays: Int!) {
  deleteOldCookieAuditEntries(olderThanDays: $olderThanDays)
}
    `;
export type DeleteOldCookieAuditEntriesMutationFn = Apollo.MutationFunction<DeleteOldCookieAuditEntriesMutation, DeleteOldCookieAuditEntriesMutationVariables>;

/**
 * __useDeleteOldCookieAuditEntriesMutation__
 *
 * To run a mutation, you first call `useDeleteOldCookieAuditEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOldCookieAuditEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOldCookieAuditEntriesMutation, { data, loading, error }] = useDeleteOldCookieAuditEntriesMutation({
 *   variables: {
 *      olderThanDays: // value for 'olderThanDays'
 *   },
 * });
 */
export function useDeleteOldCookieAuditEntriesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOldCookieAuditEntriesMutation, DeleteOldCookieAuditEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOldCookieAuditEntriesMutation, DeleteOldCookieAuditEntriesMutationVariables>(DeleteOldCookieAuditEntriesDocument, options);
      }
export type DeleteOldCookieAuditEntriesMutationHookResult = ReturnType<typeof useDeleteOldCookieAuditEntriesMutation>;
export type DeleteOldCookieAuditEntriesMutationResult = Apollo.MutationResult<DeleteOldCookieAuditEntriesMutation>;
export type DeleteOldCookieAuditEntriesMutationOptions = Apollo.BaseMutationOptions<DeleteOldCookieAuditEntriesMutation, DeleteOldCookieAuditEntriesMutationVariables>;
export const FollowUserDocument = gql`
    mutation FollowUser($userID: Int!) {
  follow(userId: $userID)
}
    `;
export type FollowUserMutationFn = Apollo.MutationFunction<FollowUserMutation, FollowUserMutationVariables>;

/**
 * __useFollowUserMutation__
 *
 * To run a mutation, you first call `useFollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserMutation, { data, loading, error }] = useFollowUserMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useFollowUserMutation(baseOptions?: Apollo.MutationHookOptions<FollowUserMutation, FollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUserMutation, FollowUserMutationVariables>(FollowUserDocument, options);
      }
export type FollowUserMutationHookResult = ReturnType<typeof useFollowUserMutation>;
export type FollowUserMutationResult = Apollo.MutationResult<FollowUserMutation>;
export type FollowUserMutationOptions = Apollo.BaseMutationOptions<FollowUserMutation, FollowUserMutationVariables>;
export const UnFollowUserDocument = gql`
    mutation UnFollowUser($userID: Int!) {
  unFollow(userId: $userID)
}
    `;
export type UnFollowUserMutationFn = Apollo.MutationFunction<UnFollowUserMutation, UnFollowUserMutationVariables>;

/**
 * __useUnFollowUserMutation__
 *
 * To run a mutation, you first call `useUnFollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnFollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unFollowUserMutation, { data, loading, error }] = useUnFollowUserMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useUnFollowUserMutation(baseOptions?: Apollo.MutationHookOptions<UnFollowUserMutation, UnFollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnFollowUserMutation, UnFollowUserMutationVariables>(UnFollowUserDocument, options);
      }
export type UnFollowUserMutationHookResult = ReturnType<typeof useUnFollowUserMutation>;
export type UnFollowUserMutationResult = Apollo.MutationResult<UnFollowUserMutation>;
export type UnFollowUserMutationOptions = Apollo.BaseMutationOptions<UnFollowUserMutation, UnFollowUserMutationVariables>;
export const UnblockUserDocument = gql`
    mutation UnblockUser($blockedUserId: Int!) {
  unblockUser(blocked_user_id: $blockedUserId)
}
    `;
export type UnblockUserMutationFn = Apollo.MutationFunction<UnblockUserMutation, UnblockUserMutationVariables>;

/**
 * __useUnblockUserMutation__
 *
 * To run a mutation, you first call `useUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockUserMutation, { data, loading, error }] = useUnblockUserMutation({
 *   variables: {
 *      blockedUserId: // value for 'blockedUserId'
 *   },
 * });
 */
export function useUnblockUserMutation(baseOptions?: Apollo.MutationHookOptions<UnblockUserMutation, UnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockUserMutation, UnblockUserMutationVariables>(UnblockUserDocument, options);
      }
export type UnblockUserMutationHookResult = ReturnType<typeof useUnblockUserMutation>;
export type UnblockUserMutationResult = Apollo.MutationResult<UnblockUserMutation>;
export type UnblockUserMutationOptions = Apollo.BaseMutationOptions<UnblockUserMutation, UnblockUserMutationVariables>;
export const BlockUserDocument = gql`
    mutation BlockUser($userId: Int!) {
  blockUser(user_id: $userId)
}
    `;
export type BlockUserMutationFn = Apollo.MutationFunction<BlockUserMutation, BlockUserMutationVariables>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockUserMutation, BlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockUserMutation, BlockUserMutationVariables>(BlockUserDocument, options);
      }
export type BlockUserMutationHookResult = ReturnType<typeof useBlockUserMutation>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<BlockUserMutation, BlockUserMutationVariables>;
export const GetBlockedUsersDocument = gql`
    query GetBlockedUsers($first: Int!, $after: ID) {
  blockedUsers(first: $first, after: $after) {
    users {
      user_id
      profile_photo_resource
      full_name
      slug
      user_type
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetBlockedUsersQuery__
 *
 * To run a query within a React component, call `useGetBlockedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetBlockedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetBlockedUsersQuery, GetBlockedUsersQueryVariables> & ({ variables: GetBlockedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockedUsersQuery, GetBlockedUsersQueryVariables>(GetBlockedUsersDocument, options);
      }
export function useGetBlockedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockedUsersQuery, GetBlockedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockedUsersQuery, GetBlockedUsersQueryVariables>(GetBlockedUsersDocument, options);
        }
export function useGetBlockedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlockedUsersQuery, GetBlockedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlockedUsersQuery, GetBlockedUsersQueryVariables>(GetBlockedUsersDocument, options);
        }
export type GetBlockedUsersQueryHookResult = ReturnType<typeof useGetBlockedUsersQuery>;
export type GetBlockedUsersLazyQueryHookResult = ReturnType<typeof useGetBlockedUsersLazyQuery>;
export type GetBlockedUsersSuspenseQueryHookResult = ReturnType<typeof useGetBlockedUsersSuspenseQuery>;
export type GetBlockedUsersQueryResult = Apollo.QueryResult<GetBlockedUsersQuery, GetBlockedUsersQueryVariables>;
export const FollowerFollowingDocument = gql`
    query followerFollowing($userId: Int!, $limit: Int, $offset: Int, $searchTerm: String) {
  MyFollowing(
    user_id: $userId
    limit: $limit
    offset: $offset
    searchTerm: $searchTerm
  ) {
    results {
      user_id
      profile_photo_resource
      slug
      full_name
      user_type
      default_listing_id
      default_listing {
        membership_type
        photo
        name
        slug
        user_type
        enhanced
        verified
      }
    }
    total
    offset
    limit
  }
  MyFollowers(
    user_id: $userId
    limit: $limit
    offset: $offset
    searchTerm: $searchTerm
  ) {
    results {
      user_id
      profile_photo_resource
      slug
      full_name
      user_type
      default_listing_id
      default_listing {
        membership_type
        photo
        name
        slug
        user_type
        enhanced
        verified
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useFollowerFollowingQuery__
 *
 * To run a query within a React component, call `useFollowerFollowingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowerFollowingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowerFollowingQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useFollowerFollowingQuery(baseOptions: Apollo.QueryHookOptions<FollowerFollowingQuery, FollowerFollowingQueryVariables> & ({ variables: FollowerFollowingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowerFollowingQuery, FollowerFollowingQueryVariables>(FollowerFollowingDocument, options);
      }
export function useFollowerFollowingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowerFollowingQuery, FollowerFollowingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowerFollowingQuery, FollowerFollowingQueryVariables>(FollowerFollowingDocument, options);
        }
export function useFollowerFollowingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FollowerFollowingQuery, FollowerFollowingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FollowerFollowingQuery, FollowerFollowingQueryVariables>(FollowerFollowingDocument, options);
        }
export type FollowerFollowingQueryHookResult = ReturnType<typeof useFollowerFollowingQuery>;
export type FollowerFollowingLazyQueryHookResult = ReturnType<typeof useFollowerFollowingLazyQuery>;
export type FollowerFollowingSuspenseQueryHookResult = ReturnType<typeof useFollowerFollowingSuspenseQuery>;
export type FollowerFollowingQueryResult = Apollo.QueryResult<FollowerFollowingQuery, FollowerFollowingQueryVariables>;
export const GetSuggestedUsersDocument = gql`
    query getSuggestedUsers($lat: Float, $long: Float, $limit: Int, $offset: Int, $searchTerm: String, $broader: Boolean) {
  suggestedUsers(
    lat: $lat
    long: $long
    limit: $limit
    offset: $offset
    searchTerm: $searchTerm
    broader: $broader
  ) {
    users {
      user_id
      full_name
      default_listing_id
      user_type
      default_listing {
        listing_id
        user_id
        user_type
        name
        enhanced
        verified
        photo
        slug
        business_description_completed
        products_completed
        vendors_completed
        selling_locations_completed
        sales_channels_completed
      }
      slug
      profile_photo_resource
    }
    total
    page
    has_next_page
  }
}
    `;

/**
 * __useGetSuggestedUsersQuery__
 *
 * To run a query within a React component, call `useGetSuggestedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedUsersQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      long: // value for 'long'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchTerm: // value for 'searchTerm'
 *      broader: // value for 'broader'
 *   },
 * });
 */
export function useGetSuggestedUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetSuggestedUsersQuery, GetSuggestedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedUsersQuery, GetSuggestedUsersQueryVariables>(GetSuggestedUsersDocument, options);
      }
export function useGetSuggestedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedUsersQuery, GetSuggestedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedUsersQuery, GetSuggestedUsersQueryVariables>(GetSuggestedUsersDocument, options);
        }
export function useGetSuggestedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedUsersQuery, GetSuggestedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuggestedUsersQuery, GetSuggestedUsersQueryVariables>(GetSuggestedUsersDocument, options);
        }
export type GetSuggestedUsersQueryHookResult = ReturnType<typeof useGetSuggestedUsersQuery>;
export type GetSuggestedUsersLazyQueryHookResult = ReturnType<typeof useGetSuggestedUsersLazyQuery>;
export type GetSuggestedUsersSuspenseQueryHookResult = ReturnType<typeof useGetSuggestedUsersSuspenseQuery>;
export type GetSuggestedUsersQueryResult = Apollo.QueryResult<GetSuggestedUsersQuery, GetSuggestedUsersQueryVariables>;
export const GetSuggestedListingsDocument = gql`
    query GetSuggestedListings($lat: Float, $long: Float, $limit: Int, $offset: Int, $searchTerm: String) {
  suggestedListings(
    lat: $lat
    long: $long
    limit: $limit
    offset: $offset
    searchTerm: $searchTerm
  ) {
    total
    has_next_page
    page
    listings {
      listing_id
      user_id
      user_type
      name
      enhanced
      photo
      slug
      latitude
      longitude
      distance
      city
      state
      user {
        profile_photo_resource
        slug
        user_id
      }
    }
  }
}
    `;

/**
 * __useGetSuggestedListingsQuery__
 *
 * To run a query within a React component, call `useGetSuggestedListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedListingsQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      long: // value for 'long'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetSuggestedListingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSuggestedListingsQuery, GetSuggestedListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedListingsQuery, GetSuggestedListingsQueryVariables>(GetSuggestedListingsDocument, options);
      }
export function useGetSuggestedListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedListingsQuery, GetSuggestedListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedListingsQuery, GetSuggestedListingsQueryVariables>(GetSuggestedListingsDocument, options);
        }
export function useGetSuggestedListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedListingsQuery, GetSuggestedListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuggestedListingsQuery, GetSuggestedListingsQueryVariables>(GetSuggestedListingsDocument, options);
        }
export type GetSuggestedListingsQueryHookResult = ReturnType<typeof useGetSuggestedListingsQuery>;
export type GetSuggestedListingsLazyQueryHookResult = ReturnType<typeof useGetSuggestedListingsLazyQuery>;
export type GetSuggestedListingsSuspenseQueryHookResult = ReturnType<typeof useGetSuggestedListingsSuspenseQuery>;
export type GetSuggestedListingsQueryResult = Apollo.QueryResult<GetSuggestedListingsQuery, GetSuggestedListingsQueryVariables>;
export const GeneralUserSearchDocument = gql`
    query GeneralUserSearch($dataToSearch: [SearchType!]!, $searchTerm: String!, $limit: Int, $offset: Int) {
  generalSearch(
    dataToSearch: $dataToSearch
    searchTerm: $searchTerm
    limit: $limit
    offset: $offset
  ) {
    results {
      ... on Listing {
        listing_id
        user_type
        name
        photo
        slug
        user {
          profile_photo_resource
        }
      }
      ... on User {
        full_name
        profile_photo_resource
        user_type
        slug
        user_id
        default_listing {
          name
          photo
          slug
        }
      }
    }
    limit
    total
  }
}
    `;

/**
 * __useGeneralUserSearchQuery__
 *
 * To run a query within a React component, call `useGeneralUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralUserSearchQuery({
 *   variables: {
 *      dataToSearch: // value for 'dataToSearch'
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGeneralUserSearchQuery(baseOptions: Apollo.QueryHookOptions<GeneralUserSearchQuery, GeneralUserSearchQueryVariables> & ({ variables: GeneralUserSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralUserSearchQuery, GeneralUserSearchQueryVariables>(GeneralUserSearchDocument, options);
      }
export function useGeneralUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralUserSearchQuery, GeneralUserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralUserSearchQuery, GeneralUserSearchQueryVariables>(GeneralUserSearchDocument, options);
        }
export function useGeneralUserSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralUserSearchQuery, GeneralUserSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralUserSearchQuery, GeneralUserSearchQueryVariables>(GeneralUserSearchDocument, options);
        }
export type GeneralUserSearchQueryHookResult = ReturnType<typeof useGeneralUserSearchQuery>;
export type GeneralUserSearchLazyQueryHookResult = ReturnType<typeof useGeneralUserSearchLazyQuery>;
export type GeneralUserSearchSuspenseQueryHookResult = ReturnType<typeof useGeneralUserSearchSuspenseQuery>;
export type GeneralUserSearchQueryResult = Apollo.QueryResult<GeneralUserSearchQuery, GeneralUserSearchQueryVariables>;
export const GetUnitOfMeasurementDocument = gql`
    query GetUnitOfMeasurement {
  getUnitOfMesurement {
    unit_of_measurement_id
    unit_name
    unit_abbreviation
  }
}
    `;

/**
 * __useGetUnitOfMeasurementQuery__
 *
 * To run a query within a React component, call `useGetUnitOfMeasurementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitOfMeasurementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitOfMeasurementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitOfMeasurementQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitOfMeasurementQuery, GetUnitOfMeasurementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitOfMeasurementQuery, GetUnitOfMeasurementQueryVariables>(GetUnitOfMeasurementDocument, options);
      }
export function useGetUnitOfMeasurementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitOfMeasurementQuery, GetUnitOfMeasurementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitOfMeasurementQuery, GetUnitOfMeasurementQueryVariables>(GetUnitOfMeasurementDocument, options);
        }
export function useGetUnitOfMeasurementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitOfMeasurementQuery, GetUnitOfMeasurementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitOfMeasurementQuery, GetUnitOfMeasurementQueryVariables>(GetUnitOfMeasurementDocument, options);
        }
export type GetUnitOfMeasurementQueryHookResult = ReturnType<typeof useGetUnitOfMeasurementQuery>;
export type GetUnitOfMeasurementLazyQueryHookResult = ReturnType<typeof useGetUnitOfMeasurementLazyQuery>;
export type GetUnitOfMeasurementSuspenseQueryHookResult = ReturnType<typeof useGetUnitOfMeasurementSuspenseQuery>;
export type GetUnitOfMeasurementQueryResult = Apollo.QueryResult<GetUnitOfMeasurementQuery, GetUnitOfMeasurementQueryVariables>;
export const GeneralRecipeSearchDocument = gql`
    query GeneralRecipeSearch($dataToSearch: [SearchType!]!, $searchTerm: String!, $limit: Int, $offset: Int, $sortBy: String, $distanceSort: DirectoryInput) {
  generalSearch(
    dataToSearch: $dataToSearch
    searchTerm: $searchTerm
    limit: $limit
    offset: $offset
    recentSort: $sortBy
    distanceSort: $distanceSort
  ) {
    __typename
    results {
      ... on Recipe {
        recipe_id
        user_id
        recipe_img_url
        recipe_name
        number_of_servings
        serving_type
        author_name
        preparation_time
        cook_time
        total_time
        average_recipe_rating
        recipe_ingredients {
          record_id
          recipe_id
          ingredient_id
          unit_of_measurement_id
          whole_number
          sort_order
          numerator
          denominator
          measurement_amount
          raw_name
          ingredient {
            ingredient_id
            ingredient_name
          }
          unit_of_measurement {
            unit_of_measurement_id
            unit_abbreviation
            unit_name
          }
        }
        recipe_image {
          resource_path
          thumbnail_path
        }
        resourcePath
        slug
        user {
          profile_photo_resource
          full_name
          slug
          default_listing {
            listing_id
            photo
            resourcePath
          }
        }
      }
      ... on Listing {
        listing_id
        user_type
        description
        tagLine
        enhanced
        verified
        membership_type
        name
        photo
        latitude
        longitude
        city
        state
        slug
        business_description_completed
        products_completed
        vendors_completed
        selling_locations_completed
        sales_channels_completed
        user {
          profile_photo_resource
          full_name
          slug
        }
        ingredients {
          ingredient_id
          name
        }
        vendors {
          name
        }
      }
      ... on User {
        user_id
        profile_photo_resource
        username
        email_address
        first_name
        last_name
        full_name
        date_last_login
        zipcode
        user_bio
        date_pro_user
        user_type
        date_onboarding_completed
        city
        country
        twitter_url
        youtube_url
        slug
        default_listing {
          listing_id
          photo
          resourcePath
          slug
        }
      }
      ... on DirectoryIngredient {
        ingredient_id
        name
        type
        mainImage
        illustrationImage
        ingredient_id
        description
        allowUsage
        date_created
        slug
        listings {
          name
        }
        thumbnail_path {
          thumbnail_path
          main_image_path
        }
      }
    }
    limit
    total
  }
}
    `;

/**
 * __useGeneralRecipeSearchQuery__
 *
 * To run a query within a React component, call `useGeneralRecipeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralRecipeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralRecipeSearchQuery({
 *   variables: {
 *      dataToSearch: // value for 'dataToSearch'
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortBy: // value for 'sortBy'
 *      distanceSort: // value for 'distanceSort'
 *   },
 * });
 */
export function useGeneralRecipeSearchQuery(baseOptions: Apollo.QueryHookOptions<GeneralRecipeSearchQuery, GeneralRecipeSearchQueryVariables> & ({ variables: GeneralRecipeSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralRecipeSearchQuery, GeneralRecipeSearchQueryVariables>(GeneralRecipeSearchDocument, options);
      }
export function useGeneralRecipeSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralRecipeSearchQuery, GeneralRecipeSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralRecipeSearchQuery, GeneralRecipeSearchQueryVariables>(GeneralRecipeSearchDocument, options);
        }
export function useGeneralRecipeSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralRecipeSearchQuery, GeneralRecipeSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralRecipeSearchQuery, GeneralRecipeSearchQueryVariables>(GeneralRecipeSearchDocument, options);
        }
export type GeneralRecipeSearchQueryHookResult = ReturnType<typeof useGeneralRecipeSearchQuery>;
export type GeneralRecipeSearchLazyQueryHookResult = ReturnType<typeof useGeneralRecipeSearchLazyQuery>;
export type GeneralRecipeSearchSuspenseQueryHookResult = ReturnType<typeof useGeneralRecipeSearchSuspenseQuery>;
export type GeneralRecipeSearchQueryResult = Apollo.QueryResult<GeneralRecipeSearchQuery, GeneralRecipeSearchQueryVariables>;
export const SendBusinessRegInviteDocument = gql`
    mutation SendBusinessRegInvite($input: BusinessRegEmailInput!, $emailType: String!) {
  sendBusinessRegEmail(input: $input, emailType: $emailType)
}
    `;
export type SendBusinessRegInviteMutationFn = Apollo.MutationFunction<SendBusinessRegInviteMutation, SendBusinessRegInviteMutationVariables>;

/**
 * __useSendBusinessRegInviteMutation__
 *
 * To run a mutation, you first call `useSendBusinessRegInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBusinessRegInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBusinessRegInviteMutation, { data, loading, error }] = useSendBusinessRegInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      emailType: // value for 'emailType'
 *   },
 * });
 */
export function useSendBusinessRegInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendBusinessRegInviteMutation, SendBusinessRegInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBusinessRegInviteMutation, SendBusinessRegInviteMutationVariables>(SendBusinessRegInviteDocument, options);
      }
export type SendBusinessRegInviteMutationHookResult = ReturnType<typeof useSendBusinessRegInviteMutation>;
export type SendBusinessRegInviteMutationResult = Apollo.MutationResult<SendBusinessRegInviteMutation>;
export type SendBusinessRegInviteMutationOptions = Apollo.BaseMutationOptions<SendBusinessRegInviteMutation, SendBusinessRegInviteMutationVariables>;
export const RequestCustomPlanDocument = gql`
    mutation RequestCustomPlan($input: CustomPlanInput!) {
  requestCustomPlan(input: $input)
}
    `;
export type RequestCustomPlanMutationFn = Apollo.MutationFunction<RequestCustomPlanMutation, RequestCustomPlanMutationVariables>;

/**
 * __useRequestCustomPlanMutation__
 *
 * To run a mutation, you first call `useRequestCustomPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCustomPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCustomPlanMutation, { data, loading, error }] = useRequestCustomPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCustomPlanMutation(baseOptions?: Apollo.MutationHookOptions<RequestCustomPlanMutation, RequestCustomPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCustomPlanMutation, RequestCustomPlanMutationVariables>(RequestCustomPlanDocument, options);
      }
export type RequestCustomPlanMutationHookResult = ReturnType<typeof useRequestCustomPlanMutation>;
export type RequestCustomPlanMutationResult = Apollo.MutationResult<RequestCustomPlanMutation>;
export type RequestCustomPlanMutationOptions = Apollo.BaseMutationOptions<RequestCustomPlanMutation, RequestCustomPlanMutationVariables>;
export const SubscribeForNewsletterDocument = gql`
    mutation SubscribeForNewsletter($input: AddSubscriberInput!) {
  addSubscriber(input: $input) {
    success
    message
  }
}
    `;
export type SubscribeForNewsletterMutationFn = Apollo.MutationFunction<SubscribeForNewsletterMutation, SubscribeForNewsletterMutationVariables>;

/**
 * __useSubscribeForNewsletterMutation__
 *
 * To run a mutation, you first call `useSubscribeForNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeForNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeForNewsletterMutation, { data, loading, error }] = useSubscribeForNewsletterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeForNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeForNewsletterMutation, SubscribeForNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeForNewsletterMutation, SubscribeForNewsletterMutationVariables>(SubscribeForNewsletterDocument, options);
      }
export type SubscribeForNewsletterMutationHookResult = ReturnType<typeof useSubscribeForNewsletterMutation>;
export type SubscribeForNewsletterMutationResult = Apollo.MutationResult<SubscribeForNewsletterMutation>;
export type SubscribeForNewsletterMutationOptions = Apollo.BaseMutationOptions<SubscribeForNewsletterMutation, SubscribeForNewsletterMutationVariables>;
export const GetIngredientsDocument = gql`
    query getIngredients($limit: Int, $offset: Int, $searchTerm: String, $isSeasonal: Boolean) {
  getIngredients(
    limit: $limit
    offset: $offset
    searchTerm: $searchTerm
    isSeasonal: $isSeasonal
  ) {
    ingredient_id
    name
    illustrationImage
    mainImage
    type
    slug
    pairing
    isSeasonal
    description
    cookingGuidance
    cooking
    choosing
    parent_product_id
    is_generic
    requires_enhanced
    seasonal_source
    seasonal_manual_until
    seasonal_updated_at
    date_updated
    date_created
    start_month
    peak_month
    end_month
    userOwned
    allowUsage
    listings {
      listing_id
    }
    availableMonths {
      month
      isPeak
    }
  }
}
    `;

/**
 * __useGetIngredientsQuery__
 *
 * To run a query within a React component, call `useGetIngredientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIngredientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIngredientsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchTerm: // value for 'searchTerm'
 *      isSeasonal: // value for 'isSeasonal'
 *   },
 * });
 */
export function useGetIngredientsQuery(baseOptions?: Apollo.QueryHookOptions<GetIngredientsQuery, GetIngredientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIngredientsQuery, GetIngredientsQueryVariables>(GetIngredientsDocument, options);
      }
export function useGetIngredientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIngredientsQuery, GetIngredientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIngredientsQuery, GetIngredientsQueryVariables>(GetIngredientsDocument, options);
        }
export function useGetIngredientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIngredientsQuery, GetIngredientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIngredientsQuery, GetIngredientsQueryVariables>(GetIngredientsDocument, options);
        }
export type GetIngredientsQueryHookResult = ReturnType<typeof useGetIngredientsQuery>;
export type GetIngredientsLazyQueryHookResult = ReturnType<typeof useGetIngredientsLazyQuery>;
export type GetIngredientsSuspenseQueryHookResult = ReturnType<typeof useGetIngredientsSuspenseQuery>;
export type GetIngredientsQueryResult = Apollo.QueryResult<GetIngredientsQuery, GetIngredientsQueryVariables>;
export const FindDirectoryIngredientByNameDocument = gql`
    query findDirectoryIngredientByName($name: String!) {
  findDirectoryIngredientByName(name: $name) {
    ingredient_id
    name
    illustrationImage
    mainImage
    type
    verified
  }
}
    `;

/**
 * __useFindDirectoryIngredientByNameQuery__
 *
 * To run a query within a React component, call `useFindDirectoryIngredientByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDirectoryIngredientByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDirectoryIngredientByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFindDirectoryIngredientByNameQuery(baseOptions: Apollo.QueryHookOptions<FindDirectoryIngredientByNameQuery, FindDirectoryIngredientByNameQueryVariables> & ({ variables: FindDirectoryIngredientByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDirectoryIngredientByNameQuery, FindDirectoryIngredientByNameQueryVariables>(FindDirectoryIngredientByNameDocument, options);
      }
export function useFindDirectoryIngredientByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDirectoryIngredientByNameQuery, FindDirectoryIngredientByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDirectoryIngredientByNameQuery, FindDirectoryIngredientByNameQueryVariables>(FindDirectoryIngredientByNameDocument, options);
        }
export function useFindDirectoryIngredientByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindDirectoryIngredientByNameQuery, FindDirectoryIngredientByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindDirectoryIngredientByNameQuery, FindDirectoryIngredientByNameQueryVariables>(FindDirectoryIngredientByNameDocument, options);
        }
export type FindDirectoryIngredientByNameQueryHookResult = ReturnType<typeof useFindDirectoryIngredientByNameQuery>;
export type FindDirectoryIngredientByNameLazyQueryHookResult = ReturnType<typeof useFindDirectoryIngredientByNameLazyQuery>;
export type FindDirectoryIngredientByNameSuspenseQueryHookResult = ReturnType<typeof useFindDirectoryIngredientByNameSuspenseQuery>;
export type FindDirectoryIngredientByNameQueryResult = Apollo.QueryResult<FindDirectoryIngredientByNameQuery, FindDirectoryIngredientByNameQueryVariables>;
export const GetSeasonalIngredientsDocument = gql`
    query getSeasonalIngredients {
  getSeasonalIngredients {
    ingredient_id
    name
    illustrationImage
    mainImage
    type
    slug
    pairing
    isSeasonal
    description
    cookingGuidance
    cooking
    choosing
    parent_product_id
    is_generic
    requires_enhanced
    seasonal_source
    seasonal_manual_until
    seasonal_updated_at
    date_updated
    date_created
    start_month
    peak_month
    end_month
    listings {
      name
    }
  }
}
    `;

/**
 * __useGetSeasonalIngredientsQuery__
 *
 * To run a query within a React component, call `useGetSeasonalIngredientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonalIngredientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonalIngredientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSeasonalIngredientsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeasonalIngredientsQuery, GetSeasonalIngredientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeasonalIngredientsQuery, GetSeasonalIngredientsQueryVariables>(GetSeasonalIngredientsDocument, options);
      }
export function useGetSeasonalIngredientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeasonalIngredientsQuery, GetSeasonalIngredientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeasonalIngredientsQuery, GetSeasonalIngredientsQueryVariables>(GetSeasonalIngredientsDocument, options);
        }
export function useGetSeasonalIngredientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSeasonalIngredientsQuery, GetSeasonalIngredientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSeasonalIngredientsQuery, GetSeasonalIngredientsQueryVariables>(GetSeasonalIngredientsDocument, options);
        }
export type GetSeasonalIngredientsQueryHookResult = ReturnType<typeof useGetSeasonalIngredientsQuery>;
export type GetSeasonalIngredientsLazyQueryHookResult = ReturnType<typeof useGetSeasonalIngredientsLazyQuery>;
export type GetSeasonalIngredientsSuspenseQueryHookResult = ReturnType<typeof useGetSeasonalIngredientsSuspenseQuery>;
export type GetSeasonalIngredientsQueryResult = Apollo.QueryResult<GetSeasonalIngredientsQuery, GetSeasonalIngredientsQueryVariables>;
export const CreateIngredientDocument = gql`
    mutation createIngredient($input: DirectoryIngredientInput!, $file: Upload, $mainFile: Upload) {
  createIngredient(input: $input, file: $file, mainFile: $mainFile) {
    ingredient_id
    name
    illustrationImage
    mainImage
    type
    pairing
    isSeasonal
    description
    cookingGuidance
    cooking
    choosing
    parent_product_id
    is_generic
    requires_enhanced
    date_updated
    date_created
  }
}
    `;
export type CreateIngredientMutationFn = Apollo.MutationFunction<CreateIngredientMutation, CreateIngredientMutationVariables>;

/**
 * __useCreateIngredientMutation__
 *
 * To run a mutation, you first call `useCreateIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIngredientMutation, { data, loading, error }] = useCreateIngredientMutation({
 *   variables: {
 *      input: // value for 'input'
 *      file: // value for 'file'
 *      mainFile: // value for 'mainFile'
 *   },
 * });
 */
export function useCreateIngredientMutation(baseOptions?: Apollo.MutationHookOptions<CreateIngredientMutation, CreateIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIngredientMutation, CreateIngredientMutationVariables>(CreateIngredientDocument, options);
      }
export type CreateIngredientMutationHookResult = ReturnType<typeof useCreateIngredientMutation>;
export type CreateIngredientMutationResult = Apollo.MutationResult<CreateIngredientMutation>;
export type CreateIngredientMutationOptions = Apollo.BaseMutationOptions<CreateIngredientMutation, CreateIngredientMutationVariables>;
export const UpdateDirectoryIngredientDocument = gql`
    mutation updateDirectoryIngredient($ingredientId: Int!, $input: DirectoryIngredientInput!) {
  updateDirectoryIngredient(ingredientId: $ingredientId, input: $input) {
    name
    illustrationImage
    mainImage
    type
    pairing
    isSeasonal
    description
    cookingGuidance
    flavoring
    preparation
    methods
    cooking
    choosing
    parent_product_id
    is_generic
    requires_enhanced
    seasonal_source
    seasonal_manual_until
    seasonal_updated_at
    start_month
    peak_month
    end_month
    resource_illustration_path
    resource_main_path
    date_updated
    date_created
  }
}
    `;
export type UpdateDirectoryIngredientMutationFn = Apollo.MutationFunction<UpdateDirectoryIngredientMutation, UpdateDirectoryIngredientMutationVariables>;

/**
 * __useUpdateDirectoryIngredientMutation__
 *
 * To run a mutation, you first call `useUpdateDirectoryIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDirectoryIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDirectoryIngredientMutation, { data, loading, error }] = useUpdateDirectoryIngredientMutation({
 *   variables: {
 *      ingredientId: // value for 'ingredientId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDirectoryIngredientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDirectoryIngredientMutation, UpdateDirectoryIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDirectoryIngredientMutation, UpdateDirectoryIngredientMutationVariables>(UpdateDirectoryIngredientDocument, options);
      }
export type UpdateDirectoryIngredientMutationHookResult = ReturnType<typeof useUpdateDirectoryIngredientMutation>;
export type UpdateDirectoryIngredientMutationResult = Apollo.MutationResult<UpdateDirectoryIngredientMutation>;
export type UpdateDirectoryIngredientMutationOptions = Apollo.BaseMutationOptions<UpdateDirectoryIngredientMutation, UpdateDirectoryIngredientMutationVariables>;
export const DeleteDirectoryIngredientDocument = gql`
    mutation deleteDirectoryIngredient($ingredientId: Int) {
  deleteDirectoryIngredient(ingredientId: $ingredientId)
}
    `;
export type DeleteDirectoryIngredientMutationFn = Apollo.MutationFunction<DeleteDirectoryIngredientMutation, DeleteDirectoryIngredientMutationVariables>;

/**
 * __useDeleteDirectoryIngredientMutation__
 *
 * To run a mutation, you first call `useDeleteDirectoryIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDirectoryIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDirectoryIngredientMutation, { data, loading, error }] = useDeleteDirectoryIngredientMutation({
 *   variables: {
 *      ingredientId: // value for 'ingredientId'
 *   },
 * });
 */
export function useDeleteDirectoryIngredientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDirectoryIngredientMutation, DeleteDirectoryIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDirectoryIngredientMutation, DeleteDirectoryIngredientMutationVariables>(DeleteDirectoryIngredientDocument, options);
      }
export type DeleteDirectoryIngredientMutationHookResult = ReturnType<typeof useDeleteDirectoryIngredientMutation>;
export type DeleteDirectoryIngredientMutationResult = Apollo.MutationResult<DeleteDirectoryIngredientMutation>;
export type DeleteDirectoryIngredientMutationOptions = Apollo.BaseMutationOptions<DeleteDirectoryIngredientMutation, DeleteDirectoryIngredientMutationVariables>;
export const IngredientDetailDocument = gql`
    query ingredientDetail($ingredient_id: Int, $slug: String) {
  ingredientDetail(ingredient_id: $ingredient_id, slug: $slug) {
    ingredient_id
    name
    slug
    illustrationImage
    mainImage
    type
    pairing
    isSeasonal
    description
    flavoring
    preparation
    methods
    cookingGuidance
    parent_product_id
    is_generic
    requires_enhanced
    listings {
      listing_id
      enhanced
      verified
      user_type
      membership_type
      resourcePath
      email
      name
      photo
      phone
      website
      latitude
      longitude
      publicPhone
      city
      date_updated
      date_created
      slug
      business_description_completed
      products_completed
      vendors_completed
      selling_locations_completed
      sales_channels_completed
    }
    cooking
    choosing
    date_updated
    date_created
    start_month
    peak_month
    end_month
    availableMonths {
      month
      isPeak
    }
  }
}
    `;

/**
 * __useIngredientDetailQuery__
 *
 * To run a query within a React component, call `useIngredientDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngredientDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngredientDetailQuery({
 *   variables: {
 *      ingredient_id: // value for 'ingredient_id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useIngredientDetailQuery(baseOptions?: Apollo.QueryHookOptions<IngredientDetailQuery, IngredientDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IngredientDetailQuery, IngredientDetailQueryVariables>(IngredientDetailDocument, options);
      }
export function useIngredientDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IngredientDetailQuery, IngredientDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IngredientDetailQuery, IngredientDetailQueryVariables>(IngredientDetailDocument, options);
        }
export function useIngredientDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IngredientDetailQuery, IngredientDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IngredientDetailQuery, IngredientDetailQueryVariables>(IngredientDetailDocument, options);
        }
export type IngredientDetailQueryHookResult = ReturnType<typeof useIngredientDetailQuery>;
export type IngredientDetailLazyQueryHookResult = ReturnType<typeof useIngredientDetailLazyQuery>;
export type IngredientDetailSuspenseQueryHookResult = ReturnType<typeof useIngredientDetailSuspenseQuery>;
export type IngredientDetailQueryResult = Apollo.QueryResult<IngredientDetailQuery, IngredientDetailQueryVariables>;
export const SetIngredientAvailableMonthsDocument = gql`
    mutation setIngredientAvailableMonths($ingredientId: Int!, $months: [IngredientMonthInput!]!) {
  setIngredientAvailableMonths(ingredientId: $ingredientId, months: $months) {
    ingredient_id
    start_month
    peak_month
    end_month
    availableMonths {
      month
      isPeak
    }
  }
}
    `;
export type SetIngredientAvailableMonthsMutationFn = Apollo.MutationFunction<SetIngredientAvailableMonthsMutation, SetIngredientAvailableMonthsMutationVariables>;

/**
 * __useSetIngredientAvailableMonthsMutation__
 *
 * To run a mutation, you first call `useSetIngredientAvailableMonthsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIngredientAvailableMonthsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIngredientAvailableMonthsMutation, { data, loading, error }] = useSetIngredientAvailableMonthsMutation({
 *   variables: {
 *      ingredientId: // value for 'ingredientId'
 *      months: // value for 'months'
 *   },
 * });
 */
export function useSetIngredientAvailableMonthsMutation(baseOptions?: Apollo.MutationHookOptions<SetIngredientAvailableMonthsMutation, SetIngredientAvailableMonthsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIngredientAvailableMonthsMutation, SetIngredientAvailableMonthsMutationVariables>(SetIngredientAvailableMonthsDocument, options);
      }
export type SetIngredientAvailableMonthsMutationHookResult = ReturnType<typeof useSetIngredientAvailableMonthsMutation>;
export type SetIngredientAvailableMonthsMutationResult = Apollo.MutationResult<SetIngredientAvailableMonthsMutation>;
export type SetIngredientAvailableMonthsMutationOptions = Apollo.BaseMutationOptions<SetIngredientAvailableMonthsMutation, SetIngredientAvailableMonthsMutationVariables>;
export const UpdateIngredientImageDocument = gql`
    mutation updateIngredientImage($file: Upload!, $ingredientID: Int!, $type: String!) {
  updateIngredientImage(file: $file, ingredientID: $ingredientID, typeArg: $type) {
    illustrationImage
  }
}
    `;
export type UpdateIngredientImageMutationFn = Apollo.MutationFunction<UpdateIngredientImageMutation, UpdateIngredientImageMutationVariables>;

/**
 * __useUpdateIngredientImageMutation__
 *
 * To run a mutation, you first call `useUpdateIngredientImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngredientImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngredientImageMutation, { data, loading, error }] = useUpdateIngredientImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *      ingredientID: // value for 'ingredientID'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateIngredientImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIngredientImageMutation, UpdateIngredientImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIngredientImageMutation, UpdateIngredientImageMutationVariables>(UpdateIngredientImageDocument, options);
      }
export type UpdateIngredientImageMutationHookResult = ReturnType<typeof useUpdateIngredientImageMutation>;
export type UpdateIngredientImageMutationResult = Apollo.MutationResult<UpdateIngredientImageMutation>;
export type UpdateIngredientImageMutationOptions = Apollo.BaseMutationOptions<UpdateIngredientImageMutation, UpdateIngredientImageMutationVariables>;
export const GetRecipeIngredientsDocument = gql`
    query GetRecipeIngredients($query: String!) {
  getRecipeIngredients(searchTerm: $query) {
    ingredient_id
    ingredient_name
  }
}
    `;

/**
 * __useGetRecipeIngredientsQuery__
 *
 * To run a query within a React component, call `useGetRecipeIngredientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipeIngredientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipeIngredientsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetRecipeIngredientsQuery(baseOptions: Apollo.QueryHookOptions<GetRecipeIngredientsQuery, GetRecipeIngredientsQueryVariables> & ({ variables: GetRecipeIngredientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipeIngredientsQuery, GetRecipeIngredientsQueryVariables>(GetRecipeIngredientsDocument, options);
      }
export function useGetRecipeIngredientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipeIngredientsQuery, GetRecipeIngredientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipeIngredientsQuery, GetRecipeIngredientsQueryVariables>(GetRecipeIngredientsDocument, options);
        }
export function useGetRecipeIngredientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecipeIngredientsQuery, GetRecipeIngredientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecipeIngredientsQuery, GetRecipeIngredientsQueryVariables>(GetRecipeIngredientsDocument, options);
        }
export type GetRecipeIngredientsQueryHookResult = ReturnType<typeof useGetRecipeIngredientsQuery>;
export type GetRecipeIngredientsLazyQueryHookResult = ReturnType<typeof useGetRecipeIngredientsLazyQuery>;
export type GetRecipeIngredientsSuspenseQueryHookResult = ReturnType<typeof useGetRecipeIngredientsSuspenseQuery>;
export type GetRecipeIngredientsQueryResult = Apollo.QueryResult<GetRecipeIngredientsQuery, GetRecipeIngredientsQueryVariables>;
export const GetUserProductsDocument = gql`
    query GetUserProducts($userId: Int!) {
  getUserIngredients(user_id: $userId) {
    ingredient_id
    slug
    name
    illustrationImage
    mainImage
    type
    isSeasonal
    parent_product_id
    is_generic
    requires_enhanced
    start_month
    peak_month
    end_month
  }
}
    `;

/**
 * __useGetUserProductsQuery__
 *
 * To run a query within a React component, call `useGetUserProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProductsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserProductsQuery(baseOptions: Apollo.QueryHookOptions<GetUserProductsQuery, GetUserProductsQueryVariables> & ({ variables: GetUserProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProductsQuery, GetUserProductsQueryVariables>(GetUserProductsDocument, options);
      }
export function useGetUserProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProductsQuery, GetUserProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProductsQuery, GetUserProductsQueryVariables>(GetUserProductsDocument, options);
        }
export function useGetUserProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProductsQuery, GetUserProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProductsQuery, GetUserProductsQueryVariables>(GetUserProductsDocument, options);
        }
export type GetUserProductsQueryHookResult = ReturnType<typeof useGetUserProductsQuery>;
export type GetUserProductsLazyQueryHookResult = ReturnType<typeof useGetUserProductsLazyQuery>;
export type GetUserProductsSuspenseQueryHookResult = ReturnType<typeof useGetUserProductsSuspenseQuery>;
export type GetUserProductsQueryResult = Apollo.QueryResult<GetUserProductsQuery, GetUserProductsQueryVariables>;
export const GetRecipeIngredientsForApprovalDocument = gql`
    query GetRecipeIngredientsForApproval {
  getRecipeIngredientsForApproval {
    ingredient_id
    ingredient_name
    ingredient_description
    is_validated
  }
}
    `;

/**
 * __useGetRecipeIngredientsForApprovalQuery__
 *
 * To run a query within a React component, call `useGetRecipeIngredientsForApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipeIngredientsForApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipeIngredientsForApprovalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecipeIngredientsForApprovalQuery(baseOptions?: Apollo.QueryHookOptions<GetRecipeIngredientsForApprovalQuery, GetRecipeIngredientsForApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipeIngredientsForApprovalQuery, GetRecipeIngredientsForApprovalQueryVariables>(GetRecipeIngredientsForApprovalDocument, options);
      }
export function useGetRecipeIngredientsForApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipeIngredientsForApprovalQuery, GetRecipeIngredientsForApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipeIngredientsForApprovalQuery, GetRecipeIngredientsForApprovalQueryVariables>(GetRecipeIngredientsForApprovalDocument, options);
        }
export function useGetRecipeIngredientsForApprovalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecipeIngredientsForApprovalQuery, GetRecipeIngredientsForApprovalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecipeIngredientsForApprovalQuery, GetRecipeIngredientsForApprovalQueryVariables>(GetRecipeIngredientsForApprovalDocument, options);
        }
export type GetRecipeIngredientsForApprovalQueryHookResult = ReturnType<typeof useGetRecipeIngredientsForApprovalQuery>;
export type GetRecipeIngredientsForApprovalLazyQueryHookResult = ReturnType<typeof useGetRecipeIngredientsForApprovalLazyQuery>;
export type GetRecipeIngredientsForApprovalSuspenseQueryHookResult = ReturnType<typeof useGetRecipeIngredientsForApprovalSuspenseQuery>;
export type GetRecipeIngredientsForApprovalQueryResult = Apollo.QueryResult<GetRecipeIngredientsForApprovalQuery, GetRecipeIngredientsForApprovalQueryVariables>;
export const ApprovalUnvalidatedIngredientDocument = gql`
    mutation ApprovalUnvalidatedIngredient($ingredID: Int!, $state: Boolean!) {
  approvalUnValidatedIngredient(ingredientID: $ingredID, state: $state)
}
    `;
export type ApprovalUnvalidatedIngredientMutationFn = Apollo.MutationFunction<ApprovalUnvalidatedIngredientMutation, ApprovalUnvalidatedIngredientMutationVariables>;

/**
 * __useApprovalUnvalidatedIngredientMutation__
 *
 * To run a mutation, you first call `useApprovalUnvalidatedIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalUnvalidatedIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalUnvalidatedIngredientMutation, { data, loading, error }] = useApprovalUnvalidatedIngredientMutation({
 *   variables: {
 *      ingredID: // value for 'ingredID'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useApprovalUnvalidatedIngredientMutation(baseOptions?: Apollo.MutationHookOptions<ApprovalUnvalidatedIngredientMutation, ApprovalUnvalidatedIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovalUnvalidatedIngredientMutation, ApprovalUnvalidatedIngredientMutationVariables>(ApprovalUnvalidatedIngredientDocument, options);
      }
export type ApprovalUnvalidatedIngredientMutationHookResult = ReturnType<typeof useApprovalUnvalidatedIngredientMutation>;
export type ApprovalUnvalidatedIngredientMutationResult = Apollo.MutationResult<ApprovalUnvalidatedIngredientMutation>;
export type ApprovalUnvalidatedIngredientMutationOptions = Apollo.BaseMutationOptions<ApprovalUnvalidatedIngredientMutation, ApprovalUnvalidatedIngredientMutationVariables>;
export const GetDirectoryListingDocument = gql`
    query GetDirectoryListing($filter: DirectoryInput, $limit: Int, $page: Int, $searchTerm: String, $isEnhanced: Boolean) {
  getDirectoryListing(
    filter: $filter
    limit: $limit
    page: $page
    searchTerm: $searchTerm
    isEnhanced: $isEnhanced
  ) {
    total
    page
    listings {
      listing_id
      name
      enhanced
      user_type
      membership_type
      photo
      description
      latitude
      longitude
      city
      state
      email
      publicEmail
      instagram
      publicPhone
      phone
      facebook
      twitter
      pending
      website
      approved
      address
      zipcode
      tagLine
      slug
      verified
      deleted_at
      date_created
      subscription {
        stripe_sub_id
      }
      user {
        profile_photo_resource
        slug
        user_id
        user_type
        date_last_login
      }
    }
  }
}
    `;

/**
 * __useGetDirectoryListingQuery__
 *
 * To run a query within a React component, call `useGetDirectoryListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectoryListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectoryListingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      searchTerm: // value for 'searchTerm'
 *      isEnhanced: // value for 'isEnhanced'
 *   },
 * });
 */
export function useGetDirectoryListingQuery(baseOptions?: Apollo.QueryHookOptions<GetDirectoryListingQuery, GetDirectoryListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectoryListingQuery, GetDirectoryListingQueryVariables>(GetDirectoryListingDocument, options);
      }
export function useGetDirectoryListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectoryListingQuery, GetDirectoryListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectoryListingQuery, GetDirectoryListingQueryVariables>(GetDirectoryListingDocument, options);
        }
export function useGetDirectoryListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectoryListingQuery, GetDirectoryListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectoryListingQuery, GetDirectoryListingQueryVariables>(GetDirectoryListingDocument, options);
        }
export type GetDirectoryListingQueryHookResult = ReturnType<typeof useGetDirectoryListingQuery>;
export type GetDirectoryListingLazyQueryHookResult = ReturnType<typeof useGetDirectoryListingLazyQuery>;
export type GetDirectoryListingSuspenseQueryHookResult = ReturnType<typeof useGetDirectoryListingSuspenseQuery>;
export type GetDirectoryListingQueryResult = Apollo.QueryResult<GetDirectoryListingQuery, GetDirectoryListingQueryVariables>;
export const GetListingVendorsDocument = gql`
    query GetListingVendors($lat: Float, $long: Float, $city: String, $state: String) {
  getListingVendors(lat: $lat, long: $long, city: $city, state: $state) {
    listing_id
    name
    enhanced
    user_type
    membership_type
    photo
    description
    latitude
    longitude
    city
    state
    zipcode
    pending
    website
    approved
    address
    tagLine
    slug
    publicEmail
    ingredients {
      ingredient_id
      name
      illustrationImage
      mainImage
      type
      pairing
      isSeasonal
      description
      cookingGuidance
      cooking
      choosing
    }
  }
}
    `;

/**
 * __useGetListingVendorsQuery__
 *
 * To run a query within a React component, call `useGetListingVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingVendorsQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      long: // value for 'long'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetListingVendorsQuery(baseOptions?: Apollo.QueryHookOptions<GetListingVendorsQuery, GetListingVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingVendorsQuery, GetListingVendorsQueryVariables>(GetListingVendorsDocument, options);
      }
export function useGetListingVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingVendorsQuery, GetListingVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingVendorsQuery, GetListingVendorsQueryVariables>(GetListingVendorsDocument, options);
        }
export function useGetListingVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetListingVendorsQuery, GetListingVendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetListingVendorsQuery, GetListingVendorsQueryVariables>(GetListingVendorsDocument, options);
        }
export type GetListingVendorsQueryHookResult = ReturnType<typeof useGetListingVendorsQuery>;
export type GetListingVendorsLazyQueryHookResult = ReturnType<typeof useGetListingVendorsLazyQuery>;
export type GetListingVendorsSuspenseQueryHookResult = ReturnType<typeof useGetListingVendorsSuspenseQuery>;
export type GetListingVendorsQueryResult = Apollo.QueryResult<GetListingVendorsQuery, GetListingVendorsQueryVariables>;
export const ListingDetailDocument = gql`
    query listingDetail($listingId: Int, $slug: String) {
  listingDetail(listingId: $listingId, slug: $slug) {
    listing_id
    user_id
    name
    enhanced
    user_type
    membership_type
    photo
    firstName
    lastName
    description
    latitude
    longitude
    city
    state
    email
    publicEmail
    instagram
    publicPhone
    phone
    facebook
    twitter
    pending
    website
    approved
    address
    zipcode
    tagLine
    verified
    slug
    business_description_completed
    products_completed
    selling_locations_completed
    sales_channels_completed
    profile_image_completed
    geolocation_completed
    has_created_recipe
    has_created_feed_post
    has_shared_content
    user {
      user_id
      profile_photo_resource
      slug
    }
    vendors {
      listing_id
      slug
      enhanced
      user_type
      membership_type
      resourcePath
      email
      firstName
      lastName
      name
      photo
      phone
      website
      latitude
      longitude
      publicPhone
      address
      zipcode
      city
      state
      description
      tagLine
    }
    ingredients {
      ingredient_id
      name
      illustrationImage
      mainImage
      type
      pairing
      isSeasonal
      description
      start_month
      end_month
      availableMonths {
        month
        isPeak
      }
      cookingGuidance
      cooking
      choosing
      listings {
        name
        photo
      }
    }
    Practices {
      practice_id
      tag
      name
      imgUrl
    }
    SalesChannels {
      sales_channel_id
      name
      description
      icon
    }
    OperatingPeriod {
      operationId
      listing_id
      day
      openingTime
      closingTime
    }
    subscription {
      subscription_id
      user_id
      status
      current_period_end
      created_at
      tax_exemption
      tax_cert_number
      tax_cert_expiration_date
    }
  }
}
    `;

/**
 * __useListingDetailQuery__
 *
 * To run a query within a React component, call `useListingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingDetailQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useListingDetailQuery(baseOptions?: Apollo.QueryHookOptions<ListingDetailQuery, ListingDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingDetailQuery, ListingDetailQueryVariables>(ListingDetailDocument, options);
      }
export function useListingDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingDetailQuery, ListingDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingDetailQuery, ListingDetailQueryVariables>(ListingDetailDocument, options);
        }
export function useListingDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingDetailQuery, ListingDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingDetailQuery, ListingDetailQueryVariables>(ListingDetailDocument, options);
        }
export type ListingDetailQueryHookResult = ReturnType<typeof useListingDetailQuery>;
export type ListingDetailLazyQueryHookResult = ReturnType<typeof useListingDetailLazyQuery>;
export type ListingDetailSuspenseQueryHookResult = ReturnType<typeof useListingDetailSuspenseQuery>;
export type ListingDetailQueryResult = Apollo.QueryResult<ListingDetailQuery, ListingDetailQueryVariables>;
export const GetPracticesDocument = gql`
    query getPractices {
  getPractices {
    practice_id
    tag
    name
    resource_path
    imgUrl
  }
}
    `;

/**
 * __useGetPracticesQuery__
 *
 * To run a query within a React component, call `useGetPracticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPracticesQuery(baseOptions?: Apollo.QueryHookOptions<GetPracticesQuery, GetPracticesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticesQuery, GetPracticesQueryVariables>(GetPracticesDocument, options);
      }
export function useGetPracticesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticesQuery, GetPracticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticesQuery, GetPracticesQueryVariables>(GetPracticesDocument, options);
        }
export function useGetPracticesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPracticesQuery, GetPracticesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPracticesQuery, GetPracticesQueryVariables>(GetPracticesDocument, options);
        }
export type GetPracticesQueryHookResult = ReturnType<typeof useGetPracticesQuery>;
export type GetPracticesLazyQueryHookResult = ReturnType<typeof useGetPracticesLazyQuery>;
export type GetPracticesSuspenseQueryHookResult = ReturnType<typeof useGetPracticesSuspenseQuery>;
export type GetPracticesQueryResult = Apollo.QueryResult<GetPracticesQuery, GetPracticesQueryVariables>;
export const GetSalesChannelsDocument = gql`
    query getSalesChannels {
  getSalesChannels {
    sales_channel_id
    name
    description
    icon
  }
}
    `;

/**
 * __useGetSalesChannelsQuery__
 *
 * To run a query within a React component, call `useGetSalesChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesChannelsQuery, GetSalesChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesChannelsQuery, GetSalesChannelsQueryVariables>(GetSalesChannelsDocument, options);
      }
export function useGetSalesChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesChannelsQuery, GetSalesChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesChannelsQuery, GetSalesChannelsQueryVariables>(GetSalesChannelsDocument, options);
        }
export function useGetSalesChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesChannelsQuery, GetSalesChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesChannelsQuery, GetSalesChannelsQueryVariables>(GetSalesChannelsDocument, options);
        }
export type GetSalesChannelsQueryHookResult = ReturnType<typeof useGetSalesChannelsQuery>;
export type GetSalesChannelsLazyQueryHookResult = ReturnType<typeof useGetSalesChannelsLazyQuery>;
export type GetSalesChannelsSuspenseQueryHookResult = ReturnType<typeof useGetSalesChannelsSuspenseQuery>;
export type GetSalesChannelsQueryResult = Apollo.QueryResult<GetSalesChannelsQuery, GetSalesChannelsQueryVariables>;
export const GetPendingListingsDocument = gql`
    query GetPendingListings {
  getPendingListings {
    listing_id
    name
    enhanced
    pending
    approved
    address
  }
}
    `;

/**
 * __useGetPendingListingsQuery__
 *
 * To run a query within a React component, call `useGetPendingListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingListingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingListingsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingListingsQuery, GetPendingListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingListingsQuery, GetPendingListingsQueryVariables>(GetPendingListingsDocument, options);
      }
export function useGetPendingListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingListingsQuery, GetPendingListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingListingsQuery, GetPendingListingsQueryVariables>(GetPendingListingsDocument, options);
        }
export function useGetPendingListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingListingsQuery, GetPendingListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingListingsQuery, GetPendingListingsQueryVariables>(GetPendingListingsDocument, options);
        }
export type GetPendingListingsQueryHookResult = ReturnType<typeof useGetPendingListingsQuery>;
export type GetPendingListingsLazyQueryHookResult = ReturnType<typeof useGetPendingListingsLazyQuery>;
export type GetPendingListingsSuspenseQueryHookResult = ReturnType<typeof useGetPendingListingsSuspenseQuery>;
export type GetPendingListingsQueryResult = Apollo.QueryResult<GetPendingListingsQuery, GetPendingListingsQueryVariables>;
export const CreateListingDocument = gql`
    mutation createListing($input: ListingInput) {
  createListing(input: $input) {
    listing_id
    enhanced
    user_type
    membership_type
    email
    firstName
    lastName
    name
    photo
    phone
    website
    latitude
    longitude
    publicPhone
    city
    state
    description
    pending
    approved
    address
    instagram
    facebook
    twitter
    tagLine
    date_updated
    date_created
  }
}
    `;
export type CreateListingMutationFn = Apollo.MutationFunction<CreateListingMutation, CreateListingMutationVariables>;

/**
 * __useCreateListingMutation__
 *
 * To run a mutation, you first call `useCreateListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingMutation, { data, loading, error }] = useCreateListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListingMutation(baseOptions?: Apollo.MutationHookOptions<CreateListingMutation, CreateListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListingMutation, CreateListingMutationVariables>(CreateListingDocument, options);
      }
export type CreateListingMutationHookResult = ReturnType<typeof useCreateListingMutation>;
export type CreateListingMutationResult = Apollo.MutationResult<CreateListingMutation>;
export type CreateListingMutationOptions = Apollo.BaseMutationOptions<CreateListingMutation, CreateListingMutationVariables>;
export const UpdateListingDocument = gql`
    mutation updateListing($listingId: Int!, $input: ListingInput) {
  updateListing(listingId: $listingId, input: $input) {
    listing_id
    enhanced
    user_type
    membership_type
    resourcePath
    email
    firstName
    lastName
    name
    photo
    phone
    website
    latitude
    longitude
    publicPhone
    city
    state
    description
    pending
    approved
    address
    instagram
    facebook
    twitter
    zipcode
    tagLine
    slug
  }
}
    `;
export type UpdateListingMutationFn = Apollo.MutationFunction<UpdateListingMutation, UpdateListingMutationVariables>;

/**
 * __useUpdateListingMutation__
 *
 * To run a mutation, you first call `useUpdateListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingMutation, { data, loading, error }] = useUpdateListingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListingMutation, UpdateListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListingMutation, UpdateListingMutationVariables>(UpdateListingDocument, options);
      }
export type UpdateListingMutationHookResult = ReturnType<typeof useUpdateListingMutation>;
export type UpdateListingMutationResult = Apollo.MutationResult<UpdateListingMutation>;
export type UpdateListingMutationOptions = Apollo.BaseMutationOptions<UpdateListingMutation, UpdateListingMutationVariables>;
export const CreateEnhancedDocument = gql`
    mutation createEnhanced($input: ListingInput, $vendors: [ListingInput], $ingredientInput: [DirectoryIngredientInput], $practices: [PracticeInput], $sellingLocations: [SellingLocationInput]) {
  createEnhanced(
    input: $input
    vendors: $vendors
    ingredientInput: $ingredientInput
    Practices: $practices
    sellingLocations: $sellingLocations
  ) {
    listing_id
    enhanced
    user_type
    membership_type
    email
    firstName
    lastName
    name
    photo
    phone
    website
    latitude
    longitude
    publicPhone
    city
    state
    description
    pending
    approved
    address
    instagram
    facebook
    twitter
    date_updated
    date_created
    tagLine
  }
}
    `;
export type CreateEnhancedMutationFn = Apollo.MutationFunction<CreateEnhancedMutation, CreateEnhancedMutationVariables>;

/**
 * __useCreateEnhancedMutation__
 *
 * To run a mutation, you first call `useCreateEnhancedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnhancedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnhancedMutation, { data, loading, error }] = useCreateEnhancedMutation({
 *   variables: {
 *      input: // value for 'input'
 *      vendors: // value for 'vendors'
 *      ingredientInput: // value for 'ingredientInput'
 *      practices: // value for 'practices'
 *      sellingLocations: // value for 'sellingLocations'
 *   },
 * });
 */
export function useCreateEnhancedMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnhancedMutation, CreateEnhancedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEnhancedMutation, CreateEnhancedMutationVariables>(CreateEnhancedDocument, options);
      }
export type CreateEnhancedMutationHookResult = ReturnType<typeof useCreateEnhancedMutation>;
export type CreateEnhancedMutationResult = Apollo.MutationResult<CreateEnhancedMutation>;
export type CreateEnhancedMutationOptions = Apollo.BaseMutationOptions<CreateEnhancedMutation, CreateEnhancedMutationVariables>;
export const CreateListingOperationTimeDocument = gql`
    mutation createListingOperationTime($input: [OperatingHoursInput!]) {
  createListingOperationTime(input: $input) {
    operationId
    listing_id
    day
    openingTime
    closingTime
  }
}
    `;
export type CreateListingOperationTimeMutationFn = Apollo.MutationFunction<CreateListingOperationTimeMutation, CreateListingOperationTimeMutationVariables>;

/**
 * __useCreateListingOperationTimeMutation__
 *
 * To run a mutation, you first call `useCreateListingOperationTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingOperationTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingOperationTimeMutation, { data, loading, error }] = useCreateListingOperationTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListingOperationTimeMutation(baseOptions?: Apollo.MutationHookOptions<CreateListingOperationTimeMutation, CreateListingOperationTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListingOperationTimeMutation, CreateListingOperationTimeMutationVariables>(CreateListingOperationTimeDocument, options);
      }
export type CreateListingOperationTimeMutationHookResult = ReturnType<typeof useCreateListingOperationTimeMutation>;
export type CreateListingOperationTimeMutationResult = Apollo.MutationResult<CreateListingOperationTimeMutation>;
export type CreateListingOperationTimeMutationOptions = Apollo.BaseMutationOptions<CreateListingOperationTimeMutation, CreateListingOperationTimeMutationVariables>;
export const ReplaceListingPracticesDocument = gql`
    mutation replaceListingPractices($listingId: Int!, $input: [PracticeInput!]!) {
  replaceListingPractices(listingId: $listingId, input: $input)
}
    `;
export type ReplaceListingPracticesMutationFn = Apollo.MutationFunction<ReplaceListingPracticesMutation, ReplaceListingPracticesMutationVariables>;

/**
 * __useReplaceListingPracticesMutation__
 *
 * To run a mutation, you first call `useReplaceListingPracticesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceListingPracticesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceListingPracticesMutation, { data, loading, error }] = useReplaceListingPracticesMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceListingPracticesMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceListingPracticesMutation, ReplaceListingPracticesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceListingPracticesMutation, ReplaceListingPracticesMutationVariables>(ReplaceListingPracticesDocument, options);
      }
export type ReplaceListingPracticesMutationHookResult = ReturnType<typeof useReplaceListingPracticesMutation>;
export type ReplaceListingPracticesMutationResult = Apollo.MutationResult<ReplaceListingPracticesMutation>;
export type ReplaceListingPracticesMutationOptions = Apollo.BaseMutationOptions<ReplaceListingPracticesMutation, ReplaceListingPracticesMutationVariables>;
export const ReplaceListingSalesChannelsDocument = gql`
    mutation replaceListingSalesChannels($listingId: Int!, $input: [SalesChannelInput!]!) {
  replaceListingSalesChannels(listingId: $listingId, input: $input)
}
    `;
export type ReplaceListingSalesChannelsMutationFn = Apollo.MutationFunction<ReplaceListingSalesChannelsMutation, ReplaceListingSalesChannelsMutationVariables>;

/**
 * __useReplaceListingSalesChannelsMutation__
 *
 * To run a mutation, you first call `useReplaceListingSalesChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceListingSalesChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceListingSalesChannelsMutation, { data, loading, error }] = useReplaceListingSalesChannelsMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceListingSalesChannelsMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceListingSalesChannelsMutation, ReplaceListingSalesChannelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceListingSalesChannelsMutation, ReplaceListingSalesChannelsMutationVariables>(ReplaceListingSalesChannelsDocument, options);
      }
export type ReplaceListingSalesChannelsMutationHookResult = ReturnType<typeof useReplaceListingSalesChannelsMutation>;
export type ReplaceListingSalesChannelsMutationResult = Apollo.MutationResult<ReplaceListingSalesChannelsMutation>;
export type ReplaceListingSalesChannelsMutationOptions = Apollo.BaseMutationOptions<ReplaceListingSalesChannelsMutation, ReplaceListingSalesChannelsMutationVariables>;
export const ReplaceListingOperationTimeDocument = gql`
    mutation replaceListingOperationTime($listingId: Int!, $input: [OperatingHoursInput!]!) {
  replaceListingOperationTime(listingId: $listingId, input: $input) {
    operationId
    listing_id
    day
    openingTime
    closingTime
  }
}
    `;
export type ReplaceListingOperationTimeMutationFn = Apollo.MutationFunction<ReplaceListingOperationTimeMutation, ReplaceListingOperationTimeMutationVariables>;

/**
 * __useReplaceListingOperationTimeMutation__
 *
 * To run a mutation, you first call `useReplaceListingOperationTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceListingOperationTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceListingOperationTimeMutation, { data, loading, error }] = useReplaceListingOperationTimeMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceListingOperationTimeMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceListingOperationTimeMutation, ReplaceListingOperationTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceListingOperationTimeMutation, ReplaceListingOperationTimeMutationVariables>(ReplaceListingOperationTimeDocument, options);
      }
export type ReplaceListingOperationTimeMutationHookResult = ReturnType<typeof useReplaceListingOperationTimeMutation>;
export type ReplaceListingOperationTimeMutationResult = Apollo.MutationResult<ReplaceListingOperationTimeMutation>;
export type ReplaceListingOperationTimeMutationOptions = Apollo.BaseMutationOptions<ReplaceListingOperationTimeMutation, ReplaceListingOperationTimeMutationVariables>;
export const UpdateListingImageDocument = gql`
    mutation updateListingImage($file: Upload!, $listingID: Int!) {
  updateListingImage(file: $file, listingID: $listingID)
}
    `;
export type UpdateListingImageMutationFn = Apollo.MutationFunction<UpdateListingImageMutation, UpdateListingImageMutationVariables>;

/**
 * __useUpdateListingImageMutation__
 *
 * To run a mutation, you first call `useUpdateListingImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingImageMutation, { data, loading, error }] = useUpdateListingImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *      listingID: // value for 'listingID'
 *   },
 * });
 */
export function useUpdateListingImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListingImageMutation, UpdateListingImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListingImageMutation, UpdateListingImageMutationVariables>(UpdateListingImageDocument, options);
      }
export type UpdateListingImageMutationHookResult = ReturnType<typeof useUpdateListingImageMutation>;
export type UpdateListingImageMutationResult = Apollo.MutationResult<UpdateListingImageMutation>;
export type UpdateListingImageMutationOptions = Apollo.BaseMutationOptions<UpdateListingImageMutation, UpdateListingImageMutationVariables>;
export const GetListingOperatingTimeDocument = gql`
    query getListingOperatingTime($listingID: Int!) {
  getListingOperatingTime(listing_id: $listingID) {
    operationId
    listing_id
    day
    openingTime
    closingTime
  }
}
    `;

/**
 * __useGetListingOperatingTimeQuery__
 *
 * To run a query within a React component, call `useGetListingOperatingTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingOperatingTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingOperatingTimeQuery({
 *   variables: {
 *      listingID: // value for 'listingID'
 *   },
 * });
 */
export function useGetListingOperatingTimeQuery(baseOptions: Apollo.QueryHookOptions<GetListingOperatingTimeQuery, GetListingOperatingTimeQueryVariables> & ({ variables: GetListingOperatingTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingOperatingTimeQuery, GetListingOperatingTimeQueryVariables>(GetListingOperatingTimeDocument, options);
      }
export function useGetListingOperatingTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingOperatingTimeQuery, GetListingOperatingTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingOperatingTimeQuery, GetListingOperatingTimeQueryVariables>(GetListingOperatingTimeDocument, options);
        }
export function useGetListingOperatingTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetListingOperatingTimeQuery, GetListingOperatingTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetListingOperatingTimeQuery, GetListingOperatingTimeQueryVariables>(GetListingOperatingTimeDocument, options);
        }
export type GetListingOperatingTimeQueryHookResult = ReturnType<typeof useGetListingOperatingTimeQuery>;
export type GetListingOperatingTimeLazyQueryHookResult = ReturnType<typeof useGetListingOperatingTimeLazyQuery>;
export type GetListingOperatingTimeSuspenseQueryHookResult = ReturnType<typeof useGetListingOperatingTimeSuspenseQuery>;
export type GetListingOperatingTimeQueryResult = Apollo.QueryResult<GetListingOperatingTimeQuery, GetListingOperatingTimeQueryVariables>;
export const DeleteListingDocument = gql`
    mutation deleteListing($listingId: Int!) {
  deleteListing(listingId: $listingId)
}
    `;
export type DeleteListingMutationFn = Apollo.MutationFunction<DeleteListingMutation, DeleteListingMutationVariables>;

/**
 * __useDeleteListingMutation__
 *
 * To run a mutation, you first call `useDeleteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListingMutation, { data, loading, error }] = useDeleteListingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useDeleteListingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListingMutation, DeleteListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListingMutation, DeleteListingMutationVariables>(DeleteListingDocument, options);
      }
export type DeleteListingMutationHookResult = ReturnType<typeof useDeleteListingMutation>;
export type DeleteListingMutationResult = Apollo.MutationResult<DeleteListingMutation>;
export type DeleteListingMutationOptions = Apollo.BaseMutationOptions<DeleteListingMutation, DeleteListingMutationVariables>;
export const ApproveEnhanceDocument = gql`
    mutation approveEnhance($listingId: Int!, $approve: Boolean!, $pending: Boolean!, $enhance: Boolean!, $taxCertNumber: String, $taxCertExpirationDate: Time) {
  approveEnhance(
    listingId: $listingId
    approve: $approve
    pending: $pending
    enhance: $enhance
    taxCertNumber: $taxCertNumber
    taxCertExpirationDate: $taxCertExpirationDate
  ) {
    listing_id
    enhanced
    user_type
    membership_type
    resourcePath
    email
    pending
    approved
  }
}
    `;
export type ApproveEnhanceMutationFn = Apollo.MutationFunction<ApproveEnhanceMutation, ApproveEnhanceMutationVariables>;

/**
 * __useApproveEnhanceMutation__
 *
 * To run a mutation, you first call `useApproveEnhanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveEnhanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveEnhanceMutation, { data, loading, error }] = useApproveEnhanceMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      approve: // value for 'approve'
 *      pending: // value for 'pending'
 *      enhance: // value for 'enhance'
 *      taxCertNumber: // value for 'taxCertNumber'
 *      taxCertExpirationDate: // value for 'taxCertExpirationDate'
 *   },
 * });
 */
export function useApproveEnhanceMutation(baseOptions?: Apollo.MutationHookOptions<ApproveEnhanceMutation, ApproveEnhanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveEnhanceMutation, ApproveEnhanceMutationVariables>(ApproveEnhanceDocument, options);
      }
export type ApproveEnhanceMutationHookResult = ReturnType<typeof useApproveEnhanceMutation>;
export type ApproveEnhanceMutationResult = Apollo.MutationResult<ApproveEnhanceMutation>;
export type ApproveEnhanceMutationOptions = Apollo.BaseMutationOptions<ApproveEnhanceMutation, ApproveEnhanceMutationVariables>;
export const GetProducersNearMeDocument = gql`
    query GetProducersNearMe($lat: Float!, $long: Float!, $distance: Float, $limit: Int, $offset: Int, $search: String) {
  getProducersNearMe(
    lat: $lat
    long: $long
    distance: $distance
    limit: $limit
    offset: $offset
    searchTerm: $search
  ) {
    listing_id
    user_type
    membership_type
    resourcePath
    name
    photo
    latitude
    longitude
    distance
    city
    state
    address
    slug
    tagLine
    description
    zipcode
    verified
    enhanced
    nearby_market_count
    business_description_completed
    products_completed
    selling_locations_completed
    sales_channels_completed
    user {
      user_id
      slug
      profile_photo_resource
      full_name
    }
    ingredients {
      ingredient_id
      name
    }
    vendors {
      name
    }
  }
}
    `;

/**
 * __useGetProducersNearMeQuery__
 *
 * To run a query within a React component, call `useGetProducersNearMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProducersNearMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProducersNearMeQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      long: // value for 'long'
 *      distance: // value for 'distance'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetProducersNearMeQuery(baseOptions: Apollo.QueryHookOptions<GetProducersNearMeQuery, GetProducersNearMeQueryVariables> & ({ variables: GetProducersNearMeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProducersNearMeQuery, GetProducersNearMeQueryVariables>(GetProducersNearMeDocument, options);
      }
export function useGetProducersNearMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProducersNearMeQuery, GetProducersNearMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProducersNearMeQuery, GetProducersNearMeQueryVariables>(GetProducersNearMeDocument, options);
        }
export function useGetProducersNearMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProducersNearMeQuery, GetProducersNearMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProducersNearMeQuery, GetProducersNearMeQueryVariables>(GetProducersNearMeDocument, options);
        }
export type GetProducersNearMeQueryHookResult = ReturnType<typeof useGetProducersNearMeQuery>;
export type GetProducersNearMeLazyQueryHookResult = ReturnType<typeof useGetProducersNearMeLazyQuery>;
export type GetProducersNearMeSuspenseQueryHookResult = ReturnType<typeof useGetProducersNearMeSuspenseQuery>;
export type GetProducersNearMeQueryResult = Apollo.QueryResult<GetProducersNearMeQuery, GetProducersNearMeQueryVariables>;
export const GetMarketsNearMeDocument = gql`
    query GetMarketsNearMe($lat: Float!, $long: Float!, $distance: Float, $limit: Int, $offset: Int, $search: String) {
  getMarketsNearMe(
    lat: $lat
    long: $long
    distance: $distance
    limit: $limit
    offset: $offset
    searchTerm: $search
  ) {
    listing_id
    user_id
    user_type
    membership_type
    resourcePath
    name
    photo
    latitude
    longitude
    distance
    city
    state
    address
    description
    slug
    tagLine
    zipcode
    verified
    enhanced
    business_description_completed
    vendors_completed
    selling_locations_completed
    user {
      user_id
      slug
      profile_photo_resource
      full_name
    }
  }
}
    `;

/**
 * __useGetMarketsNearMeQuery__
 *
 * To run a query within a React component, call `useGetMarketsNearMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketsNearMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketsNearMeQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      long: // value for 'long'
 *      distance: // value for 'distance'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMarketsNearMeQuery(baseOptions: Apollo.QueryHookOptions<GetMarketsNearMeQuery, GetMarketsNearMeQueryVariables> & ({ variables: GetMarketsNearMeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketsNearMeQuery, GetMarketsNearMeQueryVariables>(GetMarketsNearMeDocument, options);
      }
export function useGetMarketsNearMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketsNearMeQuery, GetMarketsNearMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketsNearMeQuery, GetMarketsNearMeQueryVariables>(GetMarketsNearMeDocument, options);
        }
export function useGetMarketsNearMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMarketsNearMeQuery, GetMarketsNearMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMarketsNearMeQuery, GetMarketsNearMeQueryVariables>(GetMarketsNearMeDocument, options);
        }
export type GetMarketsNearMeQueryHookResult = ReturnType<typeof useGetMarketsNearMeQuery>;
export type GetMarketsNearMeLazyQueryHookResult = ReturnType<typeof useGetMarketsNearMeLazyQuery>;
export type GetMarketsNearMeSuspenseQueryHookResult = ReturnType<typeof useGetMarketsNearMeSuspenseQuery>;
export type GetMarketsNearMeQueryResult = Apollo.QueryResult<GetMarketsNearMeQuery, GetMarketsNearMeQueryVariables>;
export const DeclineEnhanceRequestDocument = gql`
    mutation DeclineEnhanceRequest($listing_id: Int!) {
  declineEnhance(listingId: $listing_id) {
    listing_id
    enhanced
    user_type
  }
}
    `;
export type DeclineEnhanceRequestMutationFn = Apollo.MutationFunction<DeclineEnhanceRequestMutation, DeclineEnhanceRequestMutationVariables>;

/**
 * __useDeclineEnhanceRequestMutation__
 *
 * To run a mutation, you first call `useDeclineEnhanceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineEnhanceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineEnhanceRequestMutation, { data, loading, error }] = useDeclineEnhanceRequestMutation({
 *   variables: {
 *      listing_id: // value for 'listing_id'
 *   },
 * });
 */
export function useDeclineEnhanceRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeclineEnhanceRequestMutation, DeclineEnhanceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineEnhanceRequestMutation, DeclineEnhanceRequestMutationVariables>(DeclineEnhanceRequestDocument, options);
      }
export type DeclineEnhanceRequestMutationHookResult = ReturnType<typeof useDeclineEnhanceRequestMutation>;
export type DeclineEnhanceRequestMutationResult = Apollo.MutationResult<DeclineEnhanceRequestMutation>;
export type DeclineEnhanceRequestMutationOptions = Apollo.BaseMutationOptions<DeclineEnhanceRequestMutation, DeclineEnhanceRequestMutationVariables>;
export const GetProductByListingIdDocument = gql`
    query GetProductByListingID($listingID: Int!) {
  getGetDirectoryIngredientByListingID(listingID: $listingID) {
    ingredient_id
    illustrationImage
    mainImage
    name
    slug
    description
    isSeasonal
    start_month
    end_month
    availableMonths {
      month
      isPeak
    }
    listings {
      listing_id
    }
  }
}
    `;

/**
 * __useGetProductByListingIdQuery__
 *
 * To run a query within a React component, call `useGetProductByListingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductByListingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductByListingIdQuery({
 *   variables: {
 *      listingID: // value for 'listingID'
 *   },
 * });
 */
export function useGetProductByListingIdQuery(baseOptions: Apollo.QueryHookOptions<GetProductByListingIdQuery, GetProductByListingIdQueryVariables> & ({ variables: GetProductByListingIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductByListingIdQuery, GetProductByListingIdQueryVariables>(GetProductByListingIdDocument, options);
      }
export function useGetProductByListingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductByListingIdQuery, GetProductByListingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductByListingIdQuery, GetProductByListingIdQueryVariables>(GetProductByListingIdDocument, options);
        }
export function useGetProductByListingIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductByListingIdQuery, GetProductByListingIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductByListingIdQuery, GetProductByListingIdQueryVariables>(GetProductByListingIdDocument, options);
        }
export type GetProductByListingIdQueryHookResult = ReturnType<typeof useGetProductByListingIdQuery>;
export type GetProductByListingIdLazyQueryHookResult = ReturnType<typeof useGetProductByListingIdLazyQuery>;
export type GetProductByListingIdSuspenseQueryHookResult = ReturnType<typeof useGetProductByListingIdSuspenseQuery>;
export type GetProductByListingIdQueryResult = Apollo.QueryResult<GetProductByListingIdQuery, GetProductByListingIdQueryVariables>;
export const GetVendorByListingIdDocument = gql`
    query GetVendorByListingID($listingID: Int!) {
  getVendorByListingID(listingID: $listingID) {
    listing_id
    name
    photo
    slug
    tagLine
    user {
      user_id
      slug
    }
    ingredients {
      type
    }
  }
}
    `;

/**
 * __useGetVendorByListingIdQuery__
 *
 * To run a query within a React component, call `useGetVendorByListingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorByListingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorByListingIdQuery({
 *   variables: {
 *      listingID: // value for 'listingID'
 *   },
 * });
 */
export function useGetVendorByListingIdQuery(baseOptions: Apollo.QueryHookOptions<GetVendorByListingIdQuery, GetVendorByListingIdQueryVariables> & ({ variables: GetVendorByListingIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorByListingIdQuery, GetVendorByListingIdQueryVariables>(GetVendorByListingIdDocument, options);
      }
export function useGetVendorByListingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorByListingIdQuery, GetVendorByListingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorByListingIdQuery, GetVendorByListingIdQueryVariables>(GetVendorByListingIdDocument, options);
        }
export function useGetVendorByListingIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorByListingIdQuery, GetVendorByListingIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorByListingIdQuery, GetVendorByListingIdQueryVariables>(GetVendorByListingIdDocument, options);
        }
export type GetVendorByListingIdQueryHookResult = ReturnType<typeof useGetVendorByListingIdQuery>;
export type GetVendorByListingIdLazyQueryHookResult = ReturnType<typeof useGetVendorByListingIdLazyQuery>;
export type GetVendorByListingIdSuspenseQueryHookResult = ReturnType<typeof useGetVendorByListingIdSuspenseQuery>;
export type GetVendorByListingIdQueryResult = Apollo.QueryResult<GetVendorByListingIdQuery, GetVendorByListingIdQueryVariables>;
export const GetSellingLocationsDocument = gql`
    query GetSellingLocations($listingId: Int!) {
  getSellingLocations(listingID: $listingId) {
    location_id
    listing_id
    user_id
    name
    address
    latitude
    longitude
    availabilities {
      day
      time
    }
    note
  }
}
    `;

/**
 * __useGetSellingLocationsQuery__
 *
 * To run a query within a React component, call `useGetSellingLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellingLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellingLocationsQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetSellingLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetSellingLocationsQuery, GetSellingLocationsQueryVariables> & ({ variables: GetSellingLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSellingLocationsQuery, GetSellingLocationsQueryVariables>(GetSellingLocationsDocument, options);
      }
export function useGetSellingLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellingLocationsQuery, GetSellingLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSellingLocationsQuery, GetSellingLocationsQueryVariables>(GetSellingLocationsDocument, options);
        }
export function useGetSellingLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSellingLocationsQuery, GetSellingLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSellingLocationsQuery, GetSellingLocationsQueryVariables>(GetSellingLocationsDocument, options);
        }
export type GetSellingLocationsQueryHookResult = ReturnType<typeof useGetSellingLocationsQuery>;
export type GetSellingLocationsLazyQueryHookResult = ReturnType<typeof useGetSellingLocationsLazyQuery>;
export type GetSellingLocationsSuspenseQueryHookResult = ReturnType<typeof useGetSellingLocationsSuspenseQuery>;
export type GetSellingLocationsQueryResult = Apollo.QueryResult<GetSellingLocationsQuery, GetSellingLocationsQueryVariables>;
export const CreateSellingLocationDocument = gql`
    mutation CreateSellingLocation($input: SellingLocationInput!) {
  createSellingLocation(input: $input) {
    location_id
    listing_id
    user_id
    name
    address
    latitude
    longitude
    availabilities {
      day
      time
    }
    note
  }
}
    `;
export type CreateSellingLocationMutationFn = Apollo.MutationFunction<CreateSellingLocationMutation, CreateSellingLocationMutationVariables>;

/**
 * __useCreateSellingLocationMutation__
 *
 * To run a mutation, you first call `useCreateSellingLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellingLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellingLocationMutation, { data, loading, error }] = useCreateSellingLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSellingLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSellingLocationMutation, CreateSellingLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSellingLocationMutation, CreateSellingLocationMutationVariables>(CreateSellingLocationDocument, options);
      }
export type CreateSellingLocationMutationHookResult = ReturnType<typeof useCreateSellingLocationMutation>;
export type CreateSellingLocationMutationResult = Apollo.MutationResult<CreateSellingLocationMutation>;
export type CreateSellingLocationMutationOptions = Apollo.BaseMutationOptions<CreateSellingLocationMutation, CreateSellingLocationMutationVariables>;
export const UpdateSellingLocationDocument = gql`
    mutation UpdateSellingLocation($locationID: Int!, $input: SellingLocationInput!) {
  updateSellingLocation(locationID: $locationID, input: $input) {
    location_id
    listing_id
    user_id
    name
    address
    latitude
    longitude
    availabilities {
      day
      time
    }
    note
  }
}
    `;
export type UpdateSellingLocationMutationFn = Apollo.MutationFunction<UpdateSellingLocationMutation, UpdateSellingLocationMutationVariables>;

/**
 * __useUpdateSellingLocationMutation__
 *
 * To run a mutation, you first call `useUpdateSellingLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellingLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellingLocationMutation, { data, loading, error }] = useUpdateSellingLocationMutation({
 *   variables: {
 *      locationID: // value for 'locationID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSellingLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellingLocationMutation, UpdateSellingLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellingLocationMutation, UpdateSellingLocationMutationVariables>(UpdateSellingLocationDocument, options);
      }
export type UpdateSellingLocationMutationHookResult = ReturnType<typeof useUpdateSellingLocationMutation>;
export type UpdateSellingLocationMutationResult = Apollo.MutationResult<UpdateSellingLocationMutation>;
export type UpdateSellingLocationMutationOptions = Apollo.BaseMutationOptions<UpdateSellingLocationMutation, UpdateSellingLocationMutationVariables>;
export const DeleteSellingLocationDocument = gql`
    mutation DeleteSellingLocation($locationID: Int!) {
  deleteSellingLocation(locationID: $locationID)
}
    `;
export type DeleteSellingLocationMutationFn = Apollo.MutationFunction<DeleteSellingLocationMutation, DeleteSellingLocationMutationVariables>;

/**
 * __useDeleteSellingLocationMutation__
 *
 * To run a mutation, you first call `useDeleteSellingLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSellingLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSellingLocationMutation, { data, loading, error }] = useDeleteSellingLocationMutation({
 *   variables: {
 *      locationID: // value for 'locationID'
 *   },
 * });
 */
export function useDeleteSellingLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSellingLocationMutation, DeleteSellingLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSellingLocationMutation, DeleteSellingLocationMutationVariables>(DeleteSellingLocationDocument, options);
      }
export type DeleteSellingLocationMutationHookResult = ReturnType<typeof useDeleteSellingLocationMutation>;
export type DeleteSellingLocationMutationResult = Apollo.MutationResult<DeleteSellingLocationMutation>;
export type DeleteSellingLocationMutationOptions = Apollo.BaseMutationOptions<DeleteSellingLocationMutation, DeleteSellingLocationMutationVariables>;
export const GetAllOnDemandListingDocument = gql`
    query GetAllOnDemandListing {
  getAllOnDemandListing {
    listing_id
    photo
    name
    phone
    email
    city
    state
    firstName
    lastName
    user_type
    description
    date_created
    user {
      slug
      full_name
    }
  }
}
    `;

/**
 * __useGetAllOnDemandListingQuery__
 *
 * To run a query within a React component, call `useGetAllOnDemandListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOnDemandListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOnDemandListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOnDemandListingQuery(baseOptions?: Apollo.QueryHookOptions<GetAllOnDemandListingQuery, GetAllOnDemandListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllOnDemandListingQuery, GetAllOnDemandListingQueryVariables>(GetAllOnDemandListingDocument, options);
      }
export function useGetAllOnDemandListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllOnDemandListingQuery, GetAllOnDemandListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllOnDemandListingQuery, GetAllOnDemandListingQueryVariables>(GetAllOnDemandListingDocument, options);
        }
export function useGetAllOnDemandListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllOnDemandListingQuery, GetAllOnDemandListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllOnDemandListingQuery, GetAllOnDemandListingQueryVariables>(GetAllOnDemandListingDocument, options);
        }
export type GetAllOnDemandListingQueryHookResult = ReturnType<typeof useGetAllOnDemandListingQuery>;
export type GetAllOnDemandListingLazyQueryHookResult = ReturnType<typeof useGetAllOnDemandListingLazyQuery>;
export type GetAllOnDemandListingSuspenseQueryHookResult = ReturnType<typeof useGetAllOnDemandListingSuspenseQuery>;
export type GetAllOnDemandListingQueryResult = Apollo.QueryResult<GetAllOnDemandListingQuery, GetAllOnDemandListingQueryVariables>;
export const GetUserAddedDirectoryIngredientDocument = gql`
    query GetUserAddedDirectoryIngredient {
  getUserAddedDirectoryIngredient {
    name
    type
    mainImage
    illustrationImage
    ingredient_id
    description
    allowUsage
    date_created
    slug
  }
}
    `;

/**
 * __useGetUserAddedDirectoryIngredientQuery__
 *
 * To run a query within a React component, call `useGetUserAddedDirectoryIngredientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAddedDirectoryIngredientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAddedDirectoryIngredientQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAddedDirectoryIngredientQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAddedDirectoryIngredientQuery, GetUserAddedDirectoryIngredientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAddedDirectoryIngredientQuery, GetUserAddedDirectoryIngredientQueryVariables>(GetUserAddedDirectoryIngredientDocument, options);
      }
export function useGetUserAddedDirectoryIngredientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAddedDirectoryIngredientQuery, GetUserAddedDirectoryIngredientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAddedDirectoryIngredientQuery, GetUserAddedDirectoryIngredientQueryVariables>(GetUserAddedDirectoryIngredientDocument, options);
        }
export function useGetUserAddedDirectoryIngredientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAddedDirectoryIngredientQuery, GetUserAddedDirectoryIngredientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAddedDirectoryIngredientQuery, GetUserAddedDirectoryIngredientQueryVariables>(GetUserAddedDirectoryIngredientDocument, options);
        }
export type GetUserAddedDirectoryIngredientQueryHookResult = ReturnType<typeof useGetUserAddedDirectoryIngredientQuery>;
export type GetUserAddedDirectoryIngredientLazyQueryHookResult = ReturnType<typeof useGetUserAddedDirectoryIngredientLazyQuery>;
export type GetUserAddedDirectoryIngredientSuspenseQueryHookResult = ReturnType<typeof useGetUserAddedDirectoryIngredientSuspenseQuery>;
export type GetUserAddedDirectoryIngredientQueryResult = Apollo.QueryResult<GetUserAddedDirectoryIngredientQuery, GetUserAddedDirectoryIngredientQueryVariables>;
export const MarkOnDemandListingClearedDocument = gql`
    mutation MarkOnDemandListingCleared($listing_id: Int!, $state: Boolean!) {
  markOnDemandListingCleared(listing_id: $listing_id, state: $state)
}
    `;
export type MarkOnDemandListingClearedMutationFn = Apollo.MutationFunction<MarkOnDemandListingClearedMutation, MarkOnDemandListingClearedMutationVariables>;

/**
 * __useMarkOnDemandListingClearedMutation__
 *
 * To run a mutation, you first call `useMarkOnDemandListingClearedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOnDemandListingClearedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOnDemandListingClearedMutation, { data, loading, error }] = useMarkOnDemandListingClearedMutation({
 *   variables: {
 *      listing_id: // value for 'listing_id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useMarkOnDemandListingClearedMutation(baseOptions?: Apollo.MutationHookOptions<MarkOnDemandListingClearedMutation, MarkOnDemandListingClearedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkOnDemandListingClearedMutation, MarkOnDemandListingClearedMutationVariables>(MarkOnDemandListingClearedDocument, options);
      }
export type MarkOnDemandListingClearedMutationHookResult = ReturnType<typeof useMarkOnDemandListingClearedMutation>;
export type MarkOnDemandListingClearedMutationResult = Apollo.MutationResult<MarkOnDemandListingClearedMutation>;
export type MarkOnDemandListingClearedMutationOptions = Apollo.BaseMutationOptions<MarkOnDemandListingClearedMutation, MarkOnDemandListingClearedMutationVariables>;
export const DirectoryIngredientPrivacyDocument = gql`
    mutation DirectoryIngredientPrivacy($record_id: Int!, $state: Boolean!) {
  directoryIngredientPrivacy(record_id: $record_id, state: $state)
}
    `;
export type DirectoryIngredientPrivacyMutationFn = Apollo.MutationFunction<DirectoryIngredientPrivacyMutation, DirectoryIngredientPrivacyMutationVariables>;

/**
 * __useDirectoryIngredientPrivacyMutation__
 *
 * To run a mutation, you first call `useDirectoryIngredientPrivacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectoryIngredientPrivacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directoryIngredientPrivacyMutation, { data, loading, error }] = useDirectoryIngredientPrivacyMutation({
 *   variables: {
 *      record_id: // value for 'record_id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useDirectoryIngredientPrivacyMutation(baseOptions?: Apollo.MutationHookOptions<DirectoryIngredientPrivacyMutation, DirectoryIngredientPrivacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DirectoryIngredientPrivacyMutation, DirectoryIngredientPrivacyMutationVariables>(DirectoryIngredientPrivacyDocument, options);
      }
export type DirectoryIngredientPrivacyMutationHookResult = ReturnType<typeof useDirectoryIngredientPrivacyMutation>;
export type DirectoryIngredientPrivacyMutationResult = Apollo.MutationResult<DirectoryIngredientPrivacyMutation>;
export type DirectoryIngredientPrivacyMutationOptions = Apollo.BaseMutationOptions<DirectoryIngredientPrivacyMutation, DirectoryIngredientPrivacyMutationVariables>;
export const DeleteListingIngredientFromProfileDocument = gql`
    mutation deleteListingIngredientFromProfile($listingId: Int!, $ingredients: [Int!]) {
  deleteListingIngredientFromProfile(
    listing_id: $listingId
    ingredientIds: $ingredients
  )
}
    `;
export type DeleteListingIngredientFromProfileMutationFn = Apollo.MutationFunction<DeleteListingIngredientFromProfileMutation, DeleteListingIngredientFromProfileMutationVariables>;

/**
 * __useDeleteListingIngredientFromProfileMutation__
 *
 * To run a mutation, you first call `useDeleteListingIngredientFromProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListingIngredientFromProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListingIngredientFromProfileMutation, { data, loading, error }] = useDeleteListingIngredientFromProfileMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      ingredients: // value for 'ingredients'
 *   },
 * });
 */
export function useDeleteListingIngredientFromProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListingIngredientFromProfileMutation, DeleteListingIngredientFromProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListingIngredientFromProfileMutation, DeleteListingIngredientFromProfileMutationVariables>(DeleteListingIngredientFromProfileDocument, options);
      }
export type DeleteListingIngredientFromProfileMutationHookResult = ReturnType<typeof useDeleteListingIngredientFromProfileMutation>;
export type DeleteListingIngredientFromProfileMutationResult = Apollo.MutationResult<DeleteListingIngredientFromProfileMutation>;
export type DeleteListingIngredientFromProfileMutationOptions = Apollo.BaseMutationOptions<DeleteListingIngredientFromProfileMutation, DeleteListingIngredientFromProfileMutationVariables>;
export const DeleteListingVendorFromProfileDocument = gql`
    mutation deleteListingVendorFromProfile($listingId: Int!, $vendors: [Int!]) {
  deleteListingVendorFromProfile(listing_id: $listingId, vendorIds: $vendors)
}
    `;
export type DeleteListingVendorFromProfileMutationFn = Apollo.MutationFunction<DeleteListingVendorFromProfileMutation, DeleteListingVendorFromProfileMutationVariables>;

/**
 * __useDeleteListingVendorFromProfileMutation__
 *
 * To run a mutation, you first call `useDeleteListingVendorFromProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListingVendorFromProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListingVendorFromProfileMutation, { data, loading, error }] = useDeleteListingVendorFromProfileMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      vendors: // value for 'vendors'
 *   },
 * });
 */
export function useDeleteListingVendorFromProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListingVendorFromProfileMutation, DeleteListingVendorFromProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListingVendorFromProfileMutation, DeleteListingVendorFromProfileMutationVariables>(DeleteListingVendorFromProfileDocument, options);
      }
export type DeleteListingVendorFromProfileMutationHookResult = ReturnType<typeof useDeleteListingVendorFromProfileMutation>;
export type DeleteListingVendorFromProfileMutationResult = Apollo.MutationResult<DeleteListingVendorFromProfileMutation>;
export type DeleteListingVendorFromProfileMutationOptions = Apollo.BaseMutationOptions<DeleteListingVendorFromProfileMutation, DeleteListingVendorFromProfileMutationVariables>;
export const BusinessRegistrationDocument = gql`
    mutation businessRegistration($input: ListingInput, $ingredientInput: [DirectoryIngredientInput], $practices: [PracticeInput], $salesChannels: [SalesChannelInput], $sellingLocations: [SellingLocationInput]) {
  businessRegistration(
    input: $input
    ingredientInput: $ingredientInput
    practices: $practices
    salesChannels: $salesChannels
    sellingLocations: $sellingLocations
  ) {
    token
    user {
      user_id
      profile_photo_resource
      username
      email_address
      first_name
      last_name
      full_name
      zipcode
      user_bio
      user_type
      slug
      default_listing_id
      default_listing {
        slug
      }
      userRoles {
        id
        role_id
        user_id
        default
        role {
          name
          role_id
        }
      }
    }
  }
}
    `;
export type BusinessRegistrationMutationFn = Apollo.MutationFunction<BusinessRegistrationMutation, BusinessRegistrationMutationVariables>;

/**
 * __useBusinessRegistrationMutation__
 *
 * To run a mutation, you first call `useBusinessRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessRegistrationMutation, { data, loading, error }] = useBusinessRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      ingredientInput: // value for 'ingredientInput'
 *      practices: // value for 'practices'
 *      salesChannels: // value for 'salesChannels'
 *      sellingLocations: // value for 'sellingLocations'
 *   },
 * });
 */
export function useBusinessRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<BusinessRegistrationMutation, BusinessRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessRegistrationMutation, BusinessRegistrationMutationVariables>(BusinessRegistrationDocument, options);
      }
export type BusinessRegistrationMutationHookResult = ReturnType<typeof useBusinessRegistrationMutation>;
export type BusinessRegistrationMutationResult = Apollo.MutationResult<BusinessRegistrationMutation>;
export type BusinessRegistrationMutationOptions = Apollo.BaseMutationOptions<BusinessRegistrationMutation, BusinessRegistrationMutationVariables>;
export const AddProducerLocationsDocument = gql`
    mutation AddProducerLocations($input: [SellingLocationInput!]) {
  addProducerLocations(input: $input)
}
    `;
export type AddProducerLocationsMutationFn = Apollo.MutationFunction<AddProducerLocationsMutation, AddProducerLocationsMutationVariables>;

/**
 * __useAddProducerLocationsMutation__
 *
 * To run a mutation, you first call `useAddProducerLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProducerLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProducerLocationsMutation, { data, loading, error }] = useAddProducerLocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProducerLocationsMutation(baseOptions?: Apollo.MutationHookOptions<AddProducerLocationsMutation, AddProducerLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProducerLocationsMutation, AddProducerLocationsMutationVariables>(AddProducerLocationsDocument, options);
      }
export type AddProducerLocationsMutationHookResult = ReturnType<typeof useAddProducerLocationsMutation>;
export type AddProducerLocationsMutationResult = Apollo.MutationResult<AddProducerLocationsMutation>;
export type AddProducerLocationsMutationOptions = Apollo.BaseMutationOptions<AddProducerLocationsMutation, AddProducerLocationsMutationVariables>;
export const AddProducerProductsDocument = gql`
    mutation AddProducerProducts($listingID: Int!, $input: [DirectoryIngredientInput!]) {
  addProducerProducts(listingID: $listingID, input: $input)
}
    `;
export type AddProducerProductsMutationFn = Apollo.MutationFunction<AddProducerProductsMutation, AddProducerProductsMutationVariables>;

/**
 * __useAddProducerProductsMutation__
 *
 * To run a mutation, you first call `useAddProducerProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProducerProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProducerProductsMutation, { data, loading, error }] = useAddProducerProductsMutation({
 *   variables: {
 *      listingID: // value for 'listingID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProducerProductsMutation(baseOptions?: Apollo.MutationHookOptions<AddProducerProductsMutation, AddProducerProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProducerProductsMutation, AddProducerProductsMutationVariables>(AddProducerProductsDocument, options);
      }
export type AddProducerProductsMutationHookResult = ReturnType<typeof useAddProducerProductsMutation>;
export type AddProducerProductsMutationResult = Apollo.MutationResult<AddProducerProductsMutation>;
export type AddProducerProductsMutationOptions = Apollo.BaseMutationOptions<AddProducerProductsMutation, AddProducerProductsMutationVariables>;
export const AddMarketVendorsDocument = gql`
    mutation AddMarketVendors($listingID: Int!, $input: [VendorListingInput!]) {
  addMarketVendors(listingID: $listingID, input: $input)
}
    `;
export type AddMarketVendorsMutationFn = Apollo.MutationFunction<AddMarketVendorsMutation, AddMarketVendorsMutationVariables>;

/**
 * __useAddMarketVendorsMutation__
 *
 * To run a mutation, you first call `useAddMarketVendorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMarketVendorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMarketVendorsMutation, { data, loading, error }] = useAddMarketVendorsMutation({
 *   variables: {
 *      listingID: // value for 'listingID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMarketVendorsMutation(baseOptions?: Apollo.MutationHookOptions<AddMarketVendorsMutation, AddMarketVendorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMarketVendorsMutation, AddMarketVendorsMutationVariables>(AddMarketVendorsDocument, options);
      }
export type AddMarketVendorsMutationHookResult = ReturnType<typeof useAddMarketVendorsMutation>;
export type AddMarketVendorsMutationResult = Apollo.MutationResult<AddMarketVendorsMutation>;
export type AddMarketVendorsMutationOptions = Apollo.BaseMutationOptions<AddMarketVendorsMutation, AddMarketVendorsMutationVariables>;
export const SwitchUserDefaultListingDocument = gql`
    mutation SwitchUserDefaultListing($listingID: Int!) {
  switchUserDefaultListing(listingID: $listingID) {
    user_id
    default_listing_id
    default_listing {
      membership_type
      name
      latitude
      longitude
      photo
    }
    listings {
      listing_id
      name
    }
  }
}
    `;
export type SwitchUserDefaultListingMutationFn = Apollo.MutationFunction<SwitchUserDefaultListingMutation, SwitchUserDefaultListingMutationVariables>;

/**
 * __useSwitchUserDefaultListingMutation__
 *
 * To run a mutation, you first call `useSwitchUserDefaultListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchUserDefaultListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchUserDefaultListingMutation, { data, loading, error }] = useSwitchUserDefaultListingMutation({
 *   variables: {
 *      listingID: // value for 'listingID'
 *   },
 * });
 */
export function useSwitchUserDefaultListingMutation(baseOptions?: Apollo.MutationHookOptions<SwitchUserDefaultListingMutation, SwitchUserDefaultListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchUserDefaultListingMutation, SwitchUserDefaultListingMutationVariables>(SwitchUserDefaultListingDocument, options);
      }
export type SwitchUserDefaultListingMutationHookResult = ReturnType<typeof useSwitchUserDefaultListingMutation>;
export type SwitchUserDefaultListingMutationResult = Apollo.MutationResult<SwitchUserDefaultListingMutation>;
export type SwitchUserDefaultListingMutationOptions = Apollo.BaseMutationOptions<SwitchUserDefaultListingMutation, SwitchUserDefaultListingMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($locationID: Int!) {
  deleteSellingLocation(locationID: $locationID)
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      locationID: // value for 'locationID'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($locationID: Int!, $input: SellingLocationInput!) {
  updateSellingLocation(locationID: $locationID, input: $input) {
    user_id
    location_id
    name
    note
    availabilities {
      time
      day
    }
    address
    latitude
    longitude
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      locationID: // value for 'locationID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const AddListingPracticesDocument = gql`
    mutation AddListingPractices($listingID: Int!, $input: [PracticeInput!]) {
  createListingPractices(listingID: $listingID, input: $input)
}
    `;
export type AddListingPracticesMutationFn = Apollo.MutationFunction<AddListingPracticesMutation, AddListingPracticesMutationVariables>;

/**
 * __useAddListingPracticesMutation__
 *
 * To run a mutation, you first call `useAddListingPracticesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddListingPracticesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addListingPracticesMutation, { data, loading, error }] = useAddListingPracticesMutation({
 *   variables: {
 *      listingID: // value for 'listingID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddListingPracticesMutation(baseOptions?: Apollo.MutationHookOptions<AddListingPracticesMutation, AddListingPracticesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddListingPracticesMutation, AddListingPracticesMutationVariables>(AddListingPracticesDocument, options);
      }
export type AddListingPracticesMutationHookResult = ReturnType<typeof useAddListingPracticesMutation>;
export type AddListingPracticesMutationResult = Apollo.MutationResult<AddListingPracticesMutation>;
export type AddListingPracticesMutationOptions = Apollo.BaseMutationOptions<AddListingPracticesMutation, AddListingPracticesMutationVariables>;
export const UploadImageDocument = gql`
    mutation uploadImage($file: Upload!) {
  uploadImage(file: $file)
}
    `;
export type UploadImageMutationFn = Apollo.MutationFunction<UploadImageMutation, UploadImageMutationVariables>;

/**
 * __useUploadImageMutation__
 *
 * To run a mutation, you first call `useUploadImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageMutation, { data, loading, error }] = useUploadImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageMutation, UploadImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageMutation, UploadImageMutationVariables>(UploadImageDocument, options);
      }
export type UploadImageMutationHookResult = ReturnType<typeof useUploadImageMutation>;
export type UploadImageMutationResult = Apollo.MutationResult<UploadImageMutation>;
export type UploadImageMutationOptions = Apollo.BaseMutationOptions<UploadImageMutation, UploadImageMutationVariables>;
export const GetPublicPostsDocument = gql`
    query GetPublicPosts($limit: Int, $cursor: ID, $group: String, $searchTerm: String, $sortBy: SortBy) {
  getPublicPosts(
    limit: $limit
    cursor: $cursor
    group: $group
    searchTerm: $searchTerm
    sortBy: $sortBy
  ) {
    totalCount
    posts {
      id
      title
      content
      created_at
      updated_at
      likeCount
      commentCount
      group
      slug
      status
      user_id
      post_medias {
        url
        type
      }
      user {
        user_id
        user_type
        full_name
        username
        slug
        profile_photo_resource
        default_listing_id
        default_listing {
          listing_id
          slug
          photo
          name
        }
      }
      post_products {
        product {
          ingredient_id
          name
          illustrationImage
          mainImage
          type
          pairing
          isSeasonal
          description
          cookingGuidance
          cooking
          choosing
          date_updated
          date_created
        }
      }
      post_recipes {
        recipe {
          recipe_id
          user_id
          recipe_img_url
          recipe_name
          number_of_servings
          serving_type
          author_name
          preparation_time
          recipe_image {
            record_id
            resource_path
            thumbnail_path
          }
          recipe_ingredients {
            record_id
            recipe_id
            ingredient_id
            unit_of_measurement_id
            whole_number
            sort_order
            numerator
            denominator
            measurement_amount
            raw_name
            ingredient {
              ingredient_id
              ingredient_name
            }
            unit_of_measurement {
              unit_of_measurement_id
              unit_name
            }
          }
          resourcePath
          thumbnailPath
          cook_time
          inspired_by
          total_time
          average_recipe_rating
        }
      }
      comments {
        id
        content
        user {
          user_id
          full_name
          username
          user_type
          profile_photo_resource
          slug
          default_listing {
            listing_id
            photo
            name
          }
          default_listing_id
        }
      }
    }
  }
}
    `;

/**
 * __useGetPublicPostsQuery__
 *
 * To run a query within a React component, call `useGetPublicPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicPostsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      group: // value for 'group'
 *      searchTerm: // value for 'searchTerm'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetPublicPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicPostsQuery, GetPublicPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicPostsQuery, GetPublicPostsQueryVariables>(GetPublicPostsDocument, options);
      }
export function useGetPublicPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicPostsQuery, GetPublicPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicPostsQuery, GetPublicPostsQueryVariables>(GetPublicPostsDocument, options);
        }
export function useGetPublicPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicPostsQuery, GetPublicPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicPostsQuery, GetPublicPostsQueryVariables>(GetPublicPostsDocument, options);
        }
export type GetPublicPostsQueryHookResult = ReturnType<typeof useGetPublicPostsQuery>;
export type GetPublicPostsLazyQueryHookResult = ReturnType<typeof useGetPublicPostsLazyQuery>;
export type GetPublicPostsSuspenseQueryHookResult = ReturnType<typeof useGetPublicPostsSuspenseQuery>;
export type GetPublicPostsQueryResult = Apollo.QueryResult<GetPublicPostsQuery, GetPublicPostsQueryVariables>;
export const GetPostsDocument = gql`
    query GetPosts($limit: Int!, $cursor: ID, $userID: Int, $listingID: Int, $group: String!, $searchTerm: String, $followingOnly: Boolean, $sortBy: SortBy) {
  getPosts(
    limit: $limit
    cursor: $cursor
    userID: $userID
    listingID: $listingID
    group: $group
    searchTerm: $searchTerm
    followingOnly: $followingOnly
    sortBy: $sortBy
  ) {
    totalCount
    posts {
      id
      title
      content
      created_at
      updated_at
      likeCount
      commentCount
      group
      slug
      status
      scheduled
      run_at
      user_id
      post_medias {
        url
        type
      }
      user {
        user_id
        user_type
        full_name
        username
        profile_photo_resource
        slug
        default_listing_id
        default_listing {
          listing_id
          slug
          photo
          name
        }
      }
      post_products {
        product {
          ingredient_id
          name
          illustrationImage
          mainImage
          type
          pairing
          isSeasonal
          description
          cookingGuidance
          cooking
          choosing
          date_updated
          date_created
        }
      }
      post_recipes {
        recipe {
          recipe_id
          user_id
          recipe_img_url
          recipe_name
          number_of_servings
          serving_type
          author_name
          preparation_time
          recipe_image {
            record_id
            resource_path
            thumbnail_path
          }
          recipe_ingredients {
            record_id
            recipe_id
            ingredient_id
            unit_of_measurement_id
            whole_number
            sort_order
            numerator
            denominator
            measurement_amount
            raw_name
            ingredient {
              ingredient_id
              ingredient_name
            }
            unit_of_measurement {
              unit_of_measurement_id
              unit_name
            }
          }
          resourcePath
          thumbnailPath
          cook_time
          inspired_by
          total_time
          average_recipe_rating
        }
      }
      comments {
        id
        content
        user {
          user_id
          full_name
          username
          user_type
          profile_photo_resource
          slug
          default_listing {
            listing_id
            photo
            name
          }
          default_listing_id
        }
      }
    }
  }
}
    `;

/**
 * __useGetPostsQuery__
 *
 * To run a query within a React component, call `useGetPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      userID: // value for 'userID'
 *      listingID: // value for 'listingID'
 *      group: // value for 'group'
 *      searchTerm: // value for 'searchTerm'
 *      followingOnly: // value for 'followingOnly'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetPostsQuery(baseOptions: Apollo.QueryHookOptions<GetPostsQuery, GetPostsQueryVariables> & ({ variables: GetPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
      }
export function useGetPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
        }
export function useGetPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostsQuery, GetPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, options);
        }
export type GetPostsQueryHookResult = ReturnType<typeof useGetPostsQuery>;
export type GetPostsLazyQueryHookResult = ReturnType<typeof useGetPostsLazyQuery>;
export type GetPostsSuspenseQueryHookResult = ReturnType<typeof useGetPostsSuspenseQuery>;
export type GetPostsQueryResult = Apollo.QueryResult<GetPostsQuery, GetPostsQueryVariables>;
export const GetPostDetailDocument = gql`
    query GetPostDetail($slug: String!) {
  getPost(slug: $slug) {
    id
    title
    content
    created_at
    updated_at
    slug
    status
    scheduled
    run_at
    group
    post_medias {
      url
      type
    }
    user {
      user_id
      full_name
      username
      user_type
      default_listing_id
      profile_photo_resource
      slug
      default_listing {
        listing_id
        slug
        name
        photo
      }
    }
    post_products {
      product {
        ingredient_id
        name
        illustrationImage
        mainImage
        type
        pairing
        isSeasonal
        description
        cookingGuidance
        cooking
        choosing
        date_updated
        date_created
      }
    }
    post_recipes {
      recipe {
        recipe_id
        user_id
        recipe_img_url
        recipe_name
        number_of_servings
        serving_type
        author_name
        preparation_time
        recipe_image {
          record_id
          resource_path
          thumbnail_path
        }
        recipe_ingredients {
          record_id
          recipe_id
          ingredient_id
          unit_of_measurement_id
          whole_number
          sort_order
          numerator
          denominator
          measurement_amount
          raw_name
          ingredient {
            ingredient_id
            ingredient_name
          }
          unit_of_measurement {
            unit_of_measurement_id
            unit_name
          }
        }
        resourcePath
        thumbnailPath
        cook_time
        inspired_by
        total_time
        average_recipe_rating
      }
    }
    comments {
      id
      content
      created_at
      user {
        user_id
        full_name
        username
        profile_photo_resource
        default_listing_id
        default_listing {
          listing_id
          name
          photo
        }
      }
    }
    likeCount
    commentCount
  }
}
    `;

/**
 * __useGetPostDetailQuery__
 *
 * To run a query within a React component, call `useGetPostDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostDetailQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetPostDetailQuery(baseOptions: Apollo.QueryHookOptions<GetPostDetailQuery, GetPostDetailQueryVariables> & ({ variables: GetPostDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostDetailQuery, GetPostDetailQueryVariables>(GetPostDetailDocument, options);
      }
export function useGetPostDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostDetailQuery, GetPostDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostDetailQuery, GetPostDetailQueryVariables>(GetPostDetailDocument, options);
        }
export function useGetPostDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostDetailQuery, GetPostDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostDetailQuery, GetPostDetailQueryVariables>(GetPostDetailDocument, options);
        }
export type GetPostDetailQueryHookResult = ReturnType<typeof useGetPostDetailQuery>;
export type GetPostDetailLazyQueryHookResult = ReturnType<typeof useGetPostDetailLazyQuery>;
export type GetPostDetailSuspenseQueryHookResult = ReturnType<typeof useGetPostDetailSuspenseQuery>;
export type GetPostDetailQueryResult = Apollo.QueryResult<GetPostDetailQuery, GetPostDetailQueryVariables>;
export const CreateOrUpdatePostDocument = gql`
    mutation CreateOrUpdatePost($group: String = "user", $input: CreateOrUpdatePostInput!) {
  createOrUpdatePost(group: $group, input: $input) {
    id
    title
    content
    created_at
    slug
    user {
      user_id
      username
      full_name
      default_listing_id
      default_listing {
        photo
        name
      }
    }
  }
}
    `;
export type CreateOrUpdatePostMutationFn = Apollo.MutationFunction<CreateOrUpdatePostMutation, CreateOrUpdatePostMutationVariables>;

/**
 * __useCreateOrUpdatePostMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePostMutation, { data, loading, error }] = useCreateOrUpdatePostMutation({
 *   variables: {
 *      group: // value for 'group'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdatePostMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdatePostMutation, CreateOrUpdatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdatePostMutation, CreateOrUpdatePostMutationVariables>(CreateOrUpdatePostDocument, options);
      }
export type CreateOrUpdatePostMutationHookResult = ReturnType<typeof useCreateOrUpdatePostMutation>;
export type CreateOrUpdatePostMutationResult = Apollo.MutationResult<CreateOrUpdatePostMutation>;
export type CreateOrUpdatePostMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdatePostMutation, CreateOrUpdatePostMutationVariables>;
export const CreateOrUpdateAdminPostDocument = gql`
    mutation CreateOrUpdateAdminPost($input: AdminPostInput!) {
  createOrUpdateAdminPost(input: $input) {
    id
    title
    content
    created_at
    slug
    user {
      user_id
      username
      full_name
    }
  }
}
    `;
export type CreateOrUpdateAdminPostMutationFn = Apollo.MutationFunction<CreateOrUpdateAdminPostMutation, CreateOrUpdateAdminPostMutationVariables>;

/**
 * __useCreateOrUpdateAdminPostMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAdminPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAdminPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAdminPostMutation, { data, loading, error }] = useCreateOrUpdateAdminPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateAdminPostMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateAdminPostMutation, CreateOrUpdateAdminPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateAdminPostMutation, CreateOrUpdateAdminPostMutationVariables>(CreateOrUpdateAdminPostDocument, options);
      }
export type CreateOrUpdateAdminPostMutationHookResult = ReturnType<typeof useCreateOrUpdateAdminPostMutation>;
export type CreateOrUpdateAdminPostMutationResult = Apollo.MutationResult<CreateOrUpdateAdminPostMutation>;
export type CreateOrUpdateAdminPostMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateAdminPostMutation, CreateOrUpdateAdminPostMutationVariables>;
export const AddCommentDocument = gql`
    mutation AddComment($postId: Int!, $content: String!) {
  addComment(postId: $postId, content: $content) {
    id
    content
  }
}
    `;
export type AddCommentMutationFn = Apollo.MutationFunction<AddCommentMutation, AddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const LikePostDocument = gql`
    mutation LikePost($postId: Int!) {
  likePost(postId: $postId) {
    likeCount
  }
}
    `;
export type LikePostMutationFn = Apollo.MutationFunction<LikePostMutation, LikePostMutationVariables>;

/**
 * __useLikePostMutation__
 *
 * To run a mutation, you first call `useLikePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likePostMutation, { data, loading, error }] = useLikePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useLikePostMutation(baseOptions?: Apollo.MutationHookOptions<LikePostMutation, LikePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikePostMutation, LikePostMutationVariables>(LikePostDocument, options);
      }
export type LikePostMutationHookResult = ReturnType<typeof useLikePostMutation>;
export type LikePostMutationResult = Apollo.MutationResult<LikePostMutation>;
export type LikePostMutationOptions = Apollo.BaseMutationOptions<LikePostMutation, LikePostMutationVariables>;
export const GetPostLikesDocument = gql`
    query GetPostLikes($postId: Int!) {
  getPostLikes(postID: $postId) {
    user_id
  }
}
    `;

/**
 * __useGetPostLikesQuery__
 *
 * To run a query within a React component, call `useGetPostLikesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostLikesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostLikesQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostLikesQuery(baseOptions: Apollo.QueryHookOptions<GetPostLikesQuery, GetPostLikesQueryVariables> & ({ variables: GetPostLikesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostLikesQuery, GetPostLikesQueryVariables>(GetPostLikesDocument, options);
      }
export function useGetPostLikesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostLikesQuery, GetPostLikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostLikesQuery, GetPostLikesQueryVariables>(GetPostLikesDocument, options);
        }
export function useGetPostLikesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostLikesQuery, GetPostLikesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostLikesQuery, GetPostLikesQueryVariables>(GetPostLikesDocument, options);
        }
export type GetPostLikesQueryHookResult = ReturnType<typeof useGetPostLikesQuery>;
export type GetPostLikesLazyQueryHookResult = ReturnType<typeof useGetPostLikesLazyQuery>;
export type GetPostLikesSuspenseQueryHookResult = ReturnType<typeof useGetPostLikesSuspenseQuery>;
export type GetPostLikesQueryResult = Apollo.QueryResult<GetPostLikesQuery, GetPostLikesQueryVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentID: Int!) {
  deleteComment(commentID: $commentID)
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const GetPostCommentsDocument = gql`
    query GetPostComments($postId: Int!, $limit: Int, $offset: ID) {
  getComments(postID: $postId, limit: $limit, cursor: $offset) {
    id
    content
    created_at
    user {
      user_id
      username
      full_name
      user_type
      default_listing_id
      profile_photo_resource
      default_listing {
        listing_id
        name
        photo
      }
    }
  }
}
    `;

/**
 * __useGetPostCommentsQuery__
 *
 * To run a query within a React component, call `useGetPostCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCommentsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPostCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetPostCommentsQuery, GetPostCommentsQueryVariables> & ({ variables: GetPostCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCommentsQuery, GetPostCommentsQueryVariables>(GetPostCommentsDocument, options);
      }
export function useGetPostCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCommentsQuery, GetPostCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCommentsQuery, GetPostCommentsQueryVariables>(GetPostCommentsDocument, options);
        }
export function useGetPostCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostCommentsQuery, GetPostCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostCommentsQuery, GetPostCommentsQueryVariables>(GetPostCommentsDocument, options);
        }
export type GetPostCommentsQueryHookResult = ReturnType<typeof useGetPostCommentsQuery>;
export type GetPostCommentsLazyQueryHookResult = ReturnType<typeof useGetPostCommentsLazyQuery>;
export type GetPostCommentsSuspenseQueryHookResult = ReturnType<typeof useGetPostCommentsSuspenseQuery>;
export type GetPostCommentsQueryResult = Apollo.QueryResult<GetPostCommentsQuery, GetPostCommentsQueryVariables>;
export const DeletePostDocument = gql`
    mutation DeletePost($postID: Int!) {
  deletePost(postID: $postID)
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      postID: // value for 'postID'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const PostFileUploadDocument = gql`
    mutation postFileUpload($file: Upload!) {
  postFileUpload(file: $file)
}
    `;
export type PostFileUploadMutationFn = Apollo.MutationFunction<PostFileUploadMutation, PostFileUploadMutationVariables>;

/**
 * __usePostFileUploadMutation__
 *
 * To run a mutation, you first call `usePostFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postFileUploadMutation, { data, loading, error }] = usePostFileUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function usePostFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<PostFileUploadMutation, PostFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostFileUploadMutation, PostFileUploadMutationVariables>(PostFileUploadDocument, options);
      }
export type PostFileUploadMutationHookResult = ReturnType<typeof usePostFileUploadMutation>;
export type PostFileUploadMutationResult = Apollo.MutationResult<PostFileUploadMutation>;
export type PostFileUploadMutationOptions = Apollo.BaseMutationOptions<PostFileUploadMutation, PostFileUploadMutationVariables>;
export const GetUserRecipesDocument = gql`
    query GetUserRecipes($user_id: Int, $listing_id: Int, $limit: Int, $page: Int, $searchTerm: String) {
  userRecipes(
    user_id: $user_id
    listing_id: $listing_id
    limit: $limit
    page: $page
    searchTerm: $searchTerm
  ) {
    recipes {
      recipe_id
      user_id
      slug
      recipe_img_url
      recipe_name
      number_of_servings
      serving_type
      author_name
      preparation_time
      is_featured
      recipe_ingredients {
        record_id
        recipe_id
        ingredient_id
        unit_of_measurement_id
        whole_number
        sort_order
        numerator
        denominator
        measurement_amount
        raw_name
        ingredient {
          ingredient_id
          ingredient_name
        }
        unit_of_measurement {
          unit_of_measurement_id
          unit_abbreviation
          unit_name
        }
      }
      recipe_image {
        record_id
        resource_path
        thumbnail_path
      }
      resourcePath
      thumbnailPath
      cook_time
      inspired_by
      total_time
      average_recipe_rating
      recipe_comments {
        id
      }
      user {
        user_id
        profile_photo_resource
        slug
        full_name
        default_listing {
          listing_id
          photo
          resourcePath
        }
      }
    }
    total
    page
  }
}
    `;

/**
 * __useGetUserRecipesQuery__
 *
 * To run a query within a React component, call `useGetUserRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRecipesQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      listing_id: // value for 'listing_id'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetUserRecipesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRecipesQuery, GetUserRecipesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRecipesQuery, GetUserRecipesQueryVariables>(GetUserRecipesDocument, options);
      }
export function useGetUserRecipesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRecipesQuery, GetUserRecipesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRecipesQuery, GetUserRecipesQueryVariables>(GetUserRecipesDocument, options);
        }
export function useGetUserRecipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRecipesQuery, GetUserRecipesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRecipesQuery, GetUserRecipesQueryVariables>(GetUserRecipesDocument, options);
        }
export type GetUserRecipesQueryHookResult = ReturnType<typeof useGetUserRecipesQuery>;
export type GetUserRecipesLazyQueryHookResult = ReturnType<typeof useGetUserRecipesLazyQuery>;
export type GetUserRecipesSuspenseQueryHookResult = ReturnType<typeof useGetUserRecipesSuspenseQuery>;
export type GetUserRecipesQueryResult = Apollo.QueryResult<GetUserRecipesQuery, GetUserRecipesQueryVariables>;
export const MyRecipesDocument = gql`
    query myRecipes($user_id: Int, $listing_id: Int) {
  myRecipes(user_id: $user_id, listing_id: $listing_id) {
    recipe_id
    user_id
    slug
    recipe_img_url
    recipe_name
    number_of_servings
    serving_type
    author_name
    preparation_time
    is_featured
    recipe_comments {
      id
    }
    recipe_image {
      record_id
      resource_path
      thumbnail_path
    }
    user {
      user_id
      profile_photo_resource
      slug
      full_name
      default_listing {
        listing_id
        photo
        resourcePath
      }
    }
    recipe_ingredients {
      record_id
      recipe_id
      ingredient_id
      unit_of_measurement_id
      whole_number
      sort_order
      numerator
      denominator
      measurement_amount
      raw_name
      ingredient {
        ingredient_id
        ingredient_name
      }
      unit_of_measurement {
        unit_of_measurement_id
        unit_abbreviation
        unit_name
      }
    }
    resourcePath
    thumbnailPath
    cook_time
    inspired_by
    total_time
    average_recipe_rating
  }
}
    `;

/**
 * __useMyRecipesQuery__
 *
 * To run a query within a React component, call `useMyRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRecipesQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      listing_id: // value for 'listing_id'
 *   },
 * });
 */
export function useMyRecipesQuery(baseOptions?: Apollo.QueryHookOptions<MyRecipesQuery, MyRecipesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRecipesQuery, MyRecipesQueryVariables>(MyRecipesDocument, options);
      }
export function useMyRecipesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRecipesQuery, MyRecipesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRecipesQuery, MyRecipesQueryVariables>(MyRecipesDocument, options);
        }
export function useMyRecipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyRecipesQuery, MyRecipesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyRecipesQuery, MyRecipesQueryVariables>(MyRecipesDocument, options);
        }
export type MyRecipesQueryHookResult = ReturnType<typeof useMyRecipesQuery>;
export type MyRecipesLazyQueryHookResult = ReturnType<typeof useMyRecipesLazyQuery>;
export type MyRecipesSuspenseQueryHookResult = ReturnType<typeof useMyRecipesSuspenseQuery>;
export type MyRecipesQueryResult = Apollo.QueryResult<MyRecipesQuery, MyRecipesQueryVariables>;
export const RecipeStepsDocument = gql`
    query recipeSteps($recipe_id: Int!) {
  recipeSteps(recipe_id: $recipe_id) {
    record_id
    recipe_id
    step_name
    step_description
    step_order
  }
}
    `;

/**
 * __useRecipeStepsQuery__
 *
 * To run a query within a React component, call `useRecipeStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipeStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipeStepsQuery({
 *   variables: {
 *      recipe_id: // value for 'recipe_id'
 *   },
 * });
 */
export function useRecipeStepsQuery(baseOptions: Apollo.QueryHookOptions<RecipeStepsQuery, RecipeStepsQueryVariables> & ({ variables: RecipeStepsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipeStepsQuery, RecipeStepsQueryVariables>(RecipeStepsDocument, options);
      }
export function useRecipeStepsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipeStepsQuery, RecipeStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipeStepsQuery, RecipeStepsQueryVariables>(RecipeStepsDocument, options);
        }
export function useRecipeStepsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecipeStepsQuery, RecipeStepsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecipeStepsQuery, RecipeStepsQueryVariables>(RecipeStepsDocument, options);
        }
export type RecipeStepsQueryHookResult = ReturnType<typeof useRecipeStepsQuery>;
export type RecipeStepsLazyQueryHookResult = ReturnType<typeof useRecipeStepsLazyQuery>;
export type RecipeStepsSuspenseQueryHookResult = ReturnType<typeof useRecipeStepsSuspenseQuery>;
export type RecipeStepsQueryResult = Apollo.QueryResult<RecipeStepsQuery, RecipeStepsQueryVariables>;
export const RecipeNoteDocument = gql`
    query recipeNote($recipe_id: Int!) {
  recipeNote(recipe_id: $recipe_id) {
    record_id
    recipe_id
    note_name
    note_description
    note_order
  }
}
    `;

/**
 * __useRecipeNoteQuery__
 *
 * To run a query within a React component, call `useRecipeNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipeNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipeNoteQuery({
 *   variables: {
 *      recipe_id: // value for 'recipe_id'
 *   },
 * });
 */
export function useRecipeNoteQuery(baseOptions: Apollo.QueryHookOptions<RecipeNoteQuery, RecipeNoteQueryVariables> & ({ variables: RecipeNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipeNoteQuery, RecipeNoteQueryVariables>(RecipeNoteDocument, options);
      }
export function useRecipeNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipeNoteQuery, RecipeNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipeNoteQuery, RecipeNoteQueryVariables>(RecipeNoteDocument, options);
        }
export function useRecipeNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecipeNoteQuery, RecipeNoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecipeNoteQuery, RecipeNoteQueryVariables>(RecipeNoteDocument, options);
        }
export type RecipeNoteQueryHookResult = ReturnType<typeof useRecipeNoteQuery>;
export type RecipeNoteLazyQueryHookResult = ReturnType<typeof useRecipeNoteLazyQuery>;
export type RecipeNoteSuspenseQueryHookResult = ReturnType<typeof useRecipeNoteSuspenseQuery>;
export type RecipeNoteQueryResult = Apollo.QueryResult<RecipeNoteQuery, RecipeNoteQueryVariables>;
export const UpdateRecipeDocument = gql`
    mutation updateRecipe($ReciInput: RecipeInput!, $Inginput: [NewIngredientInput!]) {
  updateRecipe(input: $ReciInput, ingredientInput: $Inginput) {
    recipe_id
    user_id
    source_id
    recipe_img_url
    recipe_name
    number_of_servings
    preparation_time
    is_private
    resourcePath
    thumbnailPath
    recipe_image {
      record_id
      resource_path
      thumbnail_path
    }
    recipe_ingredients {
      record_id
      recipe_id
      ingredient_id
      unit_of_measurement_id
      whole_number
      sort_order
      numerator
      denominator
      measurement_amount
      raw_name
      ingredient {
        ingredient_id
        ingredient_name
      }
      unit_of_measurement {
        unit_of_measurement_id
        unit_abbreviation
        unit_name
      }
    }
    cook_time
  }
}
    `;
export type UpdateRecipeMutationFn = Apollo.MutationFunction<UpdateRecipeMutation, UpdateRecipeMutationVariables>;

/**
 * __useUpdateRecipeMutation__
 *
 * To run a mutation, you first call `useUpdateRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecipeMutation, { data, loading, error }] = useUpdateRecipeMutation({
 *   variables: {
 *      ReciInput: // value for 'ReciInput'
 *      Inginput: // value for 'Inginput'
 *   },
 * });
 */
export function useUpdateRecipeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecipeMutation, UpdateRecipeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecipeMutation, UpdateRecipeMutationVariables>(UpdateRecipeDocument, options);
      }
export type UpdateRecipeMutationHookResult = ReturnType<typeof useUpdateRecipeMutation>;
export type UpdateRecipeMutationResult = Apollo.MutationResult<UpdateRecipeMutation>;
export type UpdateRecipeMutationOptions = Apollo.BaseMutationOptions<UpdateRecipeMutation, UpdateRecipeMutationVariables>;
export const CreateRecipeDocument = gql`
    mutation createRecipe($ReciInput: RecipeInput!, $Inginput: [NewIngredientInput!]) {
  createRecipe(input: $ReciInput, ingredientInput: $Inginput) {
    recipe_id
    user_id
    slug
    source_id
    recipe_img_url
    recipe_name
    number_of_servings
    preparation_time
    is_private
    resourcePath
    thumbnailPath
    recipe_image {
      record_id
      resource_path
      thumbnail_path
    }
    recipe_ingredients {
      record_id
      recipe_id
      ingredient_id
      unit_of_measurement_id
      whole_number
      sort_order
      numerator
      denominator
      measurement_amount
      raw_name
      ingredient {
        ingredient_id
        ingredient_name
      }
      unit_of_measurement {
        unit_of_measurement_id
        unit_abbreviation
        unit_name
      }
    }
    cook_time
  }
}
    `;
export type CreateRecipeMutationFn = Apollo.MutationFunction<CreateRecipeMutation, CreateRecipeMutationVariables>;

/**
 * __useCreateRecipeMutation__
 *
 * To run a mutation, you first call `useCreateRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecipeMutation, { data, loading, error }] = useCreateRecipeMutation({
 *   variables: {
 *      ReciInput: // value for 'ReciInput'
 *      Inginput: // value for 'Inginput'
 *   },
 * });
 */
export function useCreateRecipeMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecipeMutation, CreateRecipeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecipeMutation, CreateRecipeMutationVariables>(CreateRecipeDocument, options);
      }
export type CreateRecipeMutationHookResult = ReturnType<typeof useCreateRecipeMutation>;
export type CreateRecipeMutationResult = Apollo.MutationResult<CreateRecipeMutation>;
export type CreateRecipeMutationOptions = Apollo.BaseMutationOptions<CreateRecipeMutation, CreateRecipeMutationVariables>;
export const UpdateIngredientDocument = gql`
    mutation updateIngredient($input: UpdateIngredientInput!) {
  updateIngredient(input: $input) {
    ingredient_id
    ingredient_name
    ingredient_description
    date_created
    measurement_amount
    unit_name
    unit_abbreviation
    unit_description
  }
}
    `;
export type UpdateIngredientMutationFn = Apollo.MutationFunction<UpdateIngredientMutation, UpdateIngredientMutationVariables>;

/**
 * __useUpdateIngredientMutation__
 *
 * To run a mutation, you first call `useUpdateIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIngredientMutation, { data, loading, error }] = useUpdateIngredientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIngredientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIngredientMutation, UpdateIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIngredientMutation, UpdateIngredientMutationVariables>(UpdateIngredientDocument, options);
      }
export type UpdateIngredientMutationHookResult = ReturnType<typeof useUpdateIngredientMutation>;
export type UpdateIngredientMutationResult = Apollo.MutationResult<UpdateIngredientMutation>;
export type UpdateIngredientMutationOptions = Apollo.BaseMutationOptions<UpdateIngredientMutation, UpdateIngredientMutationVariables>;
export const UpdateStepDocument = gql`
    mutation updateStep($input: [StepInput!]) {
  updateStep(input: $input) {
    record_id
    recipe_id
    step_name
    step_description
    step_order
    date_created
    date_updated
    date_disabled
  }
}
    `;
export type UpdateStepMutationFn = Apollo.MutationFunction<UpdateStepMutation, UpdateStepMutationVariables>;

/**
 * __useUpdateStepMutation__
 *
 * To run a mutation, you first call `useUpdateStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStepMutation, { data, loading, error }] = useUpdateStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStepMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStepMutation, UpdateStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStepMutation, UpdateStepMutationVariables>(UpdateStepDocument, options);
      }
export type UpdateStepMutationHookResult = ReturnType<typeof useUpdateStepMutation>;
export type UpdateStepMutationResult = Apollo.MutationResult<UpdateStepMutation>;
export type UpdateStepMutationOptions = Apollo.BaseMutationOptions<UpdateStepMutation, UpdateStepMutationVariables>;
export const CreateStepDocument = gql`
    mutation createStep($input: [StepInput!]) {
  createStep(input: $input) {
    record_id
    recipe_id
    step_name
    step_description
    step_order
    date_created
    date_updated
    date_disabled
  }
}
    `;
export type CreateStepMutationFn = Apollo.MutationFunction<CreateStepMutation, CreateStepMutationVariables>;

/**
 * __useCreateStepMutation__
 *
 * To run a mutation, you first call `useCreateStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStepMutation, { data, loading, error }] = useCreateStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStepMutation(baseOptions?: Apollo.MutationHookOptions<CreateStepMutation, CreateStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStepMutation, CreateStepMutationVariables>(CreateStepDocument, options);
      }
export type CreateStepMutationHookResult = ReturnType<typeof useCreateStepMutation>;
export type CreateStepMutationResult = Apollo.MutationResult<CreateStepMutation>;
export type CreateStepMutationOptions = Apollo.BaseMutationOptions<CreateStepMutation, CreateStepMutationVariables>;
export const CreateNoteDocument = gql`
    mutation createNote($input: [NoteInput!]) {
  createNote(input: $input) {
    record_id
    recipe_id
    note_name
    note_description
    note_order
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation updateNote($input: [NoteInput!]) {
  updateNote(input: $input) {
    record_id
    recipe_id
    note_name
    note_description
    note_order
    date_created
    user_created
    date_updated
    user_updated
    date_disabled
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const CreateRecipeTagDocument = gql`
    mutation createRecipeTag($input: [CategoryInput!]) {
  createRecipeTag(input: $input) {
    category_id
    category_name
    category_description
    date_created
    user_created
    date_updated
    user_updated
    date_disabled
    recipe_id
  }
}
    `;
export type CreateRecipeTagMutationFn = Apollo.MutationFunction<CreateRecipeTagMutation, CreateRecipeTagMutationVariables>;

/**
 * __useCreateRecipeTagMutation__
 *
 * To run a mutation, you first call `useCreateRecipeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecipeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecipeTagMutation, { data, loading, error }] = useCreateRecipeTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRecipeTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecipeTagMutation, CreateRecipeTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecipeTagMutation, CreateRecipeTagMutationVariables>(CreateRecipeTagDocument, options);
      }
export type CreateRecipeTagMutationHookResult = ReturnType<typeof useCreateRecipeTagMutation>;
export type CreateRecipeTagMutationResult = Apollo.MutationResult<CreateRecipeTagMutation>;
export type CreateRecipeTagMutationOptions = Apollo.BaseMutationOptions<CreateRecipeTagMutation, CreateRecipeTagMutationVariables>;
export const UpdateOrCreateRecipeTagDocument = gql`
    mutation updateOrCreateRecipeTag($input: RecipeTagUpdateInput!) {
  updateOrCreateRecipeTag(input: $input) {
    recipe_id
  }
}
    `;
export type UpdateOrCreateRecipeTagMutationFn = Apollo.MutationFunction<UpdateOrCreateRecipeTagMutation, UpdateOrCreateRecipeTagMutationVariables>;

/**
 * __useUpdateOrCreateRecipeTagMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateRecipeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateRecipeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateRecipeTagMutation, { data, loading, error }] = useUpdateOrCreateRecipeTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreateRecipeTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrCreateRecipeTagMutation, UpdateOrCreateRecipeTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrCreateRecipeTagMutation, UpdateOrCreateRecipeTagMutationVariables>(UpdateOrCreateRecipeTagDocument, options);
      }
export type UpdateOrCreateRecipeTagMutationHookResult = ReturnType<typeof useUpdateOrCreateRecipeTagMutation>;
export type UpdateOrCreateRecipeTagMutationResult = Apollo.MutationResult<UpdateOrCreateRecipeTagMutation>;
export type UpdateOrCreateRecipeTagMutationOptions = Apollo.BaseMutationOptions<UpdateOrCreateRecipeTagMutation, UpdateOrCreateRecipeTagMutationVariables>;
export const UpdateRecipeImageDocument = gql`
    mutation updateRecipeImage($file: Upload!, $RecipeID: Int!) {
  updateRecipeImage(file: $file, RecipeID: $RecipeID)
}
    `;
export type UpdateRecipeImageMutationFn = Apollo.MutationFunction<UpdateRecipeImageMutation, UpdateRecipeImageMutationVariables>;

/**
 * __useUpdateRecipeImageMutation__
 *
 * To run a mutation, you first call `useUpdateRecipeImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecipeImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecipeImageMutation, { data, loading, error }] = useUpdateRecipeImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *      RecipeID: // value for 'RecipeID'
 *   },
 * });
 */
export function useUpdateRecipeImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecipeImageMutation, UpdateRecipeImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecipeImageMutation, UpdateRecipeImageMutationVariables>(UpdateRecipeImageDocument, options);
      }
export type UpdateRecipeImageMutationHookResult = ReturnType<typeof useUpdateRecipeImageMutation>;
export type UpdateRecipeImageMutationResult = Apollo.MutationResult<UpdateRecipeImageMutation>;
export type UpdateRecipeImageMutationOptions = Apollo.BaseMutationOptions<UpdateRecipeImageMutation, UpdateRecipeImageMutationVariables>;
export const DeleteRecipeTagDocument = gql`
    mutation deleteRecipeTag($category_id: Int!) {
  deleteRecipeTag(category_id: $category_id)
}
    `;
export type DeleteRecipeTagMutationFn = Apollo.MutationFunction<DeleteRecipeTagMutation, DeleteRecipeTagMutationVariables>;

/**
 * __useDeleteRecipeTagMutation__
 *
 * To run a mutation, you first call `useDeleteRecipeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecipeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecipeTagMutation, { data, loading, error }] = useDeleteRecipeTagMutation({
 *   variables: {
 *      category_id: // value for 'category_id'
 *   },
 * });
 */
export function useDeleteRecipeTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecipeTagMutation, DeleteRecipeTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecipeTagMutation, DeleteRecipeTagMutationVariables>(DeleteRecipeTagDocument, options);
      }
export type DeleteRecipeTagMutationHookResult = ReturnType<typeof useDeleteRecipeTagMutation>;
export type DeleteRecipeTagMutationResult = Apollo.MutationResult<DeleteRecipeTagMutation>;
export type DeleteRecipeTagMutationOptions = Apollo.BaseMutationOptions<DeleteRecipeTagMutation, DeleteRecipeTagMutationVariables>;
export const DeleteRecipeNoteDocument = gql`
    mutation deleteRecipeNote($note_id: Int!) {
  deleteRecipeNote(note_id: $note_id)
}
    `;
export type DeleteRecipeNoteMutationFn = Apollo.MutationFunction<DeleteRecipeNoteMutation, DeleteRecipeNoteMutationVariables>;

/**
 * __useDeleteRecipeNoteMutation__
 *
 * To run a mutation, you first call `useDeleteRecipeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecipeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecipeNoteMutation, { data, loading, error }] = useDeleteRecipeNoteMutation({
 *   variables: {
 *      note_id: // value for 'note_id'
 *   },
 * });
 */
export function useDeleteRecipeNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecipeNoteMutation, DeleteRecipeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecipeNoteMutation, DeleteRecipeNoteMutationVariables>(DeleteRecipeNoteDocument, options);
      }
export type DeleteRecipeNoteMutationHookResult = ReturnType<typeof useDeleteRecipeNoteMutation>;
export type DeleteRecipeNoteMutationResult = Apollo.MutationResult<DeleteRecipeNoteMutation>;
export type DeleteRecipeNoteMutationOptions = Apollo.BaseMutationOptions<DeleteRecipeNoteMutation, DeleteRecipeNoteMutationVariables>;
export const DeleteRecipeStepDocument = gql`
    mutation deleteRecipeStep($step_id: Int!) {
  deleteRecipeStep(step_id: $step_id)
}
    `;
export type DeleteRecipeStepMutationFn = Apollo.MutationFunction<DeleteRecipeStepMutation, DeleteRecipeStepMutationVariables>;

/**
 * __useDeleteRecipeStepMutation__
 *
 * To run a mutation, you first call `useDeleteRecipeStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecipeStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecipeStepMutation, { data, loading, error }] = useDeleteRecipeStepMutation({
 *   variables: {
 *      step_id: // value for 'step_id'
 *   },
 * });
 */
export function useDeleteRecipeStepMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecipeStepMutation, DeleteRecipeStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecipeStepMutation, DeleteRecipeStepMutationVariables>(DeleteRecipeStepDocument, options);
      }
export type DeleteRecipeStepMutationHookResult = ReturnType<typeof useDeleteRecipeStepMutation>;
export type DeleteRecipeStepMutationResult = Apollo.MutationResult<DeleteRecipeStepMutation>;
export type DeleteRecipeStepMutationOptions = Apollo.BaseMutationOptions<DeleteRecipeStepMutation, DeleteRecipeStepMutationVariables>;
export const DeleteIngredientDocument = gql`
    mutation deleteIngredient($ingredient_id: Int!) {
  deleteIngredient(ingredient_id: $ingredient_id)
}
    `;
export type DeleteIngredientMutationFn = Apollo.MutationFunction<DeleteIngredientMutation, DeleteIngredientMutationVariables>;

/**
 * __useDeleteIngredientMutation__
 *
 * To run a mutation, you first call `useDeleteIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIngredientMutation, { data, loading, error }] = useDeleteIngredientMutation({
 *   variables: {
 *      ingredient_id: // value for 'ingredient_id'
 *   },
 * });
 */
export function useDeleteIngredientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIngredientMutation, DeleteIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIngredientMutation, DeleteIngredientMutationVariables>(DeleteIngredientDocument, options);
      }
export type DeleteIngredientMutationHookResult = ReturnType<typeof useDeleteIngredientMutation>;
export type DeleteIngredientMutationResult = Apollo.MutationResult<DeleteIngredientMutation>;
export type DeleteIngredientMutationOptions = Apollo.BaseMutationOptions<DeleteIngredientMutation, DeleteIngredientMutationVariables>;
export const DeleteRecipeIngredientDocument = gql`
    mutation deleteRecipeIngredient($record_id: Int!) {
  deleteRecipeIngredient(record_id: $record_id)
}
    `;
export type DeleteRecipeIngredientMutationFn = Apollo.MutationFunction<DeleteRecipeIngredientMutation, DeleteRecipeIngredientMutationVariables>;

/**
 * __useDeleteRecipeIngredientMutation__
 *
 * To run a mutation, you first call `useDeleteRecipeIngredientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecipeIngredientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecipeIngredientMutation, { data, loading, error }] = useDeleteRecipeIngredientMutation({
 *   variables: {
 *      record_id: // value for 'record_id'
 *   },
 * });
 */
export function useDeleteRecipeIngredientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecipeIngredientMutation, DeleteRecipeIngredientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecipeIngredientMutation, DeleteRecipeIngredientMutationVariables>(DeleteRecipeIngredientDocument, options);
      }
export type DeleteRecipeIngredientMutationHookResult = ReturnType<typeof useDeleteRecipeIngredientMutation>;
export type DeleteRecipeIngredientMutationResult = Apollo.MutationResult<DeleteRecipeIngredientMutation>;
export type DeleteRecipeIngredientMutationOptions = Apollo.BaseMutationOptions<DeleteRecipeIngredientMutation, DeleteRecipeIngredientMutationVariables>;
export const GetRecipeDocument = gql`
    query GetRecipe($recipeId: Int, $slug: String) {
  recipe(recipe_id: $recipeId, slug: $slug) {
    recipe_id
    user_id
    slug
    recipe_img_url
    recipe_name
    number_of_servings
    serving_type
    author_name
    preparation_time
    resourcePath
    thumbnailPath
    is_private
    is_featured
    recipe_comments {
      id
    }
    recipe_image {
      record_id
      resource_path
      thumbnail_path
    }
    recipe_ingredients {
      record_id
      recipe_id
      ingredient_id
      unit_of_measurement_id
      whole_number
      sort_order
      numerator
      denominator
      measurement_amount
      raw_name
      ingredient {
        ingredient_id
        ingredient_name
      }
      unit_of_measurement {
        unit_of_measurement_id
        unit_abbreviation
        unit_name
      }
    }
    categories {
      category_id
      category_name
    }
    recipe_notes {
      recipe_id
      note_name
      note_description
      note_order
    }
    recipe_steps {
      record_id
      recipe_id
      step_name
      step_description
      step_order
    }
    user {
      profile_photo_resource
      slug
      user_id
      full_name
      user_type
      default_listing {
        listing_id
        photo
        resourcePath
        slug
      }
    }
    cook_time
    inspired_by
    total_time
    average_recipe_rating
  }
}
    `;

/**
 * __useGetRecipeQuery__
 *
 * To run a query within a React component, call `useGetRecipeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipeQuery({
 *   variables: {
 *      recipeId: // value for 'recipeId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetRecipeQuery(baseOptions?: Apollo.QueryHookOptions<GetRecipeQuery, GetRecipeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipeQuery, GetRecipeQueryVariables>(GetRecipeDocument, options);
      }
export function useGetRecipeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipeQuery, GetRecipeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipeQuery, GetRecipeQueryVariables>(GetRecipeDocument, options);
        }
export function useGetRecipeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecipeQuery, GetRecipeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecipeQuery, GetRecipeQueryVariables>(GetRecipeDocument, options);
        }
export type GetRecipeQueryHookResult = ReturnType<typeof useGetRecipeQuery>;
export type GetRecipeLazyQueryHookResult = ReturnType<typeof useGetRecipeLazyQuery>;
export type GetRecipeSuspenseQueryHookResult = ReturnType<typeof useGetRecipeSuspenseQuery>;
export type GetRecipeQueryResult = Apollo.QueryResult<GetRecipeQuery, GetRecipeQueryVariables>;
export const GetRecipesDocument = gql`
    query GetRecipes($limit: Int!, $offset: Int!, $public: String!, $searchTerm: String, $isFeatured: Boolean) {
  recipes(
    limit: $limit
    offset: $offset
    public: $public
    searchTerm: $searchTerm
    isFeatured: $isFeatured
  ) {
    slug
    recipe_id
    user_id
    resourcePath
    thumbnailPath
    recipe_img_url
    recipe_name
    average_recipe_rating
    cook_time
    preparation_time
    total_time
    is_featured
    recipe_comments {
      id
    }
    recipe_ingredients {
      record_id
      recipe_id
      ingredient_id
      unit_of_measurement_id
      whole_number
      sort_order
      numerator
      denominator
      measurement_amount
      raw_name
      ingredient {
        ingredient_id
        ingredient_name
      }
      unit_of_measurement {
        unit_of_measurement_id
        unit_abbreviation
        unit_name
      }
    }
    recipe_image {
      thumbnail_path
      resource_path
    }
    user {
      user_id
      profile_photo_resource
      full_name
      slug
      default_listing {
        listing_id
        photo
        resourcePath
      }
    }
  }
}
    `;

/**
 * __useGetRecipesQuery__
 *
 * To run a query within a React component, call `useGetRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      public: // value for 'public'
 *      searchTerm: // value for 'searchTerm'
 *      isFeatured: // value for 'isFeatured'
 *   },
 * });
 */
export function useGetRecipesQuery(baseOptions: Apollo.QueryHookOptions<GetRecipesQuery, GetRecipesQueryVariables> & ({ variables: GetRecipesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipesQuery, GetRecipesQueryVariables>(GetRecipesDocument, options);
      }
export function useGetRecipesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipesQuery, GetRecipesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipesQuery, GetRecipesQueryVariables>(GetRecipesDocument, options);
        }
export function useGetRecipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecipesQuery, GetRecipesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecipesQuery, GetRecipesQueryVariables>(GetRecipesDocument, options);
        }
export type GetRecipesQueryHookResult = ReturnType<typeof useGetRecipesQuery>;
export type GetRecipesLazyQueryHookResult = ReturnType<typeof useGetRecipesLazyQuery>;
export type GetRecipesSuspenseQueryHookResult = ReturnType<typeof useGetRecipesSuspenseQuery>;
export type GetRecipesQueryResult = Apollo.QueryResult<GetRecipesQuery, GetRecipesQueryVariables>;
export const GetDiscoverRecipesDocument = gql`
    query GetDiscoverRecipes($limit: Int!, $page: Int!, $public: String!, $searchTerm: String) {
  getDiscoverRecipes(
    limit: $limit
    page: $page
    public: $public
    searchTerm: $searchTerm
  ) {
    recipes {
      recipe_id
      user_id
      slug
      resourcePath
      recipe_img_url
      recipe_name
      average_recipe_rating
      cook_time
      preparation_time
      total_time
      is_featured
      recipe_comments {
        id
      }
      recipe_ingredients {
        record_id
        recipe_id
        ingredient_id
        unit_of_measurement_id
        whole_number
        sort_order
        numerator
        denominator
        measurement_amount
        raw_name
        ingredient {
          ingredient_id
          ingredient_name
        }
        unit_of_measurement {
          unit_of_measurement_id
          unit_abbreviation
          unit_name
        }
      }
      recipe_image {
        thumbnail_path
        resource_path
      }
      user {
        user_id
        profile_photo_resource
        full_name
        slug
        default_listing {
          listing_id
          photo
          resourcePath
        }
      }
    }
    total
  }
}
    `;

/**
 * __useGetDiscoverRecipesQuery__
 *
 * To run a query within a React component, call `useGetDiscoverRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoverRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoverRecipesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      public: // value for 'public'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetDiscoverRecipesQuery(baseOptions: Apollo.QueryHookOptions<GetDiscoverRecipesQuery, GetDiscoverRecipesQueryVariables> & ({ variables: GetDiscoverRecipesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscoverRecipesQuery, GetDiscoverRecipesQueryVariables>(GetDiscoverRecipesDocument, options);
      }
export function useGetDiscoverRecipesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscoverRecipesQuery, GetDiscoverRecipesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscoverRecipesQuery, GetDiscoverRecipesQueryVariables>(GetDiscoverRecipesDocument, options);
        }
export function useGetDiscoverRecipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscoverRecipesQuery, GetDiscoverRecipesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscoverRecipesQuery, GetDiscoverRecipesQueryVariables>(GetDiscoverRecipesDocument, options);
        }
export type GetDiscoverRecipesQueryHookResult = ReturnType<typeof useGetDiscoverRecipesQuery>;
export type GetDiscoverRecipesLazyQueryHookResult = ReturnType<typeof useGetDiscoverRecipesLazyQuery>;
export type GetDiscoverRecipesSuspenseQueryHookResult = ReturnType<typeof useGetDiscoverRecipesSuspenseQuery>;
export type GetDiscoverRecipesQueryResult = Apollo.QueryResult<GetDiscoverRecipesQuery, GetDiscoverRecipesQueryVariables>;
export const DeleteRecipeDocument = gql`
    mutation DeleteRecipe($recipeId: Int!) {
  deleteRecipe(recipe_id: $recipeId)
}
    `;
export type DeleteRecipeMutationFn = Apollo.MutationFunction<DeleteRecipeMutation, DeleteRecipeMutationVariables>;

/**
 * __useDeleteRecipeMutation__
 *
 * To run a mutation, you first call `useDeleteRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecipeMutation, { data, loading, error }] = useDeleteRecipeMutation({
 *   variables: {
 *      recipeId: // value for 'recipeId'
 *   },
 * });
 */
export function useDeleteRecipeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecipeMutation, DeleteRecipeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecipeMutation, DeleteRecipeMutationVariables>(DeleteRecipeDocument, options);
      }
export type DeleteRecipeMutationHookResult = ReturnType<typeof useDeleteRecipeMutation>;
export type DeleteRecipeMutationResult = Apollo.MutationResult<DeleteRecipeMutation>;
export type DeleteRecipeMutationOptions = Apollo.BaseMutationOptions<DeleteRecipeMutation, DeleteRecipeMutationVariables>;
export const GetRecipeCommentsDocument = gql`
    query GetRecipeComments($recipeId: Int!, $sort: String, $starRating: Int) {
  getRecipeComments(recipe_id: $recipeId, sort: $sort, starRating: $starRating) {
    id
    recipeID
    userID
    content
    rating
    imagePath
    user {
      user_id
      full_name
      username
      user_type
      profile_photo_resource
      slug
      default_listing_id
      default_listing {
        listing_id
        name
        photo
      }
    }
    reactions {
      id
      commentID
      emoji
      userID
    }
  }
}
    `;

/**
 * __useGetRecipeCommentsQuery__
 *
 * To run a query within a React component, call `useGetRecipeCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipeCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipeCommentsQuery({
 *   variables: {
 *      recipeId: // value for 'recipeId'
 *      sort: // value for 'sort'
 *      starRating: // value for 'starRating'
 *   },
 * });
 */
export function useGetRecipeCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetRecipeCommentsQuery, GetRecipeCommentsQueryVariables> & ({ variables: GetRecipeCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipeCommentsQuery, GetRecipeCommentsQueryVariables>(GetRecipeCommentsDocument, options);
      }
export function useGetRecipeCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipeCommentsQuery, GetRecipeCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipeCommentsQuery, GetRecipeCommentsQueryVariables>(GetRecipeCommentsDocument, options);
        }
export function useGetRecipeCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecipeCommentsQuery, GetRecipeCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecipeCommentsQuery, GetRecipeCommentsQueryVariables>(GetRecipeCommentsDocument, options);
        }
export type GetRecipeCommentsQueryHookResult = ReturnType<typeof useGetRecipeCommentsQuery>;
export type GetRecipeCommentsLazyQueryHookResult = ReturnType<typeof useGetRecipeCommentsLazyQuery>;
export type GetRecipeCommentsSuspenseQueryHookResult = ReturnType<typeof useGetRecipeCommentsSuspenseQuery>;
export type GetRecipeCommentsQueryResult = Apollo.QueryResult<GetRecipeCommentsQuery, GetRecipeCommentsQueryVariables>;
export const AddRecipeCommentDocument = gql`
    mutation AddRecipeComment($recipeID: Int!, $userID: Int!, $content: String!, $rating: Float, $file: Upload) {
  addRecipeComment(
    recipeID: $recipeID
    userID: $userID
    content: $content
    rating: $rating
    file: $file
  ) {
    id
    recipeID
    userID
    content
    rating
    imagePath
    user {
      user_id
      full_name
      username
      user_type
      profile_photo_resource
      slug
      default_listing_id
      default_listing {
        listing_id
        name
        photo
      }
    }
    reactions {
      id
      commentID
      emoji
      userID
    }
  }
}
    `;
export type AddRecipeCommentMutationFn = Apollo.MutationFunction<AddRecipeCommentMutation, AddRecipeCommentMutationVariables>;

/**
 * __useAddRecipeCommentMutation__
 *
 * To run a mutation, you first call `useAddRecipeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecipeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecipeCommentMutation, { data, loading, error }] = useAddRecipeCommentMutation({
 *   variables: {
 *      recipeID: // value for 'recipeID'
 *      userID: // value for 'userID'
 *      content: // value for 'content'
 *      rating: // value for 'rating'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useAddRecipeCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddRecipeCommentMutation, AddRecipeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRecipeCommentMutation, AddRecipeCommentMutationVariables>(AddRecipeCommentDocument, options);
      }
export type AddRecipeCommentMutationHookResult = ReturnType<typeof useAddRecipeCommentMutation>;
export type AddRecipeCommentMutationResult = Apollo.MutationResult<AddRecipeCommentMutation>;
export type AddRecipeCommentMutationOptions = Apollo.BaseMutationOptions<AddRecipeCommentMutation, AddRecipeCommentMutationVariables>;
export const AddRecipeCommentReactionDocument = gql`
    mutation AddRecipeCommentReaction($commentID: Int!, $userID: Int!, $emoji: String!) {
  addRecipeCommentReaction(commentID: $commentID, userID: $userID, emoji: $emoji) {
    id
    commentID
    userID
    emoji
  }
}
    `;
export type AddRecipeCommentReactionMutationFn = Apollo.MutationFunction<AddRecipeCommentReactionMutation, AddRecipeCommentReactionMutationVariables>;

/**
 * __useAddRecipeCommentReactionMutation__
 *
 * To run a mutation, you first call `useAddRecipeCommentReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecipeCommentReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecipeCommentReactionMutation, { data, loading, error }] = useAddRecipeCommentReactionMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *      userID: // value for 'userID'
 *      emoji: // value for 'emoji'
 *   },
 * });
 */
export function useAddRecipeCommentReactionMutation(baseOptions?: Apollo.MutationHookOptions<AddRecipeCommentReactionMutation, AddRecipeCommentReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRecipeCommentReactionMutation, AddRecipeCommentReactionMutationVariables>(AddRecipeCommentReactionDocument, options);
      }
export type AddRecipeCommentReactionMutationHookResult = ReturnType<typeof useAddRecipeCommentReactionMutation>;
export type AddRecipeCommentReactionMutationResult = Apollo.MutationResult<AddRecipeCommentReactionMutation>;
export type AddRecipeCommentReactionMutationOptions = Apollo.BaseMutationOptions<AddRecipeCommentReactionMutation, AddRecipeCommentReactionMutationVariables>;
export const DeleteRecipeCommentDocument = gql`
    mutation DeleteRecipeComment($commentID: Int!, $userID: Int!) {
  deleteRecipeComment(commentID: $commentID, userID: $userID)
}
    `;
export type DeleteRecipeCommentMutationFn = Apollo.MutationFunction<DeleteRecipeCommentMutation, DeleteRecipeCommentMutationVariables>;

/**
 * __useDeleteRecipeCommentMutation__
 *
 * To run a mutation, you first call `useDeleteRecipeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecipeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecipeCommentMutation, { data, loading, error }] = useDeleteRecipeCommentMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useDeleteRecipeCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecipeCommentMutation, DeleteRecipeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecipeCommentMutation, DeleteRecipeCommentMutationVariables>(DeleteRecipeCommentDocument, options);
      }
export type DeleteRecipeCommentMutationHookResult = ReturnType<typeof useDeleteRecipeCommentMutation>;
export type DeleteRecipeCommentMutationResult = Apollo.MutationResult<DeleteRecipeCommentMutation>;
export type DeleteRecipeCommentMutationOptions = Apollo.BaseMutationOptions<DeleteRecipeCommentMutation, DeleteRecipeCommentMutationVariables>;
export const SetRecipeAsFeaturedDocument = gql`
    mutation SetRecipeAsFeatured($recipe_id: Int!, $isFeatured: Boolean!) {
  setRecipeAsFeatured(recipe_id: $recipe_id, isFeatured: $isFeatured) {
    recipe_id
    recipe_name
    recipe_img_url
    recipe_image {
      thumbnail_path
      resource_path
    }
    is_featured
  }
}
    `;
export type SetRecipeAsFeaturedMutationFn = Apollo.MutationFunction<SetRecipeAsFeaturedMutation, SetRecipeAsFeaturedMutationVariables>;

/**
 * __useSetRecipeAsFeaturedMutation__
 *
 * To run a mutation, you first call `useSetRecipeAsFeaturedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRecipeAsFeaturedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRecipeAsFeaturedMutation, { data, loading, error }] = useSetRecipeAsFeaturedMutation({
 *   variables: {
 *      recipe_id: // value for 'recipe_id'
 *      isFeatured: // value for 'isFeatured'
 *   },
 * });
 */
export function useSetRecipeAsFeaturedMutation(baseOptions?: Apollo.MutationHookOptions<SetRecipeAsFeaturedMutation, SetRecipeAsFeaturedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRecipeAsFeaturedMutation, SetRecipeAsFeaturedMutationVariables>(SetRecipeAsFeaturedDocument, options);
      }
export type SetRecipeAsFeaturedMutationHookResult = ReturnType<typeof useSetRecipeAsFeaturedMutation>;
export type SetRecipeAsFeaturedMutationResult = Apollo.MutationResult<SetRecipeAsFeaturedMutation>;
export type SetRecipeAsFeaturedMutationOptions = Apollo.BaseMutationOptions<SetRecipeAsFeaturedMutation, SetRecipeAsFeaturedMutationVariables>;
export const GetSeasonalRecipePicksDocument = gql`
    query GetSeasonalRecipePicks($weekOf: String!) {
  getSeasonalRecipePicks(weekOf: $weekOf) {
    id
    recipe_id
    week_of
    sort_order
    recipe {
      recipe_id
      recipe_name
      recipe_img_url
      author_name
      author_link
      total_time
      number_of_servings
      recipe_image {
        thumbnail_path
        resource_path
      }
    }
  }
}
    `;

/**
 * __useGetSeasonalRecipePicksQuery__
 *
 * To run a query within a React component, call `useGetSeasonalRecipePicksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonalRecipePicksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonalRecipePicksQuery({
 *   variables: {
 *      weekOf: // value for 'weekOf'
 *   },
 * });
 */
export function useGetSeasonalRecipePicksQuery(baseOptions: Apollo.QueryHookOptions<GetSeasonalRecipePicksQuery, GetSeasonalRecipePicksQueryVariables> & ({ variables: GetSeasonalRecipePicksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeasonalRecipePicksQuery, GetSeasonalRecipePicksQueryVariables>(GetSeasonalRecipePicksDocument, options);
      }
export function useGetSeasonalRecipePicksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeasonalRecipePicksQuery, GetSeasonalRecipePicksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeasonalRecipePicksQuery, GetSeasonalRecipePicksQueryVariables>(GetSeasonalRecipePicksDocument, options);
        }
export function useGetSeasonalRecipePicksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSeasonalRecipePicksQuery, GetSeasonalRecipePicksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSeasonalRecipePicksQuery, GetSeasonalRecipePicksQueryVariables>(GetSeasonalRecipePicksDocument, options);
        }
export type GetSeasonalRecipePicksQueryHookResult = ReturnType<typeof useGetSeasonalRecipePicksQuery>;
export type GetSeasonalRecipePicksLazyQueryHookResult = ReturnType<typeof useGetSeasonalRecipePicksLazyQuery>;
export type GetSeasonalRecipePicksSuspenseQueryHookResult = ReturnType<typeof useGetSeasonalRecipePicksSuspenseQuery>;
export type GetSeasonalRecipePicksQueryResult = Apollo.QueryResult<GetSeasonalRecipePicksQuery, GetSeasonalRecipePicksQueryVariables>;
export const SetSeasonalRecipePickDocument = gql`
    mutation SetSeasonalRecipePick($recipeId: Int!, $weekOf: String!) {
  setSeasonalRecipePick(recipeId: $recipeId, weekOf: $weekOf) {
    id
    recipe_id
    week_of
    sort_order
    recipe {
      recipe_id
      recipe_name
      recipe_img_url
      author_name
      author_link
      recipe_image {
        thumbnail_path
        resource_path
      }
    }
  }
}
    `;
export type SetSeasonalRecipePickMutationFn = Apollo.MutationFunction<SetSeasonalRecipePickMutation, SetSeasonalRecipePickMutationVariables>;

/**
 * __useSetSeasonalRecipePickMutation__
 *
 * To run a mutation, you first call `useSetSeasonalRecipePickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSeasonalRecipePickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSeasonalRecipePickMutation, { data, loading, error }] = useSetSeasonalRecipePickMutation({
 *   variables: {
 *      recipeId: // value for 'recipeId'
 *      weekOf: // value for 'weekOf'
 *   },
 * });
 */
export function useSetSeasonalRecipePickMutation(baseOptions?: Apollo.MutationHookOptions<SetSeasonalRecipePickMutation, SetSeasonalRecipePickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSeasonalRecipePickMutation, SetSeasonalRecipePickMutationVariables>(SetSeasonalRecipePickDocument, options);
      }
export type SetSeasonalRecipePickMutationHookResult = ReturnType<typeof useSetSeasonalRecipePickMutation>;
export type SetSeasonalRecipePickMutationResult = Apollo.MutationResult<SetSeasonalRecipePickMutation>;
export type SetSeasonalRecipePickMutationOptions = Apollo.BaseMutationOptions<SetSeasonalRecipePickMutation, SetSeasonalRecipePickMutationVariables>;
export const RemoveSeasonalRecipePickDocument = gql`
    mutation RemoveSeasonalRecipePick($id: Int!) {
  removeSeasonalRecipePick(id: $id)
}
    `;
export type RemoveSeasonalRecipePickMutationFn = Apollo.MutationFunction<RemoveSeasonalRecipePickMutation, RemoveSeasonalRecipePickMutationVariables>;

/**
 * __useRemoveSeasonalRecipePickMutation__
 *
 * To run a mutation, you first call `useRemoveSeasonalRecipePickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSeasonalRecipePickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSeasonalRecipePickMutation, { data, loading, error }] = useRemoveSeasonalRecipePickMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSeasonalRecipePickMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSeasonalRecipePickMutation, RemoveSeasonalRecipePickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSeasonalRecipePickMutation, RemoveSeasonalRecipePickMutationVariables>(RemoveSeasonalRecipePickDocument, options);
      }
export type RemoveSeasonalRecipePickMutationHookResult = ReturnType<typeof useRemoveSeasonalRecipePickMutation>;
export type RemoveSeasonalRecipePickMutationResult = Apollo.MutationResult<RemoveSeasonalRecipePickMutation>;
export type RemoveSeasonalRecipePickMutationOptions = Apollo.BaseMutationOptions<RemoveSeasonalRecipePickMutation, RemoveSeasonalRecipePickMutationVariables>;
export const SearchSpoonacularDocument = gql`
    query SearchSpoonacular($query: String!, $number: Int) {
  searchSpoonacular(query: $query, number: $number) {
    id
    title
    image
    ready_in_minutes
    servings
    aggregate_likes
    credits_text
    source_url
  }
}
    `;

/**
 * __useSearchSpoonacularQuery__
 *
 * To run a query within a React component, call `useSearchSpoonacularQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSpoonacularQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSpoonacularQuery({
 *   variables: {
 *      query: // value for 'query'
 *      number: // value for 'number'
 *   },
 * });
 */
export function useSearchSpoonacularQuery(baseOptions: Apollo.QueryHookOptions<SearchSpoonacularQuery, SearchSpoonacularQueryVariables> & ({ variables: SearchSpoonacularQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSpoonacularQuery, SearchSpoonacularQueryVariables>(SearchSpoonacularDocument, options);
      }
export function useSearchSpoonacularLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSpoonacularQuery, SearchSpoonacularQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSpoonacularQuery, SearchSpoonacularQueryVariables>(SearchSpoonacularDocument, options);
        }
export function useSearchSpoonacularSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSpoonacularQuery, SearchSpoonacularQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSpoonacularQuery, SearchSpoonacularQueryVariables>(SearchSpoonacularDocument, options);
        }
export type SearchSpoonacularQueryHookResult = ReturnType<typeof useSearchSpoonacularQuery>;
export type SearchSpoonacularLazyQueryHookResult = ReturnType<typeof useSearchSpoonacularLazyQuery>;
export type SearchSpoonacularSuspenseQueryHookResult = ReturnType<typeof useSearchSpoonacularSuspenseQuery>;
export type SearchSpoonacularQueryResult = Apollo.QueryResult<SearchSpoonacularQuery, SearchSpoonacularQueryVariables>;
export const ImportSpoonacularRecipeDocument = gql`
    mutation ImportSpoonacularRecipe($spoonacularId: Int!, $weekOf: String!) {
  importSpoonacularRecipe(spoonacularId: $spoonacularId, weekOf: $weekOf) {
    id
    recipe_id
    week_of
    recipe {
      recipe_id
      recipe_name
      recipe_img_url
      author_name
      author_link
      recipe_image {
        thumbnail_path
        resource_path
      }
    }
  }
}
    `;
export type ImportSpoonacularRecipeMutationFn = Apollo.MutationFunction<ImportSpoonacularRecipeMutation, ImportSpoonacularRecipeMutationVariables>;

/**
 * __useImportSpoonacularRecipeMutation__
 *
 * To run a mutation, you first call `useImportSpoonacularRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportSpoonacularRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importSpoonacularRecipeMutation, { data, loading, error }] = useImportSpoonacularRecipeMutation({
 *   variables: {
 *      spoonacularId: // value for 'spoonacularId'
 *      weekOf: // value for 'weekOf'
 *   },
 * });
 */
export function useImportSpoonacularRecipeMutation(baseOptions?: Apollo.MutationHookOptions<ImportSpoonacularRecipeMutation, ImportSpoonacularRecipeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportSpoonacularRecipeMutation, ImportSpoonacularRecipeMutationVariables>(ImportSpoonacularRecipeDocument, options);
      }
export type ImportSpoonacularRecipeMutationHookResult = ReturnType<typeof useImportSpoonacularRecipeMutation>;
export type ImportSpoonacularRecipeMutationResult = Apollo.MutationResult<ImportSpoonacularRecipeMutation>;
export type ImportSpoonacularRecipeMutationOptions = Apollo.BaseMutationOptions<ImportSpoonacularRecipeMutation, ImportSpoonacularRecipeMutationVariables>;
export const CreateRegionDocument = gql`
    mutation CreateRegion($input: CreateRegionInput!) {
  createRegion(input: $input) {
    region_id
    slug
    name
    month
    state
    latitude
    longitude
    is_active
    featured_recipes
    featured_listings
    created_at
  }
}
    `;
export type CreateRegionMutationFn = Apollo.MutationFunction<CreateRegionMutation, CreateRegionMutationVariables>;

/**
 * __useCreateRegionMutation__
 *
 * To run a mutation, you first call `useCreateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegionMutation, { data, loading, error }] = useCreateRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegionMutation, CreateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegionMutation, CreateRegionMutationVariables>(CreateRegionDocument, options);
      }
export type CreateRegionMutationHookResult = ReturnType<typeof useCreateRegionMutation>;
export type CreateRegionMutationResult = Apollo.MutationResult<CreateRegionMutation>;
export type CreateRegionMutationOptions = Apollo.BaseMutationOptions<CreateRegionMutation, CreateRegionMutationVariables>;
export const UpdateRegionDocument = gql`
    mutation UpdateRegion($input: UpdateRegionInput!) {
  updateRegion(input: $input) {
    region_id
    slug
    name
    month
    state
    latitude
    longitude
    is_active
    featured_recipes
    featured_listings
    updated_at
  }
}
    `;
export type UpdateRegionMutationFn = Apollo.MutationFunction<UpdateRegionMutation, UpdateRegionMutationVariables>;

/**
 * __useUpdateRegionMutation__
 *
 * To run a mutation, you first call `useUpdateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionMutation, { data, loading, error }] = useUpdateRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegionMutation, UpdateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegionMutation, UpdateRegionMutationVariables>(UpdateRegionDocument, options);
      }
export type UpdateRegionMutationHookResult = ReturnType<typeof useUpdateRegionMutation>;
export type UpdateRegionMutationResult = Apollo.MutationResult<UpdateRegionMutation>;
export type UpdateRegionMutationOptions = Apollo.BaseMutationOptions<UpdateRegionMutation, UpdateRegionMutationVariables>;
export const GetRegionsDocument = gql`
    query GetRegions($limit: Int!, $offset: Int!) {
  getRegions(limit: $limit, offset: $offset) {
    total
    regions {
      region_id
      slug
      name
      state
      month
      latitude
      longitude
      hero_image
      short_description
      featured_recipes
      featured_listings
      is_active
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables> & ({ variables: GetRegionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export function useGetRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsSuspenseQueryHookResult = ReturnType<typeof useGetRegionsSuspenseQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetRegionBySlugDocument = gql`
    query getRegionBySlug($slug: String!) {
  getRegionBySlug(slug: $slug) {
    region_id
    slug
    name
    state
    month
    latitude
    longitude
    hero_image
    short_description
    meta_description
    meta_keywords
    featured_recipe_objects {
      recipe_id
      recipe_name
      recipe_img_url
      resourcePath
      recipe_image {
        resource_path
        thumbnail_path
      }
      average_recipe_rating
      recipe_comments {
        id
      }
      recipe_ingredients {
        ingredient_id
      }
      user {
        profile_photo_resource
        slug
        full_name
      }
      total_time
      slug
    }
    featured_listing_objects {
      listing_id
      tagLine
      enhanced
      verified
      photo
      name
      slug
      user_type
      description
      city
      address
      state
      user {
        profile_photo_resource
      }
    }
    is_active
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetRegionBySlugQuery__
 *
 * To run a query within a React component, call `useGetRegionBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetRegionBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetRegionBySlugQuery, GetRegionBySlugQueryVariables> & ({ variables: GetRegionBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionBySlugQuery, GetRegionBySlugQueryVariables>(GetRegionBySlugDocument, options);
      }
export function useGetRegionBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionBySlugQuery, GetRegionBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionBySlugQuery, GetRegionBySlugQueryVariables>(GetRegionBySlugDocument, options);
        }
export function useGetRegionBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionBySlugQuery, GetRegionBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionBySlugQuery, GetRegionBySlugQueryVariables>(GetRegionBySlugDocument, options);
        }
export type GetRegionBySlugQueryHookResult = ReturnType<typeof useGetRegionBySlugQuery>;
export type GetRegionBySlugLazyQueryHookResult = ReturnType<typeof useGetRegionBySlugLazyQuery>;
export type GetRegionBySlugSuspenseQueryHookResult = ReturnType<typeof useGetRegionBySlugSuspenseQuery>;
export type GetRegionBySlugQueryResult = Apollo.QueryResult<GetRegionBySlugQuery, GetRegionBySlugQueryVariables>;
export const DeleteRegionDocument = gql`
    mutation DeleteRegion($region_id: Int!) {
  deleteRegion(region_id: $region_id)
}
    `;
export type DeleteRegionMutationFn = Apollo.MutationFunction<DeleteRegionMutation, DeleteRegionMutationVariables>;

/**
 * __useDeleteRegionMutation__
 *
 * To run a mutation, you first call `useDeleteRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegionMutation, { data, loading, error }] = useDeleteRegionMutation({
 *   variables: {
 *      region_id: // value for 'region_id'
 *   },
 * });
 */
export function useDeleteRegionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegionMutation, DeleteRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegionMutation, DeleteRegionMutationVariables>(DeleteRegionDocument, options);
      }
export type DeleteRegionMutationHookResult = ReturnType<typeof useDeleteRegionMutation>;
export type DeleteRegionMutationResult = Apollo.MutationResult<DeleteRegionMutation>;
export type DeleteRegionMutationOptions = Apollo.BaseMutationOptions<DeleteRegionMutation, DeleteRegionMutationVariables>;
export const GetRegionByIdDocument = gql`
    query GetRegionByID($region_id: Int!) {
  getRegionById(region_id: $region_id) {
    region_id
    slug
    name
    state
    month
    latitude
    longitude
    hero_image
    short_description
    meta_description
    meta_keywords
    featured_recipe_objects {
      recipe_id
      recipe_name
      recipe_img_url
      resourcePath
      recipe_image {
        resource_path
        thumbnail_path
      }
      average_recipe_rating
      recipe_comments {
        id
      }
      recipe_ingredients {
        ingredient_id
      }
      user {
        profile_photo_resource
        slug
        full_name
      }
      total_time
      slug
    }
    featured_listing_objects {
      listing_id
      tagLine
      enhanced
      verified
      photo
      name
      slug
      user_type
      description
      city
      address
      state
      user {
        profile_photo_resource
      }
    }
    is_active
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetRegionByIdQuery__
 *
 * To run a query within a React component, call `useGetRegionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionByIdQuery({
 *   variables: {
 *      region_id: // value for 'region_id'
 *   },
 * });
 */
export function useGetRegionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRegionByIdQuery, GetRegionByIdQueryVariables> & ({ variables: GetRegionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionByIdQuery, GetRegionByIdQueryVariables>(GetRegionByIdDocument, options);
      }
export function useGetRegionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionByIdQuery, GetRegionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionByIdQuery, GetRegionByIdQueryVariables>(GetRegionByIdDocument, options);
        }
export function useGetRegionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionByIdQuery, GetRegionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionByIdQuery, GetRegionByIdQueryVariables>(GetRegionByIdDocument, options);
        }
export type GetRegionByIdQueryHookResult = ReturnType<typeof useGetRegionByIdQuery>;
export type GetRegionByIdLazyQueryHookResult = ReturnType<typeof useGetRegionByIdLazyQuery>;
export type GetRegionByIdSuspenseQueryHookResult = ReturnType<typeof useGetRegionByIdSuspenseQuery>;
export type GetRegionByIdQueryResult = Apollo.QueryResult<GetRegionByIdQuery, GetRegionByIdQueryVariables>;
export const UploadHeroImageDocument = gql`
    mutation uploadHeroImage($region_id: Int!, $file: Upload!) {
  uploadHeroImage(region_id: $region_id, file: $file)
}
    `;
export type UploadHeroImageMutationFn = Apollo.MutationFunction<UploadHeroImageMutation, UploadHeroImageMutationVariables>;

/**
 * __useUploadHeroImageMutation__
 *
 * To run a mutation, you first call `useUploadHeroImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadHeroImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadHeroImageMutation, { data, loading, error }] = useUploadHeroImageMutation({
 *   variables: {
 *      region_id: // value for 'region_id'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadHeroImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadHeroImageMutation, UploadHeroImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadHeroImageMutation, UploadHeroImageMutationVariables>(UploadHeroImageDocument, options);
      }
export type UploadHeroImageMutationHookResult = ReturnType<typeof useUploadHeroImageMutation>;
export type UploadHeroImageMutationResult = Apollo.MutationResult<UploadHeroImageMutation>;
export type UploadHeroImageMutationOptions = Apollo.BaseMutationOptions<UploadHeroImageMutation, UploadHeroImageMutationVariables>;
export const LogShareDocument = gql`
    mutation LogShare($input: LogShareInput!) {
  logShare(input: $input)
}
    `;
export type LogShareMutationFn = Apollo.MutationFunction<LogShareMutation, LogShareMutationVariables>;

/**
 * __useLogShareMutation__
 *
 * To run a mutation, you first call `useLogShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logShareMutation, { data, loading, error }] = useLogShareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogShareMutation(baseOptions?: Apollo.MutationHookOptions<LogShareMutation, LogShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogShareMutation, LogShareMutationVariables>(LogShareDocument, options);
      }
export type LogShareMutationHookResult = ReturnType<typeof useLogShareMutation>;
export type LogShareMutationResult = Apollo.MutationResult<LogShareMutation>;
export type LogShareMutationOptions = Apollo.BaseMutationOptions<LogShareMutation, LogShareMutationVariables>;
export const LogReferralConversionDocument = gql`
    mutation LogReferralConversion($input: LogReferralConversionInput!) {
  logReferralConversion(input: $input)
}
    `;
export type LogReferralConversionMutationFn = Apollo.MutationFunction<LogReferralConversionMutation, LogReferralConversionMutationVariables>;

/**
 * __useLogReferralConversionMutation__
 *
 * To run a mutation, you first call `useLogReferralConversionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogReferralConversionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logReferralConversionMutation, { data, loading, error }] = useLogReferralConversionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogReferralConversionMutation(baseOptions?: Apollo.MutationHookOptions<LogReferralConversionMutation, LogReferralConversionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogReferralConversionMutation, LogReferralConversionMutationVariables>(LogReferralConversionDocument, options);
      }
export type LogReferralConversionMutationHookResult = ReturnType<typeof useLogReferralConversionMutation>;
export type LogReferralConversionMutationResult = Apollo.MutationResult<LogReferralConversionMutation>;
export type LogReferralConversionMutationOptions = Apollo.BaseMutationOptions<LogReferralConversionMutation, LogReferralConversionMutationVariables>;
export const GetSmsTemplatesDocument = gql`
    query GetSmsTemplates {
  getSmsTemplates {
    id
    messageType
    template
    approvedBy
    approvedAt
    legalApproved
    description
    active
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetSmsTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSmsTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSmsTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>(GetSmsTemplatesDocument, options);
      }
export function useGetSmsTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>(GetSmsTemplatesDocument, options);
        }
export function useGetSmsTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>(GetSmsTemplatesDocument, options);
        }
export type GetSmsTemplatesQueryHookResult = ReturnType<typeof useGetSmsTemplatesQuery>;
export type GetSmsTemplatesLazyQueryHookResult = ReturnType<typeof useGetSmsTemplatesLazyQuery>;
export type GetSmsTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetSmsTemplatesSuspenseQuery>;
export type GetSmsTemplatesQueryResult = Apollo.QueryResult<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>;
export const GetSmsTemplateDocument = gql`
    query GetSmsTemplate($id: Int!) {
  getSmsTemplate(id: $id) {
    id
    messageType
    template
    approvedBy
    approvedAt
    legalApproved
    description
    active
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetSmsTemplateQuery__
 *
 * To run a query within a React component, call `useGetSmsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSmsTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetSmsTemplateQuery, GetSmsTemplateQueryVariables> & ({ variables: GetSmsTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsTemplateQuery, GetSmsTemplateQueryVariables>(GetSmsTemplateDocument, options);
      }
export function useGetSmsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsTemplateQuery, GetSmsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsTemplateQuery, GetSmsTemplateQueryVariables>(GetSmsTemplateDocument, options);
        }
export function useGetSmsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsTemplateQuery, GetSmsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsTemplateQuery, GetSmsTemplateQueryVariables>(GetSmsTemplateDocument, options);
        }
export type GetSmsTemplateQueryHookResult = ReturnType<typeof useGetSmsTemplateQuery>;
export type GetSmsTemplateLazyQueryHookResult = ReturnType<typeof useGetSmsTemplateLazyQuery>;
export type GetSmsTemplateSuspenseQueryHookResult = ReturnType<typeof useGetSmsTemplateSuspenseQuery>;
export type GetSmsTemplateQueryResult = Apollo.QueryResult<GetSmsTemplateQuery, GetSmsTemplateQueryVariables>;
export const UpdateSmsTemplateDocument = gql`
    mutation UpdateSmsTemplate($input: UpdateSmsTemplateInput!) {
  updateSmsTemplate(input: $input) {
    id
    messageType
    template
    approvedBy
    approvedAt
    legalApproved
    description
    active
    updatedAt
  }
}
    `;
export type UpdateSmsTemplateMutationFn = Apollo.MutationFunction<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables>;

/**
 * __useUpdateSmsTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSmsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSmsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSmsTemplateMutation, { data, loading, error }] = useUpdateSmsTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSmsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables>(UpdateSmsTemplateDocument, options);
      }
export type UpdateSmsTemplateMutationHookResult = ReturnType<typeof useUpdateSmsTemplateMutation>;
export type UpdateSmsTemplateMutationResult = Apollo.MutationResult<UpdateSmsTemplateMutation>;
export type UpdateSmsTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables>;
export const CreateSmsTemplateDocument = gql`
    mutation CreateSmsTemplate($input: CreateSmsTemplateInput!) {
  createSmsTemplate(input: $input) {
    id
    messageType
    template
    description
    active
    createdAt
  }
}
    `;
export type CreateSmsTemplateMutationFn = Apollo.MutationFunction<CreateSmsTemplateMutation, CreateSmsTemplateMutationVariables>;

/**
 * __useCreateSmsTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSmsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSmsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSmsTemplateMutation, { data, loading, error }] = useCreateSmsTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSmsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateSmsTemplateMutation, CreateSmsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSmsTemplateMutation, CreateSmsTemplateMutationVariables>(CreateSmsTemplateDocument, options);
      }
export type CreateSmsTemplateMutationHookResult = ReturnType<typeof useCreateSmsTemplateMutation>;
export type CreateSmsTemplateMutationResult = Apollo.MutationResult<CreateSmsTemplateMutation>;
export type CreateSmsTemplateMutationOptions = Apollo.BaseMutationOptions<CreateSmsTemplateMutation, CreateSmsTemplateMutationVariables>;
export const DeleteSmsTemplateDocument = gql`
    mutation DeleteSmsTemplate($id: Int!) {
  deleteSmsTemplate(id: $id)
}
    `;
export type DeleteSmsTemplateMutationFn = Apollo.MutationFunction<DeleteSmsTemplateMutation, DeleteSmsTemplateMutationVariables>;

/**
 * __useDeleteSmsTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteSmsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSmsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSmsTemplateMutation, { data, loading, error }] = useDeleteSmsTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSmsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSmsTemplateMutation, DeleteSmsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSmsTemplateMutation, DeleteSmsTemplateMutationVariables>(DeleteSmsTemplateDocument, options);
      }
export type DeleteSmsTemplateMutationHookResult = ReturnType<typeof useDeleteSmsTemplateMutation>;
export type DeleteSmsTemplateMutationResult = Apollo.MutationResult<DeleteSmsTemplateMutation>;
export type DeleteSmsTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteSmsTemplateMutation, DeleteSmsTemplateMutationVariables>;
export const InitiateSmsOptInDocument = gql`
    mutation InitiateSmsOptIn($input: SmsOptInInput!) {
  initiateSmsOptIn(input: $input) {
    success
    message
    sessionExpiry
  }
}
    `;
export type InitiateSmsOptInMutationFn = Apollo.MutationFunction<InitiateSmsOptInMutation, InitiateSmsOptInMutationVariables>;

/**
 * __useInitiateSmsOptInMutation__
 *
 * To run a mutation, you first call `useInitiateSmsOptInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateSmsOptInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateSmsOptInMutation, { data, loading, error }] = useInitiateSmsOptInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateSmsOptInMutation(baseOptions?: Apollo.MutationHookOptions<InitiateSmsOptInMutation, InitiateSmsOptInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateSmsOptInMutation, InitiateSmsOptInMutationVariables>(InitiateSmsOptInDocument, options);
      }
export type InitiateSmsOptInMutationHookResult = ReturnType<typeof useInitiateSmsOptInMutation>;
export type InitiateSmsOptInMutationResult = Apollo.MutationResult<InitiateSmsOptInMutation>;
export type InitiateSmsOptInMutationOptions = Apollo.BaseMutationOptions<InitiateSmsOptInMutation, InitiateSmsOptInMutationVariables>;
export const VerifySmsOtpDocument = gql`
    mutation VerifySmsOtp($input: SmsVerifyOtpInput!) {
  verifySmsOtp(input: $input)
}
    `;
export type VerifySmsOtpMutationFn = Apollo.MutationFunction<VerifySmsOtpMutation, VerifySmsOtpMutationVariables>;

/**
 * __useVerifySmsOtpMutation__
 *
 * To run a mutation, you first call `useVerifySmsOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifySmsOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifySmsOtpMutation, { data, loading, error }] = useVerifySmsOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifySmsOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifySmsOtpMutation, VerifySmsOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifySmsOtpMutation, VerifySmsOtpMutationVariables>(VerifySmsOtpDocument, options);
      }
export type VerifySmsOtpMutationHookResult = ReturnType<typeof useVerifySmsOtpMutation>;
export type VerifySmsOtpMutationResult = Apollo.MutationResult<VerifySmsOtpMutation>;
export type VerifySmsOtpMutationOptions = Apollo.BaseMutationOptions<VerifySmsOtpMutation, VerifySmsOtpMutationVariables>;
export const ResendSmsOtpDocument = gql`
    mutation ResendSmsOtp {
  resendSmsOtp {
    success
    message
    sessionExpiry
  }
}
    `;
export type ResendSmsOtpMutationFn = Apollo.MutationFunction<ResendSmsOtpMutation, ResendSmsOtpMutationVariables>;

/**
 * __useResendSmsOtpMutation__
 *
 * To run a mutation, you first call `useResendSmsOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendSmsOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendSmsOtpMutation, { data, loading, error }] = useResendSmsOtpMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendSmsOtpMutation(baseOptions?: Apollo.MutationHookOptions<ResendSmsOtpMutation, ResendSmsOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendSmsOtpMutation, ResendSmsOtpMutationVariables>(ResendSmsOtpDocument, options);
      }
export type ResendSmsOtpMutationHookResult = ReturnType<typeof useResendSmsOtpMutation>;
export type ResendSmsOtpMutationResult = Apollo.MutationResult<ResendSmsOtpMutation>;
export type ResendSmsOtpMutationOptions = Apollo.BaseMutationOptions<ResendSmsOtpMutation, ResendSmsOtpMutationVariables>;
export const DisableSmsNotificationsDocument = gql`
    mutation DisableSmsNotifications {
  disableSmsNotifications
}
    `;
export type DisableSmsNotificationsMutationFn = Apollo.MutationFunction<DisableSmsNotificationsMutation, DisableSmsNotificationsMutationVariables>;

/**
 * __useDisableSmsNotificationsMutation__
 *
 * To run a mutation, you first call `useDisableSmsNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSmsNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSmsNotificationsMutation, { data, loading, error }] = useDisableSmsNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableSmsNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<DisableSmsNotificationsMutation, DisableSmsNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableSmsNotificationsMutation, DisableSmsNotificationsMutationVariables>(DisableSmsNotificationsDocument, options);
      }
export type DisableSmsNotificationsMutationHookResult = ReturnType<typeof useDisableSmsNotificationsMutation>;
export type DisableSmsNotificationsMutationResult = Apollo.MutationResult<DisableSmsNotificationsMutation>;
export type DisableSmsNotificationsMutationOptions = Apollo.BaseMutationOptions<DisableSmsNotificationsMutation, DisableSmsNotificationsMutationVariables>;
export const GetStripePricesDocument = gql`
    query GetStripePrices {
  stripePrices {
    id
    name
    currency
    unitAmount
    interval
    intervalCount
    active
    lookup_key
  }
}
    `;

/**
 * __useGetStripePricesQuery__
 *
 * To run a query within a React component, call `useGetStripePricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripePricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripePricesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripePricesQuery(baseOptions?: Apollo.QueryHookOptions<GetStripePricesQuery, GetStripePricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripePricesQuery, GetStripePricesQueryVariables>(GetStripePricesDocument, options);
      }
export function useGetStripePricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripePricesQuery, GetStripePricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripePricesQuery, GetStripePricesQueryVariables>(GetStripePricesDocument, options);
        }
export function useGetStripePricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStripePricesQuery, GetStripePricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStripePricesQuery, GetStripePricesQueryVariables>(GetStripePricesDocument, options);
        }
export type GetStripePricesQueryHookResult = ReturnType<typeof useGetStripePricesQuery>;
export type GetStripePricesLazyQueryHookResult = ReturnType<typeof useGetStripePricesLazyQuery>;
export type GetStripePricesSuspenseQueryHookResult = ReturnType<typeof useGetStripePricesSuspenseQuery>;
export type GetStripePricesQueryResult = Apollo.QueryResult<GetStripePricesQuery, GetStripePricesQueryVariables>;
export const GetTaxDocument = gql`
    query GetTax($priceID: String!, $input: TaxInput!) {
  computeTax(price_id: $priceID, input: $input) {
    taxAmount
    totalAmount
    taxPercentage
  }
}
    `;

/**
 * __useGetTaxQuery__
 *
 * To run a query within a React component, call `useGetTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxQuery({
 *   variables: {
 *      priceID: // value for 'priceID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTaxQuery(baseOptions: Apollo.QueryHookOptions<GetTaxQuery, GetTaxQueryVariables> & ({ variables: GetTaxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
      }
export function useGetTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxQuery, GetTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
        }
export function useGetTaxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaxQuery, GetTaxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
        }
export type GetTaxQueryHookResult = ReturnType<typeof useGetTaxQuery>;
export type GetTaxLazyQueryHookResult = ReturnType<typeof useGetTaxLazyQuery>;
export type GetTaxSuspenseQueryHookResult = ReturnType<typeof useGetTaxSuspenseQuery>;
export type GetTaxQueryResult = Apollo.QueryResult<GetTaxQuery, GetTaxQueryVariables>;
export const ValidateCouponDocument = gql`
    query ValidateCoupon($code: String!) {
  validateCoupon(code: $code) {
    valid
    discount
    duration_in_months
    error
  }
}
    `;

/**
 * __useValidateCouponQuery__
 *
 * To run a query within a React component, call `useValidateCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCouponQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateCouponQuery(baseOptions: Apollo.QueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables> & ({ variables: ValidateCouponQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCouponQuery, ValidateCouponQueryVariables>(ValidateCouponDocument, options);
      }
export function useValidateCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCouponQuery, ValidateCouponQueryVariables>(ValidateCouponDocument, options);
        }
export function useValidateCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCouponQuery, ValidateCouponQueryVariables>(ValidateCouponDocument, options);
        }
export type ValidateCouponQueryHookResult = ReturnType<typeof useValidateCouponQuery>;
export type ValidateCouponLazyQueryHookResult = ReturnType<typeof useValidateCouponLazyQuery>;
export type ValidateCouponSuspenseQueryHookResult = ReturnType<typeof useValidateCouponSuspenseQuery>;
export type ValidateCouponQueryResult = Apollo.QueryResult<ValidateCouponQuery, ValidateCouponQueryVariables>;
export const NewSubscriptionDocument = gql`
    mutation NewSubscription($paymentMethodID: String!, $input: PaymentIntentInput!) {
  createSubscription(paymentMethodID: $paymentMethodID, input: $input) {
    id
    customerID
    currentPeriodEnd
    status
    success
    message
  }
}
    `;
export type NewSubscriptionMutationFn = Apollo.MutationFunction<NewSubscriptionMutation, NewSubscriptionMutationVariables>;

/**
 * __useNewSubscriptionMutation__
 *
 * To run a mutation, you first call `useNewSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newSubscriptionMutation, { data, loading, error }] = useNewSubscriptionMutation({
 *   variables: {
 *      paymentMethodID: // value for 'paymentMethodID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<NewSubscriptionMutation, NewSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewSubscriptionMutation, NewSubscriptionMutationVariables>(NewSubscriptionDocument, options);
      }
export type NewSubscriptionMutationHookResult = ReturnType<typeof useNewSubscriptionMutation>;
export type NewSubscriptionMutationResult = Apollo.MutationResult<NewSubscriptionMutation>;
export type NewSubscriptionMutationOptions = Apollo.BaseMutationOptions<NewSubscriptionMutation, NewSubscriptionMutationVariables>;
export const CreateFinancialConnectionSessionDocument = gql`
    mutation CreateFinancialConnectionSession($input: PaymentIntentInput!) {
  createFinancialConnectionsSession(input: $input) {
    clientSecret
    customerID
  }
}
    `;
export type CreateFinancialConnectionSessionMutationFn = Apollo.MutationFunction<CreateFinancialConnectionSessionMutation, CreateFinancialConnectionSessionMutationVariables>;

/**
 * __useCreateFinancialConnectionSessionMutation__
 *
 * To run a mutation, you first call `useCreateFinancialConnectionSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinancialConnectionSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinancialConnectionSessionMutation, { data, loading, error }] = useCreateFinancialConnectionSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFinancialConnectionSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinancialConnectionSessionMutation, CreateFinancialConnectionSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinancialConnectionSessionMutation, CreateFinancialConnectionSessionMutationVariables>(CreateFinancialConnectionSessionDocument, options);
      }
export type CreateFinancialConnectionSessionMutationHookResult = ReturnType<typeof useCreateFinancialConnectionSessionMutation>;
export type CreateFinancialConnectionSessionMutationResult = Apollo.MutationResult<CreateFinancialConnectionSessionMutation>;
export type CreateFinancialConnectionSessionMutationOptions = Apollo.BaseMutationOptions<CreateFinancialConnectionSessionMutation, CreateFinancialConnectionSessionMutationVariables>;
export const NewAchSubscriptionDocument = gql`
    mutation NewACHSubscription($customerID: String!, $bankAccountID: String!, $input: PaymentIntentInput!) {
  createACHSubscription(
    customerID: $customerID
    bankAccountID: $bankAccountID
    input: $input
  ) {
    id
    customerID
    currentPeriodEnd
    status
    success
    message
  }
}
    `;
export type NewAchSubscriptionMutationFn = Apollo.MutationFunction<NewAchSubscriptionMutation, NewAchSubscriptionMutationVariables>;

/**
 * __useNewAchSubscriptionMutation__
 *
 * To run a mutation, you first call `useNewAchSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewAchSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newAchSubscriptionMutation, { data, loading, error }] = useNewAchSubscriptionMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      bankAccountID: // value for 'bankAccountID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewAchSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<NewAchSubscriptionMutation, NewAchSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewAchSubscriptionMutation, NewAchSubscriptionMutationVariables>(NewAchSubscriptionDocument, options);
      }
export type NewAchSubscriptionMutationHookResult = ReturnType<typeof useNewAchSubscriptionMutation>;
export type NewAchSubscriptionMutationResult = Apollo.MutationResult<NewAchSubscriptionMutation>;
export type NewAchSubscriptionMutationOptions = Apollo.BaseMutationOptions<NewAchSubscriptionMutation, NewAchSubscriptionMutationVariables>;
export const UpgradeSubscriptionDocument = gql`
    query UpgradeSubscription($priceID: String!, $baseURL: String!) {
  upgradeToEnhancedListing(priceID: $priceID, baseURL: $baseURL) {
    redirect_url
    id
    customerID
    success
    message
  }
}
    `;

/**
 * __useUpgradeSubscriptionQuery__
 *
 * To run a query within a React component, call `useUpgradeSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpgradeSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpgradeSubscriptionQuery({
 *   variables: {
 *      priceID: // value for 'priceID'
 *      baseURL: // value for 'baseURL'
 *   },
 * });
 */
export function useUpgradeSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<UpgradeSubscriptionQuery, UpgradeSubscriptionQueryVariables> & ({ variables: UpgradeSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpgradeSubscriptionQuery, UpgradeSubscriptionQueryVariables>(UpgradeSubscriptionDocument, options);
      }
export function useUpgradeSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpgradeSubscriptionQuery, UpgradeSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpgradeSubscriptionQuery, UpgradeSubscriptionQueryVariables>(UpgradeSubscriptionDocument, options);
        }
export function useUpgradeSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpgradeSubscriptionQuery, UpgradeSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpgradeSubscriptionQuery, UpgradeSubscriptionQueryVariables>(UpgradeSubscriptionDocument, options);
        }
export type UpgradeSubscriptionQueryHookResult = ReturnType<typeof useUpgradeSubscriptionQuery>;
export type UpgradeSubscriptionLazyQueryHookResult = ReturnType<typeof useUpgradeSubscriptionLazyQuery>;
export type UpgradeSubscriptionSuspenseQueryHookResult = ReturnType<typeof useUpgradeSubscriptionSuspenseQuery>;
export type UpgradeSubscriptionQueryResult = Apollo.QueryResult<UpgradeSubscriptionQuery, UpgradeSubscriptionQueryVariables>;
export const AccountUpgradeDocument = gql`
    mutation accountUpgrade($paymentMethodID: String!, $input: PaymentIntentInput!) {
  upgradeToProfessional(paymentMethodID: $paymentMethodID, input: $input) {
    id
    customerID
    currentPeriodEnd
    status
    success
    message
  }
}
    `;
export type AccountUpgradeMutationFn = Apollo.MutationFunction<AccountUpgradeMutation, AccountUpgradeMutationVariables>;

/**
 * __useAccountUpgradeMutation__
 *
 * To run a mutation, you first call `useAccountUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpgradeMutation, { data, loading, error }] = useAccountUpgradeMutation({
 *   variables: {
 *      paymentMethodID: // value for 'paymentMethodID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpgradeMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpgradeMutation, AccountUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpgradeMutation, AccountUpgradeMutationVariables>(AccountUpgradeDocument, options);
      }
export type AccountUpgradeMutationHookResult = ReturnType<typeof useAccountUpgradeMutation>;
export type AccountUpgradeMutationResult = Apollo.MutationResult<AccountUpgradeMutation>;
export type AccountUpgradeMutationOptions = Apollo.BaseMutationOptions<AccountUpgradeMutation, AccountUpgradeMutationVariables>;
export const AccountUpgradeWithAchDocument = gql`
    mutation AccountUpgradeWithACH($customerID: String!, $bankAccountID: String!, $input: PaymentIntentInput!) {
  createACHSubscription(
    customerID: $customerID
    bankAccountID: $bankAccountID
    input: $input
  ) {
    id
    customerID
    currentPeriodEnd
    status
    success
    message
  }
}
    `;
export type AccountUpgradeWithAchMutationFn = Apollo.MutationFunction<AccountUpgradeWithAchMutation, AccountUpgradeWithAchMutationVariables>;

/**
 * __useAccountUpgradeWithAchMutation__
 *
 * To run a mutation, you first call `useAccountUpgradeWithAchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpgradeWithAchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpgradeWithAchMutation, { data, loading, error }] = useAccountUpgradeWithAchMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      bankAccountID: // value for 'bankAccountID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpgradeWithAchMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpgradeWithAchMutation, AccountUpgradeWithAchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpgradeWithAchMutation, AccountUpgradeWithAchMutationVariables>(AccountUpgradeWithAchDocument, options);
      }
export type AccountUpgradeWithAchMutationHookResult = ReturnType<typeof useAccountUpgradeWithAchMutation>;
export type AccountUpgradeWithAchMutationResult = Apollo.MutationResult<AccountUpgradeWithAchMutation>;
export type AccountUpgradeWithAchMutationOptions = Apollo.BaseMutationOptions<AccountUpgradeWithAchMutation, AccountUpgradeWithAchMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription {
  cancelSubscription {
    id
    customerID
    currentPeriodEnd
    status
    success
    message
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const CurrentPaymentMethodDocument = gql`
    query CurrentPaymentMethod {
  currentPaymentMethod {
    brand
    last4
    expMonth
    expYear
  }
}
    `;

/**
 * __useCurrentPaymentMethodQuery__
 *
 * To run a query within a React component, call `useCurrentPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPaymentMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<CurrentPaymentMethodQuery, CurrentPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentPaymentMethodQuery, CurrentPaymentMethodQueryVariables>(CurrentPaymentMethodDocument, options);
      }
export function useCurrentPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentPaymentMethodQuery, CurrentPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentPaymentMethodQuery, CurrentPaymentMethodQueryVariables>(CurrentPaymentMethodDocument, options);
        }
export function useCurrentPaymentMethodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPaymentMethodQuery, CurrentPaymentMethodQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentPaymentMethodQuery, CurrentPaymentMethodQueryVariables>(CurrentPaymentMethodDocument, options);
        }
export type CurrentPaymentMethodQueryHookResult = ReturnType<typeof useCurrentPaymentMethodQuery>;
export type CurrentPaymentMethodLazyQueryHookResult = ReturnType<typeof useCurrentPaymentMethodLazyQuery>;
export type CurrentPaymentMethodSuspenseQueryHookResult = ReturnType<typeof useCurrentPaymentMethodSuspenseQuery>;
export type CurrentPaymentMethodQueryResult = Apollo.QueryResult<CurrentPaymentMethodQuery, CurrentPaymentMethodQueryVariables>;
export const UpdatePaymentMethodDocument = gql`
    mutation UpdatePaymentMethod($paymentMethodID: String!) {
  updatePaymentMethod(paymentMethodID: $paymentMethodID) {
    success
    message
    id
  }
}
    `;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      paymentMethodID: // value for 'paymentMethodID'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>(UpdatePaymentMethodDocument, options);
      }
export type UpdatePaymentMethodMutationHookResult = ReturnType<typeof useUpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationResult = Apollo.MutationResult<UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const UpdateUserSubscriptionDocument = gql`
    mutation UpdateUserSubscription($userId: Int!, $currentPeriodEnd: Time) {
  updateUserSubscription(userId: $userId, currentPeriodEnd: $currentPeriodEnd) {
    subscription_id
    user_id
    status
    current_period_end
    created_at
    updated_at
  }
}
    `;
export type UpdateUserSubscriptionMutationFn = Apollo.MutationFunction<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>;

/**
 * __useUpdateUserSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateUserSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSubscriptionMutation, { data, loading, error }] = useUpdateUserSubscriptionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      currentPeriodEnd: // value for 'currentPeriodEnd'
 *   },
 * });
 */
export function useUpdateUserSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>(UpdateUserSubscriptionDocument, options);
      }
export type UpdateUserSubscriptionMutationHookResult = ReturnType<typeof useUpdateUserSubscriptionMutation>;
export type UpdateUserSubscriptionMutationResult = Apollo.MutationResult<UpdateUserSubscriptionMutation>;
export type UpdateUserSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>;
export const GetSendGridTemplatesDocument = gql`
    query GetSendGridTemplates {
  getSendGridTemplates {
    id
    name
    generation
    updatedAt
    versions {
      id
      templateId
      active
      name
      subject
      updatedAt
    }
  }
}
    `;

/**
 * __useGetSendGridTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSendGridTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendGridTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendGridTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSendGridTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetSendGridTemplatesQuery, GetSendGridTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSendGridTemplatesQuery, GetSendGridTemplatesQueryVariables>(GetSendGridTemplatesDocument, options);
      }
export function useGetSendGridTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSendGridTemplatesQuery, GetSendGridTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSendGridTemplatesQuery, GetSendGridTemplatesQueryVariables>(GetSendGridTemplatesDocument, options);
        }
export function useGetSendGridTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSendGridTemplatesQuery, GetSendGridTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSendGridTemplatesQuery, GetSendGridTemplatesQueryVariables>(GetSendGridTemplatesDocument, options);
        }
export type GetSendGridTemplatesQueryHookResult = ReturnType<typeof useGetSendGridTemplatesQuery>;
export type GetSendGridTemplatesLazyQueryHookResult = ReturnType<typeof useGetSendGridTemplatesLazyQuery>;
export type GetSendGridTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetSendGridTemplatesSuspenseQuery>;
export type GetSendGridTemplatesQueryResult = Apollo.QueryResult<GetSendGridTemplatesQuery, GetSendGridTemplatesQueryVariables>;
export const GetSendGridContactListsDocument = gql`
    query GetSendGridContactLists {
  getSendGridContactLists {
    id
    name
    contactCount
  }
}
    `;

/**
 * __useGetSendGridContactListsQuery__
 *
 * To run a query within a React component, call `useGetSendGridContactListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendGridContactListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendGridContactListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSendGridContactListsQuery(baseOptions?: Apollo.QueryHookOptions<GetSendGridContactListsQuery, GetSendGridContactListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSendGridContactListsQuery, GetSendGridContactListsQueryVariables>(GetSendGridContactListsDocument, options);
      }
export function useGetSendGridContactListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSendGridContactListsQuery, GetSendGridContactListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSendGridContactListsQuery, GetSendGridContactListsQueryVariables>(GetSendGridContactListsDocument, options);
        }
export function useGetSendGridContactListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSendGridContactListsQuery, GetSendGridContactListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSendGridContactListsQuery, GetSendGridContactListsQueryVariables>(GetSendGridContactListsDocument, options);
        }
export type GetSendGridContactListsQueryHookResult = ReturnType<typeof useGetSendGridContactListsQuery>;
export type GetSendGridContactListsLazyQueryHookResult = ReturnType<typeof useGetSendGridContactListsLazyQuery>;
export type GetSendGridContactListsSuspenseQueryHookResult = ReturnType<typeof useGetSendGridContactListsSuspenseQuery>;
export type GetSendGridContactListsQueryResult = Apollo.QueryResult<GetSendGridContactListsQuery, GetSendGridContactListsQueryVariables>;
export const GetSendGridContactsDocument = gql`
    query GetSendGridContacts($listId: String!) {
  getSendGridContacts(listId: $listId) {
    id
    email
    firstName
    lastName
  }
}
    `;

/**
 * __useGetSendGridContactsQuery__
 *
 * To run a query within a React component, call `useGetSendGridContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendGridContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendGridContactsQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useGetSendGridContactsQuery(baseOptions: Apollo.QueryHookOptions<GetSendGridContactsQuery, GetSendGridContactsQueryVariables> & ({ variables: GetSendGridContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSendGridContactsQuery, GetSendGridContactsQueryVariables>(GetSendGridContactsDocument, options);
      }
export function useGetSendGridContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSendGridContactsQuery, GetSendGridContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSendGridContactsQuery, GetSendGridContactsQueryVariables>(GetSendGridContactsDocument, options);
        }
export function useGetSendGridContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSendGridContactsQuery, GetSendGridContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSendGridContactsQuery, GetSendGridContactsQueryVariables>(GetSendGridContactsDocument, options);
        }
export type GetSendGridContactsQueryHookResult = ReturnType<typeof useGetSendGridContactsQuery>;
export type GetSendGridContactsLazyQueryHookResult = ReturnType<typeof useGetSendGridContactsLazyQuery>;
export type GetSendGridContactsSuspenseQueryHookResult = ReturnType<typeof useGetSendGridContactsSuspenseQuery>;
export type GetSendGridContactsQueryResult = Apollo.QueryResult<GetSendGridContactsQuery, GetSendGridContactsQueryVariables>;
export const GetSurveysDocument = gql`
    query GetSurveys {
  getSurveys {
    id
    title
    intro
    type
    status
    sendgridTemplateId
    ctaLabel
    successHeading
    successBody
    successCtaLabel
    successCtaUrl
    questions {
      id
      question
      type
      required
      options {
        label
        emoji
        subtext
        is_freetext
      }
    }
    createdAt
    createdBy
    tokensSent
    responses
    completions
    lastResponse
  }
}
    `;

/**
 * __useGetSurveysQuery__
 *
 * To run a query within a React component, call `useGetSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveysQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
      }
export function useGetSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
        }
export function useGetSurveysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
        }
export type GetSurveysQueryHookResult = ReturnType<typeof useGetSurveysQuery>;
export type GetSurveysLazyQueryHookResult = ReturnType<typeof useGetSurveysLazyQuery>;
export type GetSurveysSuspenseQueryHookResult = ReturnType<typeof useGetSurveysSuspenseQuery>;
export type GetSurveysQueryResult = Apollo.QueryResult<GetSurveysQuery, GetSurveysQueryVariables>;
export const UpdateSurveyStatusDocument = gql`
    mutation UpdateSurveyStatus($input: UpdateSurveyStatusInput!) {
  updateSurveyStatus(input: $input) {
    id
    status
  }
}
    `;
export type UpdateSurveyStatusMutationFn = Apollo.MutationFunction<UpdateSurveyStatusMutation, UpdateSurveyStatusMutationVariables>;

/**
 * __useUpdateSurveyStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyStatusMutation, { data, loading, error }] = useUpdateSurveyStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSurveyStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyStatusMutation, UpdateSurveyStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyStatusMutation, UpdateSurveyStatusMutationVariables>(UpdateSurveyStatusDocument, options);
      }
export type UpdateSurveyStatusMutationHookResult = ReturnType<typeof useUpdateSurveyStatusMutation>;
export type UpdateSurveyStatusMutationResult = Apollo.MutationResult<UpdateSurveyStatusMutation>;
export type UpdateSurveyStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyStatusMutation, UpdateSurveyStatusMutationVariables>;
export const DeleteSurveyDocument = gql`
    mutation DeleteSurvey($id: ID!) {
  deleteSurvey(id: $id)
}
    `;
export type DeleteSurveyMutationFn = Apollo.MutationFunction<DeleteSurveyMutation, DeleteSurveyMutationVariables>;

/**
 * __useDeleteSurveyMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyMutation, { data, loading, error }] = useDeleteSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSurveyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurveyMutation, DeleteSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurveyMutation, DeleteSurveyMutationVariables>(DeleteSurveyDocument, options);
      }
export type DeleteSurveyMutationHookResult = ReturnType<typeof useDeleteSurveyMutation>;
export type DeleteSurveyMutationResult = Apollo.MutationResult<DeleteSurveyMutation>;
export type DeleteSurveyMutationOptions = Apollo.BaseMutationOptions<DeleteSurveyMutation, DeleteSurveyMutationVariables>;
export const GetSurveyDocument = gql`
    query GetSurvey($id: ID!) {
  getSurvey(id: $id) {
    id
    title
    intro
    type
    sendgridTemplateId
    ctaLabel
    successHeading
    successBody
    successCtaLabel
    successCtaUrl
    questions {
      id
      question
      type
      required
      options {
        label
        emoji
        subtext
        is_freetext
      }
    }
    createdAt
    createdBy
  }
}
    `;

/**
 * __useGetSurveyQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSurveyQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables> & ({ variables: GetSurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
      }
export function useGetSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
        }
export function useGetSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
        }
export type GetSurveyQueryHookResult = ReturnType<typeof useGetSurveyQuery>;
export type GetSurveyLazyQueryHookResult = ReturnType<typeof useGetSurveyLazyQuery>;
export type GetSurveySuspenseQueryHookResult = ReturnType<typeof useGetSurveySuspenseQuery>;
export type GetSurveyQueryResult = Apollo.QueryResult<GetSurveyQuery, GetSurveyQueryVariables>;
export const CreateSurveyDocument = gql`
    mutation CreateSurvey($input: CreateSurveyInput!) {
  createSurvey(input: $input) {
    id
    title
    intro
    type
    sendgridTemplateId
    ctaLabel
    successHeading
    successBody
    successCtaLabel
    successCtaUrl
    questions {
      id
      question
      type
      required
      options {
        label
        emoji
        subtext
        is_freetext
      }
    }
    createdAt
    createdBy
  }
}
    `;
export type CreateSurveyMutationFn = Apollo.MutationFunction<CreateSurveyMutation, CreateSurveyMutationVariables>;

/**
 * __useCreateSurveyMutation__
 *
 * To run a mutation, you first call `useCreateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyMutation, { data, loading, error }] = useCreateSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyMutation, CreateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument, options);
      }
export type CreateSurveyMutationHookResult = ReturnType<typeof useCreateSurveyMutation>;
export type CreateSurveyMutationResult = Apollo.MutationResult<CreateSurveyMutation>;
export type CreateSurveyMutationOptions = Apollo.BaseMutationOptions<CreateSurveyMutation, CreateSurveyMutationVariables>;
export const SendSurveyDocument = gql`
    mutation SendSurvey($input: SendSurveyInput!) {
  sendSurvey(input: $input) {
    success
    message
    tokensSent
  }
}
    `;
export type SendSurveyMutationFn = Apollo.MutationFunction<SendSurveyMutation, SendSurveyMutationVariables>;

/**
 * __useSendSurveyMutation__
 *
 * To run a mutation, you first call `useSendSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSurveyMutation, { data, loading, error }] = useSendSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SendSurveyMutation, SendSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSurveyMutation, SendSurveyMutationVariables>(SendSurveyDocument, options);
      }
export type SendSurveyMutationHookResult = ReturnType<typeof useSendSurveyMutation>;
export type SendSurveyMutationResult = Apollo.MutationResult<SendSurveyMutation>;
export type SendSurveyMutationOptions = Apollo.BaseMutationOptions<SendSurveyMutation, SendSurveyMutationVariables>;
export const ExportSurveyResponsesCsvDocument = gql`
    query ExportSurveyResponsesCSV($surveyId: ID!) {
  exportSurveyResponsesCSV(surveyId: $surveyId)
}
    `;

/**
 * __useExportSurveyResponsesCsvQuery__
 *
 * To run a query within a React component, call `useExportSurveyResponsesCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSurveyResponsesCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSurveyResponsesCsvQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useExportSurveyResponsesCsvQuery(baseOptions: Apollo.QueryHookOptions<ExportSurveyResponsesCsvQuery, ExportSurveyResponsesCsvQueryVariables> & ({ variables: ExportSurveyResponsesCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSurveyResponsesCsvQuery, ExportSurveyResponsesCsvQueryVariables>(ExportSurveyResponsesCsvDocument, options);
      }
export function useExportSurveyResponsesCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSurveyResponsesCsvQuery, ExportSurveyResponsesCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSurveyResponsesCsvQuery, ExportSurveyResponsesCsvQueryVariables>(ExportSurveyResponsesCsvDocument, options);
        }
export function useExportSurveyResponsesCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportSurveyResponsesCsvQuery, ExportSurveyResponsesCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportSurveyResponsesCsvQuery, ExportSurveyResponsesCsvQueryVariables>(ExportSurveyResponsesCsvDocument, options);
        }
export type ExportSurveyResponsesCsvQueryHookResult = ReturnType<typeof useExportSurveyResponsesCsvQuery>;
export type ExportSurveyResponsesCsvLazyQueryHookResult = ReturnType<typeof useExportSurveyResponsesCsvLazyQuery>;
export type ExportSurveyResponsesCsvSuspenseQueryHookResult = ReturnType<typeof useExportSurveyResponsesCsvSuspenseQuery>;
export type ExportSurveyResponsesCsvQueryResult = Apollo.QueryResult<ExportSurveyResponsesCsvQuery, ExportSurveyResponsesCsvQueryVariables>;
export const UpdateSurveyDocument = gql`
    mutation UpdateSurvey($input: UpdateSurveyInput!) {
  updateSurvey(input: $input) {
    id
    title
    intro
    type
    sendgridTemplateId
    ctaLabel
    successHeading
    successBody
    successCtaLabel
    successCtaUrl
    questions {
      id
      question
      type
      required
      options {
        label
        emoji
        subtext
        is_freetext
      }
    }
    createdAt
    createdBy
  }
}
    `;
export type UpdateSurveyMutationFn = Apollo.MutationFunction<UpdateSurveyMutation, UpdateSurveyMutationVariables>;

/**
 * __useUpdateSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyMutation, { data, loading, error }] = useUpdateSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyMutation, UpdateSurveyMutationVariables>(UpdateSurveyDocument, options);
      }
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>;
export type UpdateSurveyMutationResult = Apollo.MutationResult<UpdateSurveyMutation>;
export type UpdateSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>;
export const MyProfileDocument = gql`
    query MyProfile {
  myProfile {
    user_id
    profile_photo_resource
    username
    email_address
    first_name
    last_name
    full_name
    date_last_login
    zipcode
    user_bio
    date_pro_user
    phone_number
    phone_verified
    phone_verified_at
    sms_consent_captured_at
    user_type
    is_internal
    date_onboarding_completed
    state
    city
    country
    twitter_url
    youtube_url
    instagram_url
    facebook_url
    website
    slug
    stripe_customer_id
    subscription_status
    billing_interval
    current_period_end
    subscription_amount
    default_listing_id
    profile_image_completed
    bio_completed
    communication_completed
    location_completed
    profile_widget_dismissed
    producer_welcome_dismissed
    profile_widget_completed_at
    interests
    default_listing {
      listing_id
      name
      firstName
      lastName
      email
      publicEmail
      photo
      description
      membership_type
      enhanced
      verified
      address
      city
      state
      zipcode
      twitter
      instagram
      facebook
      website
      user_type
      slug
      phone
      tagLine
      publicPhone
      OperatingPeriod {
        operationId
        day
        openingTime
        closingTime
      }
      Practices {
        practice_id
        tag
        name
        imgUrl
      }
      subscription {
        status
      }
    }
    followers {
      user_id
    }
    followers_count
    followings {
      user_id
    }
    listings {
      listing_id
      user_type
      name
      city
      state
      slug
    }
    userRoles {
      id
      role_id
      user_id
      default
      role {
        name
        role_id
      }
    }
    notification_prefs {
      id
      userID
      updateType
      channel
      isEnabled
    }
  }
}
    `;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
      }
export function useMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
        }
export function useMyProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
        }
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileSuspenseQueryHookResult = ReturnType<typeof useMyProfileSuspenseQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const UserProfileDocument = gql`
    query userProfile($slug: String!) {
  userProfile(slug: $slug) {
    user_id
    profile_photo_resource
    username
    email_address
    first_name
    last_name
    full_name
    date_last_login
    zipcode
    user_bio
    date_pro_user
    phone_number
    user_type
    date_onboarding_completed
    state
    city
    country
    twitter_url
    youtube_url
    instagram_url
    facebook_url
    website
    slug
    stripe_customer_id
    subscription_status
    billing_interval
    current_period_end
    subscription_amount
    default_listing_id
    profile_image_completed
    bio_completed
    communication_completed
    location_completed
    default_listing {
      listing_id
      name
      firstName
      lastName
      email
      publicEmail
      photo
      description
      membership_type
      enhanced
      verified
      address
      city
      state
      zipcode
      twitter
      instagram
      facebook
      website
      user_type
      slug
      phone
      tagLine
      publicPhone
      OperatingPeriod {
        operationId
        day
        openingTime
        closingTime
      }
      Practices {
        practice_id
        tag
        name
        imgUrl
      }
      subscription {
        status
      }
    }
    followers {
      user_id
    }
    followers_count
    followings {
      user_id
    }
    listings {
      listing_id
      user_type
      name
      city
      state
      slug
    }
    userRoles {
      id
      role_id
      user_id
      default
      role {
        name
        role_id
      }
    }
  }
}
    `;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables> & ({ variables: UserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export function useUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileSuspenseQueryHookResult = ReturnType<typeof useUserProfileSuspenseQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UpdateProfileDocument = gql`
    mutation updateProfile($userID: Int!, $input: UserInput!) {
  updateProfile(userID: $userID, input: $input) {
    user_id
    profile_photo_resource
    username
    email_address
    first_name
    last_name
    full_name
    user_bio
    slug
    profile_image_completed
    bio_completed
    communication_completed
    location_completed
    interests
    date_onboarding_completed
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UpdateUserAvatarDocument = gql`
    mutation updateUserAvatar($file: Upload!, $userID: Int!) {
  updateUserAvatar(file: $file, userID: $userID) {
    record_id
    date_updated
    img_path
  }
}
    `;
export type UpdateUserAvatarMutationFn = Apollo.MutationFunction<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;

/**
 * __useUpdateUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarMutation, { data, loading, error }] = useUpdateUserAvatarMutation({
 *   variables: {
 *      file: // value for 'file'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useUpdateUserAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>(UpdateUserAvatarDocument, options);
      }
export type UpdateUserAvatarMutationHookResult = ReturnType<typeof useUpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationResult = Apollo.MutationResult<UpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;
export const DeleteUserAccountDocument = gql`
    mutation deleteUserAccount($userID: Int!) {
  deleteUser(user_id: $userID)
}
    `;
export type DeleteUserAccountMutationFn = Apollo.MutationFunction<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;

/**
 * __useDeleteUserAccountMutation__
 *
 * To run a mutation, you first call `useDeleteUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAccountMutation, { data, loading, error }] = useDeleteUserAccountMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useDeleteUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>(DeleteUserAccountDocument, options);
      }
export type DeleteUserAccountMutationHookResult = ReturnType<typeof useDeleteUserAccountMutation>;
export type DeleteUserAccountMutationResult = Apollo.MutationResult<DeleteUserAccountMutation>;
export type DeleteUserAccountMutationOptions = Apollo.BaseMutationOptions<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;
export const UserExistDocument = gql`
    query userExist($email: String!) {
  userExist(email: $email) {
    email_address
    user_id
    user_type
    default_listing_id
    default_listing {
      membership_type
      enhanced
      verified
      approved
    }
  }
}
    `;

/**
 * __useUserExistQuery__
 *
 * To run a query within a React component, call `useUserExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExistQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserExistQuery(baseOptions: Apollo.QueryHookOptions<UserExistQuery, UserExistQueryVariables> & ({ variables: UserExistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserExistQuery, UserExistQueryVariables>(UserExistDocument, options);
      }
export function useUserExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserExistQuery, UserExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserExistQuery, UserExistQueryVariables>(UserExistDocument, options);
        }
export function useUserExistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserExistQuery, UserExistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserExistQuery, UserExistQueryVariables>(UserExistDocument, options);
        }
export type UserExistQueryHookResult = ReturnType<typeof useUserExistQuery>;
export type UserExistLazyQueryHookResult = ReturnType<typeof useUserExistLazyQuery>;
export type UserExistSuspenseQueryHookResult = ReturnType<typeof useUserExistSuspenseQuery>;
export type UserExistQueryResult = Apollo.QueryResult<UserExistQuery, UserExistQueryVariables>;
export const GetNotificationPreferencesDocument = gql`
    query GetNotificationPreferences($userID: Int!) {
  getNotificationPreferences(userID: $userID) {
    updateType
    channel
    isEnabled
  }
}
    `;

/**
 * __useGetNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationPreferencesQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetNotificationPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables> & ({ variables: GetNotificationPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>(GetNotificationPreferencesDocument, options);
      }
export function useGetNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>(GetNotificationPreferencesDocument, options);
        }
export function useGetNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>(GetNotificationPreferencesDocument, options);
        }
export type GetNotificationPreferencesQueryHookResult = ReturnType<typeof useGetNotificationPreferencesQuery>;
export type GetNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useGetNotificationPreferencesLazyQuery>;
export type GetNotificationPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetNotificationPreferencesSuspenseQuery>;
export type GetNotificationPreferencesQueryResult = Apollo.QueryResult<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>;
export const UpsertNotificationPreferencesDocument = gql`
    mutation UpsertNotificationPreferences($input: [NotificationPreferenceInput!]!) {
  upsertNotificationPreferences(input: $input)
}
    `;
export type UpsertNotificationPreferencesMutationFn = Apollo.MutationFunction<UpsertNotificationPreferencesMutation, UpsertNotificationPreferencesMutationVariables>;

/**
 * __useUpsertNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpsertNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNotificationPreferencesMutation, { data, loading, error }] = useUpsertNotificationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNotificationPreferencesMutation, UpsertNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNotificationPreferencesMutation, UpsertNotificationPreferencesMutationVariables>(UpsertNotificationPreferencesDocument, options);
      }
export type UpsertNotificationPreferencesMutationHookResult = ReturnType<typeof useUpsertNotificationPreferencesMutation>;
export type UpsertNotificationPreferencesMutationResult = Apollo.MutationResult<UpsertNotificationPreferencesMutation>;
export type UpsertNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpsertNotificationPreferencesMutation, UpsertNotificationPreferencesMutationVariables>;